import * as A from "react";
import Te, { forwardRef as Ze, createElement as xe, useLayoutEffect as ia, useEffect as ct, useState as Ne, useRef as je, useMemo as Wt, createContext as K1, useContext as lo, useCallback as qe, Children as Bn, isValidElement as Dr, cloneElement as aa, Fragment as a1, Component as YC, PureComponent as UC, useId as JC } from "react";
import * as Bf from "react-dom";
import Vf, { flushSync as KC, createPortal as $l } from "react-dom";
import './index.css';var di = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pi = { exports: {} }, kc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M3;
function QC() {
  if (M3) return kc;
  M3 = 1;
  var e = Te, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), c = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, f, d) {
    var p, m = {}, b = null, y = null;
    d !== void 0 && (b = "" + d), f.key !== void 0 && (b = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (p in f) c.call(f, p) && !a.hasOwnProperty(p) && (m[p] = f[p]);
    if (u && u.defaultProps) for (p in f = u.defaultProps, f) m[p] === void 0 && (m[p] = f[p]);
    return { $$typeof: t, type: u, key: b, ref: y, props: m, _owner: o.current };
  }
  return kc.Fragment = n, kc.jsx = s, kc.jsxs = s, kc;
}
var Bc = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L3;
function ex() {
  return L3 || (L3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Te, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), C = Symbol.iterator, h = "@@iterator";
    function v(T) {
      if (T === null || typeof T != "object")
        return null;
      var K = C && T[C] || T[h];
      return typeof K == "function" ? K : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(T) {
      {
        for (var K = arguments.length, be = new Array(K > 1 ? K - 1 : 0), Re = 1; Re < K; Re++)
          be[Re - 1] = arguments[Re];
        L("error", T, be);
      }
    }
    function L(T, K, be) {
      {
        var Re = I.ReactDebugCurrentFrame, Ye = Re.getStackAddendum();
        Ye !== "" && (K += "%s", be = be.concat([Ye]));
        var Qe = be.map(function(We) {
          return String(We);
        });
        Qe.unshift("Warning: " + K), Function.prototype.apply.call(console[T], console, Qe);
      }
    }
    var R = !1, M = !1, $ = !1, O = !1, G = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(T) {
      return !!(typeof T == "string" || typeof T == "function" || T === c || T === a || G || T === o || T === d || T === p || O || T === y || R || M || $ || typeof T == "object" && T !== null && (T.$$typeof === b || T.$$typeof === m || T.$$typeof === s || T.$$typeof === u || T.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      T.$$typeof === J || T.getModuleId !== void 0));
    }
    function fe(T, K, be) {
      var Re = T.displayName;
      if (Re)
        return Re;
      var Ye = K.displayName || K.name || "";
      return Ye !== "" ? be + "(" + Ye + ")" : be;
    }
    function U(T) {
      return T.displayName || "Context";
    }
    function re(T) {
      if (T == null)
        return null;
      if (typeof T.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof T == "function")
        return T.displayName || T.name || null;
      if (typeof T == "string")
        return T;
      switch (T) {
        case c:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case u:
            var K = T;
            return U(K) + ".Consumer";
          case s:
            var be = T;
            return U(be._context) + ".Provider";
          case f:
            return fe(T, T.render, "ForwardRef");
          case m:
            var Re = T.displayName || null;
            return Re !== null ? Re : re(T.type) || "Memo";
          case b: {
            var Ye = T, Qe = Ye._payload, We = Ye._init;
            try {
              return re(We(Qe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var oe = Object.assign, ue = 0, te, se, ee, q, B, X, ie;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function le() {
      {
        if (ue === 0) {
          te = console.log, se = console.info, ee = console.warn, q = console.error, B = console.group, X = console.groupCollapsed, ie = console.groupEnd;
          var T = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: T,
            log: T,
            warn: T,
            error: T,
            group: T,
            groupCollapsed: T,
            groupEnd: T
          });
        }
        ue++;
      }
    }
    function ve() {
      {
        if (ue--, ue === 0) {
          var T = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: oe({}, T, {
              value: te
            }),
            info: oe({}, T, {
              value: se
            }),
            warn: oe({}, T, {
              value: ee
            }),
            error: oe({}, T, {
              value: q
            }),
            group: oe({}, T, {
              value: B
            }),
            groupCollapsed: oe({}, T, {
              value: X
            }),
            groupEnd: oe({}, T, {
              value: ie
            })
          });
        }
        ue < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = I.ReactCurrentDispatcher, Z;
    function ne(T, K, be) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (Ye) {
            var Re = Ye.stack.trim().match(/\n( *(at )?)/);
            Z = Re && Re[1] || "";
          }
        return `
` + Z + T;
      }
    }
    var ge = !1, me;
    {
      var we = typeof WeakMap == "function" ? WeakMap : Map;
      me = new we();
    }
    function j(T, K) {
      if (!T || ge)
        return "";
      {
        var be = me.get(T);
        if (be !== void 0)
          return be;
      }
      var Re;
      ge = !0;
      var Ye = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Qe;
      Qe = de.current, de.current = null, le();
      try {
        if (K) {
          var We = function() {
            throw Error();
          };
          if (Object.defineProperty(We.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(We, []);
            } catch (yt) {
              Re = yt;
            }
            Reflect.construct(T, [], We);
          } else {
            try {
              We.call();
            } catch (yt) {
              Re = yt;
            }
            T.call(We.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yt) {
            Re = yt;
          }
          T();
        }
      } catch (yt) {
        if (yt && Re && typeof yt.stack == "string") {
          for (var Ge = yt.stack.split(`
`), _t = Re.stack.split(`
`), ft = Ge.length - 1, gt = _t.length - 1; ft >= 1 && gt >= 0 && Ge[ft] !== _t[gt]; )
            gt--;
          for (; ft >= 1 && gt >= 0; ft--, gt--)
            if (Ge[ft] !== _t[gt]) {
              if (ft !== 1 || gt !== 1)
                do
                  if (ft--, gt--, gt < 0 || Ge[ft] !== _t[gt]) {
                    var Xt = `
` + Ge[ft].replace(" at new ", " at ");
                    return T.displayName && Xt.includes("<anonymous>") && (Xt = Xt.replace("<anonymous>", T.displayName)), typeof T == "function" && me.set(T, Xt), Xt;
                  }
                while (ft >= 1 && gt >= 0);
              break;
            }
        }
      } finally {
        ge = !1, de.current = Qe, ve(), Error.prepareStackTrace = Ye;
      }
      var Sn = T ? T.displayName || T.name : "", Jn = Sn ? ne(Sn) : "";
      return typeof T == "function" && me.set(T, Jn), Jn;
    }
    function Be(T, K, be) {
      return j(T, !1);
    }
    function Fe(T) {
      var K = T.prototype;
      return !!(K && K.isReactComponent);
    }
    function ut(T, K, be) {
      if (T == null)
        return "";
      if (typeof T == "function")
        return j(T, Fe(T));
      if (typeof T == "string")
        return ne(T);
      switch (T) {
        case d:
          return ne("Suspense");
        case p:
          return ne("SuspenseList");
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case f:
            return Be(T.render);
          case m:
            return ut(T.type, K, be);
          case b: {
            var Re = T, Ye = Re._payload, Qe = Re._init;
            try {
              return ut(Qe(Ye), K, be);
            } catch {
            }
          }
        }
      return "";
    }
    var $t = Object.prototype.hasOwnProperty, Ct = {}, Yn = I.ReactDebugCurrentFrame;
    function Qt(T) {
      if (T) {
        var K = T._owner, be = ut(T.type, T._source, K ? K.type : null);
        Yn.setExtraStackFrame(be);
      } else
        Yn.setExtraStackFrame(null);
    }
    function dn(T, K, be, Re, Ye) {
      {
        var Qe = Function.call.bind($t);
        for (var We in T)
          if (Qe(T, We)) {
            var Ge = void 0;
            try {
              if (typeof T[We] != "function") {
                var _t = Error((Re || "React class") + ": " + be + " type `" + We + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof T[We] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _t.name = "Invariant Violation", _t;
              }
              Ge = T[We](K, We, Re, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ft) {
              Ge = ft;
            }
            Ge && !(Ge instanceof Error) && (Qt(Ye), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Re || "React class", be, We, typeof Ge), Qt(null)), Ge instanceof Error && !(Ge.message in Ct) && (Ct[Ge.message] = !0, Qt(Ye), S("Failed %s type: %s", be, Ge.message), Qt(null));
          }
      }
    }
    var en = Array.isArray;
    function Un(T) {
      return en(T);
    }
    function b1(T) {
      {
        var K = typeof Symbol == "function" && Symbol.toStringTag, be = K && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return be;
      }
    }
    function ja(T) {
      try {
        return br(T), !1;
      } catch {
        return !0;
      }
    }
    function br(T) {
      return "" + T;
    }
    function xo(T) {
      if (ja(T))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", b1(T)), br(T);
    }
    var Cr = I.ReactCurrentOwner, xr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, C1, x1;
    function gc(T) {
      if ($t.call(T, "ref")) {
        var K = Object.getOwnPropertyDescriptor(T, "ref").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return T.ref !== void 0;
    }
    function mc(T) {
      if ($t.call(T, "key")) {
        var K = Object.getOwnPropertyDescriptor(T, "key").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return T.key !== void 0;
    }
    function hc(T, K) {
      typeof T.ref == "string" && Cr.current;
    }
    function vc(T, K) {
      {
        var be = function() {
          C1 || (C1 = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
        };
        be.isReactWarning = !0, Object.defineProperty(T, "key", {
          get: be,
          configurable: !0
        });
      }
    }
    function bc(T, K) {
      {
        var be = function() {
          x1 || (x1 = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
        };
        be.isReactWarning = !0, Object.defineProperty(T, "ref", {
          get: be,
          configurable: !0
        });
      }
    }
    var Cc = function(T, K, be, Re, Ye, Qe, We) {
      var Ge = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: T,
        key: K,
        ref: be,
        props: We,
        // Record the component responsible for creating this element.
        _owner: Qe
      };
      return Ge._store = {}, Object.defineProperty(Ge._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ge, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Re
      }), Object.defineProperty(Ge, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ye
      }), Object.freeze && (Object.freeze(Ge.props), Object.freeze(Ge)), Ge;
    };
    function xc(T, K, be, Re, Ye) {
      {
        var Qe, We = {}, Ge = null, _t = null;
        be !== void 0 && (xo(be), Ge = "" + be), mc(K) && (xo(K.key), Ge = "" + K.key), gc(K) && (_t = K.ref, hc(K, Ye));
        for (Qe in K)
          $t.call(K, Qe) && !xr.hasOwnProperty(Qe) && (We[Qe] = K[Qe]);
        if (T && T.defaultProps) {
          var ft = T.defaultProps;
          for (Qe in ft)
            We[Qe] === void 0 && (We[Qe] = ft[Qe]);
        }
        if (Ge || _t) {
          var gt = typeof T == "function" ? T.displayName || T.name || "Unknown" : T;
          Ge && vc(We, gt), _t && bc(We, gt);
        }
        return Cc(T, Ge, _t, Ye, Re, Cr.current, We);
      }
    }
    var yc = I.ReactCurrentOwner, yo = I.ReactDebugCurrentFrame;
    function yr(T) {
      if (T) {
        var K = T._owner, be = ut(T.type, T._source, K ? K.type : null);
        yo.setExtraStackFrame(be);
      } else
        yo.setExtraStackFrame(null);
    }
    var y1;
    y1 = !1;
    function I1(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function Io() {
      {
        if (yc.current) {
          var T = re(yc.current.type);
          if (T)
            return `

Check the render method of \`` + T + "`.";
        }
        return "";
      }
    }
    function Xa(T) {
      return "";
    }
    var wo = {};
    function Za(T) {
      {
        var K = Io();
        if (!K) {
          var be = typeof T == "string" ? T : T.displayName || T.name;
          be && (K = `

Check the top-level render call using <` + be + ">.");
        }
        return K;
      }
    }
    function Ic(T, K) {
      {
        if (!T._store || T._store.validated || T.key != null)
          return;
        T._store.validated = !0;
        var be = Za(K);
        if (wo[be])
          return;
        wo[be] = !0;
        var Re = "";
        T && T._owner && T._owner !== yc.current && (Re = " It was passed a child from " + re(T._owner.type) + "."), yr(T), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Re), yr(null);
      }
    }
    function Ao(T, K) {
      {
        if (typeof T != "object")
          return;
        if (Un(T))
          for (var be = 0; be < T.length; be++) {
            var Re = T[be];
            I1(Re) && Ic(Re, K);
          }
        else if (I1(T))
          T._store && (T._store.validated = !0);
        else if (T) {
          var Ye = v(T);
          if (typeof Ye == "function" && Ye !== T.entries)
            for (var Qe = Ye.call(T), We; !(We = Qe.next()).done; )
              I1(We.value) && Ic(We.value, K);
        }
      }
    }
    function Ya(T) {
      {
        var K = T.type;
        if (K == null || typeof K == "string")
          return;
        var be;
        if (typeof K == "function")
          be = K.propTypes;
        else if (typeof K == "object" && (K.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        K.$$typeof === m))
          be = K.propTypes;
        else
          return;
        if (be) {
          var Re = re(K);
          dn(be, T.props, "prop", Re, T);
        } else if (K.PropTypes !== void 0 && !y1) {
          y1 = !0;
          var Ye = re(K);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ye || "Unknown");
        }
        typeof K.getDefaultProps == "function" && !K.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ua(T) {
      {
        for (var K = Object.keys(T.props), be = 0; be < K.length; be++) {
          var Re = K[be];
          if (Re !== "children" && Re !== "key") {
            yr(T), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Re), yr(null);
            break;
          }
        }
        T.ref !== null && (yr(T), S("Invalid attribute `ref` supplied to `React.Fragment`."), yr(null));
      }
    }
    var w1 = {};
    function So(T, K, be, Re, Ye, Qe) {
      {
        var We = ae(T);
        if (!We) {
          var Ge = "";
          (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (Ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _t = Xa();
          _t ? Ge += _t : Ge += Io();
          var ft;
          T === null ? ft = "null" : Un(T) ? ft = "array" : T !== void 0 && T.$$typeof === t ? (ft = "<" + (re(T.type) || "Unknown") + " />", Ge = " Did you accidentally export a JSX literal instead of a component?") : ft = typeof T, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ft, Ge);
        }
        var gt = xc(T, K, be, Ye, Qe);
        if (gt == null)
          return gt;
        if (We) {
          var Xt = K.children;
          if (Xt !== void 0)
            if (Re)
              if (Un(Xt)) {
                for (var Sn = 0; Sn < Xt.length; Sn++)
                  Ao(Xt[Sn], T);
                Object.freeze && Object.freeze(Xt);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ao(Xt, T);
        }
        if ($t.call(K, "key")) {
          var Jn = re(T), yt = Object.keys(K).filter(function(e2) {
            return e2 !== "key";
          }), Ac = yt.length > 0 ? "{key: someKey, " + yt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!w1[Jn + Ac]) {
            var Qa = yt.length > 0 ? "{" + yt.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ac, Jn, Qa, Jn), w1[Jn + Ac] = !0;
          }
        }
        return T === c ? Ua(gt) : Ya(gt), gt;
      }
    }
    function wc(T, K, be) {
      return So(T, K, be, !0);
    }
    function Ja(T, K, be) {
      return So(T, K, be, !1);
    }
    var Ka = Ja, qa = wc;
    Bc.Fragment = c, Bc.jsx = Ka, Bc.jsxs = qa;
  }()), Bc;
}
var R3;
function tx() {
  return R3 || (R3 = 1, process.env.NODE_ENV === "production" ? pi.exports = QC() : pi.exports = ex()), pi.exports;
}
var w = tx(), gi = { exports: {} }, mi = { exports: {} }, tt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P3;
function nx() {
  if (P3) return tt;
  P3 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, c = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function L(M) {
    if (typeof M == "object" && M !== null) {
      var $ = M.$$typeof;
      switch ($) {
        case t:
          switch (M = M.type, M) {
            case f:
            case d:
            case c:
            case a:
            case o:
            case m:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case u:
                case p:
                case C:
                case y:
                case s:
                  return M;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function R(M) {
    return L(M) === d;
  }
  return tt.AsyncMode = f, tt.ConcurrentMode = d, tt.ContextConsumer = u, tt.ContextProvider = s, tt.Element = t, tt.ForwardRef = p, tt.Fragment = c, tt.Lazy = C, tt.Memo = y, tt.Portal = n, tt.Profiler = a, tt.StrictMode = o, tt.Suspense = m, tt.isAsyncMode = function(M) {
    return R(M) || L(M) === f;
  }, tt.isConcurrentMode = R, tt.isContextConsumer = function(M) {
    return L(M) === u;
  }, tt.isContextProvider = function(M) {
    return L(M) === s;
  }, tt.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, tt.isForwardRef = function(M) {
    return L(M) === p;
  }, tt.isFragment = function(M) {
    return L(M) === c;
  }, tt.isLazy = function(M) {
    return L(M) === C;
  }, tt.isMemo = function(M) {
    return L(M) === y;
  }, tt.isPortal = function(M) {
    return L(M) === n;
  }, tt.isProfiler = function(M) {
    return L(M) === a;
  }, tt.isStrictMode = function(M) {
    return L(M) === o;
  }, tt.isSuspense = function(M) {
    return L(M) === m;
  }, tt.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === c || M === d || M === a || M === o || M === m || M === b || typeof M == "object" && M !== null && (M.$$typeof === C || M.$$typeof === y || M.$$typeof === s || M.$$typeof === u || M.$$typeof === p || M.$$typeof === v || M.$$typeof === I || M.$$typeof === S || M.$$typeof === h);
  }, tt.typeOf = L, tt;
}
var nt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T3;
function rx() {
  return T3 || (T3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, c = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function L(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === c || j === d || j === a || j === o || j === m || j === b || typeof j == "object" && j !== null && (j.$$typeof === C || j.$$typeof === y || j.$$typeof === s || j.$$typeof === u || j.$$typeof === p || j.$$typeof === v || j.$$typeof === I || j.$$typeof === S || j.$$typeof === h);
    }
    function R(j) {
      if (typeof j == "object" && j !== null) {
        var Be = j.$$typeof;
        switch (Be) {
          case t:
            var Fe = j.type;
            switch (Fe) {
              case f:
              case d:
              case c:
              case a:
              case o:
              case m:
                return Fe;
              default:
                var ut = Fe && Fe.$$typeof;
                switch (ut) {
                  case u:
                  case p:
                  case C:
                  case y:
                  case s:
                    return ut;
                  default:
                    return Be;
                }
            }
          case n:
            return Be;
        }
      }
    }
    var M = f, $ = d, O = u, G = s, J = t, ae = p, fe = c, U = C, re = y, oe = n, ue = a, te = o, se = m, ee = !1;
    function q(j) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(j) || R(j) === f;
    }
    function B(j) {
      return R(j) === d;
    }
    function X(j) {
      return R(j) === u;
    }
    function ie(j) {
      return R(j) === s;
    }
    function he(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function le(j) {
      return R(j) === p;
    }
    function ve(j) {
      return R(j) === c;
    }
    function de(j) {
      return R(j) === C;
    }
    function Z(j) {
      return R(j) === y;
    }
    function ne(j) {
      return R(j) === n;
    }
    function ge(j) {
      return R(j) === a;
    }
    function me(j) {
      return R(j) === o;
    }
    function we(j) {
      return R(j) === m;
    }
    nt.AsyncMode = M, nt.ConcurrentMode = $, nt.ContextConsumer = O, nt.ContextProvider = G, nt.Element = J, nt.ForwardRef = ae, nt.Fragment = fe, nt.Lazy = U, nt.Memo = re, nt.Portal = oe, nt.Profiler = ue, nt.StrictMode = te, nt.Suspense = se, nt.isAsyncMode = q, nt.isConcurrentMode = B, nt.isContextConsumer = X, nt.isContextProvider = ie, nt.isElement = he, nt.isForwardRef = le, nt.isFragment = ve, nt.isLazy = de, nt.isMemo = Z, nt.isPortal = ne, nt.isProfiler = ge, nt.isStrictMode = me, nt.isSuspense = we, nt.isValidElementType = L, nt.typeOf = R;
  }()), nt;
}
var z3;
function Gl() {
  return z3 || (z3 = 1, process.env.NODE_ENV === "production" ? mi.exports = nx() : mi.exports = rx()), mi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fs, N3;
function cx() {
  if (N3) return fs;
  N3 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function c(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var f = Object.getOwnPropertyNames(s).map(function(p) {
        return s[p];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        d[p] = p;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fs = o() ? Object.assign : function(a, s) {
    for (var u, f = c(a), d, p = 1; p < arguments.length; p++) {
      u = Object(arguments[p]);
      for (var m in u)
        t.call(u, m) && (f[m] = u[m]);
      if (e) {
        d = e(u);
        for (var b = 0; b < d.length; b++)
          n.call(u, d[b]) && (f[d[b]] = u[d[b]]);
      }
    }
    return f;
  }, fs;
}
var ds, O3;
function kl() {
  if (O3) return ds;
  O3 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ds = e, ds;
}
var ps, F3;
function Wf() {
  return F3 || (F3 = 1, ps = Function.call.bind(Object.prototype.hasOwnProperty)), ps;
}
var gs, D3;
function ox() {
  if (D3) return gs;
  D3 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ kl(), n = {}, c = /* @__PURE__ */ Wf();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(a, s, u, f, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in a)
        if (c(a, p)) {
          var m;
          try {
            if (typeof a[p] != "function") {
              var b = Error(
                (f || "React class") + ": " + u + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            m = a[p](s, p, f, u, null, t);
          } catch (C) {
            m = C;
          }
          if (m && !(m instanceof Error) && e(
            (f || "React class") + ": type specification of " + u + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var y = d ? d() : "";
            e(
              "Failed " + u + " type: " + m.message + (y ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, gs = o, gs;
}
var ms, $3;
function ix() {
  if ($3) return ms;
  $3 = 1;
  var e = Gl(), t = cx(), n = /* @__PURE__ */ kl(), c = /* @__PURE__ */ Wf(), o = /* @__PURE__ */ ox(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var f = "Warning: " + u;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ms = function(u, f) {
    var d = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function m(B) {
      var X = B && (d && B[d] || B[p]);
      if (typeof X == "function")
        return X;
    }
    var b = "<<anonymous>>", y = {
      array: I("array"),
      bigint: I("bigint"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: S(),
      arrayOf: L,
      element: R(),
      elementType: M(),
      instanceOf: $,
      node: ae(),
      objectOf: G,
      oneOf: O,
      oneOfType: J,
      shape: U,
      exact: re
    };
    function C(B, X) {
      return B === X ? B !== 0 || 1 / B === 1 / X : B !== B && X !== X;
    }
    function h(B, X) {
      this.message = B, this.data = X && typeof X == "object" ? X : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function v(B) {
      if (process.env.NODE_ENV !== "production")
        var X = {}, ie = 0;
      function he(ve, de, Z, ne, ge, me, we) {
        if (ne = ne || b, me = me || Z, we !== n) {
          if (f) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Be = ne + ":" + Z;
            !X[Be] && // Avoid spamming the console because they are often not actionable except for lib authors
            ie < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + ne + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), X[Be] = !0, ie++);
          }
        }
        return de[Z] == null ? ve ? de[Z] === null ? new h("The " + ge + " `" + me + "` is marked as required " + ("in `" + ne + "`, but its value is `null`.")) : new h("The " + ge + " `" + me + "` is marked as required in " + ("`" + ne + "`, but its value is `undefined`.")) : null : B(de, Z, ne, ge, me);
      }
      var le = he.bind(null, !1);
      return le.isRequired = he.bind(null, !0), le;
    }
    function I(B) {
      function X(ie, he, le, ve, de, Z) {
        var ne = ie[he], ge = te(ne);
        if (ge !== B) {
          var me = se(ne);
          return new h(
            "Invalid " + ve + " `" + de + "` of type " + ("`" + me + "` supplied to `" + le + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return v(X);
    }
    function S() {
      return v(s);
    }
    function L(B) {
      function X(ie, he, le, ve, de) {
        if (typeof B != "function")
          return new h("Property `" + de + "` of component `" + le + "` has invalid PropType notation inside arrayOf.");
        var Z = ie[he];
        if (!Array.isArray(Z)) {
          var ne = te(Z);
          return new h("Invalid " + ve + " `" + de + "` of type " + ("`" + ne + "` supplied to `" + le + "`, expected an array."));
        }
        for (var ge = 0; ge < Z.length; ge++) {
          var me = B(Z, ge, le, ve, de + "[" + ge + "]", n);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return v(X);
    }
    function R() {
      function B(X, ie, he, le, ve) {
        var de = X[ie];
        if (!u(de)) {
          var Z = te(de);
          return new h("Invalid " + le + " `" + ve + "` of type " + ("`" + Z + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(B);
    }
    function M() {
      function B(X, ie, he, le, ve) {
        var de = X[ie];
        if (!e.isValidElementType(de)) {
          var Z = te(de);
          return new h("Invalid " + le + " `" + ve + "` of type " + ("`" + Z + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(B);
    }
    function $(B) {
      function X(ie, he, le, ve, de) {
        if (!(ie[he] instanceof B)) {
          var Z = B.name || b, ne = q(ie[he]);
          return new h("Invalid " + ve + " `" + de + "` of type " + ("`" + ne + "` supplied to `" + le + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return v(X);
    }
    function O(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function X(ie, he, le, ve, de) {
        for (var Z = ie[he], ne = 0; ne < B.length; ne++)
          if (C(Z, B[ne]))
            return null;
        var ge = JSON.stringify(B, function(we, j) {
          var Be = se(j);
          return Be === "symbol" ? String(j) : j;
        });
        return new h("Invalid " + ve + " `" + de + "` of value `" + String(Z) + "` " + ("supplied to `" + le + "`, expected one of " + ge + "."));
      }
      return v(X);
    }
    function G(B) {
      function X(ie, he, le, ve, de) {
        if (typeof B != "function")
          return new h("Property `" + de + "` of component `" + le + "` has invalid PropType notation inside objectOf.");
        var Z = ie[he], ne = te(Z);
        if (ne !== "object")
          return new h("Invalid " + ve + " `" + de + "` of type " + ("`" + ne + "` supplied to `" + le + "`, expected an object."));
        for (var ge in Z)
          if (c(Z, ge)) {
            var me = B(Z, ge, le, ve, de + "." + ge, n);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return v(X);
    }
    function J(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var X = 0; X < B.length; X++) {
        var ie = B[X];
        if (typeof ie != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(ie) + " at index " + X + "."
          ), s;
      }
      function he(le, ve, de, Z, ne) {
        for (var ge = [], me = 0; me < B.length; me++) {
          var we = B[me], j = we(le, ve, de, Z, ne, n);
          if (j == null)
            return null;
          j.data && c(j.data, "expectedType") && ge.push(j.data.expectedType);
        }
        var Be = ge.length > 0 ? ", expected one of type [" + ge.join(", ") + "]" : "";
        return new h("Invalid " + Z + " `" + ne + "` supplied to " + ("`" + de + "`" + Be + "."));
      }
      return v(he);
    }
    function ae() {
      function B(X, ie, he, le, ve) {
        return oe(X[ie]) ? null : new h("Invalid " + le + " `" + ve + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return v(B);
    }
    function fe(B, X, ie, he, le) {
      return new h(
        (B || "React class") + ": " + X + " type `" + ie + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + le + "`."
      );
    }
    function U(B) {
      function X(ie, he, le, ve, de) {
        var Z = ie[he], ne = te(Z);
        if (ne !== "object")
          return new h("Invalid " + ve + " `" + de + "` of type `" + ne + "` " + ("supplied to `" + le + "`, expected `object`."));
        for (var ge in B) {
          var me = B[ge];
          if (typeof me != "function")
            return fe(le, ve, de, ge, se(me));
          var we = me(Z, ge, le, ve, de + "." + ge, n);
          if (we)
            return we;
        }
        return null;
      }
      return v(X);
    }
    function re(B) {
      function X(ie, he, le, ve, de) {
        var Z = ie[he], ne = te(Z);
        if (ne !== "object")
          return new h("Invalid " + ve + " `" + de + "` of type `" + ne + "` " + ("supplied to `" + le + "`, expected `object`."));
        var ge = t({}, ie[he], B);
        for (var me in ge) {
          var we = B[me];
          if (c(B, me) && typeof we != "function")
            return fe(le, ve, de, me, se(we));
          if (!we)
            return new h(
              "Invalid " + ve + " `" + de + "` key `" + me + "` supplied to `" + le + "`.\nBad object: " + JSON.stringify(ie[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var j = we(Z, me, le, ve, de + "." + me, n);
          if (j)
            return j;
        }
        return null;
      }
      return v(X);
    }
    function oe(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(oe);
          if (B === null || u(B))
            return !0;
          var X = m(B);
          if (X) {
            var ie = X.call(B), he;
            if (X !== B.entries) {
              for (; !(he = ie.next()).done; )
                if (!oe(he.value))
                  return !1;
            } else
              for (; !(he = ie.next()).done; ) {
                var le = he.value;
                if (le && !oe(le[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ue(B, X) {
      return B === "symbol" ? !0 : X ? X["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && X instanceof Symbol : !1;
    }
    function te(B) {
      var X = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : ue(X, B) ? "symbol" : X;
    }
    function se(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var X = te(B);
      if (X === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return X;
    }
    function ee(B) {
      var X = se(B);
      switch (X) {
        case "array":
        case "object":
          return "an " + X;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + X;
        default:
          return X;
      }
    }
    function q(B) {
      return !B.constructor || !B.constructor.name ? b : B.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, ms;
}
var hs, G3;
function ax() {
  if (G3) return hs;
  G3 = 1;
  var e = /* @__PURE__ */ kl();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, hs = function() {
    function c(s, u, f, d, p, m) {
      if (m !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    c.isRequired = c;
    function o() {
      return c;
    }
    var a = {
      array: c,
      bigint: c,
      bool: c,
      func: c,
      number: c,
      object: c,
      string: c,
      symbol: c,
      any: c,
      arrayOf: o,
      element: c,
      elementType: c,
      instanceOf: o,
      node: c,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, hs;
}
var k3;
function sx() {
  if (k3) return gi.exports;
  if (k3 = 1, process.env.NODE_ENV !== "production") {
    var e = Gl(), t = !0;
    gi.exports = /* @__PURE__ */ ix()(e.isElement, t);
  } else
    gi.exports = /* @__PURE__ */ ax()();
  return gi.exports;
}
var lx = /* @__PURE__ */ sx();
const z = /* @__PURE__ */ qC(lx);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function ux(e, t, n) {
  return (t = dx(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function B3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function Q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B3(Object(n), !0).forEach(function(c) {
      ux(e, c, n[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : B3(Object(n)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(n, c));
    });
  }
  return e;
}
function fx(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var c = n.call(e, t || "default");
    if (typeof c != "object") return c;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dx(e) {
  var t = fx(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const V3 = () => {
};
let Bl = {}, Hf = {}, jf = null, Xf = {
  mark: V3,
  measure: V3
};
try {
  typeof window < "u" && (Bl = window), typeof document < "u" && (Hf = document), typeof MutationObserver < "u" && (jf = MutationObserver), typeof performance < "u" && (Xf = performance);
} catch {
}
const {
  userAgent: W3 = ""
} = Bl.navigator || {}, $r = Bl, st = Hf, H3 = jf, hi = Xf;
$r.document;
const gr = !!st.documentElement && !!st.head && typeof st.addEventListener == "function" && typeof st.createElement == "function", Zf = ~W3.indexOf("MSIE") || ~W3.indexOf("Trident/");
var px = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, gx = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, Yf = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, mx = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Uf = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Ft = "classic", sa = "duotone", hx = "sharp", vx = "sharp-duotone", Jf = [Ft, sa, hx, vx], bx = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, Cx = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, xx = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), yx = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Ix = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], j3 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, wx = ["kit"], Ax = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, Sx = ["fak", "fakd"], _x = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, X3 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, vi = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Ex = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Mx = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Lx = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Rx = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, Px = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Zs = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, Tx = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Ys = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...Ex, ...Tx], zx = ["solid", "regular", "light", "thin", "duotone", "brands"], Kf = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Nx = Kf.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Ox = [...Object.keys(Px), ...zx, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", vi.GROUP, vi.SWAP_OPACITY, vi.PRIMARY, vi.SECONDARY].concat(Kf.map((e) => "".concat(e, "x"))).concat(Nx.map((e) => "w-".concat(e))), Fx = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const sr = "___FONT_AWESOME___", Us = 16, qf = "fa", Qf = "svg-inline--fa", s1 = "data-fa-i2svg", Js = "data-fa-pseudo-element", Dx = "data-fa-pseudo-element-pending", Vl = "data-prefix", Wl = "data-icon", Z3 = "fontawesome-i2svg", $x = "async", Gx = ["HTML", "HEAD", "STYLE", "SCRIPT"], ed = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function uo(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[Ft];
    }
  });
}
const td = Q({}, Yf);
td[Ft] = Q(Q(Q(Q({}, {
  "fa-duotone": "duotone"
}), Yf[Ft]), j3.kit), j3["kit-duotone"]);
const kx = uo(td), Ks = Q({}, yx);
Ks[Ft] = Q(Q(Q(Q({}, {
  duotone: "fad"
}), Ks[Ft]), X3.kit), X3["kit-duotone"]);
const Y3 = uo(Ks), qs = Q({}, Zs);
qs[Ft] = Q(Q({}, qs[Ft]), _x.kit);
const Hl = uo(qs), Qs = Q({}, Rx);
Qs[Ft] = Q(Q({}, Qs[Ft]), Ax.kit);
uo(Qs);
const Bx = px, nd = "fa-layers-text", Vx = gx, Wx = Q({}, bx);
uo(Wx);
const Hx = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], vs = mx, jx = [...wx, ...Ox], Uc = $r.FontAwesomeConfig || {};
function Xx(e) {
  var t = st.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Zx(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
st && typeof st.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, c] = t;
  const o = Zx(Xx(n));
  o != null && (Uc[c] = o);
});
const rd = {
  styleDefault: "solid",
  familyDefault: Ft,
  cssPrefix: qf,
  replacementClass: Qf,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Uc.familyPrefix && (Uc.cssPrefix = Uc.familyPrefix);
const q1 = Q(Q({}, rd), Uc);
q1.autoReplaceSvg || (q1.observeMutations = !1);
const Ie = {};
Object.keys(rd).forEach((e) => {
  Object.defineProperty(Ie, e, {
    enumerable: !0,
    set: function(t) {
      q1[e] = t, Jc.forEach((n) => n(Ie));
    },
    get: function() {
      return q1[e];
    }
  });
});
Object.defineProperty(Ie, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    q1.cssPrefix = e, Jc.forEach((t) => t(Ie));
  },
  get: function() {
    return q1.cssPrefix;
  }
});
$r.FontAwesomeConfig = Ie;
const Jc = [];
function Yx(e) {
  return Jc.push(e), () => {
    Jc.splice(Jc.indexOf(e), 1);
  };
}
const Pr = Us, Gn = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Ux(e) {
  if (!e || !gr)
    return;
  const t = st.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = st.head.childNodes;
  let c = null;
  for (let o = n.length - 1; o > -1; o--) {
    const a = n[o], s = (a.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(s) > -1 && (c = a);
  }
  return st.head.insertBefore(t, c), e;
}
const Jx = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Qc() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += Jx[Math.random() * 62 | 0];
  return t;
}
function oc(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function jl(e) {
  return e.classList ? oc(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function cd(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Kx(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(cd(e[n]), '" '), "").trim();
}
function la(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Xl(e) {
  return e.size !== Gn.size || e.x !== Gn.x || e.y !== Gn.y || e.rotate !== Gn.rotate || e.flipX || e.flipY;
}
function qx(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: c
  } = e;
  const o = {
    transform: "translate(".concat(n / 2, " 256)")
  }, a = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), s = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), u = "rotate(".concat(t.rotate, " 0 0)"), f = {
    transform: "".concat(a, " ").concat(s, " ").concat(u)
  }, d = {
    transform: "translate(".concat(c / 2 * -1, " -256)")
  };
  return {
    outer: o,
    inner: f,
    path: d
  };
}
function Qx(e) {
  let {
    transform: t,
    width: n = Us,
    height: c = Us,
    startCentered: o = !1
  } = e, a = "";
  return o && Zf ? a += "translate(".concat(t.x / Pr - n / 2, "em, ").concat(t.y / Pr - c / 2, "em) ") : o ? a += "translate(calc(-50% + ".concat(t.x / Pr, "em), calc(-50% + ").concat(t.y / Pr, "em)) ") : a += "translate(".concat(t.x / Pr, "em, ").concat(t.y / Pr, "em) "), a += "scale(".concat(t.size / Pr * (t.flipX ? -1 : 1), ", ").concat(t.size / Pr * (t.flipY ? -1 : 1), ") "), a += "rotate(".concat(t.rotate, "deg) "), a;
}
var ey = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function od() {
  const e = qf, t = Qf, n = Ie.cssPrefix, c = Ie.replacementClass;
  let o = ey;
  if (n !== e || c !== t) {
    const a = new RegExp("\\.".concat(e, "\\-"), "g"), s = new RegExp("\\--".concat(e, "\\-"), "g"), u = new RegExp("\\.".concat(t), "g");
    o = o.replace(a, ".".concat(n, "-")).replace(s, "--".concat(n, "-")).replace(u, ".".concat(c));
  }
  return o;
}
let U3 = !1;
function bs() {
  Ie.autoAddCss && !U3 && (Ux(od()), U3 = !0);
}
var ty = {
  mixout() {
    return {
      dom: {
        css: od,
        insertCss: bs
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        bs();
      },
      beforeI2svg() {
        bs();
      }
    };
  }
};
const lr = $r || {};
lr[sr] || (lr[sr] = {});
lr[sr].styles || (lr[sr].styles = {});
lr[sr].hooks || (lr[sr].hooks = {});
lr[sr].shims || (lr[sr].shims = []);
var kn = lr[sr];
const id = [], ad = function() {
  st.removeEventListener("DOMContentLoaded", ad), Bi = 1, id.map((e) => e());
};
let Bi = !1;
gr && (Bi = (st.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(st.readyState), Bi || st.addEventListener("DOMContentLoaded", ad));
function ny(e) {
  gr && (Bi ? setTimeout(e, 0) : id.push(e));
}
function fo(e) {
  const {
    tag: t,
    attributes: n = {},
    children: c = []
  } = e;
  return typeof e == "string" ? cd(e) : "<".concat(t, " ").concat(Kx(n), ">").concat(c.map(fo).join(""), "</").concat(t, ">");
}
function J3(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var Cs = function(t, n, c, o) {
  var a = Object.keys(t), s = a.length, u = n, f, d, p;
  for (c === void 0 ? (f = 1, p = t[a[0]]) : (f = 0, p = c); f < s; f++)
    d = a[f], p = u(p, t[d], d, t);
  return p;
};
function ry(e) {
  const t = [];
  let n = 0;
  const c = e.length;
  for (; n < c; ) {
    const o = e.charCodeAt(n++);
    if (o >= 55296 && o <= 56319 && n < c) {
      const a = e.charCodeAt(n++);
      (a & 64512) == 56320 ? t.push(((o & 1023) << 10) + (a & 1023) + 65536) : (t.push(o), n--);
    } else
      t.push(o);
  }
  return t;
}
function el(e) {
  const t = ry(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function cy(e, t) {
  const n = e.length;
  let c = e.charCodeAt(t), o;
  return c >= 55296 && c <= 56319 && n > t + 1 && (o = e.charCodeAt(t + 1), o >= 56320 && o <= 57343) ? (c - 55296) * 1024 + o - 56320 + 65536 : c;
}
function K3(e) {
  return Object.keys(e).reduce((t, n) => {
    const c = e[n];
    return !!c.icon ? t[c.iconName] = c.icon : t[n] = c, t;
  }, {});
}
function tl(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: c = !1
  } = n, o = K3(t);
  typeof kn.hooks.addPack == "function" && !c ? kn.hooks.addPack(e, K3(t)) : kn.styles[e] = Q(Q({}, kn.styles[e] || {}), o), e === "fas" && tl("fa", t);
}
const {
  styles: eo,
  shims: oy
} = kn, sd = Object.keys(Hl), iy = sd.reduce((e, t) => (e[t] = Object.keys(Hl[t]), e), {});
let Zl = null, ld = {}, ud = {}, fd = {}, dd = {}, pd = {};
function ay(e) {
  return ~jx.indexOf(e);
}
function sy(e, t) {
  const n = t.split("-"), c = n[0], o = n.slice(1).join("-");
  return c === e && o !== "" && !ay(o) ? o : null;
}
const gd = () => {
  const e = (c) => Cs(eo, (o, a, s) => (o[s] = Cs(a, c, {}), o), {});
  ld = e((c, o, a) => (o[3] && (c[o[3]] = a), o[2] && o[2].filter((u) => typeof u == "number").forEach((u) => {
    c[u.toString(16)] = a;
  }), c)), ud = e((c, o, a) => (c[a] = a, o[2] && o[2].filter((u) => typeof u == "string").forEach((u) => {
    c[u] = a;
  }), c)), pd = e((c, o, a) => {
    const s = o[2];
    return c[a] = a, s.forEach((u) => {
      c[u] = a;
    }), c;
  });
  const t = "far" in eo || Ie.autoFetchSvg, n = Cs(oy, (c, o) => {
    const a = o[0];
    let s = o[1];
    const u = o[2];
    return s === "far" && !t && (s = "fas"), typeof a == "string" && (c.names[a] = {
      prefix: s,
      iconName: u
    }), typeof a == "number" && (c.unicodes[a.toString(16)] = {
      prefix: s,
      iconName: u
    }), c;
  }, {
    names: {},
    unicodes: {}
  });
  fd = n.names, dd = n.unicodes, Zl = ua(Ie.styleDefault, {
    family: Ie.familyDefault
  });
};
Yx((e) => {
  Zl = ua(e.styleDefault, {
    family: Ie.familyDefault
  });
});
gd();
function Yl(e, t) {
  return (ld[e] || {})[t];
}
function ly(e, t) {
  return (ud[e] || {})[t];
}
function i1(e, t) {
  return (pd[e] || {})[t];
}
function md(e) {
  return fd[e] || {
    prefix: null,
    iconName: null
  };
}
function uy(e) {
  const t = dd[e], n = Yl("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Gr() {
  return Zl;
}
const hd = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function fy(e) {
  let t = Ft;
  const n = sd.reduce((c, o) => (c[o] = "".concat(Ie.cssPrefix, "-").concat(o), c), {});
  return Jf.forEach((c) => {
    (e.includes(n[c]) || e.some((o) => iy[c].includes(o))) && (t = c);
  }), t;
}
function ua(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = Ft
  } = t, c = kx[n][e];
  if (n === sa && !e)
    return "fad";
  const o = Y3[n][e] || Y3[n][c], a = e in kn.styles ? e : null;
  return o || a || null;
}
function dy(e) {
  let t = [], n = null;
  return e.forEach((c) => {
    const o = sy(Ie.cssPrefix, c);
    o ? n = o : c && t.push(c);
  }), {
    iconName: n,
    rest: t
  };
}
function q3(e) {
  return e.sort().filter((t, n, c) => c.indexOf(t) === n);
}
function fa(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let c = null;
  const o = Ys.concat(Mx), a = q3(e.filter((m) => o.includes(m))), s = q3(e.filter((m) => !Ys.includes(m))), u = a.filter((m) => (c = m, !Uf.includes(m))), [f = null] = u, d = fy(a), p = Q(Q({}, dy(s)), {}, {
    prefix: ua(f, {
      family: d
    })
  });
  return Q(Q(Q({}, p), hy({
    values: e,
    family: d,
    styles: eo,
    config: Ie,
    canonical: p,
    givenPrefix: c
  })), py(n, c, p));
}
function py(e, t, n) {
  let {
    prefix: c,
    iconName: o
  } = n;
  if (e || !c || !o)
    return {
      prefix: c,
      iconName: o
    };
  const a = t === "fa" ? md(o) : {}, s = i1(c, o);
  return o = a.iconName || s || o, c = a.prefix || c, c === "far" && !eo.far && eo.fas && !Ie.autoFetchSvg && (c = "fas"), {
    prefix: c,
    iconName: o
  };
}
const gy = Jf.filter((e) => e !== Ft || e !== sa), my = Object.keys(Zs).filter((e) => e !== Ft).map((e) => Object.keys(Zs[e])).flat();
function hy(e) {
  const {
    values: t,
    family: n,
    canonical: c,
    givenPrefix: o = "",
    styles: a = {},
    config: s = {}
  } = e, u = n === sa, f = t.includes("fa-duotone") || t.includes("fad"), d = s.familyDefault === "duotone", p = c.prefix === "fad" || c.prefix === "fa-duotone";
  if (!u && (f || d || p) && (c.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (c.prefix = "fab"), !c.prefix && gy.includes(n) && (Object.keys(a).find((b) => my.includes(b)) || s.autoFetchSvg)) {
    const b = xx.get(n).defaultShortPrefixId;
    c.prefix = b, c.iconName = i1(c.prefix, c.iconName) || c.iconName;
  }
  return (c.prefix === "fa" || o === "fa") && (c.prefix = Gr() || "fas"), c;
}
class vy {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), c = 0; c < t; c++)
      n[c] = arguments[c];
    const o = n.reduce(this._pullDefinitions, {});
    Object.keys(o).forEach((a) => {
      this.definitions[a] = Q(Q({}, this.definitions[a] || {}), o[a]), tl(a, o[a]);
      const s = Hl[Ft][a];
      s && tl(s, o[a]), gd();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const c = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(c).map((o) => {
      const {
        prefix: a,
        iconName: s,
        icon: u
      } = c[o], f = u[2];
      t[a] || (t[a] = {}), f.length > 0 && f.forEach((d) => {
        typeof d == "string" && (t[a][d] = u);
      }), t[a][s] = u;
    }), t;
  }
}
let Q3 = [], j1 = {};
const Z1 = {}, by = Object.keys(Z1);
function Cy(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return Q3 = e, j1 = {}, Object.keys(Z1).forEach((c) => {
    by.indexOf(c) === -1 && delete Z1[c];
  }), Q3.forEach((c) => {
    const o = c.mixout ? c.mixout() : {};
    if (Object.keys(o).forEach((a) => {
      typeof o[a] == "function" && (n[a] = o[a]), typeof o[a] == "object" && Object.keys(o[a]).forEach((s) => {
        n[a] || (n[a] = {}), n[a][s] = o[a][s];
      });
    }), c.hooks) {
      const a = c.hooks();
      Object.keys(a).forEach((s) => {
        j1[s] || (j1[s] = []), j1[s].push(a[s]);
      });
    }
    c.provides && c.provides(Z1);
  }), n;
}
function nl(e, t) {
  for (var n = arguments.length, c = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    c[o - 2] = arguments[o];
  return (j1[e] || []).forEach((s) => {
    t = s.apply(null, [t, ...c]);
  }), t;
}
function l1(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++)
    n[c - 1] = arguments[c];
  (j1[e] || []).forEach((a) => {
    a.apply(null, n);
  });
}
function kr() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Z1[e] ? Z1[e].apply(null, t) : void 0;
}
function rl(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || Gr();
  if (t)
    return t = i1(n, t) || t, J3(vd.definitions, n, t) || J3(kn.styles, n, t);
}
const vd = new vy(), xy = () => {
  Ie.autoReplaceSvg = !1, Ie.observeMutations = !1, l1("noAuto");
}, yy = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return gr ? (l1("beforeI2svg", e), kr("pseudoElements2svg", e), kr("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    Ie.autoReplaceSvg === !1 && (Ie.autoReplaceSvg = !0), Ie.observeMutations = !0, ny(() => {
      wy({
        autoReplaceSvgRoot: t
      }), l1("watch", e);
    });
  }
}, Iy = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: i1(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = ua(e[0]);
      return {
        prefix: n,
        iconName: i1(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Ie.cssPrefix, "-")) > -1 || e.match(Bx))) {
      const t = fa(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || Gr(),
        iconName: i1(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = Gr();
      return {
        prefix: t,
        iconName: i1(t, e) || e
      };
    }
  }
}, fn = {
  noAuto: xy,
  config: Ie,
  dom: yy,
  parse: Iy,
  library: vd,
  findIconDefinition: rl,
  toHtml: fo
}, wy = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = st
  } = e;
  (Object.keys(kn.styles).length > 0 || Ie.autoFetchSvg) && gr && Ie.autoReplaceSvg && fn.dom.i2svg({
    node: t
  });
};
function da(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => fo(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!gr) return;
      const n = st.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function Ay(e) {
  let {
    children: t,
    main: n,
    mask: c,
    attributes: o,
    styles: a,
    transform: s
  } = e;
  if (Xl(s) && n.found && !c.found) {
    const {
      width: u,
      height: f
    } = n, d = {
      x: u / f / 2,
      y: 0.5
    };
    o.style = la(Q(Q({}, a), {}, {
      "transform-origin": "".concat(d.x + s.x / 16, "em ").concat(d.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: o,
    children: t
  }];
}
function Sy(e) {
  let {
    prefix: t,
    iconName: n,
    children: c,
    attributes: o,
    symbol: a
  } = e;
  const s = a === !0 ? "".concat(t, "-").concat(Ie.cssPrefix, "-").concat(n) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Q(Q({}, o), {}, {
        id: s
      }),
      children: c
    }]
  }];
}
function Ul(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: c,
    iconName: o,
    transform: a,
    symbol: s,
    title: u,
    maskId: f,
    titleId: d,
    extra: p,
    watchable: m = !1
  } = e, {
    width: b,
    height: y
  } = n.found ? n : t, C = Sx.includes(c), h = [Ie.replacementClass, o ? "".concat(Ie.cssPrefix, "-").concat(o) : ""].filter((M) => p.classes.indexOf(M) === -1).filter((M) => M !== "" || !!M).concat(p.classes).join(" ");
  let v = {
    children: [],
    attributes: Q(Q({}, p.attributes), {}, {
      "data-prefix": c,
      "data-icon": o,
      class: h,
      role: p.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(b, " ").concat(y)
    })
  };
  const I = C && !~p.classes.indexOf("fa-fw") ? {
    width: "".concat(b / y * 16 * 0.0625, "em")
  } : {};
  m && (v.attributes[s1] = ""), u && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(d || Qc())
    },
    children: [u]
  }), delete v.attributes.title);
  const S = Q(Q({}, v), {}, {
    prefix: c,
    iconName: o,
    main: t,
    mask: n,
    maskId: f,
    transform: a,
    symbol: s,
    styles: Q(Q({}, I), p.styles)
  }), {
    children: L,
    attributes: R
  } = n.found && t.found ? kr("generateAbstractMask", S) || {
    children: [],
    attributes: {}
  } : kr("generateAbstractIcon", S) || {
    children: [],
    attributes: {}
  };
  return S.children = L, S.attributes = R, s ? Sy(S) : Ay(S);
}
function e6(e) {
  const {
    content: t,
    width: n,
    height: c,
    transform: o,
    title: a,
    extra: s,
    watchable: u = !1
  } = e, f = Q(Q(Q({}, s.attributes), a ? {
    title: a
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  u && (f[s1] = "");
  const d = Q({}, s.styles);
  Xl(o) && (d.transform = Qx({
    transform: o,
    startCentered: !0,
    width: n,
    height: c
  }), d["-webkit-transform"] = d.transform);
  const p = la(d);
  p.length > 0 && (f.style = p);
  const m = [];
  return m.push({
    tag: "span",
    attributes: f,
    children: [t]
  }), a && m.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [a]
  }), m;
}
function _y(e) {
  const {
    content: t,
    title: n,
    extra: c
  } = e, o = Q(Q(Q({}, c.attributes), n ? {
    title: n
  } : {}), {}, {
    class: c.classes.join(" ")
  }), a = la(c.styles);
  a.length > 0 && (o.style = a);
  const s = [];
  return s.push({
    tag: "span",
    attributes: o,
    children: [t]
  }), n && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), s;
}
const {
  styles: xs
} = kn;
function cl(e) {
  const t = e[0], n = e[1], [c] = e.slice(4);
  let o = null;
  return Array.isArray(c) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(Ie.cssPrefix, "-").concat(vs.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Ie.cssPrefix, "-").concat(vs.SECONDARY),
        fill: "currentColor",
        d: c[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Ie.cssPrefix, "-").concat(vs.PRIMARY),
        fill: "currentColor",
        d: c[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: c
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: o
  };
}
const Ey = {
  found: !1,
  width: 512,
  height: 512
};
function My(e, t) {
  !ed && !Ie.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function ol(e, t) {
  let n = t;
  return t === "fa" && Ie.styleDefault !== null && (t = Gr()), new Promise((c, o) => {
    if (n === "fa") {
      const a = md(e);
      e = a.iconName || e, t = a.prefix || t;
    }
    if (e && t && xs[t] && xs[t][e]) {
      const a = xs[t][e];
      return c(cl(a));
    }
    My(e, t), c(Q(Q({}, Ey), {}, {
      icon: Ie.showMissingIcons && e ? kr("missingIconAbstract") || {} : {}
    }));
  });
}
const t6 = () => {
}, il = Ie.measurePerformance && hi && hi.mark && hi.measure ? hi : {
  mark: t6,
  measure: t6
}, jc = 'FA "6.7.2"', Ly = (e) => (il.mark("".concat(jc, " ").concat(e, " begins")), () => bd(e)), bd = (e) => {
  il.mark("".concat(jc, " ").concat(e, " ends")), il.measure("".concat(jc, " ").concat(e), "".concat(jc, " ").concat(e, " begins"), "".concat(jc, " ").concat(e, " ends"));
};
var Jl = {
  begin: Ly,
  end: bd
};
const Ti = () => {
};
function n6(e) {
  return typeof (e.getAttribute ? e.getAttribute(s1) : null) == "string";
}
function Ry(e) {
  const t = e.getAttribute ? e.getAttribute(Vl) : null, n = e.getAttribute ? e.getAttribute(Wl) : null;
  return t && n;
}
function Py(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Ie.replacementClass);
}
function Ty() {
  return Ie.autoReplaceSvg === !0 ? zi.replace : zi[Ie.autoReplaceSvg] || zi.replace;
}
function zy(e) {
  return st.createElementNS("http://www.w3.org/2000/svg", e);
}
function Ny(e) {
  return st.createElement(e);
}
function Cd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? zy : Ny
  } = t;
  if (typeof e == "string")
    return st.createTextNode(e);
  const c = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(a) {
    c.setAttribute(a, e.attributes[a]);
  }), (e.children || []).forEach(function(a) {
    c.appendChild(Cd(a, {
      ceFn: n
    }));
  }), c;
}
function Oy(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const zi = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(Cd(n), t);
      }), t.getAttribute(s1) === null && Ie.keepOriginalSource) {
        let n = st.createComment(Oy(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~jl(t).indexOf(Ie.replacementClass))
      return zi.replace(e);
    const c = new RegExp("".concat(Ie.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const a = n[0].attributes.class.split(" ").reduce((s, u) => (u === Ie.replacementClass || u.match(c) ? s.toSvg.push(u) : s.toNode.push(u), s), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", a.toNode.join(" "));
    }
    const o = n.map((a) => fo(a)).join(`
`);
    t.setAttribute(s1, ""), t.innerHTML = o;
  }
};
function r6(e) {
  e();
}
function xd(e, t) {
  const n = typeof t == "function" ? t : Ti;
  if (e.length === 0)
    n();
  else {
    let c = r6;
    Ie.mutateApproach === $x && (c = $r.requestAnimationFrame || r6), c(() => {
      const o = Ty(), a = Jl.begin("mutate");
      e.map(o), a(), n();
    });
  }
}
let Kl = !1;
function yd() {
  Kl = !0;
}
function al() {
  Kl = !1;
}
let Vi = null;
function c6(e) {
  if (!H3 || !Ie.observeMutations)
    return;
  const {
    treeCallback: t = Ti,
    nodeCallback: n = Ti,
    pseudoElementsCallback: c = Ti,
    observeMutationsRoot: o = st
  } = e;
  Vi = new H3((a) => {
    if (Kl) return;
    const s = Gr();
    oc(a).forEach((u) => {
      if (u.type === "childList" && u.addedNodes.length > 0 && !n6(u.addedNodes[0]) && (Ie.searchPseudoElements && c(u.target), t(u.target)), u.type === "attributes" && u.target.parentNode && Ie.searchPseudoElements && c(u.target.parentNode), u.type === "attributes" && n6(u.target) && ~Hx.indexOf(u.attributeName))
        if (u.attributeName === "class" && Ry(u.target)) {
          const {
            prefix: f,
            iconName: d
          } = fa(jl(u.target));
          u.target.setAttribute(Vl, f || s), d && u.target.setAttribute(Wl, d);
        } else Py(u.target) && n(u.target);
    });
  }), gr && Vi.observe(o, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Fy() {
  Vi && Vi.disconnect();
}
function Dy(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((c, o) => {
    const a = o.split(":"), s = a[0], u = a.slice(1);
    return s && u.length > 0 && (c[s] = u.join(":").trim()), c;
  }, {})), n;
}
function $y(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), c = e.innerText !== void 0 ? e.innerText.trim() : "";
  let o = fa(jl(e));
  return o.prefix || (o.prefix = Gr()), t && n && (o.prefix = t, o.iconName = n), o.iconName && o.prefix || (o.prefix && c.length > 0 && (o.iconName = ly(o.prefix, e.innerText) || Yl(o.prefix, el(e.innerText))), !o.iconName && Ie.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (o.iconName = e.firstChild.data)), o;
}
function Gy(e) {
  const t = oc(e.attributes).reduce((o, a) => (o.name !== "class" && o.name !== "style" && (o[a.name] = a.value), o), {}), n = e.getAttribute("title"), c = e.getAttribute("data-fa-title-id");
  return Ie.autoA11y && (n ? t["aria-labelledby"] = "".concat(Ie.replacementClass, "-title-").concat(c || Qc()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function ky() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Gn,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function o6(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: c,
    rest: o
  } = $y(e), a = Gy(e), s = nl("parseNodeAttributes", {}, e);
  let u = t.styleParser ? Dy(e) : [];
  return Q({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: c,
    transform: Gn,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: o,
      styles: u,
      attributes: a
    }
  }, s);
}
const {
  styles: By
} = kn;
function Id(e) {
  const t = Ie.autoReplaceSvg === "nest" ? o6(e, {
    styleParser: !1
  }) : o6(e);
  return ~t.extra.classes.indexOf(nd) ? kr("generateLayersText", e, t) : kr("generateSvgReplacementMutation", e, t);
}
function Vy() {
  return [...Ix, ...Ys];
}
function i6(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!gr) return Promise.resolve();
  const n = st.documentElement.classList, c = (p) => n.add("".concat(Z3, "-").concat(p)), o = (p) => n.remove("".concat(Z3, "-").concat(p)), a = Ie.autoFetchSvg ? Vy() : Uf.concat(Object.keys(By));
  a.includes("fa") || a.push("fa");
  const s = [".".concat(nd, ":not([").concat(s1, "])")].concat(a.map((p) => ".".concat(p, ":not([").concat(s1, "])"))).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  let u = [];
  try {
    u = oc(e.querySelectorAll(s));
  } catch {
  }
  if (u.length > 0)
    c("pending"), o("complete");
  else
    return Promise.resolve();
  const f = Jl.begin("onTree"), d = u.reduce((p, m) => {
    try {
      const b = Id(m);
      b && p.push(b);
    } catch (b) {
      ed || b.name === "MissingIcon" && console.error(b);
    }
    return p;
  }, []);
  return new Promise((p, m) => {
    Promise.all(d).then((b) => {
      xd(b, () => {
        c("active"), c("complete"), o("pending"), typeof t == "function" && t(), f(), p();
      });
    }).catch((b) => {
      f(), m(b);
    });
  });
}
function Wy(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Id(e).then((n) => {
    n && xd([n], t);
  });
}
function Hy(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = (t || {}).icon ? t : rl(t || {});
    let {
      mask: o
    } = n;
    return o && (o = (o || {}).icon ? o : rl(o || {})), e(c, Q(Q({}, n), {}, {
      mask: o
    }));
  };
}
const jy = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Gn,
    symbol: c = !1,
    mask: o = null,
    maskId: a = null,
    title: s = null,
    titleId: u = null,
    classes: f = [],
    attributes: d = {},
    styles: p = {}
  } = t;
  if (!e) return;
  const {
    prefix: m,
    iconName: b,
    icon: y
  } = e;
  return da(Q({
    type: "icon"
  }, e), () => (l1("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), Ie.autoA11y && (s ? d["aria-labelledby"] = "".concat(Ie.replacementClass, "-title-").concat(u || Qc()) : (d["aria-hidden"] = "true", d.focusable = "false")), Ul({
    icons: {
      main: cl(y),
      mask: o ? cl(o.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: m,
    iconName: b,
    transform: Q(Q({}, Gn), n),
    symbol: c,
    title: s,
    maskId: a,
    titleId: u,
    extra: {
      attributes: d,
      styles: p,
      classes: f
    }
  })));
};
var Xy = {
  mixout() {
    return {
      icon: Hy(jy)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = i6, e.nodeCallback = Wy, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = st,
        callback: c = () => {
        }
      } = t;
      return i6(n, c);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: c,
        title: o,
        titleId: a,
        prefix: s,
        transform: u,
        symbol: f,
        mask: d,
        maskId: p,
        extra: m
      } = n;
      return new Promise((b, y) => {
        Promise.all([ol(c, s), d.iconName ? ol(d.iconName, d.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((C) => {
          let [h, v] = C;
          b([t, Ul({
            icons: {
              main: h,
              mask: v
            },
            prefix: s,
            iconName: c,
            transform: u,
            symbol: f,
            maskId: p,
            title: o,
            titleId: a,
            extra: m,
            watchable: !0
          })]);
        }).catch(y);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: c,
        main: o,
        transform: a,
        styles: s
      } = t;
      const u = la(s);
      u.length > 0 && (c.style = u);
      let f;
      return Xl(a) && (f = kr("generateAbstractTransformGrouping", {
        main: o,
        transform: a,
        containerWidth: o.width,
        iconWidth: o.width
      })), n.push(f || o.icon), {
        children: n,
        attributes: c
      };
    };
  }
}, Zy = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return da({
          type: "layer"
        }, () => {
          l1("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let c = [];
          return e((o) => {
            Array.isArray(o) ? o.map((a) => {
              c = c.concat(a.abstract);
            }) : c = c.concat(o.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Ie.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: c
          }];
        });
      }
    };
  }
}, Yy = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: c = [],
          attributes: o = {},
          styles: a = {}
        } = t;
        return da({
          type: "counter",
          content: e
        }, () => (l1("beforeDOMElementCreation", {
          content: e,
          params: t
        }), _y({
          content: e.toString(),
          title: n,
          extra: {
            attributes: o,
            styles: a,
            classes: ["".concat(Ie.cssPrefix, "-layers-counter"), ...c]
          }
        })));
      }
    };
  }
}, Uy = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Gn,
          title: c = null,
          classes: o = [],
          attributes: a = {},
          styles: s = {}
        } = t;
        return da({
          type: "text",
          content: e
        }, () => (l1("beforeDOMElementCreation", {
          content: e,
          params: t
        }), e6({
          content: e,
          transform: Q(Q({}, Gn), n),
          title: c,
          extra: {
            attributes: a,
            styles: s,
            classes: ["".concat(Ie.cssPrefix, "-layers-text"), ...o]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: c,
        transform: o,
        extra: a
      } = n;
      let s = null, u = null;
      if (Zf) {
        const f = parseInt(getComputedStyle(t).fontSize, 10), d = t.getBoundingClientRect();
        s = d.width / f, u = d.height / f;
      }
      return Ie.autoA11y && !c && (a.attributes["aria-hidden"] = "true"), Promise.resolve([t, e6({
        content: t.innerHTML,
        width: s,
        height: u,
        transform: o,
        title: c,
        extra: a,
        watchable: !0
      })]);
    };
  }
};
const Jy = new RegExp('"', "ug"), a6 = [1105920, 1112319], s6 = Q(Q(Q(Q({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), Cx), Fx), Lx), sl = Object.keys(s6).reduce((e, t) => (e[t.toLowerCase()] = s6[t], e), {}), Ky = Object.keys(sl).reduce((e, t) => {
  const n = sl[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function qy(e) {
  const t = e.replace(Jy, ""), n = cy(t, 0), c = n >= a6[0] && n <= a6[1], o = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: el(o ? t[0] : t),
    isSecondary: c || o
  };
}
function Qy(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), c = parseInt(t), o = isNaN(c) ? "normal" : c;
  return (sl[n] || {})[o] || Ky[n];
}
function l6(e, t) {
  const n = "".concat(Dx).concat(t.replace(":", "-"));
  return new Promise((c, o) => {
    if (e.getAttribute(n) !== null)
      return c();
    const s = oc(e.children).filter((b) => b.getAttribute(Js) === t)[0], u = $r.getComputedStyle(e, t), f = u.getPropertyValue("font-family"), d = f.match(Vx), p = u.getPropertyValue("font-weight"), m = u.getPropertyValue("content");
    if (s && !d)
      return e.removeChild(s), c();
    if (d && m !== "none" && m !== "") {
      const b = u.getPropertyValue("content");
      let y = Qy(f, p);
      const {
        value: C,
        isSecondary: h
      } = qy(b), v = d[0].startsWith("FontAwesome");
      let I = Yl(y, C), S = I;
      if (v) {
        const L = uy(C);
        L.iconName && L.prefix && (I = L.iconName, y = L.prefix);
      }
      if (I && !h && (!s || s.getAttribute(Vl) !== y || s.getAttribute(Wl) !== S)) {
        e.setAttribute(n, S), s && e.removeChild(s);
        const L = ky(), {
          extra: R
        } = L;
        R.attributes[Js] = t, ol(I, y).then((M) => {
          const $ = Ul(Q(Q({}, L), {}, {
            icons: {
              main: M,
              mask: hd()
            },
            prefix: y,
            iconName: S,
            extra: R,
            watchable: !0
          })), O = st.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(O, e.firstChild) : e.appendChild(O), O.outerHTML = $.map((G) => fo(G)).join(`
`), e.removeAttribute(n), c();
        }).catch(o);
      } else
        c();
    } else
      c();
  });
}
function eI(e) {
  return Promise.all([l6(e, "::before"), l6(e, "::after")]);
}
function tI(e) {
  return e.parentNode !== document.head && !~Gx.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Js) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function u6(e) {
  if (gr)
    return new Promise((t, n) => {
      const c = oc(e.querySelectorAll("*")).filter(tI).map(eI), o = Jl.begin("searchPseudoElements");
      yd(), Promise.all(c).then(() => {
        o(), al(), t();
      }).catch(() => {
        o(), al(), n();
      });
    });
}
var nI = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = u6, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = st
      } = t;
      Ie.searchPseudoElements && u6(n);
    };
  }
};
let f6 = !1;
var rI = {
  mixout() {
    return {
      dom: {
        unwatch() {
          yd(), f6 = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        c6(nl("mutationObserverCallbacks", {}));
      },
      noAuto() {
        Fy();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        f6 ? al() : c6(nl("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const d6 = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, c) => {
    const o = c.toLowerCase().split("-"), a = o[0];
    let s = o.slice(1).join("-");
    if (a && s === "h")
      return n.flipX = !0, n;
    if (a && s === "v")
      return n.flipY = !0, n;
    if (s = parseFloat(s), isNaN(s))
      return n;
    switch (a) {
      case "grow":
        n.size = n.size + s;
        break;
      case "shrink":
        n.size = n.size - s;
        break;
      case "left":
        n.x = n.x - s;
        break;
      case "right":
        n.x = n.x + s;
        break;
      case "up":
        n.y = n.y - s;
        break;
      case "down":
        n.y = n.y + s;
        break;
      case "rotate":
        n.rotate = n.rotate + s;
        break;
    }
    return n;
  }, t);
};
var cI = {
  mixout() {
    return {
      parse: {
        transform: (e) => d6(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = d6(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: c,
        containerWidth: o,
        iconWidth: a
      } = t;
      const s = {
        transform: "translate(".concat(o / 2, " 256)")
      }, u = "translate(".concat(c.x * 32, ", ").concat(c.y * 32, ") "), f = "scale(".concat(c.size / 16 * (c.flipX ? -1 : 1), ", ").concat(c.size / 16 * (c.flipY ? -1 : 1), ") "), d = "rotate(".concat(c.rotate, " 0 0)"), p = {
        transform: "".concat(u, " ").concat(f, " ").concat(d)
      }, m = {
        transform: "translate(".concat(a / 2 * -1, " -256)")
      }, b = {
        outer: s,
        inner: p,
        path: m
      };
      return {
        tag: "g",
        attributes: Q({}, b.outer),
        children: [{
          tag: "g",
          attributes: Q({}, b.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: Q(Q({}, n.icon.attributes), b.path)
          }]
        }]
      };
    };
  }
};
const ys = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function p6(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function oI(e) {
  return e.tag === "g" ? e.children : [e];
}
var iI = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), c = n ? fa(n.split(" ").map((o) => o.trim())) : hd();
        return c.prefix || (c.prefix = Gr()), e.mask = c, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: c,
        main: o,
        mask: a,
        maskId: s,
        transform: u
      } = t;
      const {
        width: f,
        icon: d
      } = o, {
        width: p,
        icon: m
      } = a, b = qx({
        transform: u,
        containerWidth: p,
        iconWidth: f
      }), y = {
        tag: "rect",
        attributes: Q(Q({}, ys), {}, {
          fill: "white"
        })
      }, C = d.children ? {
        children: d.children.map(p6)
      } : {}, h = {
        tag: "g",
        attributes: Q({}, b.inner),
        children: [p6(Q({
          tag: d.tag,
          attributes: Q(Q({}, d.attributes), b.path)
        }, C))]
      }, v = {
        tag: "g",
        attributes: Q({}, b.outer),
        children: [h]
      }, I = "mask-".concat(s || Qc()), S = "clip-".concat(s || Qc()), L = {
        tag: "mask",
        attributes: Q(Q({}, ys), {}, {
          id: I,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [y, v]
      }, R = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: S
          },
          children: oI(m)
        }, L]
      };
      return n.push(R, {
        tag: "rect",
        attributes: Q({
          fill: "currentColor",
          "clip-path": "url(#".concat(S, ")"),
          mask: "url(#".concat(I, ")")
        }, ys)
      }), {
        children: n,
        attributes: c
      };
    };
  }
}, aI = {
  provides(e) {
    let t = !1;
    $r.matchMedia && (t = $r.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], c = {
        fill: "currentColor"
      }, o = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: Q(Q({}, c), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const a = Q(Q({}, o), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: Q(Q({}, c), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || s.children.push({
        tag: "animate",
        attributes: Q(Q({}, o), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Q(Q({}, a), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(s), n.push({
        tag: "path",
        attributes: Q(Q({}, c), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: Q(Q({}, a), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: Q(Q({}, c), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Q(Q({}, a), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, sI = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), c = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = c, e;
      }
    };
  }
}, lI = [ty, Xy, Zy, Yy, Uy, nI, rI, cI, iI, aI, sI];
Cy(lI, {
  mixoutsTo: fn
});
fn.noAuto;
fn.config;
const uI = fn.library;
fn.dom;
const ll = fn.parse;
fn.findIconDefinition;
fn.toHtml;
const fI = fn.icon;
fn.layer;
fn.text;
fn.counter;
function g6(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function Fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g6(Object(n), !0).forEach(function(c) {
      X1(e, c, n[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : g6(Object(n)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(n, c));
    });
  }
  return e;
}
function Wi(e) {
  "@babel/helpers - typeof";
  return Wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wi(e);
}
function X1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function dI(e, t) {
  if (e == null) return {};
  var n = {}, c = Object.keys(e), o, a;
  for (a = 0; a < c.length; a++)
    o = c[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function pI(e, t) {
  if (e == null) return {};
  var n = dI(e, t), c, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      c = a[o], !(t.indexOf(c) >= 0) && Object.prototype.propertyIsEnumerable.call(e, c) && (n[c] = e[c]);
  }
  return n;
}
function ul(e) {
  return gI(e) || mI(e) || hI(e) || vI();
}
function gI(e) {
  if (Array.isArray(e)) return fl(e);
}
function mI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function hI(e, t) {
  if (e) {
    if (typeof e == "string") return fl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fl(e, t);
  }
}
function fl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
function vI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bI(e) {
  var t, n = e.beat, c = e.fade, o = e.beatFade, a = e.bounce, s = e.shake, u = e.flash, f = e.spin, d = e.spinPulse, p = e.spinReverse, m = e.pulse, b = e.fixedWidth, y = e.inverse, C = e.border, h = e.listItem, v = e.flip, I = e.size, S = e.rotation, L = e.pull, R = (t = {
    "fa-beat": n,
    "fa-fade": c,
    "fa-beat-fade": o,
    "fa-bounce": a,
    "fa-shake": s,
    "fa-flash": u,
    "fa-spin": f,
    "fa-spin-reverse": p,
    "fa-spin-pulse": d,
    "fa-pulse": m,
    "fa-fw": b,
    "fa-inverse": y,
    "fa-border": C,
    "fa-li": h,
    "fa-flip": v === !0,
    "fa-flip-horizontal": v === "horizontal" || v === "both",
    "fa-flip-vertical": v === "vertical" || v === "both"
  }, X1(t, "fa-".concat(I), typeof I < "u" && I !== null), X1(t, "fa-rotate-".concat(S), typeof S < "u" && S !== null && S !== 0), X1(t, "fa-pull-".concat(L), typeof L < "u" && L !== null), X1(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(R).map(function(M) {
    return R[M] ? M : null;
  }).filter(function(M) {
    return M;
  });
}
function CI(e) {
  return e = e - 0, e === e;
}
function wd(e) {
  return CI(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var xI = ["style"];
function yI(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function II(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var c = n.indexOf(":"), o = wd(n.slice(0, c)), a = n.slice(c + 1).trim();
    return o.startsWith("webkit") ? t[yI(o)] = a : t[o] = a, t;
  }, {});
}
function Ad(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var c = (t.children || []).map(function(f) {
    return Ad(e, f);
  }), o = Object.keys(t.attributes || {}).reduce(function(f, d) {
    var p = t.attributes[d];
    switch (d) {
      case "class":
        f.attrs.className = p, delete t.attributes.class;
        break;
      case "style":
        f.attrs.style = II(p);
        break;
      default:
        d.indexOf("aria-") === 0 || d.indexOf("data-") === 0 ? f.attrs[d.toLowerCase()] = p : f.attrs[wd(d)] = p;
    }
    return f;
  }, {
    attrs: {}
  }), a = n.style, s = a === void 0 ? {} : a, u = pI(n, xI);
  return o.attrs.style = Fn(Fn({}, o.attrs.style), s), e.apply(void 0, [t.tag, Fn(Fn({}, o.attrs), u)].concat(ul(c)));
}
var Sd = !1;
try {
  Sd = process.env.NODE_ENV === "production";
} catch {
}
function wI() {
  if (!Sd && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function m6(e) {
  if (e && Wi(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (ll.icon)
    return ll.icon(e);
  if (e === null)
    return null;
  if (e && Wi(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Is(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? X1({}, e, t) : {};
}
var h6 = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, ql = /* @__PURE__ */ Te.forwardRef(function(e, t) {
  var n = Fn(Fn({}, h6), e), c = n.icon, o = n.mask, a = n.symbol, s = n.className, u = n.title, f = n.titleId, d = n.maskId, p = m6(c), m = Is("classes", [].concat(ul(bI(n)), ul((s || "").split(" ")))), b = Is("transform", typeof n.transform == "string" ? ll.transform(n.transform) : n.transform), y = Is("mask", m6(o)), C = fI(p, Fn(Fn(Fn(Fn({}, m), b), y), {}, {
    symbol: a,
    title: u,
    titleId: f,
    maskId: d
  }));
  if (!C)
    return wI("Could not find icon", p), null;
  var h = C.abstract, v = {
    ref: t
  };
  return Object.keys(n).forEach(function(I) {
    h6.hasOwnProperty(I) || (v[I] = n[I]);
  }), AI(h[0], v);
});
ql.displayName = "FontAwesomeIcon";
ql.propTypes = {
  beat: z.bool,
  border: z.bool,
  beatFade: z.bool,
  bounce: z.bool,
  className: z.string,
  fade: z.bool,
  flash: z.bool,
  mask: z.oneOfType([z.object, z.array, z.string]),
  maskId: z.string,
  fixedWidth: z.bool,
  inverse: z.bool,
  flip: z.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: z.oneOfType([z.object, z.array, z.string]),
  listItem: z.bool,
  pull: z.oneOf(["right", "left"]),
  pulse: z.bool,
  rotation: z.oneOf([0, 90, 180, 270]),
  shake: z.bool,
  size: z.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: z.bool,
  spinPulse: z.bool,
  spinReverse: z.bool,
  symbol: z.oneOfType([z.bool, z.string]),
  title: z.string,
  titleId: z.string,
  transform: z.oneOfType([z.string, z.object]),
  swapOpacity: z.bool
};
var AI = Ad.bind(null, Te.createElement);
class SI extends Te.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0 };
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const _I = {
  prefix: "fas",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, EI = {
  prefix: "fas",
  iconName: "right-from-bracket",
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
}, MI = {
  prefix: "fas",
  iconName: "hand-point-right",
  icon: [512, 512, [], "f0a4", "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"]
}, LI = {
  prefix: "fas",
  iconName: "file-csv",
  icon: [512, 512, [], "f6dd", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z"]
}, RI = {
  prefix: "fas",
  iconName: "grid",
  icon: [448, 512, ["grid-3"], "e195", "M0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40L0 72zM0 232c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM128 392l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM288 232l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 72l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 392l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z"]
}, PI = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, TI = {
  prefix: "fas",
  iconName: "caret-right",
  icon: [256, 512, [], "f0da", "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"]
}, zI = {
  prefix: "fas",
  iconName: "user-check",
  icon: [640, 512, [], "f4fc", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, NI = {
  prefix: "fas",
  iconName: "binoculars",
  icon: [512, 512, [], "f1e5", "M128 32l32 0c17.7 0 32 14.3 32 32l0 32L96 96l0-32c0-17.7 14.3-32 32-32zm64 96l0 320c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32l0-59.1c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28l99.8 0zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3l0 59.1c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-320 99.8 0zM320 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32-96 0 0-32zm-32 64l0 160-64 0 0-160 64 0z"]
}, OI = {
  prefix: "fas",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
}, FI = {
  prefix: "fas",
  iconName: "caret-left",
  icon: [256, 512, [], "f0d9", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"]
}, DI = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, $I = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"]
}, GI = {
  prefix: "fas",
  iconName: "calendar-exclamation",
  icon: [448, 512, [], "f334", "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM192 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
}, kI = {
  prefix: "fas",
  iconName: "users",
  icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"]
}, BI = {
  prefix: "fas",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
}, VI = {
  prefix: "fas",
  iconName: "plug",
  icon: [384, 512, [128268], "f1e6", "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2C297 398 352 333.4 352 256l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"]
}, WI = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, HI = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, jI = {
  prefix: "fas",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"]
}, XI = {
  prefix: "fas",
  iconName: "star",
  icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
}, ZI = {
  prefix: "fas",
  iconName: "file-invoice-dollar",
  icon: [384, 512, [], "f571", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c0 0 0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7l0-17.3c0-8.8 7.2-16 16-16z"]
}, YI = {
  prefix: "fas",
  iconName: "circle-quarter-stroke",
  icon: [512, 512, [], "e5d3", "M64 256l160 0c17.7 0 32-14.3 32-32l0-160c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
}, UI = {
  prefix: "fas",
  iconName: "paper-plane-top",
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M57.6 35.8C23.1 20.6-11.3 57.4 6.1 90.9l63 121.2c4.4 8.4 12.6 14.1 22 15.3c0 0 0 0 0 0L266 249.3c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7L91.1 284.6s0 0 0 0c-9.4 1.2-17.6 6.9-22 15.3L6.1 421.1c-17.4 33.5 17 70.2 51.6 55.1L492.9 285.3c25.5-11.2 25.5-47.4 0-58.6L57.6 35.8z"]
}, JI = {
  prefix: "fas",
  iconName: "fire",
  icon: [448, 512, [128293], "f06d", "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
}, KI = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, qI = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
}, QI = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, ew = {
  prefix: "fas",
  iconName: "left",
  icon: [448, 512, ["arrow-alt-left"], "f355", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 96 184 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-184 0 0 96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z"]
}, tw = {
  prefix: "fas",
  iconName: "arrow-turn-down-right",
  icon: [512, 512, [], "e3d6", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 224c0 53 43 96 96 96l306.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 96 256c-17.7 0-32-14.3-32-32L64 64z"]
}, nw = {
  prefix: "fas",
  iconName: "code",
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
}, rw = {
  prefix: "fas",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"]
}, cw = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, ow = {
  prefix: "fas",
  iconName: "tags",
  icon: [512, 512, [], "f02c", "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, iw = {
  prefix: "fas",
  iconName: "arrows-to-line",
  icon: [448, 512, [], "e0a7", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z"]
}, aw = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, sw = {
  prefix: "fas",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
}, lw = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, uw = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, fw = {
  prefix: "fas",
  iconName: "user-secret",
  icon: [448, 512, [128373], "f21b", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48l-59.9 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4l-59.9 0c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208l-12.4 0c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2L168 224c-22.1 0-40-17.9-40-40l0-14.4c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4l0 14.4c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"]
}, dw = {
  prefix: "fas",
  iconName: "clipboard-user",
  icon: [384, 512, [], "f7f3", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16z"]
}, pw = {
  prefix: "fas",
  iconName: "brackets-curly",
  icon: [576, 512, [], "f7ea", "M416 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9l0 37.5c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96l0-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6l0-37.5c0-53-43-96-96-96zM160 32c-53 0-96 43-96 96l0 37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c6 6 9.4 14.1 9.4 22.6L64 384c0 53 43 96 96 96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32-14.3-32-32l0-37.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9l0-37.5c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z"]
}, gw = {
  prefix: "fas",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
}, mw = {
  prefix: "fas",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
}, hw = {
  prefix: "fas",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
}, vw = {
  prefix: "fas",
  iconName: "grip-vertical",
  icon: [320, 512, [], "f58e", "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"]
}, bw = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, Cw = {
  prefix: "fas",
  iconName: "download",
  icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, xw = {
  prefix: "fas",
  iconName: "upload",
  icon: [512, 512, [], "f093", "M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, yw = {
  prefix: "fas",
  iconName: "bolt",
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"]
}, Iw = {
  prefix: "fas",
  iconName: "arrows-turn-to-dots",
  icon: [512, 512, [], "e4c1", "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
}, ww = {
  prefix: "fas",
  iconName: "chart-simple-horizontal",
  icon: [448, 512, [], "e474", "M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0zM208 480c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0zM384 112l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48z"]
}, Aw = {
  prefix: "fas",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
}, Sw = {
  prefix: "fas",
  iconName: "arrows-from-line",
  icon: [448, 512, [], "e0a4", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z"]
}, _w = {
  prefix: "fas",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"]
}, Ew = {
  prefix: "fas",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, _d = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, Mw = _d, Lw = {
  prefix: "fas",
  iconName: "square-pen",
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
}, Rw = Lw, Pw = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, Tw = {
  prefix: "fas",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"]
}, zw = {
  prefix: "fas",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"]
}, Nw = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"]
}, Ow = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, Fw = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, Dw = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, $w = {
  prefix: "fas",
  iconName: "cloud-minus",
  icon: [640, 512, [], "e35d", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
}, Gw = {
  prefix: "fas",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"]
}, kw = {
  prefix: "fas",
  iconName: "rotate",
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z"]
}, Bw = {
  prefix: "fas",
  iconName: "hashtag",
  icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"]
}, Vw = {
  prefix: "fas",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, Ww = {
  prefix: "fas",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"]
}, Hw = {
  prefix: "fas",
  iconName: "user-plus",
  icon: [640, 512, [], "f234", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, jw = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, Xw = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, Zw = {
  prefix: "fas",
  iconName: "share",
  icon: [512, 512, ["mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
}, Yw = {
  prefix: "fas",
  iconName: "turn-down-right",
  icon: [512, 512, [], "e455", "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88-192 0c-17.7 0-32-14.3-32-32L96 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64L0 208c0 70.7 57.3 128 128 128l192 0 0 88c0 9.6 5.7 18.2 14.5 22z"]
}, Uw = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, Jw = {
  prefix: "fas",
  iconName: "grip-dots",
  icon: [448, 512, [], "e410", "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
}, Kw = {
  prefix: "fas",
  iconName: "shield-keyhole",
  icon: [512, 512, [], "e248", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6l0 69.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-69.4c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const qw = {
  prefix: "far",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
}, Qw = {
  prefix: "far",
  iconName: "calendar-days",
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"]
}, eA = {
  prefix: "far",
  iconName: "circle-minus",
  icon: [512, 512, ["minus-circle"], "f056", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
}, tA = {
  prefix: "far",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
}, nA = {
  prefix: "far",
  iconName: "clipboard-list",
  icon: [384, 512, [], "f46d", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, rA = {
  prefix: "far",
  iconName: "cloud-xmark",
  icon: [640, 512, [], "e35f", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
}, cA = {
  prefix: "far",
  iconName: "cloud",
  icon: [640, 512, [9729], "f0c2", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z"]
}, oA = {
  prefix: "far",
  iconName: "binoculars",
  icon: [512, 512, [], "f1e5", "M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 16L96 80l0-16zM59.6 158c4.8-26.6 28-46 55.1-46l85.3 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24c0-13.3 10.7-24 24-24l85.3 0c27.1 0 50.3 19.4 55.1 46l5 27.3c3.6 19.9 10.8 39 21.2 56.4l2.6 4.4c20.1 33.6 30.8 72 30.8 111.1l0 66.8c0 30.9-25.1 56-56 56l-112 0c-30.9 0-56-25.1-56-56l0-136-64 0 0 136c0 30.9-25.1 56-56 56L56 480c-30.9 0-56-25.1-56-56l0-66.8C0 318 10.6 279.6 30.8 246l2.6-4.4c10.4-17.4 17.6-36.5 21.2-56.4l5-27.3zm55.1 2c-3.9 0-7.2 2.8-7.9 6.6l-5 27.3C97.2 219.5 88 244 74.6 266.4l-2.6 4.4C56.3 296.9 48 326.7 48 357.2L48 424c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-264-61.3 0zm282.6 0L336 160l0 264c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-66.8c0-30.4-8.3-60.3-23.9-86.4l-2.6-4.4c-13.4-22.3-22.6-46.9-27.3-72.5l-5-27.3c-.7-3.8-4-6.6-7.9-6.6zM352 32l32 0c17.7 0 32 14.3 32 32l0 16-96 0 0-16c0-17.7 14.3-32 32-32z"]
}, iA = {
  prefix: "far",
  iconName: "magnifying-glass-arrow-right",
  icon: [512, 512, [], "e521", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm33-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L128 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
}, aA = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, sA = {
  prefix: "far",
  iconName: "sitemap",
  icon: [576, 512, [], "f0e8", "M320 80l0 64-64 0 0-64 64 0zM256 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l8 0 0 40-152 0c-30.9 0-56 25.1-56 56l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-4.4 3.6-8 8-8l152 0 0 40-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-40 152 0c4.4 0 8 3.6 8 8l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-30.9-25.1-56-56-56l-152 0 0-40 8 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0zM48 368l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64z"]
}, lA = {
  prefix: "far",
  iconName: "circle-dollar-to-slot",
  icon: [512, 512, ["donate"], "f4b9", "M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.6-64-64-64c-13.6 18.2-29.8 34.3-48 48l48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0c-18.2-13.7-34.3-29.8-48-48zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
}, uA = {
  prefix: "far",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]
}, fA = {
  prefix: "far",
  iconName: "sack-dollar",
  icon: [512, 512, [128176], "f81d", "M218.7 152l74.6 0 13.8 8.8C361.1 195.4 464 277 464 416c0 26.5-21.5 48-48 48L96 464c-26.5 0-48-21.5-48-48c0-139 102.9-220.6 156.9-255.2l13.8-8.8zM286 104l-60 0-7.5-10.8L187.4 48l137.2 0L293.5 93.2 286 104zM150.8 139.9C89.4 185.5 0 274.8 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-141.2-89.4-230.5-150.8-276.1c-10.4-7.7-20-14.2-28.2-19.4l27.3-39.5 29.8-43.2C401 21.7 389.6 0 370.3 0L141.7 0C122.4 0 111 21.7 121.9 37.6l29.8 43.2L179 120.4c-8.2 5.3-17.8 11.7-28.2 19.4zM276 216c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
}, dA = {
  prefix: "far",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"]
}, pA = {
  prefix: "far",
  iconName: "bag-shopping",
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96l-64 0 0 208c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208-64 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-128 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zm0-48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0z"]
}, gA = {
  prefix: "far",
  iconName: "right",
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M397.6 256L247.7 398.7c-.8 .8-2 1.3-3.2 1.3c-2.5 0-4.6-2-4.6-4.6l0-83.4c0-13.3-10.7-24-24-24L48 288l0-64 168 0c13.3 0 24-10.7 24-24l0-83.4c0-2.5 2-4.6 4.6-4.6c1.2 0 2.3 .5 3.2 1.3L397.6 256zm-153 192c13.5 0 26.5-5.2 36.3-14.5L434.8 286.9c8.5-8.1 13.2-19.2 13.2-30.9s-4.8-22.8-13.2-30.9L280.8 78.5C271.1 69.2 258.1 64 244.6 64c-29 0-52.6 23.5-52.6 52.6l0 59.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l144 0 0 59.4c0 29 23.5 52.6 52.6 52.6z"]
}, mA = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
}, hA = {
  prefix: "far",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, vA = {
  prefix: "far",
  iconName: "filters",
  icon: [640, 512, [], "e17e", "M233.8 32C210.7 32 192 50.7 192 73.8c0 9.3 3.1 18.4 8.9 25.8L336 272.3l0 63.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-143.3L631.1 99.6c5.8-7.4 8.9-16.4 8.9-25.8C640 50.7 621.3 32 598.2 32L233.8 32zM378.9 249.2L246.5 80l339 0L453.1 249.2c-3.3 4.2-5.1 9.4-5.1 14.8l0 118.6-64-50.3 0-68.3c0-5.4-1.8-10.6-5.1-14.8zM163.4 96L41.8 96C18.7 96 0 114.7 0 137.8c0 9.3 3.1 18.4 8.9 25.8L144 336.3l0 31.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-111.3c0 0 0 0 0-.1l0-52.9-9.7-12.5-33.2 42.4c-3.3 4.2-5.1 9.4-5.1 14.8l0 86.6-64-50.3 0-36.3c0-5.4-1.8-10.6-5.1-14.8L54.5 144 195 144l-19.3-24.6c-5.5-7-9.6-15-12.3-23.4z"]
}, bA = {
  prefix: "far",
  iconName: "gauge",
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 181.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, CA = {
  prefix: "far",
  iconName: "badge-percent",
  icon: [512, 512, [], "f646", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
}, xA = {
  prefix: "far",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"]
}, yA = {
  prefix: "far",
  iconName: "key",
  icon: [512, 512, [128273], "f084", "M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6c-8.1-2-16.7 .4-22.6 6.4L254.1 336 200 336c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24l0 40-64 0 0-78.1L205.2 228.7c5.9-5.9 8.3-14.5 6.4-22.6c-2.3-9.6-3.6-19.7-3.6-30.1zM336 0C238.8 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, IA = {
  prefix: "far",
  iconName: "globe",
  icon: [512, 512, [127760], "f0ac", "M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6l-139.2 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304l155 0c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4l-65.9 0c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
}, wA = {
  prefix: "far",
  iconName: "file-chart-column",
  icon: [384, 512, ["file-chart-line"], "f659", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96zM128 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z"]
}, AA = {
  prefix: "far",
  iconName: "star",
  icon: [576, 512, [11088, 61446], "f005", "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"]
}, SA = {
  prefix: "far",
  iconName: "shapes",
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M288 63.1L220.3 176l135.5 0L288 63.1zM411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM464 320l-128 0 0 128 128 0 0-128zM328 272l144 0c22.1 0 40 17.9 40 40l0 144c0 22.1-17.9 40-40 40l-144 0c-22.1 0-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zM208 384A80 80 0 1 0 48 384a80 80 0 1 0 160 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z"]
}, _A = {
  prefix: "far",
  iconName: "file-invoice-dollar",
  icon: [384, 512, [], "f571", "M336 448l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 215.6c11 0 20 9 20 20l0 10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8l0 10.1c0 11-9 20-20 20s-20-9-20-20l0-10.8c-10-1.9-19.3-4.8-27.5-7.3c0 0 0 0 0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2c0 0 0 0 0 0s0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3l0-10.3c0-11 9-20 20-20zM96 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, EA = {
  prefix: "far",
  iconName: "calendar-star",
  icon: [448, 512, [], "f736", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM233.3 242.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L224 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z"]
}, MA = {
  prefix: "far",
  iconName: "server",
  icon: [512, 512, [], "f233", "M64 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96zM64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 336zM0 352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64zm392 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM328 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, LA = {
  prefix: "far",
  iconName: "objects-column",
  icon: [448, 512, [], "e3c1", "M48 80l0 160 96 0 0-160L48 80zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM304 272l0 160 96 0 0-160-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM144 368l-96 0 0 64 96 0 0-64zM48 320l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM304 80l0 64 96 0 0-64-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64z"]
}, RA = {
  prefix: "far",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, PA = {
  prefix: "far",
  iconName: "map-location-dot",
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 8.6-1.8 18.3-5 28.6c-5.7 18.4-15.6 38.8-27.4 59.2l-.1 .2c-3.1 5.4-6.3 10.7-9.6 16c-4.4 7-8.9 14-13.5 20.8l-.4 .6c-18.1 26.9-36.7 51.1-49.2 66.6c-7.7 9.6-22 9.6-29.6 0c-12.4-15.5-31.1-39.7-49.2-66.6c-18.4-27.3-36.3-57.5-46.7-84.4c-.8-2.1-1.6-4.2-2.3-6.3c-4.4-12.6-7-24.4-7-34.6c0-4.7 .3-9.3 .8-13.8C175.6 46.4 226.4 0 288 0c66.3 0 120 53.7 120 120zM352 300.6c13.5-18.2 28.8-39.9 42.7-62.4c1.8-2.9 3.6-5.8 5.3-8.8l0 224.3 128-46.5 0-252.9L419.3 193.8c2.2-4.7 4.4-9.3 6.3-14c5.9-14 11-29.2 13.2-44.2l105-38.2c7.4-2.7 15.6-1.6 22 2.9s10.2 11.8 10.2 19.7l0 304c0 10.1-6.3 19.1-15.8 22.6l-176 64c-5.3 1.9-11.1 1.9-16.4 0L200 449.5l-167.8 61c-7.4 2.7-15.6 1.6-22-2.9S0 495.8 0 488L0 184c0-10.1 6.3-19.1 15.8-22.6L136 117.7c0 .8 0 1.5 0 2.3c0 15.1 3.7 30.7 8.9 45.6L48 200.8l0 252.9 128-46.5 0-177.7c1.8 3 3.5 5.9 5.3 8.8c13.9 22.5 29.1 44.2 42.7 62.4l0 106.6 128 46.5 0-153.1zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, TA = {
  prefix: "far",
  iconName: "gauge-circle-bolt",
  icon: [640, 512, [], "e496", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
}, zA = {
  prefix: "far",
  iconName: "chart-bar",
  icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, NA = {
  prefix: "far",
  iconName: "window-restore",
  icon: [512, 512, [], "f2d2", "M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z"]
}, OA = {
  prefix: "far",
  iconName: "bucket",
  icon: [448, 512, [], "e4cf", "M96 152l0 8-48 0 0-8C48 68.1 116.1 0 200 0l48 0c83.9 0 152 68.1 152 152l0 8-48 0 0-8c0-57.4-46.6-104-104-104l-48 0C142.6 48 96 94.6 96 152zM0 216c0-13.3 10.7-24 24-24l48.4 0 303.3 0 48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-6 0L389.3 470c-3 24-23.4 42-47.6 42l-235.3 0c-24.2 0-44.6-18-47.6-42L30 240l-6 0c-13.3 0-24-10.7-24-24zm78.4 24l28 224 235.3 0 28-224L78.4 240z"]
}, FA = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, DA = {
  prefix: "far",
  iconName: "file-import",
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M448 464l-256 0c-8.8 0-16-7.2-16-16l0-80-48 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 192 48 0 0-192c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
}, $A = {
  prefix: "far",
  iconName: "money-bills",
  icon: [640, 512, [], "e1f3", "M528 80c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
}, GA = {
  prefix: "far",
  iconName: "list-tree",
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48zM160 96c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72c-13.3 0-24 10.7-24 24zM288 256c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z"]
}, kA = {
  prefix: "far",
  iconName: "memo-pad",
  icon: [448, 512, [], "e1da", "M400 128l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320 352 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 200c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z"]
}, BA = {
  prefix: "far",
  iconName: "greater-than-equal",
  icon: [448, 512, [], "f532", "M47 78.2c-12.3-5-18.2-19-13.2-31.3s19-18.2 31.3-13.2l336 136c9.1 3.7 15 12.5 15 22.2s-5.9 18.6-15 22.2L65 350.2c-12.3 5-26.3-1-31.3-13.2s1-26.3 13.2-31.3L328 192 47 78.2zM424 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0z"]
}, VA = {
  prefix: "far",
  iconName: "layer-group",
  icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
}, WA = {
  prefix: "far",
  iconName: "memo",
  icon: [384, 512, [], "e1d8", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm120 64l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, HA = {
  prefix: "far",
  iconName: "magnifying-glass-chart",
  icon: [512, 512, [], "e522", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
}, jA = {
  prefix: "far",
  iconName: "chart-pie",
  icon: [576, 512, ["pie-chart"], "f200", "M493.1 192L352 192l0-141.1C423.5 64 480 120.5 493.1 192zM352 240l175.4 0c9 0 16.6-7 16.6-16C544 100.3 443.7 0 320 0c-9 0-16 7.6-16 16.6L304 192l0 48 48 0zM222.1 321.9L348.4 448.2C325 458.4 299.2 464 272 464C166 464 80 378 80 272c0-83.6 53.4-154.7 128-181.1L208 288c0 12.7 5.1 24.9 14.1 33.9zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288l0-238.4c0-9.2-7.8-16.6-17-15.4zM558.4 288L320 288 478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3c1.3-9.2-6.1-17-15.4-17z"]
}, XA = jA, ZA = {
  prefix: "far",
  iconName: "file-contract",
  icon: [384, 512, [], "f56c", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0zm54.2 221.8L160 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l10.6-21.3c.6-1.2 1.8-1.9 3.1-1.9s2.5 .7 3.1 1.9l10.6 21.3c2.7 5.4 8.3 8.8 14.3 8.8l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-30.1 0-6.2-12.4c-6-12-18.3-19.6-31.7-19.6c-8.6 0-16.8 3.1-23.1 8.6l-11.3-37.5C182.2 311.7 171.8 304 160 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L96 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2z"]
}, YA = {
  prefix: "far",
  iconName: "square-list",
  icon: [448, 512, [], "e489", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, UA = {
  prefix: "far",
  iconName: "object-group",
  icon: [576, 512, [], "f247", "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"]
}, JA = {
  prefix: "far",
  iconName: "chart-line",
  icon: [512, 512, ["line-chart"], "f201", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM473 169c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z"]
}, KA = {
  prefix: "far",
  iconName: "arrows-to-eye",
  icon: [640, 512, [], "e4bf", "M49 15C39.6 5.7 24.4 5.7 15 15S5.7 39.6 15 49l63 63L40 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 38.1L49 15zM320 352c-64.5 0-113.8-52.1-138.5-96c24.7-43.9 74-96 138.5-96s113.8 52.1 138.5 96c-24.7 43.9-74 96-138.5 96zm0-240c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM625 15c-9.4-9.4-24.6-9.4-33.9 0l-63 63L528 40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 63-63c9.4-9.4 9.4-24.6 0-33.9zM49 497l63-63 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0L15 463c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm576 0c9.4-9.4 9.4-24.6 0-33.9l-63-63 38.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-38.1 63 63c9.4 9.4 24.6 9.4 33.9 0zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
}, qA = {
  prefix: "far",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
}, QA = {
  prefix: "far",
  iconName: "badge-check",
  icon: [512, 512, [], "f336", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, eS = {
  prefix: "far",
  iconName: "wallet",
  icon: [512, 512, [], "f555", "M88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88l0-176c0-48.6-39.4-88-88-88l-304 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c22.1 0 40 17.9 40 40l0 176c0 22.1-17.9 40-40 40L88 432c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, tS = {
  prefix: "far",
  iconName: "clipboard-check",
  icon: [384, 512, [], "f46c", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
}, nS = {
  prefix: "far",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, rS = {
  prefix: "far",
  iconName: "clipboard-question",
  icon: [384, 512, [], "e4e3", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM105.8 229.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM224 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, cS = {
  prefix: "far",
  iconName: "tags",
  icon: [512, 512, [], "f02c", "M345 39.1c-9.3-9.4-24.5-9.5-33.9-.2s-9.5 24.5-.2 33.9L438.6 202.1c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6 .2 33.9s24.6 9.2 33.9-.2L472.8 359.6c52.4-53 52.4-138.2 0-191.2L345 39.1zM242.7 50.7c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168zM48 80l149.5 0c4.2 0 8.3 1.7 11.3 4.7l168 168c6.2 6.2 6.2 16.4 0 22.6L243.3 408.8c-6.2 6.2-16.4 6.2-22.6 0l-168-168c-3-3-4.7-7.1-4.7-11.3L48 80zm96 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, oS = {
  prefix: "far",
  iconName: "arrows-to-line",
  icon: [448, 512, [], "e0a7", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"]
}, iS = {
  prefix: "far",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
}, aS = {
  prefix: "far",
  iconName: "floppy-disk",
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
}, sS = {
  prefix: "far",
  iconName: "comment-dots",
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, lS = {
  prefix: "far",
  iconName: "grid-dividers",
  icon: [512, 512, [], "e3ad", "M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM80 176l32 0 0-32-32 0 0 32zM32 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM80 464l32 0 0-32-32 0 0 32zM32 416c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM240 144l0 32 32 0 0-32-32 0zM224 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM400 144l0 32 32 0 0-32-32 0zM384 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM24 288l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, uS = {
  prefix: "far",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l287.3 0c3.3 4.2 6.7 8.2 10.3 12c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-3.6 2.3-7 5.1-9.9 8.4c-14.4-5.5-30.1-8.5-46.5-8.5l-91.4 0c-65.7 0-120.1 48.7-129 112zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, fS = {
  prefix: "far",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"]
}, dS = {
  prefix: "far",
  iconName: "tag",
  icon: [448, 512, [127991], "f02b", "M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0L384.8 283.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7L48 80l0 149.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, pS = {
  prefix: "far",
  iconName: "comment",
  icon: [512, 512, [128489, 61669], "f075", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"]
}, gS = {
  prefix: "far",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"]
}, mS = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, hS = {
  prefix: "far",
  iconName: "calendar-check",
  icon: [448, 512, [], "f274", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, vS = {
  prefix: "far",
  iconName: "presentation-screen",
  icon: [576, 512, ["presentation"], "f685", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm8 80l0 216c0 30.9 25.1 56 56 56l176 0 0 46.1-73 73c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73-73 0-46.1 176 0c30.9 0 56-25.1 56-56l0-216-48 0 0 216c0 4.4-3.6 8-8 8l-200 0L88 304c-4.4 0-8-3.6-8-8L80 80 32 80z"]
}, bS = {
  prefix: "far",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
}, CS = {
  prefix: "far",
  iconName: "clock",
  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
}, xS = {
  prefix: "far",
  iconName: "coins",
  icon: [512, 512, [], "f51e", "M176 88c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c.4 .3 .8 .7 1.2 1c-18.7 .4-36.9 1.7-54.4 4.1L128 88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-13.7 5.2-29.4 9.6-46.3 12.9c-5.1-7.5-11-13.9-16.8-19.1c-10.1-9.1-21.8-16.5-34-22.6c31.7-2.3 59.3-8.2 80-16.1c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM48 216c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7c-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM0 216c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424L0 320 0 216zM336 320l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2L48 320c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0c0 0 0 0 0 0zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2L48 424s0 0 0 0c0 0 0 .5 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z"]
}, yS = {
  prefix: "far",
  iconName: "filter-list",
  icon: [512, 512, [], "e17c", "M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1 0 126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4c18 0 32.6-14.6 32.6-32.6l0-182 93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64L41.2 64zM145.6 207.7L56.8 112l238.5 0-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3l0 162.8-48-31.7L152 224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM320 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zM408 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
}, IS = {
  prefix: "far",
  iconName: "sliders",
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
}, wS = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
}, AS = {
  prefix: "far",
  iconName: "calculator",
  icon: [384, 512, [128425], "f1ec", "M336 176l0 272c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-272 288 0zm0-48L48 128l0-64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 64zm48 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 24 0 24L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-272 0-24 0-24zM80 232a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM80 408c0 13.3 10.7 24 24 24l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM192 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM168 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM280 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM256 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
}, SS = {
  prefix: "far",
  iconName: "cloud-binary",
  icon: [640, 512, [], "e601", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM176 216l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm72-16c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm120-16c-22.1 0-40 17.9-40 40l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16zM192 320c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm80 24l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm88-32c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0z"]
}, _S = {
  prefix: "far",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3L496 200c0 13.3-10.7 24-24 24l-116.7 0c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176l62.1 0 0-62.1z"]
}, ES = {
  prefix: "far",
  iconName: "gear-code",
  icon: [512, 512, [], "e5e8", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zm73.7 111.8l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
}, MS = {
  prefix: "far",
  iconName: "arrows-from-line",
  icon: [448, 512, [], "e0a4", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-86.1zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z"]
}, LS = {
  prefix: "far",
  iconName: "hexagon-check",
  icon: [512, 512, [], "e416", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, RS = {
  prefix: "far",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
}, PS = {
  prefix: "far",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
}, TS = {
  prefix: "far",
  iconName: "earth-americas",
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
}, zS = {
  prefix: "far",
  iconName: "link",
  icon: [640, 512, [128279, "chain"], "f0c1", "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"]
}, NS = {
  prefix: "far",
  iconName: "receipt",
  icon: [384, 512, [129534], "f543", "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24L0 488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8l0-464c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430L48 76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14 0 359.6-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM96 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z"]
}, OS = {
  prefix: "far",
  iconName: "link-horizontal",
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-52.9 42.9-95.9 95.9-95.9l160.3 0c52.9 0 95.9 42.9 95.9 95.9c0 50.5-39.1 92.3-89.5 95.6l-8.1 .5c-13.2 .9-23.2 12.3-22.4 25.5s12.3 23.2 25.5 22.3l8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64L143.9 64zM496.1 448C575.6 448 640 383.6 640 304.1c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 52.9-42.9 95.9-95.9 95.9l-160.2 0c-53 0-95.9-42.9-95.9-95.9c0-50.5 39.1-92.3 89.5-95.7l7.1-.5c13.2-.9 23.2-12.3 22.3-25.6s-12.3-23.2-25.6-22.3l-7.1 .5C250.7 165.6 192 228.4 192 304.1C192 383.6 256.4 448 335.9 448l160.2 0z"]
}, FS = {
  prefix: "far",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"]
}, DS = {
  prefix: "far",
  iconName: "bars-filter",
  icon: [448, 512, [], "e0ad", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24z"]
}, $S = {
  prefix: "far",
  iconName: "cloud-check",
  icon: [640, 512, [], "e35c", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
}, GS = {
  prefix: "far",
  iconName: "rocket",
  icon: [512, 512, [], "f135", "M368.3 265c-44.5 30.1-129.3 68.2-175.7 88l-35-35c20.4-46.1 59.2-130 89.3-174.4C309.1 52 398.4 41.8 461.7 50.3c8.5 63.3-1.7 152.6-93.3 214.7zM118.5 288c-3.6 8-6.8 15.2-9.4 21.2c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8l0 96.2c0 8.6 4.6 16.6 12.1 20.9s16.7 4.2 24.1-.2l88.5-52.5c21.9-13 35.3-36.5 35.3-61.9l0-82.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-82.1 0c-25.4 0-49 13.4-61.9 35.3L3.4 251.8c-4.4 7.4-4.5 16.6-.2 24.1S15.4 288 24 288l94.5 0zM408 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
}, kS = {
  prefix: "far",
  iconName: "arrow-trend-up",
  icon: [576, 512, [], "e098", "M352 120c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1L337 369c-9.4 9.4-24.6 9.4-33.9 0l-111-111L41 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 207c9.4-9.4 24.6-9.4 33.9 0l111 111L494.1 144 376 144c-13.3 0-24-10.7-24-24z"]
}, BS = {
  prefix: "far",
  iconName: "clouds",
  icon: [640, 512, [], "f744", "M272 112c0 .7 0 1.4 0 2c-.3 10.3 6 19.7 15.6 23.2s20.5 .6 27-7.4c8.8-10.9 22.3-17.9 37.4-17.9c26.5 0 48 21.5 48 48c0 8.7-2.3 16.8-6.3 23.8c3.6 2.3 7.1 4.8 10.6 7.4c12.8-4.4 26.5-6.8 40.7-7.2c2-7.7 3-15.7 3-24c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96l65.9 0c2.7-17.1 8.3-33.3 16.2-48L96 240c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.4 1 16.6 2.9c7.9 2.9 16.8 1.5 23.4-3.8s9.9-13.7 8.7-22c-.4-2.9-.6-6-.6-9.1c0-35.3 28.7-64 64-64s64 28.7 64 64zM240 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C201.3 462.4 176 436.2 176 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C154.4 322.1 128 359.9 128 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C534.5 247 494.9 216 448 216c-18 0-34.9 4.6-49.7 12.6C376.5 206.1 345.9 192 312 192z"]
}, VS = {
  prefix: "far",
  iconName: "filter-slash",
  icon: [640, 512, [], "e17d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7l-429 0c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80L521 80 370.3 265 134.4 80zM400 411.2l-48-37.8 0 41.9-64-50.8 0-41.5-48-37.8 0 83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3l0-36.5z"]
}, WS = {
  prefix: "far",
  iconName: "percent",
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
}, HS = {
  prefix: "far",
  iconName: "face-smile",
  icon: [512, 512, [128578, "smile"], "f118", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, jS = {
  prefix: "far",
  iconName: "gears",
  icon: [640, 512, ["cogs"], "f085", "M147.1 52.7l-6.5 23.5c-1.7 6.2-6.3 11.2-12.4 13.5c-10 3.7-19.1 9-27.2 15.7c-5 4.1-11.6 5.6-17.9 4l-23.6-6.2c-5 6.9-9.4 14.4-12.9 22.3l17.1 17.4c4.5 4.6 6.6 11.1 5.5 17.4c-.9 5.1-1.3 10.3-1.3 15.7s.5 10.6 1.3 15.7c1.1 6.4-.9 12.9-5.5 17.4L46.7 226.5c3.5 7.9 7.9 15.4 12.9 22.3l23.6-6.2c6.3-1.6 12.9-.1 17.9 4c8 6.7 17.2 12 27.2 15.7c6.1 2.2 10.7 7.2 12.4 13.5l6.5 23.5c4.2 .4 8.5 .7 12.9 .7s8.7-.2 12.9-.7l6.5-23.5c1.7-6.2 6.3-11.2 12.4-13.5c10-3.7 19.1-9 27.2-15.7c5-4.1 11.6-5.6 17.9-4l23.6 6.2c5-6.9 9.4-14.4 12.9-22.3l-17.1-17.4c-4.5-4.6-6.6-11.1-5.5-17.4c.9-5.1 1.3-10.3 1.3-15.7s-.5-10.6-1.3-15.7c-1.1-6.4 .9-12.9 5.5-17.4l17.1-17.4c-3.5-7.9-7.9-15.4-12.9-22.3l-23.6 6.2c-6.3 1.6-12.9 .1-17.9-4c-8-6.7-17.2-12-27.2-15.7c-6.1-2.2-10.7-7.2-12.4-13.5l-6.5-23.5c-4.2-.4-8.5-.7-12.9-.7s-8.7 .2-12.9 .7zM127.3 15.3C137.9 13.1 148.8 12 160 12s22.1 1.1 32.7 3.3c7.4 1.5 13.3 7 15.3 14.3l7.3 26.6c7.3 3.4 14.3 7.4 20.8 12l26.6-7c7.3-1.9 15 .4 20 6.1c14.4 16.3 25.7 35.5 32.8 56.7c2.4 7.1 .6 15-4.7 20.4L291.5 164c.4 4 .5 8 .5 12s-.2 8-.5 12l19.4 19.6c5.3 5.4 7.1 13.2 4.7 20.4c-7.1 21.2-18.3 40.4-32.8 56.7c-5 5.6-12.7 8-20 6.1l-26.6-7c-6.5 4.6-13.5 8.6-20.8 12L208 322.4c-2 7.3-7.9 12.8-15.3 14.3c-10.6 2.1-21.5 3.3-32.7 3.3s-22.1-1.1-32.7-3.3c-7.4-1.5-13.3-7-15.3-14.3l-7.3-26.6c-7.3-3.4-14.3-7.4-20.8-12l-26.6 7c-7.3 1.9-15-.4-20-6.1C22.8 268.4 11.5 249.2 4.4 228c-2.4-7.1-.6-15 4.7-20.4L28.5 188c-.4-4-.5-8-.5-12s.2-8 .5-12L9.2 144.4C3.9 139 2 131.1 4.4 124c7.1-21.2 18.3-40.4 32.8-56.7c5-5.6 12.7-8 20-6.1l26.6 7c6.5-4.6 13.5-8.6 20.8-12L112 29.6c2-7.3 7.9-12.8 15.3-14.3zM120 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM340.7 364.9l23.5 6.5c6.2 1.7 11.2 6.3 13.5 12.4c3.7 10 9 19.1 15.7 27.2c4.1 5 5.6 11.6 4 17.9l-6.2 23.6c6.9 5 14.4 9.4 22.3 12.9l17.4-17.1c4.6-4.5 11.1-6.6 17.4-5.5c5.1 .9 10.3 1.3 15.7 1.3s10.6-.5 15.7-1.3c6.4-1.1 12.8 .9 17.4 5.5l17.4 17.1c7.9-3.5 15.4-7.9 22.3-12.9l-6.2-23.6c-1.6-6.2-.1-12.9 4-17.9c6.7-8 12.1-17.2 15.7-27.2c2.2-6.1 7.2-10.7 13.5-12.4l23.5-6.5c.4-4.2 .7-8.5 .7-12.9s-.2-8.7-.7-12.9l-23.5-6.5c-6.2-1.7-11.2-6.3-13.5-12.4c-3.7-10-9-19.1-15.7-27.2c-4.1-5-5.6-11.6-4-17.9l6.2-23.6c-6.9-5-14.4-9.4-22.3-12.9l-17.4 17.1c-4.6 4.5-11.1 6.6-17.4 5.5c-5.1-.9-10.4-1.3-15.7-1.3s-10.6 .5-15.7 1.3c-6.4 1.1-12.9-.9-17.4-5.5l-17.4-17.1c-7.9 3.5-15.4 7.9-22.3 12.9l6.2 23.6c1.6 6.3 .1 12.9-4 17.9c-6.7 8-12.1 17.2-15.7 27.2c-2.2 6.1-7.2 10.7-13.5 12.4l-23.5 6.5c-.4 4.2-.7 8.5-.7 12.9s.2 8.7 .7 12.9zm-37.4 19.8c-2.1-10.6-3.3-21.5-3.3-32.7s1.1-22.1 3.3-32.7c1.5-7.4 7-13.3 14.3-15.3l26.6-7.3c3.4-7.3 7.4-14.3 12-20.8l-7-26.6c-1.9-7.3 .5-15 6.1-20c16.3-14.4 35.5-25.7 56.7-32.8c7.1-2.4 15-.6 20.4 4.7L452 220.5c4-.4 8-.5 12-.5s8 .2 12 .5l19.6-19.4c5.4-5.3 13.2-7.1 20.4-4.7c21.2 7.1 40.4 18.3 56.7 32.8c5.6 5 8 12.7 6.1 20l-7 26.6c4.6 6.5 8.6 13.5 12 20.8l26.6 7.3c7.3 2 12.8 7.9 14.3 15.3c2.1 10.6 3.3 21.5 3.3 32.7s-1.1 22.1-3.3 32.7c-1.5 7.4-7 13.3-14.3 15.3l-26.6 7.3c-3.4 7.3-7.4 14.3-12 20.8l7 26.6c1.9 7.3-.5 15-6.1 20c-16.3 14.4-35.5 25.7-56.7 32.8c-7.1 2.4-15 .6-20.4-4.7L476 483.5c-4 .4-8 .5-12 .5s-8-.2-12-.5l-19.6 19.4c-5.4 5.3-13.2 7.1-20.4 4.7c-21.2-7.1-40.4-18.3-56.7-32.8c-5.6-5-8-12.7-6.1-20l7-26.6c-4.6-6.5-8.6-13.5-12-20.8L317.6 400c-7.3-2-12.8-7.9-14.3-15.3zM464 392a40 40 0 1 1 0-80 40 40 0 1 1 0 80z"]
}, XS = {
  prefix: "far",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
}, ZS = {
  prefix: "far",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", "M48 106.7L48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 168c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.3 0c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"]
}, YS = {
  prefix: "far",
  iconName: "hashtag",
  icon: [448, 512, [62098], "23", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136l111 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136l71.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-81.1 0L314.1 328l77.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-87.5 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144L56 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l87.5 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144-111 0z"]
}, US = {
  prefix: "far",
  iconName: "object-intersect",
  icon: [512, 512, [], "e49d", "M96 48L64 48c-8.8 0-16 7.2-16 16l0 32L0 96 0 64C0 28.7 28.7 0 64 0L96 0l0 48zm32 0l0-48 96 0 0 48-96 0zM0 128l48 0 0 96L0 224l0-96zm352 32l0 48 0 48 0 32c0 35.3-28.7 64-64 64l-64 0-16 0-48 0 0-48 0-48 0-32c0-35.3 28.7-64 64-64l64 0 16 0 48 0zM160 416l48 0 0 32c0 8.8 7.2 16 16 16l32 0 0 48-32 0c-35.3 0-64-28.7-64-64l0-32zM352 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0 0-48 32 0c35.3 0 64 28.7 64 64zm64 144l0-48 32 0c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0zM96 304l0 48-32 0c-35.3 0-64-28.7-64-64l0-32 48 0 0 32c0 8.8 7.2 16 16 16l32 0zM288 464l96 0 0 48-96 0 0-48zm160 48l-32 0 0-48 32 0c8.8 0 16-7.2 16-16l0-32 48 0 0 32c0 35.3-28.7 64-64 64zm64-128l-48 0 0-96 48 0 0 96zM304 208l-80 0c-8.8 0-16 7.2-16 16l0 80 80 0c8.8 0 16-7.2 16-16l0-80z"]
}, JS = {
  prefix: "far",
  iconName: "pencil-mechanical",
  icon: [512, 512, [], "e5ca", "M500.7 36.7L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L389.5 42.5c-4.3-1.6-8.9-2.5-13.5-2.5c-10.2 0-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L460.7 163.3c7.2-7.2 11.3-17.1 11.3-27.3c0-4.7-.8-9.3-2.5-13.5l31.1-31.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zM376 91.9L420.1 136 183 373.1 138.9 329 376 91.9zM89.1 422.9l16.9-59 42.2 42.2-59 16.9z"]
}, KS = {
  prefix: "far",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"]
}, qS = {
  prefix: "far",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, QS = {
  prefix: "far",
  iconName: "link-slash",
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l91-91c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6l-95.1 95.1-45.5-35.7c24.2-53.3 14.1-117.9-29.3-161.3c-52.1-52.1-134.4-55.9-190.8-11.2L38.8 5.1zm186.3 146c36.9-22.3 85.6-17.6 117.4 14.3c26 26 34 63.3 23.7 96.4L225.1 151.1zM352.6 373.8c-20.2-2.7-39.7-11.7-55.2-27.3c-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9c38.8 38.8 94.2 50.8 143.4 36l-54.2-42.7zm-236-186L59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z"]
}, e_ = {
  prefix: "far",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"]
}, t_ = {
  prefix: "far",
  iconName: "arrow-trend-down",
  icon: [576, 512, [], "e097", "M352 392c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1L337 143c-9.4-9.4-24.6-9.4-33.9 0l-111 111L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 305c9.4 9.4 24.6 9.4 33.9 0l111-111L494.1 368 376 368c-13.3 0-24 10.7-24 24z"]
}, n_ = {
  prefix: "far",
  iconName: "buildings",
  icon: [512, 512, [], "e0cc", "M448 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-384c0-8.8 7.2-16 16-16l160 0zM288 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L288 0zM192 128L72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l144.4 0c-11.8-13.2-20.1-29.7-23.1-48L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l120 0 0-48zM112 320c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm224 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM112 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM336 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 144l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16z"]
}, r_ = {
  prefix: "far",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z"]
}, c_ = {
  prefix: "far",
  iconName: "database",
  icon: [448, 512, [], "f1c0", "M400 86l0 88.7c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 203 269.5 208 224 208s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7L48 86l.6-.5C53.9 81 64.5 74.8 81.8 68.6C115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6 .5zm0 141.5l0 75.2c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 331 269.5 336 224 336s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7l0-75.2c13.3 5.3 27.9 9.9 43.3 13.7C129.5 250.6 175.2 256 224 256s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7zM48 426l0-70.4c13.3 5.3 27.9 9.9 43.3 13.7C129.5 378.6 175.2 384 224 384s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7l0 70.4-.6 .5c-5.3 4.5-15.9 10.7-33.2 16.9C332.1 455.5 281.8 464 224 464s-108.1-8.5-142.2-20.6c-17.3-6.2-27.8-12.4-33.2-16.9L48 426zm354.1-2.1s0 .1-.2 .2l.1-.2c0 0 0 0 0-.1zm-356.1 0s0 .1 .2 .2c-.1-.1-.1-.2-.2-.2zm0-335.8s.1-.1 .2-.2c-.1 .1-.2 .2-.2 .2zm356-.2c.1 .1 .2 .2 .2 .2s0-.1-.2-.2zM448 432l0-352C448 35.8 347.7 0 224 0S0 35.8 0 80L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80z"]
}, o_ = {
  prefix: "far",
  iconName: "message-dollar",
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
}, i_ = {
  prefix: "far",
  iconName: "file-spreadsheet",
  icon: [384, 512, [], "f65b", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM176 256l0 48-64 0 0-48 64 0zm-64 80l64 0 0 48-64 0 0-48zm96 0l64 0 0 48-64 0 0-48zm-16 80l16 0 64 0c17.7 0 32-14.3 32-32l0-48 0-16 0-16 0-48c0-17.7-14.3-32-32-32l-64 0-16 0-16 0-64 0c-17.7 0-32 14.3-32 32l0 48 0 16 0 16 0 48c0 17.7 14.3 32 32 32l64 0 16 0zm16-112l0-48 64 0 0 48-64 0z"]
}, a_ = {
  prefix: "far",
  iconName: "calendar-day",
  icon: [448, 512, [], "f783", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z"]
}, s_ = {
  prefix: "far",
  iconName: "magnifying-glass-plus",
  icon: [512, 512, ["search-plus"], "f00e", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, l_ = {
  prefix: "far",
  iconName: "file-check",
  icon: [384, 512, [], "f316", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
}, u_ = {
  prefix: "far",
  iconName: "dollar-sign",
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 47.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1c-12.1-5.4-26.3 .1-31.7 12.2s.1 26.3 12.2 31.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2l0 49.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48.6c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5c12.9 3.1 25.8-4.9 28.9-17.8S268.4 89 255.5 86c-18.7-4.4-44.2-9.7-71.5-12.5L184 24z"]
}, f_ = {
  prefix: "far",
  iconName: "magnifying-glass-dollar",
  icon: [512, 512, ["search-dollar"], "f688", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm20-312c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
}, d_ = {
  prefix: "far",
  iconName: "graduation-cap",
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const p_ = {
  prefix: "fad",
  iconName: "circle-user",
  icon: [512, 512, [62142, "user-circle"], "f2bd", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM113 384.2c22.1-38.3 63.5-64.2 111-64.2l64 0c47.4 0 88.9 25.8 111 64.2C363.8 423.3 312.8 448 256 448s-107.8-24.7-143-63.8zM328 200a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z", "M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z"]]
}, yn = {
  wallet: {
    name: "wallet",
    value: eS
  },
  shapes: {
    name: "shapes",
    value: SA
  },
  share: {
    name: "share",
    value: Zw
  },
  shieldKeyhole: {
    name: "shieldKeyhole",
    value: Kw
  },
  arrowsTurnToDots: {
    name: "arrowsTurnToDots",
    value: Iw
  },
  chartLine: {
    name: "chartLine",
    value: JA
  },
  cloudCheck: {
    name: "cloudCheck",
    value: $S
  },
  cloudBinary: {
    name: "cloudBinary",
    value: SS
  },
  cloudXMark: {
    name: "cloudXMark",
    value: rA
  },
  cloudMinus: {
    name: "cloudMinus",
    value: $w
  },
  gaugeCircleBolt: {
    name: "gaugeCircleBolt",
    value: TA
  },
  bolt: {
    name: "bolt",
    value: yw
  },
  sackDollar: {
    name: "sackDollar",
    value: fA
  },
  badgeCheck: {
    name: "badgeCheck",
    value: QA
  },
  check: {
    name: "check",
    value: jw
  },
  envelope: {
    name: "envelope",
    value: gS
  },
  bell: {
    name: "bell",
    value: Aw
  },
  refresh: {
    name: "refresh",
    value: kw
  },
  reset: {
    name: "reset",
    value: _S
  },
  magnifyingGlass: {
    name: "magnifyingGlass",
    value: _d
  },
  magnifyingGlassDollar: {
    name: "magnifyingGlassDollar",
    value: f_
  },
  magnifyingGlassChart: {
    name: "magnifyingGlassChart",
    value: HA
  },
  magnifyingGlassPlus: {
    name: "magnifyingGlassPlus",
    value: s_
  },
  magnifyingGlassArrowRight: {
    name: "magnifyingGlassArrowRight",
    value: iA
  },
  objectsColumn: {
    name: "objectsColumn",
    value: LA
  },
  mapLocationDot: {
    name: "mapLocationDot",
    value: PA
  },
  sliders: {
    name: "sliders",
    value: IS
  },
  plug: {
    name: "plug",
    value: VI
  },
  chevronUp: {
    name: "chevronUp",
    value: WI
  },
  chevronRight: {
    name: "chevronRight",
    value: Dw
  },
  chevronDown: {
    name: "chevronDown",
    value: Pw
  },
  chevronLeft: {
    name: "chevronLeft",
    value: Fw
  },
  gauge: {
    name: "gauge",
    value: bA
  },
  grid: {
    name: "grid",
    value: RI
  },
  cloud: {
    name: "cloud",
    value: cA
  },
  binoculars: {
    name: "binoculars",
    value: oA
  },
  binocularsSolid: {
    name: "binocularsSolid",
    value: NI
  },
  user: {
    name: "user",
    value: p_
  },
  userGroup: {
    name: "userGroup",
    value: "partner"
  },
  users: {
    name: "users",
    value: kI
  },
  mainUser: {
    name: "mainUser",
    value: jI
  },
  userGear: {
    name: "userGear",
    value: uS
  },
  userGearSolid: {
    name: "userGearSolid",
    value: lw
  },
  userCheck: {
    name: "userCheck",
    value: zI
  },
  mainUserRegular: {
    name: "mainUserRegular",
    value: xA
  },
  userPlus: {
    name: "userPlus",
    value: Hw
  },
  arrowRightFromBracket: {
    name: "arrowRightFromBracket",
    value: EI
  },
  right: {
    name: "right",
    value: gA
  },
  triangleExclamation: {
    name: "triangleExclamation",
    value: Xw
  },
  triangleExclamationRegular: {
    name: "triangleExclamationRegular",
    value: r_
  },
  arrowUpRightFromSquare: {
    name: "arrowUpRightFromSquare",
    value: rw
  },
  arrowUp: {
    name: "arrowUp",
    value: Tw
  },
  arrowDown: {
    name: "arrowDown",
    value: Ew
  },
  circleXmark: {
    name: "circleXmark",
    value: Uw
  },
  xMark: {
    name: "xMark",
    value: Ow
  },
  circleQuarterStroke: {
    name: "circleQuarterStroke",
    value: YI
  },
  sparkles: {
    name: "sparkles",
    value: HI
  },
  bracketsCurly: {
    name: "bracketsCurly",
    value: pw
  },
  gear: {
    name: "gear",
    value: hw
  },
  gearCode: {
    name: "gearCode",
    value: ES
  },
  arrowsToLine: {
    name: "arrowsToLine",
    value: iw
  },
  arrowsFromLine: {
    name: "arrowsFromLine",
    value: Sw
  },
  arrowsToLineRegular: {
    name: "arrowsToLineRegular",
    value: oS
  },
  arrowsFromLineRegular: {
    name: "arrowsFromLineRegular",
    value: MS
  },
  gearRegular: {
    name: "gearRegular",
    value: bS
  },
  gearsRegular: {
    name: "gearsRegular",
    value: jS
  },
  calculator: {
    name: "calculator",
    value: AS
  },
  caretDown: {
    name: "caretDown",
    value: bw
  },
  caretUp: {
    name: "caretUp",
    value: KI
  },
  caretRight: {
    name: "caretRight",
    value: TI
  },
  caretLeft: {
    name: "caretLeft",
    value: FI
  },
  plus: {
    name: "plus",
    value: Nw
  },
  clone: {
    name: "clone",
    value: e_
  },
  delete: {
    name: "delete",
    value: uw
  },
  deleteRegular: {
    name: "deleteRegular",
    value: fS
  },
  userSecret: {
    name: "userSecret",
    value: fw
  },
  linkHorizontal: {
    name: "linkHorizontal",
    value: OS
  },
  sitemap: {
    name: "sitemap",
    value: sA
  },
  edit: {
    name: "edit",
    value: sw
  },
  penSquare: {
    name: "penSquare",
    value: Rw
  },
  penToSquare: {
    name: "penToSquare",
    value: $I
  },
  penToSquareRegular: {
    name: "penToSquare",
    value: dA
  },
  fire: {
    name: "fire",
    value: JI
  },
  fileInvoiceDollarSolid: {
    name: "fileInvoiceDollarSolid",
    value: ZI
  },
  arrowRotateLeft: {
    name: "arrowRotateLeft",
    value: gw
  },
  minus: {
    name: "minus",
    value: mw
  },
  globe: {
    name: "globe",
    value: IA
  },
  gripDots: {
    name: "gripDots",
    value: Jw
  },
  verticalDots: {
    name: "verticalDots",
    value: wS
  },
  search: {
    name: "search",
    value: Mw
  },
  play: {
    name: "play",
    value: qI
  },
  fileLines: {
    name: "fileLines",
    value: _I
  },
  fileLinesLight: {
    name: "fileLinesLight",
    value: qw
  },
  fileChartColumn: {
    name: "fileChartColumn",
    value: wA
  },
  fileCSV: {
    name: "fileCSV",
    value: LI
  },
  send: {
    name: "send",
    value: UI
  },
  circleQuestion: {
    name: "circleQuestion",
    value: cw
  },
  graduationCap: {
    name: "graduationCap",
    value: d_
  },
  circlePlus: {
    name: "circlePlus",
    value: qS
  },
  circlePlusSolid: {
    name: "circlePlusSolid",
    value: Vw
  },
  download: {
    name: "download",
    value: Cw
  },
  clockRotateLeft: {
    name: "clockRotateLeft",
    value: ZS
  },
  pencil: {
    name: "pencil",
    value: PI
  },
  pencilLight: {
    name: "pencilLight",
    value: tA
  },
  pencilMechanical: {
    name: "pencilMechanical",
    value: JS
  },
  calendarDays: {
    name: "calendarDays",
    value: Qw
  },
  calendarDay: {
    name: "calendarDay",
    value: a_
  },
  calendar: {
    name: "calendar",
    value: KS
  },
  calendarCheck: {
    name: "calendarCheck",
    value: hS
  },
  calendarStar: {
    name: "calendarStar",
    value: EA
  },
  arrowTrendUp: {
    name: "arrowTrendUp",
    value: kS
  },
  arrowTrendDown: {
    name: "arrowTrendDown",
    value: t_
  },
  buildings: {
    name: "buildings",
    value: n_
  },
  building: {
    name: "building",
    value: XS
  },
  percent: {
    name: "percent",
    value: WS
  },
  gridDividers: {
    name: "gridDividers",
    value: lS
  },
  key: {
    name: "key",
    value: yA
  },
  file: {
    name: "file",
    value: _w
  },
  fileCheck: {
    name: "fileCheck",
    value: l_
  },
  fileImport: {
    name: "fileImport",
    value: DA
  },
  code: {
    name: "code",
    value: nw
  },
  pin: {
    name: "pin",
    value: Gw
  },
  earth: {
    name: "earth",
    value: TS
  },
  bucket: {
    name: "bucket",
    value: OA
  },
  hashtag: {
    name: "hashtag",
    value: YS
  },
  circleInfo: {
    name: "circleInfo",
    value: mS
  },
  moneyBills: {
    name: "moneyBills",
    value: $A
  },
  handPointRight: {
    name: "handPointRight",
    value: MI
  },
  dollarSign: {
    name: "dollarSign",
    value: u_
  },
  link: {
    name: "link",
    value: zS
  },
  linkSlash: {
    name: "linkSlash",
    value: QS
  },
  server: {
    name: "server",
    value: MA
  },
  memo: {
    name: "memo",
    value: WA
  },
  floppyDisk: {
    name: "floppyDisk",
    value: aS
  },
  list: {
    name: "list",
    value: uA
  },
  eye: {
    name: "eye",
    value: aw
  },
  star: {
    name: "star",
    value: XI
  },
  starHollow: {
    name: "starHollow",
    value: AA
  },
  copy: {
    name: "copy",
    value: zw
  },
  copyRegular: {
    name: "copyRegular",
    value: FS
  },
  coins: {
    name: "coins",
    value: xS
  },
  clipboardUser: {
    name: "clipboardUser",
    value: dw
  },
  circleExclamation: {
    name: "circleExclamation",
    value: DI
  },
  circleExclamationRegular: {
    name: "circleExclamationRegular",
    value: aA
  },
  eyeSlash: {
    name: "eyeSlash",
    value: mA
  },
  regularEye: {
    name: "regularEye",
    value: iS
  },
  comment: {
    name: "comment",
    value: pS
  },
  commentDots: {
    name: "commentDots",
    value: sS
  },
  circle: {
    name: "circle",
    value: qA
  },
  circleCheck: {
    name: "circleCheck",
    value: FA
  },
  circleMinus: {
    name: "circleMinus",
    value: eA
  },
  circleCheckSolid: {
    name: "circleCheckSolid",
    value: QI
  },
  left: {
    name: "left",
    value: ew
  },
  lightbulb: {
    name: "lightbulb",
    value: OI
  },
  chartSimpleHorizontal: {
    name: "chartSimpleHorizontal",
    value: ww
  },
  barsFilter: {
    name: "barsFilter",
    value: DS
  },
  fileSpreadsheet: {
    name: "fileSpreadsheet",
    value: i_
  },
  circleDollarToSlot: {
    name: "circleDollarToSlot",
    value: lA
  },
  tag: {
    name: "tag",
    value: dS
  },
  gripVertical: {
    name: "gripVertical",
    value: vw
  },
  arrowTurnDownRight: {
    name: "arrowTurnDownRight",
    value: tw
  },
  tags: {
    name: "tags",
    value: cS
  },
  tagsSolid: {
    name: "tagsSolid",
    value: ow
  },
  pieChart: {
    name: "pieChart",
    value: XA
  },
  squareList: {
    name: "squareList",
    value: YA
  },
  layerGroup: {
    name: "layerGroup",
    value: VA
  },
  clipboardQuestion: {
    name: "clipboardQuestion",
    value: rS
  },
  clipboardCheck: {
    name: "clipboardCheck",
    value: tS
  },
  clipboard: {
    name: "clipboard",
    value: RA
  },
  clipboardList: {
    name: "clipboardList",
    value: nA
  },
  rocket: {
    name: "rocket",
    value: GS
  },
  listTree: {
    name: "listTree",
    value: GA
  },
  objectIntersect: {
    name: "objectIntersect",
    value: US
  },
  hexagonCheck: {
    name: "hexagonCheck",
    value: LS
  },
  filters: {
    name: "filters",
    value: vA
  },
  filterList: {
    name: "filterList",
    value: yS
  },
  filterSlash: {
    name: "filterSlash",
    value: VS
  },
  turnDownRight: {
    name: "turnDownRight",
    value: Yw
  },
  calendarExclamation: {
    name: "calendarExclamation",
    value: GI
  },
  eyeSlashSolid: {
    name: "turnDownRight",
    value: BI
  },
  hashtagSolid: {
    name: "hashtagSolid",
    value: Bw
  },
  upload: {
    name: "upload",
    value: xw
  },
  memoPad: {
    name: "memoPad",
    value: kA
  },
  clock: {
    name: "clock",
    value: CS
  },
  badgePercent: {
    name: "badgePercent",
    value: CA
  },
  windowRestore: {
    name: "windowRestore",
    value: NA
  },
  database: {
    name: "database",
    value: c_
  },
  fileContract: {
    name: "fileContract",
    value: ZA
  },
  fileInvoiceDollar: {
    name: "fileInvoiceDollar",
    value: _A
  },
  receipt: {
    name: "receipt",
    value: NS
  },
  objectGroup: {
    name: "objectGroup",
    value: UA
  },
  clouds: {
    name: "clouds",
    value: BS
  },
  locationDot: {
    name: "locationDot",
    value: RS
  },
  faceSmile: {
    name: "faceSmile",
    value: HS
  },
  greaterThanEqual: {
    name: "greaterThanEqual",
    value: BA
  },
  arrowsToEye: {
    name: "arrowsToEye",
    value: KA
  },
  messageDollar: {
    name: "messageDollar",
    value: o_
  },
  chartBar: {
    name: "chartBar",
    value: zA
  },
  presentationScreen: {
    name: "presentationScreen",
    value: vS
  },
  circleQuestionRegular: {
    name: "circleQuestionRegular",
    value: nS
  },
  fileRegular: {
    name: "fileRegular",
    value: PS
  },
  bagShopping: {
    name: "bagShopping",
    value: pA
  },
  sparklesRegular: {
    name: "sparklesRegular",
    value: hA
  },
  cloneSolid: {
    name: "cloneSolid",
    value: Ww
  },
  // ---------- CUSTOM ICONS ----------
  addLinkedAccounts: {
    name: "addLinkedAccounts",
    value: "add-linked-account"
  },
  addCostCenters: {
    name: "addCostCenters",
    value: "add-cc"
  },
  addUser: {
    name: "addUser",
    value: "add-user"
  },
  anobot: {
    name: "anobot",
    value: "anobot"
  },
  collapse: {
    name: "collapse",
    value: "collaps"
  },
  commitment: {
    name: "commitment",
    value: "commitment"
  },
  costAndUsage: {
    name: "costAndUsage",
    value: "cost-n-usage"
  },
  dashboard: {
    name: "dashboard",
    value: "dashboard"
  },
  ddEmpty: {
    name: "ddEmpty",
    value: "dd-empty"
  },
  enrTagExcluded: {
    name: "enrTagExcluded",
    value: "enr-tag-excluded"
  },
  excluded: {
    name: "excluded",
    value: "excluded"
  },
  expand: {
    name: "expand",
    value: "expand"
  },
  infoStroke: {
    name: "infoStroke",
    value: "info-stroke"
  },
  kubernetes: {
    name: "kubernetes",
    value: "kubernetes"
  },
  lightServerSlash: {
    name: "lightServerSlash",
    value: "light-server-slash"
  },
  modelsExcluded: {
    name: "modelsExcluded",
    value: "models-excluded"
  },
  monitor: {
    name: "monitor",
    value: "monitoring"
  },
  partner: {
    name: "partner",
    value: "partner"
  },
  recommendations: {
    name: "recommendations",
    value: "recommendations"
  },
  regularBellGear: {
    name: "regularBellGear",
    value: "regular-bell-gear"
  },
  regularCalendarGear: {
    name: "regularCalendarGear",
    value: "regular-calendar-gear"
  },
  regularClipboardCheckSlash: {
    name: "regularClipboardCheckSlash",
    value: "regular-clipboard-check-slash"
  },
  regularClipboardUserSlash: {
    name: "regularClipboardUserSlash",
    value: "regular-clipboard-user-slash"
  },
  regularCubeMagnifyingGlass: {
    name: "regularCubeMagnifyingGlass",
    value: "regular-cube-magnifying-glass"
  },
  regularEnvelopeCircleXmark: {
    name: "regularEnvelopeCircleXmark",
    value: "regular-envelope-circle-xmark"
  },
  regularEyeCircleCheck: {
    name: "regularEyeCircleCheck",
    value: "regular-eye-circle-check"
  },
  regularStarSlash: {
    name: "regularStarSlash",
    value: "regular-star-slash"
  },
  regularUserSecretCircleCheck: {
    name: "regularUserSecretCircleCheck",
    value: "regular-user-secret-circle-check"
  },
  regularListTreeSlash: {
    name: "regularListTreeSlash",
    value: "regular-list-tree-slash"
  },
  solidEarthSlash: {
    name: "solidEarthSlash",
    value: "solid-earth-americas-slash"
  },
  solidHashtagSlash: {
    name: "solidHashtagSlash",
    value: "solid-hashtag-slash"
  },
  solidUserCheckSlash: {
    name: "solidUserCheckSlash",
    value: "solid-user-check-slash"
  },
  solidUserSecretSlash: {
    name: "solidUserSecretSlash",
    value: "solid-user-secret-slash"
  },
  tagExcluded: {
    name: "tagExcluded",
    value: "tag-excluded"
  },
  thumbDown: {
    name: "thumbDown",
    value: "thumb-down"
  },
  thumbUp: {
    name: "thumbUp",
    value: "thumb-up"
  },
  userSecretSlash: {
    name: "userSecretSlash",
    value: "solid-user-secret-slash"
  },
  resetFilter: {
    name: "resetFilter",
    value: "solid-bars-filter-circle-xmark"
  },
  regularMoney: {
    name: "regularMoney",
    value: "regular-money-bill-1-wave-circle-arrow-right"
  },
  views: {
    name: "views",
    value: "views"
  },
  purchase: {
    name: "purchase",
    value: "purchase"
  },
  filterIcons: {
    name: "filterIcons",
    value: "filter-icons"
  },
  focusNewTag: {
    name: "focusNewTag",
    value: "focus-new-tag"
  },
  goToExplore: {
    name: "goToExplore",
    value: "go-to-explor"
  },
  solidBarsFilterCircleXmark: {
    name: "solidBarsFilterCircleXmark",
    value: "solid-bars-filter-circle-xmark"
  },
  solidBarsFilterSlash: {
    name: "solidBarsFilterSlash",
    value: "solid-bars-filter-slash"
  },
  solidTagCircleCheck: {
    name: "solidTagCircleCheck",
    value: "solid-tag-circle-check"
  },
  solidTagCircleMinus: {
    name: "solidTagCircleMinus",
    value: "solid-tag-circle-minus"
  },
  solidTagCirclePlus: {
    name: "solidTagCirclePlus",
    value: "solid-tag-circle-plus"
  },
  regularArrowsSplitUpAndLeftCircleDollar: {
    name: "regularArrowsSplitUpAndLeftCircleDollar",
    value: "regular-arrows-split-up-and-left-circle-dollar"
  },
  regularCalendarCircleDollar: {
    name: "regularCalendarCircleDollar",
    value: "regular-calendar-circle-dollar"
  },
  regularCalendarTag: {
    name: "regularCalendarTag",
    value: "regular-calendar-tag"
  },
  regularCloudCircleDollar: {
    name: "regularCloudCircleDollar",
    value: "regular-cloud-circle-dollar"
  },
  regularCubesGear: {
    name: "regularCubesGear",
    value: "regular-cubes-gear"
  },
  solidCalculatorGear: {
    name: "solidCalculatorGear",
    value: "solid-calculator-gear"
  },
  unpin: {
    name: "unpin",
    value: "solid-thumbtack-slash"
  }
}, g_ = "fas", Ed = {
  "add-cc": [
    633,
    512,
    [],
    "e039",
    "M538.9 65.8l0 52.1 52.1 0c6.2 0 11.6 5.4 11.6 11.6c0 4.9-3.1 9-7.2 10.7c4.1-1.7 7.2-5.8 7.2-10.7c0-6.2-5.4-11.6-11.6-11.6l-52.1 0 0-52.1c0-6.2-5.4-11.6-11.6-11.6c-.9 0-1.9 .1-2.7 .3c.9-.2 1.8-.3 2.7-.3c6.2 0 11.6 5.4 11.6 11.6zm0 75.3s0 0 0 0l0 52.1c0 4.9-3.1 9-7.2 10.7c4.1-1.7 7.2-5.8 7.2-10.7l0-52.1zm-78.2-22.8c.9-.2 1.9-.4 2.9-.4l52.1 0s0 0 0 0l-52.1 0c-1 0-2 .1-2.9 .4zm87.2 74.9l0-43.1 43.1 0c11 0 20.6-8.9 20.6-20.6c0-11.1-9.5-20.6-20.6-20.6l-43.1 0 0-43.1c0-11.1-9.5-20.6-20.6-20.6c-11.7 0-20.6 9.7-20.6 20.6l0 43.1-43.1 0c-11.7 0-20.6 9.7-20.6 20.6c0 11.5 9.1 20.6 20.6 20.6l43.1 0 0 43.1c0 11.5 9.1 20.6 20.6 20.6c11 0 20.6-8.9 20.6-20.6zM296.7 122.8c0 .9 0 .9 0 1.8c-.9 .9-1.8 2.6-4.4 4.4c0 .9-.9 .9-.9 .9c16.8 .9 32.6 1.8 47.6 4.4V122.8c0-15.9-7.9-28.2-18.5-37.1c-9.7-9.7-22.9-16.8-37.9-22.1c-30-11.5-69.7-18.5-112.9-18.5c-42.4 0-82.1 7.1-112.1 18.5C42.6 69 29.4 76.1 19.7 85.8C9.1 94.6 .3 106.9 .3 122.8v91.8 91.8c0 15.9 8.8 29.1 19.4 37.9c9.7 8.8 22.9 16.8 37.9 22.1c8.8 3.5 17.6 6.2 27.4 8.8V331.1c-4.4-.9-7.9-2.6-12.4-4.4c-11.5-4.4-20.3-9.7-24.7-13.2c-2.6-2.6-3.5-4.4-4.4-5.3s-.9-.9-.9-.9V268.4c5.3 1.8 9.7 4.4 15 6.2c8.8 3.5 17.6 6.2 27.4 8.8V239.3c-4.4-.9-7.9-2.6-12.4-4.4c-11.5-4.4-20.3-9.7-24.7-13.2c-2.6-2.6-3.5-4.4-4.4-5.3s-.9-.9-.9-.9V176.6c5.3 1.8 9.7 4.4 15 6.2c12.4 4.4 25.6 8.8 40.6 11.5c4.4-7.1 9.7-12.4 15-16.8c8.8-7.9 19.4-15 30-20.3c-28.2-1.8-52.1-7.1-70.6-14.1c-11.5-4.4-20.3-9.7-24.7-14.1c-2.6-1.8-3.5-3.5-4.4-4.4s-.9-.9-.9-1.8c0 0 0 0 .9-.9s1.8-2.6 4.4-5.3c4.4-4.4 13.2-8.8 24.7-13.2c23.8-9.7 58.2-15.9 97.1-15.9c39.7 0 74.1 6.2 97.9 15.9c11.5 4.4 20.3 8.8 24.7 13.2c2.6 2.6 3.5 4.4 4.4 5.3c0 .9 0 .9 0 .9zM409.7 235.8c0 .9 0 .9 0 1.8c-.9 .9-1.8 2.6-4.4 4.4c-4.4 4.4-13.2 9.7-24.7 14.1c-23.8 8.8-58.2 15-97.9 15c-38.8 0-73.2-6.2-97.1-15c-11.5-4.4-20.3-9.7-24.7-14.1c-2.6-1.8-3.5-3.5-4.4-4.4c0-.9-.9-.9-.9-1.8c0 0 0 0 .9-.9s1.8-2.6 4.4-5.3c4.4-4.4 13.2-8.8 24.7-13.2c23.8-9.7 58.2-15 97.1-15c39.7 0 74.1 5.3 97.9 15c11.5 4.4 20.3 9.7 24.7 13.2c2.6 2.6 3.5 4.4 4.4 5.3c0 .9 0 .9 0 .9zm42.4 0c0-15.9-7.9-28.2-18.5-37.1c-9.7-9.7-22.9-16.8-37.9-22.1c-30-11.5-69.7-18.5-112.9-18.5c-42.4 0-82.1 7.1-112.1 18.5c-15 5.3-28.2 12.4-37.9 22.1c-10.6 8.8-19.4 21.2-19.4 37.1v91.8 91.8c0 15.9 8.8 29.1 19.4 37.9c9.7 8.8 22.9 16.8 37.9 22.1c30 11.5 69.7 17.6 112.1 17.6c43.2 0 82.9-6.2 112.9-17.6c15-5.3 28.2-12.4 37.9-22.1c10.6-8.8 18.5-22.1 18.5-37.9V327.5 235.8zM155.6 327.5V289.6c5.3 1.8 9.7 4.4 15 6.2c30 11.5 69.7 17.6 112.1 17.6c43.2 0 82.9-6.2 112.9-17.6c5.3-1.8 9.7-3.5 14.1-6.2v37.9c0 .9 0 .9 0 1.8c-.9 .9-1.8 2.6-4.4 4.4c-4.4 4.4-13.2 9.7-24.7 14.1c-23.8 8.8-58.2 15-97.9 15c-38.8 0-73.2-6.2-97.1-15c-11.5-4.4-20.3-9.7-24.7-14.1c-2.6-1.8-3.5-3.5-4.4-4.4c0-.9-.9-.9-.9-1.8zm240 60c5.3-1.8 9.7-3.5 14.1-6.2v37.9s0 .9 0 1.8c-.9 .9-1.8 2.6-4.4 4.4c-4.4 4.4-13.2 9.7-24.7 14.1c-23.8 8.8-58.2 15-97.9 15c-38.8 0-73.2-6.2-97.1-15c-11.5-4.4-20.3-9.7-24.7-14.1c-2.6-1.8-3.5-3.5-4.4-4.4s-.9-1.8-.9-1.8V381.4c5.3 1.8 9.7 4.4 15 6.2c30 11.5 69.7 17.6 112.1 17.6c43.2 0 82.9-6.2 112.9-17.6z"
  ],
  "add-linked-account": [
    640,
    512,
    [],
    "e01b",
    "M33.8 130l0 0c-45.1 45.7-45 119.9 0 166.4l0 0 86.6 87.9 0 0c45.8 45.7 119.1 45.7 164.2 0l0 0c42.6-44 45-113.3 5.6-159.8l-3.9-4.8c-8.9-10-23.9-11.1-33.9-2c-9.8 8.9-10.9 23.9-2 34l3.2 4c24.1 27.4 22.7 68.5-2.9 94.4c-26.2 26.6-69.4 26.7-96.5 0L67.7 262.4c-26.3-27.4-26.3-70.7-.1-98.2c25.6-25.2 66-26.6 92.9-2.8l.1 .1 4.5 3.8c10 9.1 24.9 7.9 33.8-2c8.9-10.1 7.9-25.2-1.9-34.1l-.2-.1-4.5-3.8C146.4 84.3 77.2 86.8 33.8 130zM353.6 183c-45.1-45.7-118.3-45.7-163.4 0c-43.4 43.3-45.8 113.4-5.6 159.9l.2 .3 4.4 4.5c8 9.9 23.8 11.9 33.9 2.7c9.8-9 10.9-24.1 1.9-34.1l-.2-.2-4.5-4.5c-23.3-27.4-21.9-68.4 3.7-94.4l.1-.1c26.2-27.3 69.4-27.3 95.6 0l.1 .1L407.1 305c26.2 26.6 26.3 70.6 0 98.1c-25.6 25.2-66 26.6-92.9 2.9l-.1-.1-4.5-3.8c-10-9-24.9-7.9-33.8 2c-8.9 10.1-7.9 25.2 1.9 34.1l.2 .1 4.5 3.8c45.9 40.8 115.1 38.3 158.5-4.9l0 0c45-45.7 45-120.7 0-166.4L353.6 183zM540.3 53.9v55.4h55.4c6.5 0 12.3 5.8 12.3 12.3c0 5.2-3.2 9.5-7.6 11.4c4.4-1.8 7.6-6.2 7.6-11.4c0-6.5-5.8-12.3-12.3-12.3H540.3V53.9c0-6.5-5.8-12.3-12.3-12.3c-1 0-2 .1-2.9 .3c.9-.2 1.9-.3 2.9-.3c6.5 0 12.3 5.8 12.3 12.3zm0 80h0v55.4c0 5.2-3.2 9.5-7.6 11.4c4.4-1.8 7.6-6.2 7.6-11.4V133.9zm-83-24.2c1-.3 2-.4 3-.4h55.4v0H460.3c-1.1 0-2.1 .1-3 .4zm92.6 79.6V143.5h45.8c11.6 0 21.9-9.5 21.9-21.9c0-11.8-10.1-21.9-21.9-21.9H549.9V53.9C549.9 42.1 539.8 32 528 32c-12.4 0-21.9 10.3-21.9 21.9V99.7H460.3c-12.4 0-21.9 10.3-21.9 21.9c0 12.2 9.7 21.9 21.9 21.9h45.8v45.8c0 12.2 9.7 21.9 21.9 21.9c11.6 0 21.9-9.5 21.9-21.9z"
  ],
  "add-user": [
    640,
    512,
    [],
    "e01c",
    "M533.3 57.5v64.5h64.5c7.6 0 14.3 6.7 14.3 14.3c0 8.1-6.7 14.3-14.3 14.3H533.3v64.5c0 8.1-6.7 14.3-14.3 14.3c-8.1 0-14.3-6.3-14.3-14.3V150.7H440.1c-8.1 0-14.3-6.3-14.3-14.3c0-7.6 6.3-14.3 14.3-14.3h64.5V57.5c0-7.6 6.3-14.3 14.3-14.3c7.6 0 14.3 6.7 14.3 14.3zm0 64.5V57.5c0-7.6-6.7-14.3-14.3-14.3c-8.1 0-14.3 6.7-14.3 14.3v64.5H440.1c-8.1 0-14.3 6.7-14.3 14.3c0 8.1 6.3 14.3 14.3 14.3h64.5v64.5c0 8.1 6.3 14.3 14.3 14.3c7.6 0 14.3-6.3 14.3-14.3V150.7h64.5c7.6 0 14.3-6.3 14.3-14.3c0-7.6-6.7-14.3-14.3-14.3H533.3zm11.2 39.9v53.4c0 14.5-12 25.5-25.5 25.5c-14.2 0-25.5-11.3-25.5-25.5V161.9H440.1c-14.2 0-25.5-11.3-25.5-25.5c0-13.6 11.1-25.5 25.5-25.5h53.4V57.5C493.5 44 504.5 32 519 32c13.8 0 25.5 11.7 25.5 25.5v53.4h53.4c13.8 0 25.5 11.7 25.5 25.5c0 14.5-12 25.5-25.5 25.5H544.5zm-276.7 6.8c0-22.2-13.3-42.8-33.2-54.7c-20.7-11.1-46.5-11.1-66.4 0c-20.7 11.9-33.2 32.5-33.2 54.7c0 23 12.4 43.6 33.2 55.5c19.9 11.1 45.6 11.1 66.4 0c19.9-11.9 33.2-32.5 33.2-55.5zm-172.6 0c0-35.7 19.9-69 53.1-87.2c32.4-18.2 73-18.2 106.2 0c32.4 18.2 53.1 51.5 53.1 87.2c0 36.5-20.7 69.8-53.1 88c-33.2 18.2-73.8 18.2-106.2 0c-33.2-18.2-53.1-51.5-53.1-88zm-39 266.5H345.8c-7.5-50-52.3-88.8-107-88.8H163.3c-54.8 0-99.6 38.9-107 88.8zM15.6 450.2c0-78.5 65.5-142 147.7-142h75.5c82.1 0 148.5 63.4 148.5 142c0 12.7-11.6 23-24.9 23H39.7c-13.3 0-24.1-10.3-24.1-23zM257.8 75.6c34.3 19.3 56.5 54.8 56.5 93.1c0 39.1-22.2 74.6-56.5 93.9l-.1 0c-35.2 19.3-78.3 19.4-112.7 0c-35.3-19.4-56.6-54.9-56.6-93.9c0-38.2 21.3-73.8 56.6-93.1c34.4-19.4 77.6-19.4 112.7 0l.1 0zm-26.6 44.3c-18.8-10-41.9-9.9-59.7 0c-18.8 10.8-29.8 29.3-29.8 48.8c0 20.4 11 38.9 29.8 49.6c17.8 9.9 41 10 59.7 0C249.4 207.5 261 189 261 168.7c0-19.4-11.6-38-29.8-48.8zm3.3 104.4c-20.7 11.1-46.5 11.1-66.4 0c-20.7-11.9-33.2-32.5-33.2-55.5c0-22.2 12.4-42.8 33.2-54.7c19.9-11.1 45.6-11.1 66.4 0c19.9 11.9 33.2 32.5 33.2 54.7c0 23-13.3 43.6-33.2 55.5zm111.2 211H56.2c.3-2.3 .8-4.5 1.3-6.8c10.3-46.7 53.5-82.1 105.8-82.1h75.5c52.3 0 95.5 35.4 105.8 82.1c.5 2.2 .9 4.5 1.2 6.8zM64.4 428.4H337.6c-10.2-42.8-50.2-75.3-98.8-75.3H163.3c-48.6 0-88.6 32.6-98.8 75.3zM8.8 450.2c0-82.5 68.8-148.7 154.4-148.7h75.5c85.6 0 155.3 66.2 155.3 148.7c0 17-15.2 29.8-31.6 29.8H39.7c-16.7 0-30.8-13.1-30.8-29.8zM148.3 81.5C115.2 99.7 95.2 133 95.2 168.7c0 36.5 19.9 69.8 53.1 88c32.4 18.2 73 18.2 106.2 0c32.4-18.2 53.1-51.5 53.1-88c0-35.7-20.7-69-53.1-87.2c-33.2-18.2-73.8-18.2-106.2 0zm14.9 226.8c-82.1 0-147.7 63.4-147.7 142c0 12.7 10.8 23 24.1 23H362.4c13.3 0 24.9-10.3 24.9-23c0-78.5-66.4-142-148.5-142H163.3z"
  ],
  anobot: [
    640,
    512,
    [],
    "e011",
    "M281.6 229.3a37.4 37.4 0 1 1 74.8 0 37.4 37.4 0 1 1 -74.8 0zm99.2 0a37.4 37.4 0 1 1 74.8 0 37.4 37.4 0 1 1 -74.8 0zM64.9 39.9c0-22 18.8-39.9 42-39.9c16.3 0 30.5 8.9 37.4 21.8c26.2 4.3 67.7 23.5 83 78.6c9.4-1.6 19.1-2.5 29-2.5H387c93.3 0 166.3 76.6 157.1 164.9c-5.6 54.2-41.2 99.4-90.2 121.2c0 0-5 3.8-23 7.7c54.1 14.9 96.9 40.2 130.6 69.4c15.1 13.1 28.3 26.9 39.8 40.8c3.4 4.1 .4 10.2-4.9 10.2H553c-1.7 0-3.4-.7-4.6-1.9c-5.1-5.1-10.5-10.2-16.2-15.1c-46-39.9-112.9-72.5-211.3-72.5c-93.2 0-159.8 40.6-203.6 87.5c-1.2 1.3-2.9 2.1-4.7 2.1H70.3c-5.2 0-8.2-5.9-5-10c34.4-44 84.8-86.8 153.4-108.9c-23.5-4.3-29.3-9.1-29.3-9.1c-44.4-19.8-77.9-58.7-88-106.8c-14.6-70.2 24.6-136.7 87.6-165c-9.1-35.3-31.9-47.7-46.3-51.6c-7.4 11.5-20.7 19.2-35.9 19.2c-23.2 0-42-17.9-42-39.9zm191.5 96.2c-74.2 0-129.9 64.5-115.5 133.7c10.9 52.4 59.3 90.2 115.5 90.2H387c60.5 0 111.2-43.6 117.2-100.9c6.9-65.9-47.6-123-117.2-123H256.3z"
  ],
  collaps: [
    640,
    512,
    [],
    "e019",
    "M473.6 12.2c9.8 12.4 8.1 29.7-3.3 40.2l-3.1 2.5L320 160 172.8 54.9l-3.1-2.5c-10.5-9.6-12.8-24.9-5.5-37l2.2-3.2L169 9.3C179.1-.7 195.2-2.9 207.8 4l3.4 2.1L320 83.8 428.8 6.1 432.2 4c13.8-7.5 31.7-4.2 41.4 8.2zM512 224c17.7 0 32 14.3 32 32c0 16.4-12.4 29.9-28.3 31.8L512 288H128c-17.7 0-32-14.3-32-32c0-16.4 12.4-29.9 28.3-31.8l3.7-.2H512zM320 352L467.2 457.1l3.1 2.5c10.5 9.6 12.8 24.9 5.5 37l-2.2 3.2-2.6 2.9c-10.1 10-26.2 12.2-38.8 5.3l-3.4-2.1L320 428.2 211.2 505.9l-3.4 2.1c-13.8 7.5-31.7 4.2-41.4-8.2s-8.1-29.7 3.3-40.2l3.1-2.5L320 352z"
  ],
  commitment: [
    672,
    512,
    [],
    "e009",
    "M354.3 332.4c-20.7 2.3-42.9 3.6-65.9 3.6c-46.1 0-88.1-5-122.2-13c-23-6-41.1-13-54.1-20V228c13 5 27 10 43.1 14c38.1 9 84.1 14 133.2 14c48.1 0 94.2-5 132.2-14c3.3-.8 6.4-1.7 9.5-2.6c24.4-13.9 52.6-21.8 82.6-21.8l0-137.6c0-44-101.2-80-224.4-80C164.2 0 64 36 64 80V432c0 45 100.2 80 224.4 80c38.8 0 75.3-3.5 107.3-9.6c-12.8-12.6-23.5-27.2-31.7-43.3c-23.1 3.1-48.7 4.9-75.6 4.9c-58.1 0-109.2-8-143.2-20c-16.1-5.7-26-12.3-32.1-16.3l-1-.7V356c13 5 27 10 43.1 14c38.1 9 84.1 14 133.2 14c19.7 0 39.1-.8 57.7-2.5c.2-17.1 3.1-33.7 8.2-49.2zM464.7 175c-14 7-32.1 14-55.1 20c-34.1 8-76.1 13-121.2 13c-46.1 0-88.1-5-122.2-13c-23-6-41.1-13-54.1-20V79.7c25.1-11.1 84.7-31.2 142.4-32.9c37.1-2.9 82.1-2.7 122.1 6.3c37.6 7.2 70.7 19 87.7 26.5V111c.1 0 .3-.1 .4-.1V175zm48.1 145c8.9 0 16 7.2 16 16v38.1L552 385.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-32.1-16c-5.4-2.7-8.9-8.2-8.9-14.3V336c0-8.8 7.2-16 16-16zm0 192a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-214.4a86.4 86.4 0 1 1 0 172.8 86.4 86.4 0 1 1 0-172.8z"
  ],
  "cost-n-usage": [
    640,
    512,
    [],
    "e007",
    "M64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zm456.4 56H312c-13.3 0-24-10.7-24-24V50.4C188.3 65.8 112 152 112 256c0 114.9 93.1 208 208 208c95.5 0 175.9-64.3 200.4-152zm7.5-48c.1-2.7 .2-5.3 .2-8c0-109.5-84.6-199.2-192-207.4V264H527.8z"
  ],
  dashboard: [
    569,
    512,
    [],
    "e016",
    "M204.6 326c16.9 0 25.9 1.7 35.2 6.7c8.8 4.7 15.7 11.7 20.4 20.4c5 9.4 6.7 18.4 6.7 35.2v32.8c0 16.9-1.7 25.9-6.7 35.2c-4.7 8.8-11.7 15.7-20.4 20.4c-9.4 5-18.4 6.7-35.2 6.7H119.3c-16.9 0-25.9-1.7-35.2-6.7c-8.8-4.7-15.7-11.7-20.4-20.4c-5-9.4-6.7-18.4-6.7-35.2V388.4c0-16.9 1.7-25.9 6.7-35.2c4.7-8.8 11.7-15.7 20.4-20.4c9.4-5 18.4-6.7 35.2-6.7h85.3zm245.1-70c16.9 0 25.9 1.7 35.2 6.7c8.8 4.7 15.7 11.7 20.4 20.4c5 9.4 6.7 18.4 6.7 35.2V421.2c0 16.9-1.7 25.9-6.7 35.2c-4.7 8.8-11.7 15.7-20.4 20.4c-9.4 5-18.4 6.7-35.2 6.7H381.9c-16.9 0-25.9-1.7-35.2-6.7c-8.8-4.7-15.7-11.7-20.4-20.4c-5-9.4-6.7-18.4-6.7-35.2V318.4c0-16.9 1.7-25.9 6.7-35.2c4.7-8.8 11.7-15.7 20.4-20.4c9.4-5 18.4-6.7 35.2-6.7h67.8zM207.6 361H116.4l-4.9 .1c-.7 0-1.4 .1-2 .1l-3.3 .4c-2.4 .4-4 1-5.6 1.9c-2.7 1.4-4.6 3.4-6.1 6.1c-1.4 2.5-2.1 5.1-2.4 10.4l-.2 5.3v38.7l.1 4.9c0 .7 .1 1.4 .1 2l.4 3.3c.4 2.4 1 4 1.9 5.6c1.4 2.7 3.4 4.6 6.1 6.1c2.5 1.4 5.1 2.1 10.4 2.4l5.3 .2h91.2l4.9-.1c.7 0 1.4-.1 2-.1l3.3-.4c2.4-.4 4-1 5.6-1.9c2.7-1.4 4.6-3.4 6.1-6.1c.9-1.6 1.5-3.3 1.9-5.6l.4-3.3c.1-.6 .1-1.3 .1-2l.1-4.9V385.4l-.1-4.9c0-.7-.1-1.4-.1-2l-.4-3.3c-.4-2.4-1-4-1.9-5.6c-1.4-2.7-3.4-4.6-6.1-6.1c-1.6-.9-3.3-1.5-5.6-1.9l-3.3-.4c-.6-.1-1.3-.1-2-.1l-4.9-.1zm245.1-70H378.9l-4.9 .1c-.7 0-1.4 .1-2 .1l-3.3 .4c-2.4 .4-4 1-5.6 1.9c-2.7 1.4-4.6 3.4-6.1 6.1c-.9 1.6-1.5 3.3-1.9 5.6l-.4 3.3c-.1 .6-.1 1.3-.1 2l-.1 4.9V424.1l.1 4.9c0 .7 .1 1.4 .1 2l.4 3.3c.4 2.4 1 4 1.9 5.6c1.4 2.7 3.4 4.6 6.1 6.1c1.6 .9 3.3 1.5 5.6 1.9l3.3 .4c.6 .1 1.3 .1 2 .1l4.9 .1h73.7l5.3-.2c5.3-.3 7.9-1.1 10.4-2.4c2.7-1.4 4.6-3.4 6.1-6.1c.9-1.6 1.5-3.3 1.9-5.6l.4-3.3c.1-.6 .1-1.3 .1-2l.1-4.9V315.4l-.2-5.3c-.3-5.3-1.1-7.9-2.4-10.4c-1.4-2.7-3.4-4.6-6.1-6.1c-1.6-.9-3.3-1.5-5.6-1.9l-3.3-.4c-.6-.1-1.3-.1-2-.1l-4.9-.1zM204.6 28.4c16.9 0 25.9 1.7 35.2 6.7c8.8 4.7 15.7 11.7 20.4 20.4c5 9.4 6.7 18.4 6.7 35.2V211.1c0 16.9-1.7 25.9-6.7 35.2c-4.7 8.8-11.7 15.7-20.4 20.4c-9.4 5-18.4 6.7-35.2 6.7H119.3c-16.9 0-25.9-1.7-35.2-6.7c-8.8-4.7-15.7-11.7-20.4-20.4c-5-9.4-6.7-18.4-6.7-35.2V90.8c0-16.9 1.7-25.9 6.7-35.2c4.7-8.8 11.7-15.7 20.4-20.4c9.4-5 18.4-6.7 35.2-6.7h85.3zm3 35H116.4l-5.3 .2c-5.3 .3-7.9 1.1-10.4 2.4c-2.7 1.4-4.6 3.4-6.1 6.1c-.9 1.6-1.5 3.3-1.9 5.6L92.3 81c-.1 .6-.1 1.3-.1 2L92 87.9V214.1l.2 5.3c.3 5.3 1.1 7.9 2.4 10.4c1.4 2.7 3.4 4.6 6.1 6.1c1.6 .9 3.3 1.5 5.6 1.9l3.3 .4c.6 .1 1.3 .1 2 .1l4.9 .1h91.2l4.9-.1c.7 0 1.4-.1 2-.1l3.3-.4c2.4-.4 4-1 5.6-1.9c2.7-1.4 4.6-3.4 6.1-6.1c.9-1.6 1.5-3.3 1.9-5.6l.4-3.3c.1-.6 .1-1.3 .1-2l.1-4.9V87.9l-.1-4.9c0-.7-.1-1.4-.1-2l-.4-3.3c-.4-2.4-1-4-1.9-5.6c-1.4-2.7-3.4-4.6-6.1-6.1c-1.6-.9-3.3-1.5-5.6-1.9l-3.3-.4c-.6-.1-1.3-.1-2-.1l-4.9-.1zm242.1-35c16.9 0 25.9 1.7 35.2 6.7c8.8 4.7 15.7 11.7 20.4 20.4c5 9.4 6.7 18.4 6.7 35.2v50.3c0 16.9-1.7 25.9-6.7 35.2c-4.7 8.8-11.7 15.7-20.4 20.4c-9.4 5-18.4 6.7-35.2 6.7H381.9c-16.9 0-25.9-1.7-35.2-6.7c-8.8-4.7-15.7-11.7-20.4-20.4c-5-9.4-6.7-18.4-6.7-35.2V90.8c0-16.9 1.7-25.9 6.7-35.2c4.7-8.8 11.7-15.7 20.4-20.4c9.4-5 18.4-6.7 35.2-6.7h67.8zm3 35H378.9l-4.9 .1c-.7 0-1.4 .1-2 .1l-3.3 .4c-2.4 .4-4 1-5.6 1.9c-2.7 1.4-4.6 3.4-6.1 6.1c-.9 1.6-1.5 3.3-1.9 5.6l-.4 3.3c-.1 .6-.1 1.3-.1 2l-.1 4.9v56.2l.1 4.9c0 .7 .1 1.4 .1 2l.4 3.3c.4 2.4 1 4 1.9 5.6c1.4 2.7 3.4 4.6 6.1 6.1c1.6 .9 3.3 1.5 5.6 1.9l3.3 .4c.6 .1 1.3 .1 2 .1l4.9 .1h73.7l4.9-.1c.7 0 1.4-.1 2-.1l3.3-.4c2.4-.4 4-1 5.6-1.9c2.7-1.4 4.6-3.4 6.1-6.1c1.4-2.5 2.1-5.1 2.4-10.4l.2-5.3V87.9l-.1-4.9c0-.7-.1-1.4-.1-2l-.4-3.3c-.4-2.4-1-4-1.9-5.6c-1.4-2.7-3.4-4.6-6.1-6.1c-2.5-1.4-5.1-2.1-10.4-2.4l-5.3-.2zM119.3 32.7c-16.5 0-24.7 1.7-33.2 6.2c-8 4.3-14.4 10.7-18.7 18.7c-4.5 8.5-6.2 16.7-6.2 33.2V211.1c0 16.5 1.7 24.7 6.2 33.2c4.3 8 10.7 14.4 18.7 18.7c8.5 4.5 16.7 6.2 33.2 6.2h85.3c16.5 0 24.7-1.7 33.2-6.2c8-4.3 14.4-10.7 18.7-18.7c4.5-8.5 6.2-16.7 6.2-33.2V90.8c0-16.5-1.7-24.7-6.2-33.2c-4.3-8-10.7-14.4-18.7-18.7c-8.5-4.5-16.7-6.2-33.2-6.2H119.3zM82.1 31.4c10.2-5.5 20-7.2 37.2-7.2h85.3c17.2 0 27 1.8 37.2 7.2c9.5 5.1 17.1 12.7 22.2 22.2c5.5 10.2 7.2 20 7.2 37.2V211.1c0 17.2-1.8 27-7.2 37.2c-5.1 9.5-12.7 17.1-22.2 22.2c-10.2 5.5-20 7.2-37.2 7.2H119.3c-17.2 0-27-1.8-37.2-7.2c-9.5-5.1-17.1-12.7-22.2-22.2c-5.5-10.2-7.2-20-7.2-37.2V90.8c0-17.2 1.8-27 7.2-37.2C65 44.1 72.6 36.5 82.1 31.4zm299.8 1.3c-16.5 0-24.7 1.7-33.2 6.2c-8 4.3-14.4 10.7-18.7 18.7c-4.5 8.5-6.2 16.7-6.2 33.2v50.3c0 16.5 1.7 24.7 6.2 33.2c4.3 8 10.6 14.4 18.7 18.7c8.5 4.5 16.7 6.2 33.2 6.2h67.8c16.5 0 24.7-1.7 33.2-6.2c8-4.3 14.4-10.7 18.7-18.7c4.5-8.5 6.2-16.7 6.2-33.2V90.8c0-16.5-1.7-24.7-6.2-33.2c-4.3-8-10.7-14.4-18.7-18.7c-8.5-4.5-16.7-6.2-33.2-6.2H381.9zm-37.2-1.3c10.2-5.5 20-7.2 37.2-7.2h67.8c17.2 0 27 1.8 37.2 7.2c9.5 5.1 17.1 12.7 22.2 22.2c5.5 10.2 7.2 20 7.2 37.2v50.3c0 17.2-1.8 27-7.2 37.2c-5.1 9.5-12.7 17.1-22.2 22.2c-10.2 5.5-20 7.2-37.2 7.2H381.9c-17.2 0-27-1.8-37.2-7.2c-9.5-5.1-17.1-12.7-22.2-22.2c-5.5-10.2-7.2-20-7.2-37.2V90.8c0-17.2 1.8-27 7.2-37.2c5.1-9.5 12.7-17.1 22.2-22.2zM116.4 59.2h91.3l5 .2c.7 0 1.5 .1 2.1 .1l.2 0 3.5 .4c2.8 .5 4.9 1.3 6.9 2.4c3.4 1.8 6 4.4 7.8 7.8c1.1 2 1.9 4.1 2.3 6.9l0 .2 .4 3.4c.1 .7 .1 1.4 .1 2.1l0 .1 .1 5 0 126.4-.2 5c0 .7-.1 1.5-.1 2.1l0 .2-.4 3.5c-.5 2.8-1.3 4.9-2.4 6.9c-1.8 3.4-4.4 6-7.8 7.8c-2 1.1-4.1 1.9-6.9 2.3l-.2 0-3.4 .4c-.7 .1-1.4 .1-2.1 .1l-.1 0-5 .1-91.3 0-5-.2c-.7 0-1.5-.1-2.1-.1l-.2 0-3.5-.4c-2.8-.5-4.9-1.3-6.9-2.4c-3.4-1.8-6-4.4-7.8-7.8c-1.7-3.3-2.6-6.4-2.9-12.2l0-.1-.2-5.5 0-126.4 .2-5c0-.7 .1-1.5 .1-2.1l0-.2 .4-3.5c.5-2.8 1.3-4.9 2.4-6.9c1.8-3.4 4.4-6 7.8-7.8c3.3-1.7 6.4-2.6 12.2-2.9l.1 0 5.5-.2zm262.6 0h73.8l5.5 .2c5.7 .3 8.9 1.2 12.2 2.9c3.4 1.8 6 4.4 7.8 7.8c1.1 2 1.9 4.1 2.3 6.9l0 .2 .4 3.4c.1 .7 .1 1.4 .1 2.1l0 .1 .1 5 0 56.3-.2 5.5c-.3 5.7-1.2 8.9-2.9 12.2c-1.8 3.4-4.4 6-7.8 7.8c-2 1.1-4.1 1.9-6.9 2.3l-.2 0-3.4 .4c-.7 .1-1.4 .1-2.1 .1l-.1 0-5 .1-73.8 0-5-.2c-.7 0-1.4-.1-2.1-.1l-.2 0-3.5-.4c-2.8-.5-4.9-1.3-6.9-2.4c-3.4-1.8-6-4.4-7.8-7.8c-1.1-2-1.9-4.1-2.3-6.9l0-.2-.4-3.4c-.1-.7-.1-1.4-.1-2.1l0-.1-.1-5 0-56.3 .2-5c0-.7 .1-1.5 .1-2.1l0-.2L351 77c.5-2.8 1.3-4.9 2.4-6.9c1.8-3.4 4.4-6 7.8-7.8c2-1.1 4.1-1.9 6.9-2.3l.2 0 3.4-.4c.7-.1 1.4-.1 2.1-.1l.1 0 5-.1zM116.4 67.7l-5.2 .2c-4.9 .3-6.8 .9-8.6 1.9c-1.9 1-3.3 2.4-4.3 4.3c-.7 1.2-1.1 2.4-1.4 4.3l-.4 3.1c0 .5-.1 1.1-.1 1.7l-.1 4.8V214l.2 5.2c.3 4.9 .9 6.8 1.9 8.6c1 1.9 2.4 3.3 4.3 4.3c1.2 .7 2.4 1.1 4.3 1.4l3.1 .4c.5 0 1.1 .1 1.7 .1l4.8 .1h91.1l4.8-.1c.6 0 1.2-.1 1.7-.1l3.1-.4c1.8-.3 3-.8 4.3-1.4c1.9-1 3.3-2.4 4.3-4.3c.7-1.2 1.1-2.4 1.4-4.3l.4-3.1c0-.5 .1-1.1 .1-1.7l.1-4.8V87.9l-.1-4.8c0-.6-.1-1.2-.1-1.7l-.4-3.1c-.3-1.8-.8-3-1.4-4.3c-1-1.9-2.4-3.3-4.3-4.3c-1.2-.7-2.4-1.1-4.3-1.4L214 68c-.5 0-1.1-.1-1.7-.1l-4.8-.1H116.4zm262.6 0l-4.8 .1c-.6 0-1.2 .1-1.7 .1l-3.1 .4c-1.8 .3-3 .8-4.3 1.4c-1.9 1-3.3 2.4-4.3 4.3c-.7 1.2-1.1 2.4-1.5 4.3l-.4 3.1c0 .5-.1 1.1-.1 1.7l-.1 4.8V144l.1 4.8c0 .6 .1 1.2 .1 1.7l.4 3.1c.3 1.8 .8 3 1.5 4.3c1 1.9 2.4 3.3 4.3 4.3c1.2 .7 2.4 1.1 4.3 1.4l3.1 .4c.5 0 1.1 .1 1.7 .1l4.8 .1h73.6l4.8-.1c.6 0 1.2-.1 1.7-.1l3.1-.4c1.8-.3 3-.8 4.2-1.4c1.9-1 3.3-2.4 4.3-4.3c1-1.8 1.6-3.7 1.9-8.6l.2-5.2V87.9l-.1-4.8c0-.6-.1-1.2-.1-1.7l-.4-3.1c-.3-1.8-.8-3-1.5-4.3c-1-1.9-2.4-3.3-4.3-4.3c-1.8-1-3.7-1.6-8.6-1.9l-5.2-.2H379zm2.9 192.5c-16.5 0-24.7 1.7-33.2 6.2c-8 4.3-14.4 10.7-18.7 18.7c-4.5 8.5-6.2 16.7-6.2 33.2V421.2c0 16.5 1.7 24.7 6.2 33.2c4.3 8 10.6 14.4 18.7 18.7c8.5 4.5 16.7 6.2 33.2 6.2h67.8c16.5 0 24.7-1.7 33.2-6.2c8-4.3 14.4-10.7 18.7-18.7c4.5-8.5 6.2-16.7 6.2-33.2V318.4c0-16.5-1.7-24.7-6.2-33.2c-4.3-8-10.7-14.4-18.7-18.7c-8.5-4.5-16.7-6.2-33.2-6.2H381.9zM344.7 259c10.2-5.5 20-7.2 37.2-7.2h67.8c17.2 0 27 1.8 37.2 7.2c9.5 5.1 17.1 12.7 22.2 22.2c5.5 10.2 7.2 20 7.2 37.2V421.2c0 17.2-1.8 27-7.2 37.2c-5.1 9.5-12.7 17.1-22.2 22.2c-10.2 5.5-20 7.2-37.2 7.2H381.9c-17.2 0-27-1.8-37.2-7.2c-9.5-5.1-17.1-12.7-22.2-22.2c-5.5-10.2-7.2-20-7.2-37.2V318.4c0-17.2 1.8-27 7.2-37.2c5.1-9.5 12.7-17.1 22.2-22.2zm34.3 27.8h73.8l5 .2c.7 0 1.5 .1 2.1 .1l.2 0 3.5 .4c2.8 .5 4.9 1.3 6.9 2.4c3.4 1.8 6 4.4 7.8 7.8c1.7 3.3 2.6 6.4 2.9 12.2l0 .1 .2 5.5 0 108.8-.2 5c0 .7-.1 1.5-.1 2.1l0 .2-.4 3.5c-.5 2.8-1.3 4.9-2.4 6.9c-1.8 3.4-4.4 6-7.8 7.8c-3.3 1.7-6.4 2.6-12.2 2.9l-.1 0-5.5 .2-73.8 0-5-.2c-.7 0-1.4-.1-2.1-.1l-.2 0-3.5-.4c-2.8-.5-4.9-1.3-6.9-2.4c-3.4-1.8-6-4.4-7.8-7.8c-1.1-2-1.9-4.1-2.3-6.9l0-.2-.4-3.4c-.1-.7-.1-1.4-.1-2.1l0-.1-.1-5 0-108.8 .2-5c0-.7 .1-1.5 .1-2.1l0-.2 .4-3.5c.5-2.8 1.3-4.9 2.4-6.9c1.8-3.4 4.4-6 7.8-7.8c2-1.1 4.1-1.9 6.9-2.3l.2 0 3.4-.4c.7-.1 1.4-.1 2.1-.1l.1 0 5-.1zm.1 8.5l-4.8 .1c-.6 0-1.2 .1-1.7 .1l-3.1 .4c-1.8 .3-3 .8-4.3 1.4c-1.9 1-3.3 2.4-4.3 4.3c-.7 1.2-1.1 2.4-1.5 4.2l-.4 3.1c0 .5-.1 1.1-.1 1.7l-.1 4.8V424.1l.1 4.8c0 .6 .1 1.2 .1 1.7l.4 3.1c.3 1.8 .8 3 1.5 4.2c1 1.9 2.4 3.3 4.3 4.3c1.2 .7 2.4 1.1 4.3 1.5l3.1 .4c.5 0 1.1 .1 1.7 .1l4.8 .1h73.6l5.2-.2c4.9-.3 6.8-.9 8.6-1.9c1.9-1 3.3-2.4 4.3-4.3c.7-1.2 1.1-2.4 1.5-4.2l.4-3.1c0-.5 .1-1.1 .1-1.7l.1-4.8V315.5l-.2-5.2c-.3-4.9-.9-6.8-1.9-8.6c-1-1.9-2.4-3.3-4.3-4.3c-1.2-.7-2.4-1.1-4.2-1.4l-3.1-.4c-.5 0-1.1-.1-1.7-.1l-4.8-.1H379zm-259.7 35c-16.5 0-24.7 1.7-33.2 6.2c-8 4.3-14.4 10.7-18.7 18.7c-4.5 8.5-6.2 16.7-6.2 33.2v32.8c0 16.5 1.7 24.7 6.2 33.2c4.3 8 10.7 14.4 18.7 18.7c8.5 4.5 16.7 6.2 33.2 6.2h85.3c16.5 0 24.7-1.7 33.2-6.2c8-4.3 14.4-10.7 18.7-18.7c4.5-8.5 6.2-16.7 6.2-33.2V388.4c0-16.5-1.7-24.7-6.2-33.2c-4.3-8-10.7-14.4-18.7-18.7c-8.5-4.5-16.7-6.2-33.2-6.2H119.3zM82.1 329c10.2-5.5 20-7.3 37.2-7.3h85.3c17.2 0 27 1.8 37.2 7.3c9.5 5.1 17.1 12.7 22.2 22.2c5.5 10.2 7.2 20 7.2 37.2v32.8c0 17.2-1.8 27-7.2 37.2c-5.1 9.5-12.7 17.1-22.2 22.2c-10.2 5.5-20 7.2-37.2 7.2H119.3c-17.2 0-27-1.8-37.2-7.2c-9.5-5.1-17.1-12.7-22.2-22.2c-5.5-10.2-7.2-20-7.2-37.2V388.4c0-17.2 1.8-27 7.2-37.2c5.1-9.5 12.7-17.1 22.2-22.2zm34.3 27.8h91.3l5 .2c.7 0 1.5 .1 2.1 .1l.2 0 3.5 .4c2.8 .5 4.9 1.3 6.9 2.4c3.4 1.8 6 4.4 7.8 7.8c1.1 2 1.9 4.1 2.3 6.9l0 .2 .4 3.4c.1 .7 .1 1.4 .1 2.1l0 .1 .1 5 0 38.8-.2 5c0 .7-.1 1.5-.1 2.1l0 .2-.4 3.5c-.5 2.8-1.3 4.9-2.4 6.9c-1.8 3.4-4.4 6-7.8 7.8c-2 1.1-4.1 1.9-6.9 2.3l-.2 0-3.4 .4c-.7 .1-1.4 .1-2.1 .1l-.1 0-5 .1-91.4 0-5.5-.2c-5.7-.3-8.9-1.2-12.2-2.9c-3.4-1.8-6-4.4-7.8-7.8c-1.1-2-1.9-4.1-2.3-6.9l0-.2-.4-3.4c-.1-.7-.1-1.4-.1-2.1l0-.1-.1-5 0-38.8 .2-5.5c.3-5.7 1.2-8.9 2.9-12.2c1.8-3.4 4.4-6 7.8-7.8c2-1.1 4.1-1.9 6.9-2.3l.2 0 3.4-.4c.7-.1 1.4-.1 2.1-.1l.1 0 5-.1zm.1 8.5l-4.8 .1c-.6 0-1.2 .1-1.7 .1l-3.1 .4c-1.8 .3-3 .8-4.3 1.4c-1.9 1-3.3 2.4-4.3 4.3c-1 1.8-1.6 3.7-1.9 8.6l-.2 5.2v38.6l.1 4.8c0 .6 .1 1.2 .1 1.7l.4 3.1c.3 1.8 .8 3 1.4 4.2c1 1.9 2.4 3.3 4.3 4.3c1.8 1 3.7 1.6 8.6 1.9l5.2 .2h91.1l4.8-.1c.6 0 1.2-.1 1.7-.1l3.1-.4c1.8-.3 3-.8 4.3-1.5c1.9-1 3.3-2.4 4.3-4.3c.7-1.2 1.1-2.4 1.4-4.2l.4-3.1c0-.5 .1-1.1 .1-1.7l.1-4.8V385.5l-.1-4.8c0-.6-.1-1.2-.1-1.7l-.4-3.1c-.3-1.8-.8-3-1.4-4.3c-1-1.9-2.4-3.3-4.3-4.3c-1.2-.7-2.4-1.1-4.3-1.4l-3.1-.4c-.5 0-1.1-.1-1.7-.1l-4.8-.1H116.4z"
  ],
  "dd-empty": [
    729,
    512,
    [],
    "e005",
    "M256.3 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM.4 260.6l0-1 585.9 0c11.2 0 19.5 2 26.6 5.8a39.3 39.3 0 0 1 16.4 16.4c3.8 7.1 5.8 15.4 5.8 26.6v3.5c0 11.2-2 19.5-5.8 26.6a39.3 39.3 0 0 1 -16.4 16.4c-7.1 3.8-15.4 5.8-26.6 5.8l-563.6 0A254.9 254.9 0 0 1 .4 260.6zM236.5 115.4h407.4c11.2 0 19.5 2 26.6 5.8a39.3 39.3 0 0 1 16.4 16.4c3.8 7.1 5.8 15.4 5.8 26.6v3.5c0 11.2-2 19.5-5.8 26.6a39.3 39.3 0 0 1 -16.4 16.4c-7.1 3.8-15.4 5.8-26.6 5.8H236.5c-11.2 0-19.5-2-26.6-5.8a39.3 39.3 0 0 1 -16.4-16.4c-3.8-7.1-5.8-15.4-5.8-26.6v-3.5c0-11.2 2-19.5 5.8-26.6a39.3 39.3 0 0 1 16.4-16.4c7.1-3.8 15.4-5.8 26.6-5.8zM445.7 403.8H680c11.2 0 19.5 2 26.6 5.8a39.3 39.3 0 0 1 16.4 16.4c3.8 7.1 5.8 15.4 5.8 26.6v3.5c0 11.2-2 19.5-5.8 26.6A39.3 39.3 0 0 1 706.5 499c-7.1 3.8-15.4 5.8-26.6 5.8H445.7c-11.2 0-19.5-2-26.6-5.8a39.3 39.3 0 0 1 -16.4-16.4c-3.8-7.1-5.8-15.4-5.8-26.6v-3.5c0-11.2 2-19.5 5.8-26.6a39.3 39.3 0 0 1 16.4-16.4c7.1-3.8 15.4-5.8 26.6-5.8z"
  ],
  "enr-tag-excluded": [
    640,
    512,
    [],
    "e02d",
    "M395.1 180.9c0 16.7 13.9 29.7 29.7 29.7c16.7 0 29.7-13 29.7-29.7c0-15.8-13-29.7-29.7-29.7c-15.8 0-29.7 13.9-29.7 29.7zM67.6 4.7C58-2.8 44.2-1.1 36.7 8.5s-5.8 23.4 3.8 30.9L582.8 463.1c9.6 7.5 23.4 5.8 30.9-3.8s5.8-23.4-3.8-30.9L484.1 330.1l27.8-27.8c11.1-11.1 16.7-26 16.7-41.7l0-139c0-24.1-19.5-44.5-44.5-44.5L346 77.1c-15.8 0-30.6 6.5-41.7 17.6L251 148l-23.8-18.6 14-14.3c8.3-8.3 8.3-22.2-.9-31.5c-8.3-8.3-22.2-8.3-31.5 .9l-17 17.2L67.6 4.7zM286.4 175.6l49.4-49.4c2.8-2.8 6.5-4.6 10.2-4.6l138.1 0 0 139c0 3.7-.9 7.4-3.7 10.2l-31.6 31.6L286.4 175.6zM91.1 204.1l52.2-53 35.4 27.6-56.1 56.9c-31.5 31.5-31.5 82.5 0 114L226.4 455.3c8.3 8.3 8.3 22.2 0 30.6c-9.3 9.3-23.2 9.3-31.5 0L91.1 381.1C42 332 42 253.2 91.1 204.1zm57.5 46.3l53.5-53.5 35.4 27.6-57.4 57.4c-6.5 5.6-6.5 15.8 0 21.3L303.4 426.5c5.6 5.6 15.8 5.6 21.3 0l75.1-75.1 35.4 27.6-79 79c-23.2 23.2-61.2 23.2-84.3 0L148.6 334.8c-23.2-23.2-23.2-61.2 0-84.3z"
  ],
  excluded: [
    384,
    512,
    [],
    "e01e",
    "M320 64l-40 0-10 0c-7-36-40-64-78-64c-39 0-71 28-79 64l-9 0L64 64C28 64 0 93 0 128L0 448c0 36 28 64 64 64l256 0c35 0 64-28 64-64l0-320c0-35-29-64-64-64zM48 128c0-8 7-16 16-16l16 0 0 24c0 14 10 24 24 24l88 0 88 0c13 0 24-10 24-24l0-24 16 0c8 0 16 8 16 16l0 320c0 9-8 16-16 16L64 464c-9 0-16-7-16-16l0-320zM216 80c0 14-11 24-24 24c-14 0-24-10-24-24c0-13 10-24 24-24c13 0 24 11 24 24zm69.4 176.1l.2-.2c4.1-4.5 5.9-10.3 4.9-15.8c1.1-4.7-.7-9.7-5.5-12.8c-4.1-2.7-9.1-3.7-13.8-3c-7.5-1-15.5 1.1-20.8 6.8l-56.7 58.2-57.2-58.2c-5.4-5.8-13.3-7.8-20.8-6.8c-4.6-.8-9.7 .3-13.8 3c-4.8 3.2-6.6 8.1-5.5 12.8c-1.1 5.5 .7 11.3 4.9 15.8l62.5 63.9L101.3 384l-.1 .1c-4.1 4.5-5.9 10.3-4.9 15.8c-1.1 4.7 .7 9.7 5.5 12.9c4.1 2.7 9.1 3.7 13.8 3c7.5 1 15.5-1.1 20.8-6.8l57.2-58.6 56.7 58.6c5.4 5.8 13.3 7.8 20.8 6.8c4.6 .8 9.7-.3 13.8-3c4.8-3.2 6.6-8.1 5.5-12.8c1.1-5.5-.7-11.3-4.9-15.8L223 319.8l62.4-63.8z"
  ],
  expand: [
    640,
    512,
    [],
    "e01a",
    "M467.2 105.1c14.1 10.1 17 29.2 6.4 42.7c-9.8 12.4-27.6 15.7-41.4 8.2l-3.4-2.1L320 76.2 211.2 153.9c-13.1 9.3-31.1 7.7-42.2-3.2l-2.6-2.9c-9.8-12.4-8.1-29.7 3.3-40.2l3.1-2.5L320 0 467.2 105.1zM512 224c17.7 0 32 14.3 32 32c0 16.4-12.4 29.9-28.3 31.8L512 288H128c-17.7 0-32-14.3-32-32c0-16.4 12.4-29.9 28.3-31.8l3.7-.2H512zM471 361.3l2.6 2.9c9.8 12.4 8.1 29.7-3.3 40.2l-3.1 2.5L320 512 172.8 406.9c-14.1-10.1-17-29.2-6.4-42.7c9.8-12.4 27.6-15.7 41.4-8.2l3.4 2.1L320 435.8l108.8-77.7c13-9.3 31.1-7.7 42.2 3.2z"
  ],
  "filter-icons": [
    640,
    512,
    [],
    "e026",
    "M576 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l512 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM235.2 271.7L360 370v34c0 8.3-4.7 15.9-12.2 19.7s-16.4 3-23-2.1l-44-33c-5.6-4.1-8.8-10.7-8.8-17.6V316.6l-36.8-45zM485.8 162.9L375.5 297.6l-223.4-175c4.5-3 9.8-4.7 15.3-4.7h297c10.7 0 20.3 6.1 24.8 15.7s3.2 21-3.6 29.2l.1-.1zM99.5 102.3c5.6-7.2 16-8.5 23.2-2.8l407 319c7.1 5.6 8.5 16 2.8 23.2s-16 8.5-23.2 2.8l-407-319c-7.2-5.6-8.5-16-2.8-23.2z"
  ],
  "focus-new-tag": [
    633,
    512,
    [],
    "e037",
    "M208 171.5c-.7-.7-2.1-.7-3.5 0L70.4 222.4 206.6 276l135.5-53.6L208 171.5zM59.8 402.4c0 2.8 1.4 4.9 3.5 5.6l126.4 48V305.7L59.8 254.8V402.4zM223.5 456l125.6-48c2.1-.7 4.2-2.8 4.2-5.6V254.8L223.5 305.7V456zM192.5 139.8c8.5-3.5 19.1-3.5 27.5 0l141.2 53.6c15.5 5.6 26.1 20.5 26.1 37.4V402.4c0 16.9-10.6 31.1-26.1 37.4L220 493.4c-8.5 3.5-18.4 3.5-27.5 0L51.3 439.8c-15.5-6.4-25.4-20.5-25.4-37.4V230.8c0-16.9 9.9-31.8 25.4-37.4l141.2-53.6zM433.4 245l60-24.2 22.1-61.5c1.1-5.5 6.3-8.8 11.6-8.8c4.2 0 9.5 3.3 10.5 8.8l23.2 61.5 59 24.2c5.3 1.1 8.4 6.6 8.4 11c0 5.5-3.2 11-8.4 12.1l-59 23.1-23.2 62.6c-1.1 4.4-6.3 7.7-10.5 7.7c-5.3 0-10.5-3.3-11.6-7.7l-22.1-62.6-60-23.1c-4.2-1.1-7.4-6.6-7.4-12.1c0-4.4 3.2-9.9 7.4-11zM345.7 80.9l51.5-20.7 19-52.7C417 2.8 421.5 0 426 0c3.6 0 8.1 2.8 9 7.5l19.9 52.7 50.6 20.7c4.5 .9 7.2 5.6 7.2 9.4c0 4.7-2.7 9.4-7.2 10.4l-50.6 19.8L435 174.1c-.9 3.8-5.4 6.6-9 6.6c-4.5 0-9-2.8-9.9-6.6l-19-53.6-51.5-19.8c-3.6-.9-6.3-5.6-6.3-10.4c0-3.8 2.7-8.5 6.3-9.4z"
  ],
  "go-to-explor": [
    512,
    512,
    [],
    "e038",
    "M309.6 217.2l-60.2-60.2c-9.4-8.5-23.5-8.5-32 0c-9.4 9.4-9.4 23.5 0 32l21.6 21.6h-96c-13.2 0-22.6 10.4-22.6 22.6c0 13.2 9.4 22.6 22.6 22.6h96l-21.6 21.6c-9.4 9.4-9.4 23.5 0 32c8.5 9.4 22.6 9.4 32 0l60.2-60.2c8.5-8.5 8.5-22.6 0-32zm-289.6 8c0-113.3 91.8-205.1 205.1-205.1s205.1 91.8 205.1 205.1c0 48.7-17 93.5-45.4 128.7L486.5 455.5c8.6 8.6 8.6 22.4 0 31s-22.4 8.6-31 0L353.9 384.8c-35.2 28.4-80 45.4-128.7 45.4c-113.3 0-205.1-91.8-205.1-205.1zM225.2 63.9a161.3 161.3 0 1 0 0 322.6 161.3 161.3 0 1 0 0-322.6z"
  ],
  "info-": [
    640,
    512,
    [],
    "e017",
    "M96 256a224 224 0 1 0 448 0A224 224 0 1 0 96 256zM362.3 130.5c0 27.3-17.6 45.5-44.9 45.5c-20.9 0-35.1-13.6-35.1-34.5c0-27.3 17.6-45.5 44.1-45.5c21.7 0 35.9 13.6 35.9 34.5zm-23.5 229c-4.1 29.3-.9 31 19.5 31h22.4l-6 36.6c-15.5 3.4-49.1 4.9-59.5 4.9c-31.1 0-47-12.8-47-38.9c0-4.2 .4-8.7 1.2-14L289 251.8l-33-5.3 6-38.5h96.3l4 4.9L338.7 359.5z"
  ],
  "info-stroke": [
    640,
    512,
    [],
    "e025",
    "M332.2 96c23.5 0 38.8 13 38.8 32.9c0 26-19 43.3-48.6 43.3c-22.7 0-38-13-38-32.9c0-26 19-43.3 47.7-43.3zM371 207.3L345.6 346.9c-4.5 27.9-1 29.5 21.2 29.5l24.3 0-6.5 34.9c-16.8 3.2-53.2 4.7-64.4 4.7c-33.6 0-50.9-12.2-50.9-37.1c0-4 .4-8.3 1.3-13.3l21.1-121.2-35.7-5 6.5-36.7 104.2 0 4.3 4.7zM320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 320 0a256 256 0 1 0 0 512z"
  ],
  kubernetes: [
    640,
    512,
    [],
    "e004",
    "M603 325.1c2.7-11.2-4.3-22.4-15.6-24.8l-51.4-11c6.5-47.2-5.3-95.1-33.2-134.9l37.4-27.9c9.7-7.2 11.2-21.1 3.4-30.3v0c-7.1-8.4-19.5-9.8-28.4-3.2l-39.6 29.5c-35.6-34.3-83-55.7-133.9-60.5V21.8C341.8 9.8 332 0 320 0V0c-12 0-21.8 9.8-21.8 21.8V62.1c-50.9 4.8-98.3 26.2-133.9 60.5L124.7 93c-8.8-6.6-21.2-5.2-28.4 3.2v0c-7.8 9.2-6.3 23.1 3.4 30.3l37.5 27.9c-28 39.8-39.7 87.7-33.2 134.9l-51.4 11c-11.3 2.4-18.3 13.6-15.6 24.8v0c2.6 10.7 13.3 17.4 24.1 15.1L113.5 329c16.3 45.4 49.3 84 93 109.1l-18.6 36.1c-5.6 10.9-.9 24.4 10.3 29.4v0c10.4 4.7 22.7 .4 27.9-9.8l19.6-38.1c47.9 16.6 100.6 16.6 148.5 0l19.6 38.1c5.2 10.2 17.5 14.4 27.9 9.8v0c11.2-5.1 15.9-18.5 10.3-29.4l-18.6-36.1c43.7-25 76.6-63.7 93-109.1l52.4 11.2c10.8 2.3 21.5-4.4 24.1-15.1v0zM494.2 264.7c0 5.2-.3 10.4-.8 15.5L384.5 256.9c-.5-4.1-1.5-8.2-3-12.1l87-64.9c16.8 25.5 25.7 54.8 25.7 84.7zm-196 0c0-4 1.3-8 3.7-11.3s5.8-6 9.8-7.5s8.4-1.9 12.6-1.2s8.1 2.7 11.2 5.6s5.1 6.5 6 10.4s.4 8-1.2 11.8s-4.4 6.9-8 9.1s-7.8 3.4-12.1 3.4c-5.8 0-11.3-2.1-15.4-6s-6.4-9-6.4-14.4zM441.4 148.1l-87 64.9c-4-2.3-8.2-4.2-12.6-5.6V103.2c37.6 4.4 72.6 20.2 99.7 44.9zM298.2 103.2V207.4c-4.4 1.5-8.6 3.3-12.6 5.6l-87-64.9c27.1-24.7 62.1-40.5 99.7-44.9zM145.7 264.7c0-29.9 8.9-59.2 25.7-84.7l87 64.9c-1.4 3.9-2.4 8-3 12.1L146.6 280.2c-.5-5.2-.8-10.3-.8-15.5zm10.5 55.2l108.4-23.1c2.6 3.9 5.6 7.6 9 10.9l-48.2 93.6c-31.9-19.4-56.2-48-69.2-81.4zM320 427.5c-18.8 0-37.5-2.9-55.3-8.6L313 325.1c2.3 .3 4.6 .6 7 .6c2.3-.1 4.6-.3 6.9-.6L375.3 419c-17.8 5.6-36.5 8.5-55.3 8.6zm94.5-26.3l-48.2-93.6c3.4-3.3 6.5-7 9-10.9l108.4 23.1c-13 33.4-37.3 62-69.2 81.4z"
  ],
  "light-server-slash": [
    640,
    512,
    [],
    "e027",
    "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c7 5.5 8.1 14.7 2.7 22.5c-5.5 7-15.6 8.1-22.5 2.7L6.1 28.6C-.8 23.1-2 13 3.4 6.1zM64 135.4l32 25.3c.4 17.4 14.5 31.3 32 31.3l7.6 0 40.5 32L128 224c-35.3 0-64-28.7-64-64l0-24.6zM64 352c0-35.3 28.7-64 64-64l129.2 0 40.5 32L128 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l331.9 0 40.5 32L128 480c-35.3 0-64-28.7-64-64l0-64zM139.6 32L512 32c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-129.2 0-40.5-32L512 192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L180.1 64 139.6 32zM368 128c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm0 256c0-2.7 .4-5.2 1.2-7.6l35.4 28c-3.7 2.3-8 3.6-12.7 3.6c-13.3 0-24-10.7-24-24zm80-256c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm15.8 160l48.2 0c35.3 0 64 28.7 64 64l0 24.6-32-25.3c-.4-17.4-14.5-31.3-32-31.3l-7.6 0-40.5-32z"
  ],
  "models-excluded": [
    640,
    512,
    [],
    "e02b",
    "M476.5 179.4c0-13.2-6.1-25.4-17.5-32c-10.5-6.6-23.6-6.6-35 0c-10.5 6.6-17.5 18.8-17.5 32c0 14.1 7 26.4 17.5 32.9c11.4 6.6 24.5 6.6 35 0c11.4-6.6 17.5-18.8 17.5-32.9zM111.6 4.7c-9.1-7.6-22.1-5.9-29.2 3.9S77 32.4 86 40L598 470.3c9.1 7.6 22.1 5.9 29.2-3.9s5.5-23.8-3.6-31.4l-140-117.7 6.9-25c6.1-2.8 12.2-6.6 18.4-11.3l22.8 6.6c6.1 1.9 13.1 0 17.5-5.6c13.1-15.1 22.7-32.9 28.9-53.7c1.8-6.6 .9-14.1-4.4-18.8L557 190.7l0-22.6 16.6-17.9c5.2-5.6 6.1-12.2 4.4-19.8c-6.1-19.8-15.8-37.6-28.9-52.7c-4.4-5.6-10.5-7.5-17.5-5.6l-22.8 6.6c-6.1-4.7-12.2-8.5-18.4-11.3l-7-25.4c-1.8-6.6-6.1-12.2-13.1-13.2c-8.7-1.9-18.4-3.8-28.9-3.8c-9.6 0-19.3 1.9-28 3.8c-7 .9-12.2 6.6-14 13.2l-6.1 25.4c-6.1 2.8-12.2 6.6-18.4 11.3l-22.8-6.6c-7-1.9-13.1 0-17.5 5.6c-13.1 15.1-22.7 32.9-28.9 52.7c-1.7 7.5-.9 14.1 4.4 19.8l16.6 17.9c0 1.9-.2 3.8-.4 5.6s-.4 3.8-.4 5.6s.2 3.8 .4 5.6c0 .1 0 .1 0 .2L111.6 4.7zM357.5 211.4c4.4-4.7 6.1-11.3 5.2-16.9c-.9-4.7-1.8-9.4-1.8-15.1c0-4.7 .9-9.4 1.8-14.1c.9-6.6-.9-12.2-5.2-16.9l-14.9-16c2.6-7.5 7-14.1 11.4-20.7l20.1 5.6c6.1 .9 11.4 0 15.8-3.8c7-6.6 15.8-11.3 24.5-15.1c5.3-1.9 8.8-6.6 10.5-12.2l5.3-22.6c2.3 0 4.4-.3 6.3-.5c1.7-.2 3.4-.4 5-.4c2.3 0 4.4 .3 6.3 .5c1.7 .2 3.4 .4 5 .4L459 86.2c1.7 5.6 5.2 10.4 10.5 12.2c8.7 3.8 16.6 8.5 23.6 15.1c4.4 3.8 10.5 4.7 15.7 3.8l21-5.6c4.4 6.6 7.9 13.2 11.4 20.7l-14.9 16c-4.4 4.7-6.1 10.4-5.2 16.9c.9 4.7 1.7 9.4 1.7 14.1c0 5.6-.9 10.4-1.7 15.1c-.9 6.6 .9 12.2 5.2 16.9l14.9 16c-3.5 7.5-7 14.1-11.4 20.7l-21-5.6c-5.2-1.9-11.4 0-15.7 3.8c-7 6.6-14.9 11.3-23.6 15.1c-5.3 1.9-9.6 6.6-10.5 12.2l-5.1 18.8-96.4-81zm-182 171.3c13.1 0 24.5-6.6 30.6-18.8c6.1-11.3 6.1-25.4 0-37.6c-6.1-11.3-17.5-18.8-30.6-18.8c-12.3 0-23.6 7.5-29.8 18.8c-6.1 12.2-6.1 26.4 0 37.6c6.1 12.2 17.5 18.8 29.8 18.8zm140.9-6.6c1.8-9.4 2.6-19.8 2.6-31.1c0-10.4-.9-20.7-2.6-30.1c-.9-7.5-6.1-13.2-12.2-15.1l-23.6-6.6c-2.6-6.6-6.1-13.2-10.5-19.8l6.1-24.5c1.7-7.5 0-14.1-5.3-18.8c-14-14.1-30.6-24.5-49.9-31.1c-6.1-1.9-13.1-.9-17.5 4.7L186 221.8c-1.8 0-3.5-.2-5.2-.5s-3.5-.5-5.2-.5s-3.5 .2-5.3 .5s-3.5 .5-5.2 .5l-16.6-17.9c-5.2-5.6-11.4-7.5-18.4-4.7c-18.4 6.6-35 16.9-49 31.1c-5.2 4.7-7 11.3-5.2 18.8l6.1 24.5c-4.4 6.6-7.9 13.2-10.5 19.8l-23.6 6.6c-6.1 1.9-11.4 7.5-12.2 15.1c-1.8 9.4-3.5 19.8-3.5 30.1c0 10.5 1.5 19.3 3.1 28.8l.4 2.2c.9 6.6 6.1 12.2 12.2 14.1l23.6 7.5c2.6 6.6 6.1 13.2 10.5 18.8L75.8 442c-1.8 6.6 0 14.1 5.2 18.8c14 13.2 30.6 24.5 49 31.1c7 1.9 13.1 0 18.4-4.7L165 469.3l21 0 17.5 17.9c4.4 5.6 11.4 6.6 17.5 4.7c19.2-6.6 35.9-16.9 49.9-31.1c5.3-4.7 7-11.3 5.3-18.8L270 417.6c4.4-6.6 7.9-13.2 10.5-19.8l23.6-7.5c6.1-1.9 11.4-6.6 12.2-14.1zM284 357.3l-21 6.6c-5.2 1.9-9.6 5.6-11.4 11.3c-3.5 9.4-7.9 17.9-14 25.4c-3.5 4.7-5.2 11.3-3.5 16.9l5.2 22.6c-6.1 4.7-12.2 8.5-19.2 12.2l-14.9-16c-4.4-4.7-10.5-6.6-15.7-5.6c-4.4 .9-8.8 1.9-14 1.9c-4.4 0-8.8-.9-13.1-1.9c-6.1-.9-11.4 .9-15.8 5.6l-14.9 16c-7-3.8-13.1-7.5-19.2-12.2l5.2-22.6c.9-5.6 0-12.2-3.5-16.9c-6.1-7.5-10.5-16-14-25.4c-1.7-5.6-6.1-9.4-11.4-11.3l-21-6.6c0-1.8-.2-3.6-.4-5.4c-.2-2.1-.5-4.3-.5-6.8c0-1.9 .2-3.8 .4-5.6s.4-3.8 .4-5.6l21-6.6c5.3-1.9 9.6-5.6 11.4-11.3c3.5-9.4 7.9-17.9 14-26.4c3.5-4.7 4.4-10.4 3.5-16L112.5 251c6.1-4.7 12.2-8.5 19.2-12.2l14.9 16c4.4 4.7 9.6 6.6 15.8 5.6c4.4-.9 8.8-1.9 13.1-1.9c5.2 0 9.6 .9 14 1.9c6.1 .9 11.4-.9 15.7-5.6l14.9-16c7 3.8 13.1 7.5 19.2 12.2l-5.2 22.6c-1.8 5.6 0 11.3 3.5 16c6.1 7.5 10.5 16.9 14 26.4c1.8 5.6 6.1 9.4 11.4 11.3l21 6.6 0 23.5z"
  ],
  monitoring: [
    640,
    512,
    [],
    "e00a",
    "M112 80H528c17.7 0 32 14.3 32 32v80c0 13.3 10.7 24 24 24s24-10.7 24-24V112c0-44.2-35.8-80-80-80H112c-44.2 0-80 35.8-80 80v80c0 13.3 10.7 24 24 24s24-10.7 24-24V112c0-17.7 14.3-32 32-32zM528 432l-416 0c-17.7 0-32-14.3-32-32l0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v56c0 17.7-14.3 32-32 32zM386.5 160.1c8.9 .9 16.5 6.7 19.8 15l26 64.9H576c13.3 0 24 10.7 24 24s-10.7 24-24 24H416c-9.8 0-18.6-6-22.3-15.1l-15.1-37.6-102 140.3c-4.4 6.6-11.7 10.6-19.6 10.7s-15.3-3.6-19.9-10L163.6 288H64c-13.3 0-24-10.7-24-24s10.7-24 24-24H176c7.8 0 15 3.7 19.5 10.1L256 320 364 170.7c4.9-7.4 13.6-11.5 22.5-10.6z"
  ],
  partner: [
    640,
    512,
    [],
    "e008",
    "M282 238.2c38.2-23 62.7-65 62.7-111c0-45-24.5-87-62.7-110c-39.2-23-87.1-23-125.3 0c-39.2 23-62.7 65-62.7 110c0 46 23.5 88 62.7 111c38.2 23 86.2 23 125.3 0zm34.2 73.2c-16.7-5.4-34.4-8.2-52.8-8.2H174.3C77.3 303.2 0 383.3 0 482.2c0 3.6 .7 7.1 1.9 10.3c1.8 4.8 4.9 9.1 8.7 12.3c4.9 4 11.1 6.4 17.8 6.4H409.2c6.7 0 13.1-2.4 18.2-6.4c3.6-2.9 6.6-6.6 8.6-10.8c1.7-3.6 2.6-7.6 2.6-11.8c0-45.9-16.8-87.7-44.5-119.3c-20.7-23.7-47.5-41.6-77.9-51.4zm186 158.4c0 .2 0 .3 0 .5c.2 3.9 .4 7.9 .4 11.8c0 3.6-.1 7.1-.4 10.3c-1.1 11.1-4.8 19.4-16.9 19.4H618.2c1.4 0 2.7-.2 4-.5c9.9-2.3 17.8-12.6 17.8-25c0-7.1-.4-14-1.1-20.8c-7.2-65.7-48.1-118.5-101.1-132.4c-9-2.4-18.3-3.6-27.9-3.6H443.6c-7.2 0-14.3 .7-21.2 2.1c7.5 4.9 14.6 10.4 21.2 16.4c7.8 7 14.9 14.8 21.4 23.1c.1 .2 .2 .3 .4 .5h44.5c5.7 0 11.2 .6 16.6 1.7c27.8 5.9 51.4 26.5 65.1 54.8c6.1 12.6 10.3 26.6 12.1 41.6H502.2zM180.1 58.2c23.5-14 53.8-14 78.3 0c23.5 15 39.2 41 39.2 69c0 29-15.7 55-39.2 70c-24.5 14-54.8 14-78.3 0c-24.5-15-39.2-41-39.2-70c0-28 14.7-54 39.2-69zm209.5 405H48c2.1-14.8 6.6-28.8 13.1-41.6c21.2-41.7 63.8-70.4 113.2-70.4h89.1c49.4 0 92 28.7 113.2 70.4c6.5 12.8 11 26.8 13.1 41.6zM496 105.6a70.4 70.4 0 1 1 0 140.8 70.4 70.4 0 1 1 0-140.8zM496 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
  ],
  purchase: [
    640,
    512,
    [],
    "e035",
    "M410 135c-19 8-42 3-56-13c-22-25-54-42-90-42c-67 0-120 54-120 120v1c0 20-13 38-32 45c-38 13-64 49-64 90c0 53 43 96 96 96H504h3s1 0 2 0c46-2 83-41 83-88c0-36-22-67-53-80c-20-9-32-30-28-52c0-4 1-8 1-12c0-39-33-72-72-72c-11 0-21 3-30 7zM512 480h-8H464 144C64 480 0 416 0 336c0-62 40-116 96-135v-1c0-92 75-168 168-168c50 0 96 23 127 59c15-7 31-11 49-11c66 0 120 54 120 120c0 7-1 13-2 20c48 21 82 69 82 124c0 73-57 132-128 136zM370.6 182l-20-3.8 0-12.2c0-11.7-9.9-22-21.6-22c-12.3 0-21.6 10.3-21.6 22l0 12c-5.9 1-11.4 2.5-17.1 5c-16.4 6.8-32.3 19.9-36.1 41.7c-2.1 11.3-1.1 22.4 3.3 32.4l.1 .1c4.5 9.7 12.1 16.8 19.4 21.6c13.3 8.9 30.8 13.9 44.1 17.3l1.2 .4 .3 .1c16.1 4.5 26.9 7.6 33.5 11.9c1.4 .9 2.2 1.7 2.7 2.3s.8 1.2 1.2 2l.2 .4 .1 .1c0 .1 .1 .4 .1 .8c.1 .9 .1 2.4 0 4.5c-.5 1.9-1.3 3.5-2.5 4.9c-1.2 1.5-3.2 3-6.5 4.4c-7.3 2.9-18.5 4.3-32.8 2c0 0 0 0 0 0c-9.1-1.4-25.1-5.6-34-9.7c-11.7-5.6-23.7 .3-28.8 10.7l-.1 .3c-4.7 10.9 0 24 11.4 28.8c11.8 5.3 28.4 10.3 40.5 12.4l0 11.4c0 12.2 9.4 22 21.6 22c11.5 0 21.6-9.6 21.6-22l0-10.6c5.7-1 11.5-2.5 17.1-4.9c16.7-6.9 31.4-20.6 35.2-41.7l0-.3c1.5-11.3 1.1-22.5-3.9-32.8c-4.5-9.6-12.1-16.8-19.4-21.5c-12.2-8.1-28.1-12.7-40.5-16.3l-3.4-1-1.6-.5-.3-.1c-16-4-26.6-7.1-33.1-11.6c-2.4-1.8-3.5-2.9-3.9-3.5c-.2-.7-.3-1.3-.4-2.1c-.1-1-.1-2.4 .2-4.4c.4-1.8 2.5-5.7 9.9-8.9c8-3 20.1-4.8 33.7-2.6l22.8 4.4c0 0 0 0 .1 0c11.6 2.1 22.9-6.2 25-17.8c2-11.5-5.3-23.3-17.5-25.4z"
  ],
  recommendations: [
    603,
    512,
    [],
    "e003",
    "M176.5 268.9c-34.2-28.2-55.7-69.2-55.7-114.9C120.8 69 195.5 0 287.6 0s166.9 69 166.9 154c0 46.7-22.5 88.6-58.1 116.8V481.3c0 7.4-8.4 11.6-14.3 7.3l-95.6-69.4-95.6 69.4c-6 4.3-14.3 .1-14.3-7.3V268.9zm180.7-25.5v-2.4h3.7c30-20.4 48.4-52.8 48.4-86.9c0-56.8-51-108.8-121.7-108.8S166 97.2 166 154s51 108.8 121.7 108.8c26.5 0 50.3-7.3 69.6-19.5zm0 50.7c-21.2 9-44.7 14-69.6 14c-25.8 0-50.2-5.4-72-15V404.5l70.8-40.7 70.8 40.7V294z"
  ],
  "regular-arrows-split-up-and-left-circle-dollar": [
    640,
    512,
    [],
    "e03b",
    "M0 288c0-6.4 2.5-12.5 7-17l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55L224 264c27 0 51.9 8.9 72 24l0-206.1-55 55 0 .1c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55 0 197.3c-15.3 26.1-24 56.4-24 88.8c0 57.9 28.1 109.3 71.3 141.5C336.9 498.1 296 449.8 296 392l0-8c0-39.8-32.2-72-72-72L81.9 312l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-4.5-4.5-7-10.6-7-17zm352 80c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm88.1-27c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3c.6 .2 1.2 .3 1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.1-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c-.1-2 .3-3 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2z"
  ],
  "regular-bell-gear": [
    640,
    512,
    [],
    "e00e",
    "M224 0c-17.7 0-32 14.3-32 32c0 6 0 11.9 0 17.9C119.5 61.4 64 124.2 64 200c0 11.1 0 22.3 0 33.4c0 45.4-15.5 89.5-43.8 124.9c-5 6.2-9.9 12.5-14.9 18.7c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416c99.6 0 199.2 0 298.8 0c-.3-.8-.5-1.7-.8-2.5c-5.3-17.2 0-34 10.6-45.5c-86.8 0-173.6 0-260.4 0C98.1 328 112 281.3 112 233.4c0-11.1 0-22.3 0-33.4c0-57.4 46.6-104 104-104c2.7 0 5.3 0 8 0s5.3 0 8 0c57.4 0 104 46.6 104 104c0 11.1 0 22.3 0 33.4c0 12 .9 23.9 2.6 35.6c6.8-11.8 15-22.8 24.2-32.8c6.1-6.6 13.5-10.8 21.2-13c0-7.8 0-15.5 0-23.3c0-75.8-55.5-138.6-128-150.1c0-6 0-11.9 0-17.9c0-17.7-14.3-32-32-32zm64 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM463.7 211.7c-6.8 1.5-11.3 7.8-11.3 14.8c0 10.1 0 20.3 0 30.4c-8 3.4-15.6 7.8-22.5 12.9c-8.3-4.8-16.5-9.5-24.8-14.3c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2c8.3 4.8 16.5 9.5 24.8 14.3c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4c-8.3 4.8-16.5 9.5-24.8 14.3c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4c8.2-4.8 16.5-9.5 24.7-14.3c6.9 5.1 14.5 9.4 22.5 12.9c0 10.2 0 20.3 0 30.5c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8c0-10.2 0-20.4 0-30.6c7.9-3.4 15.4-7.7 22.3-12.8c8.3 4.8 16.6 9.5 24.9 14.3c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2c-8.3-4.8-16.7-9.6-25-14.4c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3c8.3-4.8 16.7-9.6 25-14.4c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.6-5.1-12.3-5.9-18.4-2.4c-8.3 4.8-16.6 9.5-24.9 14.3c-6.9-5.1-14.3-9.4-22.3-12.8c0-10.2 0-20.4 0-30.6c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c0 .1 0 0 0 .1zM496.4 312c17.1 0 33 9.1 41.6 24s8.6 33.1 0 48s-24.4 24-41.6 24s-33-9.1-41.6-24s-8.6-33.1 0-48s24.4-24 41.6-24z"
  ],
  "regular-calendar-circle-dollar": [
    640,
    512,
    [],
    "e036",
    "M0 128C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 6.6c-17.2 4.9-33.4 12.3-48 21.8l0-28.5L48 192l0 256c0 8.8 7.2 16 16 16l284.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm88.1-27c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3c.6 .2 1.2 .3 1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.1-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c-.1-2 .3-3 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2z"
  ],
  "regular-calendar-gear": [
    640,
    512,
    [],
    "e00f",
    "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 13.3 0 26.7 0 40c-13.3 0-26.7 0-40 0C28.7 64 0 92.7 0 128c0 5.3 0 10.7 0 16c0 16 0 32 0 48c0 85.4 0 170.7 0 256c0 35.3 28.7 64 64 64c106.7 0 213.3 0 320 0c13.6 0 26.2-4.2 36.5-11.5c-.4-2.5-.5-5.1-.5-7.7c-17.6 9.7-41.5 8.1-57.2-8.8c-5.8-6.3-11.2-13-16.1-20c-94.2 0-188.5 0-282.7 0c-8.8 0-16-7.2-16-16c0-85.4 0-170.7 0-256c117.4 0 234.7 0 352 0c0 9.9 0 19.8 0 29.6c7 .5 13.9 2.5 20 5.9c0-19.1 10.9-36.6 28-44.2c0-13.1 0-26.2 0-39.3c0-5.3 0-10.7 0-16c0-35.3-28.7-64-64-64c-13.3 0-26.7 0-40 0c0-13.3 0-26.7 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 13.3 0 26.7 0 40c-48 0-96 0-144 0c0-13.3 0-26.7 0-40zM463.7 211.7c-6.8 1.5-11.3 7.8-11.3 14.8c0 10.1 0 20.3 0 30.4c-8 3.4-15.6 7.8-22.5 12.9c-8.3-4.8-16.5-9.5-24.8-14.3c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2c8.3 4.8 16.5 9.5 24.8 14.3c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4c-8.3 4.8-16.5 9.5-24.8 14.3c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4c8.2-4.8 16.5-9.5 24.7-14.3c6.9 5.1 14.5 9.4 22.5 12.9c0 10.2 0 20.3 0 30.5c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8c0-10.2 0-20.4 0-30.6c7.9-3.4 15.4-7.7 22.3-12.8c8.3 4.8 16.6 9.5 24.9 14.3c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2c-8.3-4.8-16.7-9.6-25-14.4c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3c8.3-4.8 16.7-9.6 25-14.4c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.6-5.1-12.3-5.9-18.4-2.4c-8.3 4.8-16.6 9.5-24.9 14.3c-6.9-5.1-14.3-9.4-22.3-12.8c0-10.2 0-20.4 0-30.6c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c0 .1 0 0 0 .1zM496.4 312c17.1 0 33 9.1 41.6 24s8.6 33.1 0 48s-24.4 24-41.6 24s-33-9.1-41.6-24s-8.6-33.1 0-48s24.4-24 41.6-24z"
  ],
  "regular-calendar-tag": [
    640,
    512,
    [],
    "e03f",
    "M0 128C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-48 0-16.5 0L48 192l0 256c0 8.8 7.2 16 16 16l320 0c6.2 0 11.6-3.6 14.2-8.7l34.3 34.4C420.8 503.3 403.4 512 384 512L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16zM359 262.6c0-17.6 14.3-32 32-32l82.7 0c17 0 33.3 6.7 45.3 18.7L626.3 356.7c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.3c-18.7 18.7-49.1 18.7-67.9 0L377.7 390.6c-12-12-18.7-28.3-18.7-45.2l0-82.8zm56 48c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z"
  ],
  "regular-clipboard-check-slash": [
    640,
    512,
    [],
    "e022",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L143 86.8C154.8 72.9 172.4 64 192 64l40 0 9.6 0C249 27.5 281.3 0 320 0s71 27.5 78.4 64l9.6 0 40 0c35.3 0 64 28.7 64 64l0 248 118.8 93.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM128 196.9l48 37.8L176 448c0 8.8 7.2 16 16 16l256 0c4.8 0 9.1-2.1 12.1-5.5l37.7 29.7C486 502.7 468.1 512 448 512l-256 0c-35.3 0-64-28.7-64-64l0-251.1zm52.9-80.4l27.1 21.3c0-.6-.1-1.2-.1-1.8l0-24-16 0c-4.3 0-8.2 1.7-11.1 4.5zM223.1 287c3.2-3.2 7.1-5.4 11.2-6.4l94.8 74.7-18.9 18.9c-9.3 9.4-24.5 9.4-33.9 0l-53.3-53.3c-9.4-9.3-9.3-24.5 0-33.9zm13.3-127L360 256.8l23.1-23.1c9.3-9.4 24.5-9.3 33.9 0s9.4 24.5 0 33.9l-19 19 66 51.8L464 128c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-83.6 0zM296 80c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z"
  ],
  "regular-clipboard-user-slash": [
    640,
    512,
    [],
    "e02a",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L143 86.8C154.8 72.9 172.4 64 192 64l40 0 9.6 0C249 27.5 281.3 0 320 0s71 27.5 78.4 64l9.6 0 40 0c35.3 0 64 28.7 64 64l0 248 118.8 93.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM128 196.9l48 37.8L176 448c0 8.8 7.2 16 16 16l16 0c0-44.2 35.8-80 80-80l64 0c5.3 0 10.4 .5 15.4 1.5l57.3 45.2c4.7 10.2 7.3 21.4 7.3 33.4l16 0c4.8 0 9.1-2.1 12.1-5.5l37.7 29.7C486 502.7 468.1 512 448 512l-256 0c-35.3 0-64-28.7-64-64l0-251.1zm52.9-80.4l27.1 21.3c0-.6-.1-1.2-.1-1.8l0-24-16 0c-4.3 0-8.2 1.7-11.1 4.5zM236.4 160l81.7 64c11.7-.3 23.4 2.5 33.9 8.5c15.8 9.1 26.8 24.5 30.6 42L464 338.4 464 128c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-83.6 0zm20.4 138.4l67.9 53.5c-12.6 .9-25.4-1.9-36.7-8.4c-16.8-9.7-28.1-26.3-31.2-45.1zM296 80c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z"
  ],
  "regular-cloud-circle-dollar": [
    640,
    512,
    [],
    "e034",
    "M0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 1.3 0 2.7-.1 4c-15.2-5.9-31.4-9.8-48.3-11.3c-3.6-36.4-34.3-64.8-71.6-64.8c-10.5 0-20.4 2.2-29.2 6.2l0 .1c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l188 0c6.9 17.5 16.5 33.7 28.3 48L144 480C64.5 480 0 415.5 0 336zm352 32c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm88.1-27c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3c.6 .2 1.2 .3 1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.1-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c-.1-2 .3-3 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2z"
  ],
  "regular-cube-magnifying-glass": [
    640,
    512,
    [],
    "e024",
    "M0 134.1C0 110.8 14.4 90 36.1 81.7l200-75.9 0 .1C248.9 1 263 1 275.8 5.9l200 75.9c21.8 8.2 36.2 29 36.2 52.3l0 39.2c-19.6-8.6-41.2-13.3-64-13.3c-52.8 0-99.6 25.6-128.8 65L280 240.4l0 212.8 54.3-20.6c13.7 13.8 29.9 25.2 47.8 33.3L275.9 506.2c-12.8 4.9-26.9 4.9-39.7 0l-200-75.9C14.4 422 0 401.2 0 377.9L0 134.1zm48 34l0 209.8c0 3.3 2.1 6.3 5.2 7.5L232 453.2l0-212.8L48 168.1zm15.6-45.5L256 198.2l192.4-75.6L258.8 50.7c-1.8-.7-3.8-.7-5.7 0L63.6 122.6zM320 320c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L520 425.8l-.1 .1C499.4 439.8 474.7 448 448 448c-70.7 0-128-57.3-128-128zm48 0c0 28.6 15.2 55 40 69.3s55.2 14.3 80 0s40-40.7 40-69.3s-15.2-55-40-69.3s-55.2-14.3-80 0s-40 40.7-40 69.3z"
  ],
  "regular-cubes-gear": [
    640,
    512,
    [],
    "e03e",
    "M0 294.7c0-23.3 14.4-44.1 36.1-52.4L128 207.5 128 93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1C433.1 48.2 448 69.3 448 93l0 104.3c-14.6 6.9-25.7 19.8-30.1 35.7c-23.7-6.1-49.6 4-62.5 26.2L344.5 278l-4.4 1.6 2.9 1.1-11.6 20.1c-4.4 7.6-6.8 15.7-7.4 23.9l-12-4.6 0 98.6c4.9 2 9.8 4.1 14.7 6.1c1.2 3.6 2.7 7 4.7 10.4l24 41.6c5 8.7 12 15.5 20.1 20.2L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5L33.5 465.1C13.1 456.2 0 436.1 0 413.9L0 294.7zm48 28.5l0 90.7c0 3.2 1.9 6 4.8 7.3L128 454.3l0-100.4L48 323.2zm22.8-42.6L152 311.7l83.9-32.1L155 250.7c-1.8-.6-3.7-.6-5.5 .1L70.8 280.6zM176 118l0 89.3c29.3 10.4 58.7 20.8 88 31.3l0-86.9L176 118zm0 235.9l0 101.3 88-36.4 0-98.6-88 33.7zM204.1 77.3L288 109.5l83.9-32.1-81.2-29 0-.1c-1.7-.6-3.6-.6-5.4 0l-81.2 29zM312 151.6l0 86.9c29.3-10.4 58.7-20.8 88-31.3l0-89.3-88 33.7zm51.2 165.2l24-41.6c6.6-11.5 21.3-15.4 32.8-8.8l8 4.6c4.9 2.8 10.9 2.5 15.8-.3s8.2-7.9 8.2-13.5l0-9.2c0-13.3 10.7-24 24-24l.1-.2 48 0c13.3 0 24 10.7 24 24l0 9.4c0 5.6 3.3 10.6 8.1 13.4c4.9 2.8 10.8 3.1 15.7 .3l8.2-4.7c11.5-6.6 26.2-2.7 32.8 8.8l24 41.6c6.6 11.5 2.7 26.2-8.8 32.8l-8.9 5.1c-4.6 2.6-7.2 7.7-7.2 13c0 5.7 2.7 11.1 7.6 13.9l8.4 4.9c11.5 6.6 15.4 21.3 8.8 32.8l-24 41.6c-6.6 11.5-21.3 15.4-32.8 8.8l-8.9-5.1c-4.7-2.7-10.5-2.4-15.2 .3s-7.9 7.6-7.9 13l0 10.3c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-10c0-5.5-3.2-10.4-7.9-13.1c-4.8-2.7-10.6-3-15.3-.3l-8.7 5c-11.5 6.6-26.2 2.7-32.8-8.8l-24-41.6c-6.6-11.5-2.7-26.1 8.7-32.8l8-4.6c5-2.9 7.8-8.4 7.8-14.1c0-5.4-2.6-10.5-7.3-13.2l-8.5-4.9c-11.5-6.6-15.4-21.3-8.8-32.8zM389.9 503c9.1 2.4 18.8 2.5 28.1 0c.9 3.1 2 6.1 3.3 9l.1 0 8.1 0c-9.2 1-18.6-.3-27.3-3.9L389.9 503zm68.5-159.3c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z"
  ],
  "regular-envelope-circle-xmark": [
    640,
    512,
    [],
    "e010",
    "M64 112c-8.8 0-16 7.2-16 16c0 7.4 0 14.7 0 22.1c57.5 47.2 115 94.4 172.5 141.6c20.7 17 50.4 17 71.1 0c57.5-47.2 114.9-94.4 172.4-141.6c0-7.4 0-14.7 0-22.1c0-8.8-7.2-16-16-16c-128 0-256 0-384 0zM48 212.2L48 384c0 8.8 7.2 16 16 16c86.3 0 172.6 0 258.9 0c3.1 17 8.7 33.1 16.3 48c-91.8 0-183.5 0-275.2 0c-35.3 0-64-28.7-64-64c0-85.4 0-170.7 0-256C0 92.7 28.7 64 64 64c128 0 256 0 384 0c35.3 0 64 28.7 64 64c0 21.6 0 43.1 0 64.7c-5.3-.5-10.6-.7-16-.7c-82.9 0-152.3 57.3-171 134.4c-1 .8-2 1.6-3 2.4c-38.4 31.5-93.7 31.5-132 0c-47.3-38.9-94.7-77.7-142-116.6zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM532.7 308.7L496 345.4c-12.2-12.2-24.5-24.5-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6c12.2 12.2 24.5 24.5 36.7 36.7l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.2-12.2 24.5-24.5 36.7-36.7c12.2 12.2 24.5 24.5 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12.2-12.2-24.5-24.5-36.7-36.7c12.2-12.2 24.5-24.5 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
  ],
  "regular-eye-circle-check": [
    640,
    512,
    [],
    "e021",
    "M2.5 243.7C17.3 208 48.6 156 95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c30.3 28.2 54.1 59.9 71.2 88.5c-17.5-5.9-36.3-9.1-55.8-9.1c-2.7 0-5.4 .1-8 .2c-11.4-15.1-24.8-30.3-40-44.5C406.8 109.6 353.2 80 288 80s-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256C63 286 89.6 328.5 128 364.3c41.2 38.1 94.8 67.7 160 67.7c14.7 0 28.9-1.5 42.4-4.3c5.7 15.8 13.6 30.5 23.3 43.9C333.2 477 311.3 480 288 480c-80.8 0-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6zM177.1 192c22.9-39.6 65.1-64 110.9-64s88 24.4 110.9 64c4.2 7.3 7.7 15 10.4 22.9c-15.5 8.8-29.5 19.9-41.6 32.8C363.4 207.4 329.4 176 288 176c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80c13.3 0 25.8-3.2 36.8-8.9c-3.1 13.1-4.8 26.8-4.8 40.9c0 4 .1 7.9 .4 11.8c-10.4 2.7-21.3 4.2-32.4 4.2c-45.7 0-88-24.4-110.9-64s-22.9-88.4 0-128zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6c13.3 13.3 26.7 26.7 40 40c6.2 6.2 16.4 6.2 22.6 0c24-24 48-48 72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-20.2 20.2-40.5 40.5-60.7 60.7c-9.6-9.6-19.1-19.1-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"
  ],
  "regular-list-tree-slash": [
    640,
    512,
    [],
    "e029",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L93.5 48 136 48c13.3 0 24 10.7 24 24l0 28.1L352.5 251c2.3-10.9 11.9-19 23.5-19l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-162.5 0L532.4 392l19.6 0c13.3 0 24 10.7 24 24c0 3.1-.6 6.1-1.7 8.8l56.5 44.3c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM88 165.3l48 37.8 0 28.8 36.6 0L264 304l-48 0c-13.3 0-24-10.7-24-24l-56 0 0 104c0 4.4 3.6 8 8 8l48 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l-48 0c-30.9 0-56-25.1-56-56l0-128 0-90.7zM224 96c0-13.3 10.7-24 24-24l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24zM352 416c0-13.2 10.5-23.8 23.7-24l60.9 48L376 440c-13.3 0-24-10.7-24-24z"
  ],
  "regular-money-bill-1-wave-circle-arrow-right": [
    640,
    512,
    [],
    "e032",
    "M0 113C0 88.8 25.4 72.7 48.4 79c79.8 22 159.7 1.6 239.6-18.7c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5l0 120.7c-14.9-7.6-31-13.2-48-16.3l0-50.9c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192l0 176c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24c4.5-1.1 9-2.3 13.5-3.4c13.8-3.5 28-7.2 42.7-10.6c2.4 16.2 7 31.7 13.5 46.1c-15.8 3.7-31.6 7.7-47.4 11.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5L0 113zM192 256c0-61.9 43-112 96-112c46.5 0 85.3 38.6 94.1 89.8c-36.5 31-60.2 76.6-62 127.8c-10 4.2-20.9 6.4-32.1 6.4c-53 0-96-50.1-96-112zm56 48c0 8.8 7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16zm104 64c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16z"
  ],
  "regular-star-slash": [
    640,
    512,
    [],
    "e01f",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1C102.4 55 166.1 104.9 229.7 154.7c22.9-47.1 45.7-94.2 68.6-141.2C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5c22.9 47.1 45.7 94.2 68.6 141.3c51.1 7.5 102.1 15.1 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5c-37 36.7-74.1 73.5-111.1 110.2c.7 4.3 1.5 8.6 2.2 12.9c54.3 42.6 108.7 85.2 163 127.8c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1C403.8 352.2 206.5 197.6 9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM57.2 193.7c2.8-8.6 10.3-14.9 19.3-16.3c7.5-1.1 15.1-2.2 22.6-3.3c17.3 13.6 34.6 27.3 51.9 40.9c-6.7 1-13.3 2-20 2.9c28.6 28.4 57.3 56.7 85.9 85.1c5.5 5.5 8.1 13.3 6.8 21c-6.8 39.9-13.5 79.8-20.3 119.7c35.1-18.7 70.1-37.5 105.2-56.2c7.1-3.8 15.6-3.8 22.6 0c35.1 18.7 70.1 37.5 105.2 56.2c-.3-1.5-.5-3-.8-4.5c18.7 14.7 37.4 29.4 56.1 44.2c0 .2 .1 .4 .1 .6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7c-45.7-24.4-91.3-48.8-137-73.2c-45.6 24.4-91.3 48.7-136.9 73.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5c8.7-51.9 17.5-103.7 26.2-155.6c-37-36.7-74.1-73.4-111.1-110.1c-6.5-6.4-8.7-15.9-5.9-24.5zm211.2-8.6L421.3 304.9c.5-.6 1.1-1.2 1.7-1.8c28.6-28.4 57.3-56.7 85.9-85.1c-39.4-5.8-78.9-11.7-118.3-17.5c-7.8-1.2-14.6-6.1-18.1-13.3C355 151.1 337.4 115.1 319.9 79c-17.2 35.4-34.3 70.7-51.5 106.1z"
  ],
  "regular-user-secret-circle-check": [
    640,
    512,
    [],
    "e01d",
    "M0 482.3c0-58.5 28.2-110.5 71.8-143C58.9 307 45.9 274.7 33 242.4c-.7-1.6-1-3.3-1-5C32 230 38 224 45.4 224c16.2 0 32.4 0 48.6 0c-3.9-12.6-6-26.1-6-40c0-7.4 .6-14.6 1.7-21.7C54.1 153.6 32 141.4 32 128c0-15.8 30.7-29.9 78-38.6C124 43.7 145.5 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.7-2.8 15.5-6.1C246.1 5.4 254 0 272 0c30.5 0 52 43.7 66 89.4c47.3 8.7 78 22.8 78 38.6c0 13.4-22.1 25.6-57.7 34.3c1.1 7.1 1.7 14.3 1.7 21.7c0 13.9-2.1 27.4-6 40c13.6 0 27.2 0 40.8 0c-18.3 12.9-34.1 29.2-46.3 48c-6.9 0-13.8 0-20.8 0c-16.9 19.9-39.5 34.9-65.2 42.5c-5.2 8.7-10.5 17.5-15.7 26.2c-4.4 7.3-5.7 16-3.6 24.2c8.3 33 16.5 66.1 24.8 99.1c26.8 0 53.7 0 80.5 0c12.3 18.8 28 35.1 46.3 48c-38.3 0-76.5 0-114.8 0c-37.3 0-74.7 0-112 0c-46.1 0-92.2 0-138.3 0C13.3 512 0 498.7 0 482.3zM49.3 464c43.6 0 87.1 0 130.7 0c8.3-33 16.5-66.1 24.8-99.1c2.1-8.2 .8-16.9-3.6-24.2c-5.2-8.7-10.5-17.5-15.7-26.2c-25.7-7.6-48.3-22.6-65.2-42.5c-7.9 0-15.9 0-23.8 0c6.6 16.5 13.3 33 19.9 49.5c8 20.2 1.5 43.3-15.9 56.3c-27.3 20.4-46.3 51-51.2 86.2zm91.8-250.4c12.2 34 44.7 58.4 82.9 58.4s70.7-24.4 82.9-58.4c-7.1 6.5-16.5 10.4-26.9 10.4c-4.2 0-8.3 0-12.5 0c-16.4 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.8 26.2-36.3 26.2c-4.1 0-8.3 0-12.4 0c-10.4 0-19.8-3.9-26.9-10.4zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6c13.3 13.3 26.7 26.7 40 40c6.2 6.2 16.4 6.2 22.6 0c24-24 48-48 72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-20.2 20.2-40.5 40.5-60.7 60.7c-9.6-9.6-19.1-19.1-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"
  ],
  "solid-bars-filter-circle-xmark": [
    640,
    512,
    [],
    "e030",
    "M0 96c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96zM64 256c0 17.7 14.3 32 32 32l243.2 0c9.8-19.2 23-36.3 38.9-50.6c-5.8-8.1-15.3-13.4-26-13.4L96 224c-17.7 0-32 14.3-32 32zm96 160c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm192-48c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144zm84.7-59.3c6.2-6.2 16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
  ],
  "solid-bars-filter-slash": [
    640,
    512,
    [],
    "e033",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l77.8 61C120.1 64.7 124 64 128 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-316.4 0 122.5 96L448 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48.3 0L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM160 256c0-10 4.5-18.9 11.7-24.7l72 56.7L192 288c-17.7 0-32-14.3-32-32zm96 160c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32z"
  ],
  "solid-calculator-gear": [
    576,
    512,
    [],
    "e040",
    "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 133.3c-14.6 6.9-25.7 19.8-30.1 35.7c-12.2-3.1-24.9-2-36.2 2.9c1.5-3.7 2.3-7.7 2.3-11.9c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c2 0 3.9-.2 5.8-.5c-.8 1.2-1.6 2.4-2.4 3.7L272.5 292c-9.8 5.5-16.5 15.9-16.5 28c0 5.9 1.6 11.4 4.4 16.1c1.6 11.9 6.9 23.1 15.5 31.9c-8.6 8.8-14 20-15.5 31.9c-2.8 4.7-4.4 10.2-4.4 16.1c0 12 6.6 22.5 16.5 28l18.9 32.8c12.6 21.6 37.3 31.8 60.4 26.7c-9.4 5.4-20.2 8.5-31.8 8.5L64 512c-35.3 0-64-28.7-64-64L0 64zM64 96l0 32c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zm0 128c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm96-192c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm139.2-3.2l24-41.6c6.6-11.5 21.3-15.4 32.8-8.8l8 4.6c4.9 2.8 10.9 2.5 15.8-.3s8.2-7.9 8.2-13.5l0-9.2c0-13.3 10.7-24 24-24l.1-.2 48 0c13.3 0 24 10.7 24 24l0 9.4c0 5.6 3.3 10.6 8.1 13.4c4.9 2.8 10.8 3.1 15.7 .3l8.2-4.7c11.5-6.6 26.2-2.7 32.8 8.8l24 41.6c6.6 11.5 2.7 26.2-8.8 32.8l-8.9 5.1c-4.6 2.6-7.2 7.7-7.2 13c0 5.7 2.7 11.1 7.6 13.9l8.4 4.9c11.5 6.6 15.4 21.3 8.8 32.8l-24 41.6c-6.6 11.5-21.3 15.4-32.8 8.8l-8.9-5.1c-4.7-2.7-10.5-2.4-15.2 .3s-7.9 7.6-7.9 13l0 10.3c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-10c0-5.5-3.2-10.4-7.9-13.1c-4.8-2.7-10.6-3-15.3-.3l-8.7 5c-11.5 6.6-26.2 2.7-32.8-8.8l-24-41.6c-6.6-11.5-2.7-26.1 8.7-32.8l8-4.6c5-2.9 7.8-8.4 7.8-14.1c0-5.4-2.6-10.5-7.3-13.2l-8.5-4.9c-11.5-6.6-15.4-21.3-8.8-32.8zm95.2 26.9c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z"
  ],
  "solid-earth-americas-slash": [
    640,
    512,
    [],
    "e02f",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l95.4 74.8c16.7-17.7 36.1-33.1 57.8-45.6c79.2-45.7 176.8-45.7 256 0S576 164.5 576 256c0 49.9-14.5 97.7-40.6 138.3l95.4 74.8c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM64 256c0-33.1 6.4-65.3 18.3-95.1L122 192.1c-.1 .3-.2 .6-.3 .9l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8l19.8 5.6L256 297.7l0 36.4c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c1.9-7.5 5-14.5 9.3-20.7l105.4 83c-6.5 4.6-13.2 8.9-20.1 12.9c-79.2 45.7-176.8 45.7-256 0S64 347.5 64 256zM172.2 109.6l98.1 76.9c4.2-.6 8.6-.2 12.6 1.2l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3c-57.7 0-110 23.6-147.7 61.6zM358.9 256l56.5 44.3c-1.6-9.9-6.3-19.1-13.5-26.3l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1l-5.2 0zm98.6-51.4l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5l.1 0c0-36.8-9.6-71.4-26.4-101.5L476 164.8c-15.7 6.3-23.8 23.8-18.5 39.8z"
  ],
  "solid-hashtag-slash": [
    640,
    512,
    [],
    "e028",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L195.6 128l33.3 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3l.1 0c17.4 2.9 29.2 19.4 26.3 36.8L293.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L453.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L424 307l16.6 13 39.4 0c17.7 0 32 14.3 32 32c0 7.1-2.3 13.7-6.3 19.1l125.1 98c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM96 352c0-17.7 14.3-32 32-32l68.9 0L207 259.1l57.4 45.2L261.8 320l22.5 0 121.5 95.7-6.2 37.6c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.2 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.7-58.9L128 384c-17.7 0-32-14.3-32-32zM282.4 196.1L366.6 262l11.6-70-95.1 0-.7 4.1z"
  ],
  "solid-tag-circle-check": [
    640,
    512,
    [],
    "e03c",
    "M0 80C0 53.5 21.5 32 48 32l149.4 .1c17 0 33.3 6.7 45.3 18.7L407.6 215.7C355.2 246.2 320 303 320 368c0 14.7 1.8 29.1 5.2 42.8l-40 40c-25 25-65.5 25-90.5 0l-176-176C6.7 262.8 0 246.5 0 229.5L0 80zm80 64c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"
  ],
  "solid-tag-circle-minus": [
    640,
    512,
    [],
    "e03d",
    "M0 80C0 53.5 21.5 32 48 32l149.4 .1c17 0 33.3 6.7 45.3 18.7L407.6 215.7C355.2 246.2 320 303 320 368c0 14.7 1.8 29.1 5.2 42.8l-40 40c-25 25-65.5 25-90.5 0l-176-176C6.7 262.8 0 246.5 0 229.5L0 80zm80 64c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z"
  ],
  "solid-tag-circle-plus": [
    640,
    512,
    [],
    "e03a",
    "M0 80C0 53.5 21.5 32 48 32l149.4 .1c17 0 33.3 6.7 45.3 18.7L407.6 215.7C355.2 246.2 320 303 320 368c0 14.7 1.8 29.1 5.2 42.8l-40 40c-25 25-65.5 25-90.5 0l-176-176C6.7 262.8 0 246.5 0 229.5L0 80zm80 64c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z"
  ],
  "solid-user-check-slash": [
    640,
    512,
    [],
    "e023",
    "M0 482.3C0 383.8 79.8 304 178.3 304l85.7 0L444.3 446.1c2.4 11.7 3.7 23.8 3.7 36.2c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l74.6 58.5c11-19 26.9-35.1 46.6-46.4c39.6-22.9 88.4-22.9 128 0S352 82.3 352 128c0 35.1-14.4 68.2-39 92L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM107.3 180.5l93 73.3c-14-2.6-27.6-7.6-40.3-14.9c-23.7-13.7-41.9-34.2-52.7-58.3zm291.8 26.6c9.4-9.3 24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l.1 .1L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9z"
  ],
  "solid-user-secret-slash": [
    640,
    512,
    [],
    "e001",
    "M320 16c-6.7 0-10.8-2.8-15.5-6.1C297.9 5.4 290 0 272 0c-30.5 0-52 43.7-66 89.4c-17.4 3.2-32.6 7.1-44.8 11.6c-40.8-32-81.6-64-122.4-95.9C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9c197.3 154.7 394.6 309.3 592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7c-42.3-33.2-84.6-66.3-126.9-99.5c-9.3-11.4-19.9-21.6-31.6-30.3c12.9-32.3 25.8-64.6 38.7-96.9c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4c-20 0-39.9 0-59.9 0c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C487 155.1 512 142.3 512 128c0-15.8-30.7-29.9-78-38.6C420 43.7 398.5 0 368 0c-18 0-25.9 5.4-32.5 9.9c-4.7 3.3-8.8 6.1-15.5 6.1zm0 160c35 0 67.8-2.3 96-6.4c0 4.8 0 9.6 0 14.4c0 22.1-17.9 40-40 40c-4.1 0-8.3 0-12.4 0c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-1.9 5.7-5.1 10.8-9.2 14.9c-16.9-13.2-33.7-26.4-50.6-39.6c20.8 1.9 43.4 3 66.9 3zm96 112l-2.7 10.7c-2.4-1.9-4.8-3.8-7.3-5.7c3.3-1.7 6.6-3.3 9.9-5zM141.4 224c-7.4 0-13.4 6-13.4 13.4c0 1.7 .3 3.4 1 5c12.9 32.3 25.9 64.6 38.8 96.9C124.2 371.8 96 423.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7c129.6 0 259.1 0 388.6 0c3.9 0 7.6-.7 11-2.1c-45.9-36.2-91.8-72.3-137.7-108.5c-6.5 26.2-13.1 52.4-19.6 78.6c-9.8-39.1-19.5-78.1-29.3-117.1c-16.1-12.7-32.2-25.4-48.3-38.1c4.5 9.1 9.1 18.1 13.6 27.2c-10.7 42.7-21.3 85.3-32 128c-16-64-32-128-48-192c18 9 35.9 18 53.9 26.9c-38.5-30.3-77-60.6-115.4-90.9c-7 0-14 0-21.1 0z"
  ],
  "tag-excluded": [
    640,
    512,
    [],
    "e02c",
    "M398.3 154.4c-16.1 0-30.3 14.2-30.3 30.3c0 17 14.2 30.3 30.3 30.3c17 0 30.3-13.2 30.3-30.3c0-16.1-13.2-30.3-30.3-30.3zM68.3 4.8C58.5-2.9 44.4-1.1 36.8 8.6s-5.9 23.9 3.9 31.6L594.2 472.6c9.8 7.6 23.9 5.9 31.6-3.9s5.9-23.9-3.9-31.6L474 321.7l13.2-13.2c11.4-11.4 17-26.5 17-42.6l0-141.9c0-24.6-19.9-45.4-45.4-45.4l-140.9 0c-16.1 0-31.2 6.6-42.6 18l-39.2 39.2L68.3 4.8zM272.2 164.1l35.2-35.2c2.8-2.8 6.6-4.7 10.4-4.7l140.9 0 0 141.9c0 3.8-.9 7.6-3.8 10.4l-17.1 17.1L272.2 164.1zM108.8 263.2l77.3-77.3L222.3 214 141 295.3c-6.6 5.7-6.6 16.1 0 21.8L266.8 442.9c5.7 5.7 16.1 5.7 21.8 0L388 343.5l36.1 28.2L320.7 475.1c-23.6 23.7-62.4 23.7-86.1 0L108.8 349.3c-23.6-23.7-23.6-62.4 0-86.1z"
  ],
  "thumb-down": [
    640,
    512,
    [],
    "e014",
    "M512 64c17.7 0 32 14.3 32 32V281.6c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM96 277.6c-.1-22.7-.1-36.3 0-40.8L161 89.4c6.7-15 22.6-25.4 41.1-25.4H403.3c24.6 0 44.7 18.7 44.7 41.6v208c0 11.4-4.9 21.8-13.2 29.3L310.3 459c-12.6 11.8-32.5 11.8-45.1 .1l-1.1-1c-6-5.6-9.8-13.5-9.8-22l.7-6.7 26.9-110.2h-141c-24.6 0-44.7-18.7-44.7-41.6z"
  ],
  "thumb-up": [
    640,
    512,
    [],
    "e013",
    "M128 416c0 17.7 14.3 32 32 32v0c17.7 0 32-14.3 32-32V230.4c0-17.7-14.3-32-32-32v0c-17.7 0-32 14.3-32 32V416zM567.6 234.4c0-22.9-19.6-41.6-43.6-41.6H386.3L412.5 82.5l.7-6.7c0-8.5-3.7-16.4-9.6-22l-1-1c-12.4-11.7-31.8-11.6-44.1 .1L236.9 169.1c-8.1 7.5-12.9 17.9-12.9 29.3v208c0 22.9 19.6 41.6 43.6 41.6H464c18.1 0 33.6-10.4 40.1-25.4l63.5-147.5c.1-6.8 0-40.8 0-40.8z"
  ],
  views: [
    640,
    512,
    [],
    "e018",
    "M120 0h80c13 0 24 11 24 24c0 14-11 24-24 24H120c-5 0-8 4-8 8v80c0 14-11 24-24 24c-14 0-24-10-24-24V56C64 26 89 0 120 0zM440 0h80c30 0 56 26 56 56v80c0 14-11 24-24 24c-14 0-24-10-24-24V56c0-4-4-8-8-8H440c-14 0-24-10-24-24c0-13 10-24 24-24zM112 376v80c0 5 3 8 8 8h80c13 0 24 11 24 24c0 14-11 24-24 24H120c-31 0-56-25-56-56V376c0-13 10-24 24-24c13 0 24 11 24 24zm464 0v80c0 31-26 56-56 56H440c-14 0-24-10-24-24c0-13 10-24 24-24h80c4 0 8-3 8-8V376c0-13 10-24 24-24c13 0 24 11 24 24zM323.5 128c54.3 0 98.4 22.5 130.2 49.2c31.9 26.1 52.9 57.7 63.1 79.5c2 4.9 2 10.3 0 15.2c-10.2 21.2-31.2 52.8-63.1 79.5s-76 48.6-130.2 48.6c-54.9 0-99-21.9-130.9-48.6s-52.9-58.3-63.1-79.5c-2-4.9-2-10.3 0-15.2c10.2-21.9 31.2-53.4 63.1-79.5c31.9-26.7 76-49.2 130.9-49.2zM225.9 264c0 31.6 18.3 60.1 48.8 75.9c29.8 15.8 67.2 15.8 97.7 0c29.8-15.8 48.8-44.3 48.8-75.9c0-31-19-59.5-48.8-75.3c-30.5-15.8-67.8-15.8-97.7 0c-30.5 15.8-48.8 44.3-48.8 75.3zm97.7-38.9c0-4.2-1.4-7.9-2.7-12.1c-1.4-3 1.4-7.3 5.4-7.3c27.1 1.2 52.2 18.2 59.7 43.7c9.5 31-10.9 62.5-46.1 71c-34.6 8.5-70.6-10.3-79.4-41.3c-1.4-4.2-2-8.5-2-12.1c-.7-3.6 4.1-6.1 7.5-4.9c4.7 1.2 8.8 1.8 14.2 1.8c23.7 0 43.4-17 43.4-38.9z"
  ],
  "solid-thumbtack-slash": [
    640,
    512,
    [],
    "e044",
    "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L215.4 143.5 221.5 64 192 64c-17.7 0-32-14.3-32-32s14.3-32 32-32L448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8c-5.7 7.9-14.9 12.9-24.6 13.3L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM129.6 309.9l1-3c9.3-28.1 25.6-52.4 46.5-71.3L324.9 352 160 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8zM288 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"
  ]
}, m_ = Object.keys(Ed);
m_.forEach((e) => {
  const t = {
    prefix: g_,
    iconName: e,
    icon: Ed[e]
  };
  uI.add(t);
});
function h_({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx("i", { ...t, className: e, children: /* @__PURE__ */ w.jsxs("svg", { width: "35", height: "34", viewBox: "0 0 35 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ w.jsxs("g", { clipPath: "url(#clip0_406_8483)", children: [
      /* @__PURE__ */ w.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.1566 0C22.2349 0 26.3621 1.65489 29.6694 4.9019C32.8173 8.18238 34.4103 12.1551 34.4418 16.8841L34.4423 17.0276V32.7117C34.4423 32.7976 34.428 32.8828 34.4 32.964C34.2632 33.3606 33.8363 33.5747 33.4385 33.4508L33.416 33.4434L26.9604 31.2173C24.2406 32.9966 20.9799 33.9263 17.1566 33.9263C12.2074 33.9263 8.07943 32.2726 4.7729 29.0244C1.59398 25.7697 0 21.7529 0 17.0276C0 12.2354 1.59398 8.21552 4.7729 4.9019C8.07943 1.65489 12.2074 0 17.1566 0ZM17.2856 7.73984C12.2274 7.73984 8.12683 11.8404 8.12683 16.8986C8.12683 21.9569 12.2274 26.0575 17.2856 26.0575C22.3439 26.0575 26.4444 21.9569 26.4444 16.8986C26.4444 11.8404 22.3439 7.73984 17.2856 7.73984Z",
          fill: "#1F2C9C"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M17.2857 22.8325C20.5629 22.8325 23.2196 20.1758 23.2196 16.8986C23.2196 13.6214 20.5629 10.9647 17.2857 10.9647C14.0085 10.9647 11.3518 13.6214 11.3518 16.8986C11.3518 20.1758 14.0085 22.8325 17.2857 22.8325Z",
          fill: "#FF8F24"
        }
      )
    ] }),
    /* @__PURE__ */ w.jsx("defs", { children: /* @__PURE__ */ w.jsx("clipPath", { id: "clip0_406_8483", children: /* @__PURE__ */ w.jsx("rect", { width: "34.4607", height: "34", fill: "white" }) }) })
  ] }) });
}
h_.propTypes = {
  className: z.string
};
function Md({ currentColorDot: e = "#8995a0", currentColor: t = "currentColor", className: n = "", ...c }) {
  return /* @__PURE__ */ w.jsx("i", { ...c, className: n, children: /* @__PURE__ */ w.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ w.jsx("circle", { cx: "12", cy: "4", r: "3", fill: e }),
    /* @__PURE__ */ w.jsx(
      "path",
      {
        d: "M7.38462 1.23077V2.46154H2.46154C2.13512 2.46154 1.82207 2.59121 1.59125 2.82202C1.36044 3.05284 1.23077 3.36589 1.23077 3.69231V13.5385C1.23077 13.8649 1.36044 14.1779 1.59125 14.4087C1.82207 14.6396 2.13512 14.7692 2.46154 14.7692H12.3077C12.6341 14.7692 12.9472 14.6396 13.178 14.4087C13.4088 14.1779 13.5385 13.8649 13.5385 13.5385V8.61539H14.7692V13.5385C14.7692 14.1913 14.5099 14.8174 14.0483 15.279C13.5866 15.7407 12.9605 16 12.3077 16H2.46154C1.8087 16 1.1826 15.7407 0.720968 15.279C0.25934 14.8174 0 14.1913 0 13.5385V3.69231C0 3.03947 0.25934 2.41337 0.720968 1.95174C1.1826 1.49011 1.8087 1.23077 2.46154 1.23077H7.38462Z",
        fill: t
      }
    ),
    /* @__PURE__ */ w.jsx(
      "path",
      {
        d: "M12.3077 6.15385C12.9605 6.15385 13.5866 5.89451 14.0483 5.43288C14.5099 4.97125 14.7692 4.34515 14.7692 3.69231C14.7692 3.03947 14.5099 2.41337 14.0483 1.95174C13.5866 1.49011 12.9605 1.23077 12.3077 1.23077C11.6549 1.23077 11.0288 1.49011 10.5671 1.95174C10.1055 2.41337 9.84615 3.03947 9.84615 3.69231C9.84615 4.34515 10.1055 4.97125 10.5671 5.43288C11.0288 5.89451 11.6549 6.15385 12.3077 6.15385ZM12.3077 7.38462C11.8228 7.38462 11.3427 7.28911 10.8947 7.10356C10.4467 6.918 10.0397 6.64603 9.69684 6.30316C9.35397 5.9603 9.082 5.55326 8.89645 5.10529C8.71089 4.65732 8.61539 4.17719 8.61539 3.69231C8.61539 3.20743 8.71089 2.72729 8.89645 2.27932C9.082 1.83135 9.35397 1.42431 9.69684 1.08145C10.0397 0.738589 10.4467 0.466616 10.8947 0.28106C11.3427 0.0955043 11.8228 -7.22529e-09 12.3077 0C13.287 1.45921e-08 14.2261 0.38901 14.9185 1.08145C15.611 1.77389 16 2.71305 16 3.69231C16 4.67157 15.611 5.61072 14.9185 6.30316C14.2261 6.99561 13.287 7.38462 12.3077 7.38462Z",
        fill: t
      }
    )
  ] }) });
}
Md.propTypes = {
  currentColorDot: z.string,
  currentColor: z.string,
  className: z.string
};
function v_() {
  return /* @__PURE__ */ w.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "101", height: "71", viewBox: "0 0 101 71", children: /* @__PURE__ */ w.jsxs("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ w.jsx("circle", { cx: "35.5", cy: "35.5", r: "35.5", fill: "#F4F7FB" }),
    /* @__PURE__ */ w.jsx(
      "path",
      {
        fill: "#D4D9E0",
        d: "M.006 36.144L.003 36 81.245 36c1.55 0 2.708.278 3.686.801a5.452 5.452 0 012.268 2.268c.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686a5.452 5.452 0 01-2.268 2.268c-.978.523-2.136.801-3.686.801l-78.158.001A35.35 35.35 0 01.006 36.144zM32.755 16h56.49c1.55 0 2.708.278 3.686.801a5.452 5.452 0 012.268 2.268c.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686a5.452 5.452 0 01-2.268 2.268c-.978.523-2.136.801-3.686.801h-56.49c-1.55 0-2.708-.278-3.686-.801a5.452 5.452 0 01-2.268-2.268c-.523-.978-.801-2.136-.801-3.686v-.49c0-1.55.278-2.708.801-3.686a5.452 5.452 0 012.268-2.268c.978-.523 2.136-.801 3.686-.801zM61.755 56h32.49c1.55 0 2.708.278 3.686.801a5.452 5.452 0 012.268 2.268c.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686a5.452 5.452 0 01-2.268 2.268c-.978.523-2.136.801-3.686.801h-32.49c-1.55 0-2.708-.278-3.686-.801a5.452 5.452 0 01-2.268-2.268c-.523-.978-.801-2.136-.801-3.686v-.49c0-1.55.278-2.708.801-3.686a5.452 5.452 0 012.268-2.268c.978-.523 2.136-.801 3.686-.801z"
      }
    )
  ] }) });
}
const pa = {
  xxs: "2xs",
  xs: "xs",
  sm: "sm",
  lg: "lg",
  xl: "xl",
  xxl: "2xl"
};
function Ld({ iconName: e, ...t }) {
  if (!yn[e])
    throw new Error(`Icon ${e} not found`);
  return /* @__PURE__ */ w.jsx(ql, { icon: yn[e].value, ...t });
}
function Hn({ iconName: e, ...t }) {
  return (
    // eslint-disable-next-line react/no-unescaped-entities
    /* @__PURE__ */ w.jsx(SI, { fallback: /* @__PURE__ */ w.jsx("span", { style: { fontSize: 10, color: "#e49a13" }, children: 'No Icon found in "ICONS"' }), children: /* @__PURE__ */ w.jsx(Ld, { iconName: e, ...t }) })
  );
}
Hn.propTypes = {
  iconName: z.string.isRequired
};
Ld.propTypes = {
  iconName: z.string.isRequired
};
function Ht(e, t = []) {
  let n = [];
  function c(a, s) {
    const u = A.createContext(s), f = n.length;
    n = [...n, s];
    const d = (m) => {
      var I;
      const { scope: b, children: y, ...C } = m, h = ((I = b == null ? void 0 : b[e]) == null ? void 0 : I[f]) || u, v = A.useMemo(() => C, Object.values(C));
      return /* @__PURE__ */ w.jsx(h.Provider, { value: v, children: y });
    };
    d.displayName = a + "Provider";
    function p(m, b) {
      var h;
      const y = ((h = b == null ? void 0 : b[e]) == null ? void 0 : h[f]) || u, C = A.useContext(y);
      if (C) return C;
      if (s !== void 0) return s;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [d, p];
  }
  const o = () => {
    const a = n.map((s) => A.createContext(s));
    return function(u) {
      const f = (u == null ? void 0 : u[e]) || a;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: f } }),
        [u, f]
      );
    };
  };
  return o.scopeName = e, [c, b_(o, ...t)];
}
function b_(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const c = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = c.reduce((u, { useScope: f, scopeName: d }) => {
        const m = f(a)[`__scope${d}`];
        return { ...u, ...m };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function v6(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ga(...e) {
  return (t) => {
    let n = !1;
    const c = e.map((o) => {
      const a = v6(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < c.length; o++) {
          const a = c[o];
          typeof a == "function" ? a() : v6(e[o], null);
        }
      };
  };
}
function pt(...e) {
  return A.useCallback(ga(...e), e);
}
var Q1 = A.forwardRef((e, t) => {
  const { children: n, ...c } = e, o = A.Children.toArray(n), a = o.find(C_);
  if (a) {
    const s = a.props.children, u = o.map((f) => f === a ? A.Children.count(s) > 1 ? A.Children.only(null) : A.isValidElement(s) ? s.props.children : null : f);
    return /* @__PURE__ */ w.jsx(dl, { ...c, ref: t, children: A.isValidElement(s) ? A.cloneElement(s, void 0, u) : null });
  }
  return /* @__PURE__ */ w.jsx(dl, { ...c, ref: t, children: n });
});
Q1.displayName = "Slot";
var dl = A.forwardRef((e, t) => {
  const { children: n, ...c } = e;
  if (A.isValidElement(n)) {
    const o = y_(n);
    return A.cloneElement(n, {
      ...x_(c, n.props),
      // @ts-ignore
      ref: t ? ga(t, o) : o
    });
  }
  return A.Children.count(n) > 1 ? A.Children.only(null) : null;
});
dl.displayName = "SlotClone";
var Rd = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function C_(e) {
  return A.isValidElement(e) && e.type === Rd;
}
function x_(e, t) {
  const n = { ...t };
  for (const c in t) {
    const o = e[c], a = t[c];
    /^on[A-Z]/.test(c) ? o && a ? n[c] = (...u) => {
      a(...u), o(...u);
    } : o && (n[c] = o) : c === "style" ? n[c] = { ...o, ...a } : c === "className" && (n[c] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function y_(e) {
  var c, o;
  let t = (c = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : c.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Ql(e) {
  const t = e + "CollectionProvider", [n, c] = Ht(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (y) => {
    const { scope: C, children: h } = y, v = Te.useRef(null), I = Te.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w.jsx(o, { scope: C, itemMap: I, collectionRef: v, children: h });
  };
  s.displayName = t;
  const u = e + "CollectionSlot", f = Te.forwardRef(
    (y, C) => {
      const { scope: h, children: v } = y, I = a(u, h), S = pt(C, I.collectionRef);
      return /* @__PURE__ */ w.jsx(Q1, { ref: S, children: v });
    }
  );
  f.displayName = u;
  const d = e + "CollectionItemSlot", p = "data-radix-collection-item", m = Te.forwardRef(
    (y, C) => {
      const { scope: h, children: v, ...I } = y, S = Te.useRef(null), L = pt(C, S), R = a(d, h);
      return Te.useEffect(() => (R.itemMap.set(S, { ref: S, ...I }), () => void R.itemMap.delete(S))), /* @__PURE__ */ w.jsx(Q1, { [p]: "", ref: L, children: v });
    }
  );
  m.displayName = d;
  function b(y) {
    const C = a(e + "CollectionConsumer", y);
    return Te.useCallback(() => {
      const v = C.collectionRef.current;
      if (!v) return [];
      const I = Array.from(v.querySelectorAll(`[${p}]`));
      return Array.from(C.itemMap.values()).sort(
        (R, M) => I.indexOf(R.ref.current) - I.indexOf(M.ref.current)
      );
    }, [C.collectionRef, C.itemMap]);
  }
  return [
    { Provider: s, Slot: f, ItemSlot: m },
    b,
    c
  ];
}
function Ae(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function wn(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => {
    var c;
    return (c = t.current) == null ? void 0 : c.call(t, ...n);
  }, []);
}
function qt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [c, o] = I_({ defaultProp: t, onChange: n }), a = e !== void 0, s = a ? e : c, u = wn(n), f = A.useCallback(
    (d) => {
      if (a) {
        const m = typeof d == "function" ? d(e) : d;
        m !== e && u(m);
      } else
        o(d);
    },
    [a, e, o, u]
  );
  return [s, f];
}
function I_({
  defaultProp: e,
  onChange: t
}) {
  const n = A.useState(e), [c] = n, o = A.useRef(c), a = wn(t);
  return A.useEffect(() => {
    o.current !== c && (a(c), o.current = c);
  }, [c, o, a]), n;
}
var w_ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ke = w_.reduce((e, t) => {
  const n = A.forwardRef((c, o) => {
    const { asChild: a, ...s } = c, u = a ? Q1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(u, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Pd(e, t) {
  e && Bf.flushSync(() => e.dispatchEvent(t));
}
var Br = globalThis != null && globalThis.document ? A.useLayoutEffect : () => {
};
function A_(e, t) {
  return A.useReducer((n, c) => t[n][c] ?? n, e);
}
var Tn = (e) => {
  const { present: t, children: n } = e, c = S_(t), o = typeof n == "function" ? n({ present: c.isPresent }) : A.Children.only(n), a = pt(c.ref, __(o));
  return typeof n == "function" || c.isPresent ? A.cloneElement(o, { ref: a }) : null;
};
Tn.displayName = "Presence";
function S_(e) {
  const [t, n] = A.useState(), c = A.useRef({}), o = A.useRef(e), a = A.useRef("none"), s = e ? "mounted" : "unmounted", [u, f] = A_(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const d = bi(c.current);
    a.current = u === "mounted" ? d : "none";
  }, [u]), Br(() => {
    const d = c.current, p = o.current;
    if (p !== e) {
      const b = a.current, y = bi(d);
      e ? f("MOUNT") : y === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(p && b !== y ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), Br(() => {
    if (t) {
      let d;
      const p = t.ownerDocument.defaultView ?? window, m = (y) => {
        const h = bi(c.current).includes(y.animationName);
        if (y.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, b = (y) => {
        y.target === t && (a.current = bi(c.current));
      };
      return t.addEventListener("animationstart", b), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        p.clearTimeout(d), t.removeEventListener("animationstart", b), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(u),
    ref: A.useCallback((d) => {
      d && (c.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function bi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function __(e) {
  var c, o;
  let t = (c = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : c.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var E_ = A.useId || (() => {
}), M_ = 0;
function jn(e) {
  const [t, n] = A.useState(E_());
  return Br(() => {
    n((c) => c ?? String(M_++));
  }, [e]), t ? `radix-${t}` : "";
}
var e4 = "Collapsible", [L_, Td] = Ht(e4), [R_, t4] = L_(e4), zd = A.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: c,
      defaultOpen: o,
      disabled: a,
      onOpenChange: s,
      ...u
    } = e, [f = !1, d] = qt({
      prop: c,
      defaultProp: o,
      onChange: s
    });
    return /* @__PURE__ */ w.jsx(
      R_,
      {
        scope: n,
        disabled: a,
        contentId: jn(),
        open: f,
        onOpenToggle: A.useCallback(() => d((p) => !p), [d]),
        children: /* @__PURE__ */ w.jsx(
          ke.div,
          {
            "data-state": r4(f),
            "data-disabled": a ? "" : void 0,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
zd.displayName = e4;
var Nd = "CollapsibleTrigger", Od = A.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...c } = e, o = t4(Nd, n);
    return /* @__PURE__ */ w.jsx(
      ke.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": r4(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...c,
        ref: t,
        onClick: Ae(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Od.displayName = Nd;
var n4 = "CollapsibleContent", Fd = A.forwardRef(
  (e, t) => {
    const { forceMount: n, ...c } = e, o = t4(n4, e.__scopeCollapsible);
    return /* @__PURE__ */ w.jsx(Tn, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ w.jsx(P_, { ...c, ref: t, present: a }) });
  }
);
Fd.displayName = n4;
var P_ = A.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: c, children: o, ...a } = e, s = t4(n4, n), [u, f] = A.useState(c), d = A.useRef(null), p = pt(t, d), m = A.useRef(0), b = m.current, y = A.useRef(0), C = y.current, h = s.open || u, v = A.useRef(h), I = A.useRef(void 0);
  return A.useEffect(() => {
    const S = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(S);
  }, []), Br(() => {
    const S = d.current;
    if (S) {
      I.current = I.current || {
        transitionDuration: S.style.transitionDuration,
        animationName: S.style.animationName
      }, S.style.transitionDuration = "0s", S.style.animationName = "none";
      const L = S.getBoundingClientRect();
      m.current = L.height, y.current = L.width, v.current || (S.style.transitionDuration = I.current.transitionDuration, S.style.animationName = I.current.animationName), f(c);
    }
  }, [s.open, c]), /* @__PURE__ */ w.jsx(
    ke.div,
    {
      "data-state": r4(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !h,
      ...a,
      ref: p,
      style: {
        "--radix-collapsible-content-height": b ? `${b}px` : void 0,
        "--radix-collapsible-content-width": C ? `${C}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function r4(e) {
  return e ? "open" : "closed";
}
var T_ = zd, z_ = Od, N_ = Fd, O_ = A.createContext(void 0);
function ic(e) {
  const t = A.useContext(O_);
  return e || t || "ltr";
}
var mr = "Accordion", F_ = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [c4, D_, $_] = Ql(mr), [ma, mV] = Ht(mr, [
  $_,
  Td
]), o4 = Td(), Dd = Te.forwardRef(
  (e, t) => {
    const { type: n, ...c } = e, o = c, a = c;
    return /* @__PURE__ */ w.jsx(c4.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ w.jsx(V_, { ...a, ref: t }) : /* @__PURE__ */ w.jsx(B_, { ...o, ref: t }) });
  }
);
Dd.displayName = mr;
var [$d, G_] = ma(mr), [Gd, k_] = ma(
  mr,
  { collapsible: !1 }
), B_ = Te.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: c,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...s
    } = e, [u, f] = qt({
      prop: n,
      defaultProp: c,
      onChange: o
    });
    return /* @__PURE__ */ w.jsx(
      $d,
      {
        scope: e.__scopeAccordion,
        value: u ? [u] : [],
        onItemOpen: f,
        onItemClose: Te.useCallback(() => a && f(""), [a, f]),
        children: /* @__PURE__ */ w.jsx(Gd, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ w.jsx(kd, { ...s, ref: t }) })
      }
    );
  }
), V_ = Te.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: c,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s = [], u] = qt({
    prop: n,
    defaultProp: c,
    onChange: o
  }), f = Te.useCallback(
    (p) => u((m = []) => [...m, p]),
    [u]
  ), d = Te.useCallback(
    (p) => u((m = []) => m.filter((b) => b !== p)),
    [u]
  );
  return /* @__PURE__ */ w.jsx(
    $d,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: f,
      onItemClose: d,
      children: /* @__PURE__ */ w.jsx(Gd, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ w.jsx(kd, { ...a, ref: t }) })
    }
  );
}), [W_, ha] = ma(mr), kd = Te.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: c, dir: o, orientation: a = "vertical", ...s } = e, u = Te.useRef(null), f = pt(u, t), d = D_(n), m = ic(o) === "ltr", b = Ae(e.onKeyDown, (y) => {
      var G;
      if (!F_.includes(y.key)) return;
      const C = y.target, h = d().filter((J) => {
        var ae;
        return !((ae = J.ref.current) != null && ae.disabled);
      }), v = h.findIndex((J) => J.ref.current === C), I = h.length;
      if (v === -1) return;
      y.preventDefault();
      let S = v;
      const L = 0, R = I - 1, M = () => {
        S = v + 1, S > R && (S = L);
      }, $ = () => {
        S = v - 1, S < L && (S = R);
      };
      switch (y.key) {
        case "Home":
          S = L;
          break;
        case "End":
          S = R;
          break;
        case "ArrowRight":
          a === "horizontal" && (m ? M() : $());
          break;
        case "ArrowDown":
          a === "vertical" && M();
          break;
        case "ArrowLeft":
          a === "horizontal" && (m ? $() : M());
          break;
        case "ArrowUp":
          a === "vertical" && $();
          break;
      }
      const O = S % I;
      (G = h[O].ref.current) == null || G.focus();
    });
    return /* @__PURE__ */ w.jsx(
      W_,
      {
        scope: n,
        disabled: c,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ w.jsx(c4.Slot, { scope: n, children: /* @__PURE__ */ w.jsx(
          ke.div,
          {
            ...s,
            "data-orientation": a,
            ref: f,
            onKeyDown: c ? void 0 : b
          }
        ) })
      }
    );
  }
), Hi = "AccordionItem", [H_, i4] = ma(Hi), Bd = Te.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: c, ...o } = e, a = ha(Hi, n), s = G_(Hi, n), u = o4(n), f = jn(), d = c && s.value.includes(c) || !1, p = a.disabled || e.disabled;
    return /* @__PURE__ */ w.jsx(
      H_,
      {
        scope: n,
        open: d,
        disabled: p,
        triggerId: f,
        children: /* @__PURE__ */ w.jsx(
          T_,
          {
            "data-orientation": a.orientation,
            "data-state": Zd(d),
            ...u,
            ...o,
            ref: t,
            disabled: p,
            open: d,
            onOpenChange: (m) => {
              m ? s.onItemOpen(c) : s.onItemClose(c);
            }
          }
        )
      }
    );
  }
);
Bd.displayName = Hi;
var Vd = "AccordionHeader", Wd = Te.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...c } = e, o = ha(mr, n), a = i4(Vd, n);
    return /* @__PURE__ */ w.jsx(
      ke.h3,
      {
        "data-orientation": o.orientation,
        "data-state": Zd(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...c,
        ref: t
      }
    );
  }
);
Wd.displayName = Vd;
var pl = "AccordionTrigger", Hd = Te.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...c } = e, o = ha(mr, n), a = i4(pl, n), s = k_(pl, n), u = o4(n);
    return /* @__PURE__ */ w.jsx(c4.ItemSlot, { scope: n, children: /* @__PURE__ */ w.jsx(
      z_,
      {
        "aria-disabled": a.open && !s.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...u,
        ...c,
        ref: t
      }
    ) });
  }
);
Hd.displayName = pl;
var jd = "AccordionContent", Xd = Te.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...c } = e, o = ha(mr, n), a = i4(jd, n), s = o4(n);
    return /* @__PURE__ */ w.jsx(
      N_,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...s,
        ...c,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Xd.displayName = jd;
function Zd(e) {
  return e ? "open" : "closed";
}
var j_ = Dd, X_ = Bd, Z_ = Wd, Y_ = Hd, U_ = Xd;
const J_ = "_AccordionRoot_p8wxd_405", K_ = "_AccordionItem_p8wxd_410", q_ = "_AccordionHeader_p8wxd_419", Q_ = "_AccordionTrigger_p8wxd_423", eE = "_AccordionContent_p8wxd_434", tE = "_slideDown_p8wxd_1", nE = "_slideUp_p8wxd_1", rE = "_AccordionChevron_p8wxd_449", cE = "_rotateUp_p8wxd_1", oE = "_rotateDown_p8wxd_1", iE = "_fadeIn_p8wxd_1", aE = "_fadeOut_p8wxd_1", sE = "_slideUpAndFade_p8wxd_1", lE = "_slideRightAndFade_p8wxd_1", uE = "_slideDownAndFade_p8wxd_1", fE = "_slideLeftAndFade_p8wxd_1", ac = {
  AccordionRoot: J_,
  AccordionItem: K_,
  AccordionHeader: q_,
  AccordionTrigger: Q_,
  AccordionContent: eE,
  slideDown: tE,
  slideUp: nE,
  AccordionChevron: rE,
  rotateUp: cE,
  rotateDown: oE,
  fadeIn: iE,
  fadeOut: aE,
  slideUpAndFade: sE,
  slideRightAndFade: lE,
  slideDownAndFade: uE,
  slideLeftAndFade: fE
};
function Yd({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(j_, { ...t, className: `${ac.AccordionRoot} ${e}` });
}
function gl({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(X_, { ...t, className: `${ac.AccordionItem} ${e}` });
}
function ml({ className: e = "", isActive: t, ...n }) {
  return /* @__PURE__ */ w.jsx(
    Z_,
    {
      ...n,
      className: `${ac.AccordionHeader} ${t ? "isActive" : ""} ${e}`
    }
  );
}
function hl({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(Y_, { ...t, className: `${ac.AccordionTrigger} ${e}` });
}
function Ud({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(U_, { ...t, className: `${ac.AccordionContent} ${e}` });
}
function Jd({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(
    Hn,
    {
      size: pa.sm,
      iconName: yn.chevronDown.name,
      className: `${ac.AccordionChevron} ${e}`,
      ...t
    }
  );
}
Yd.propTypes = {
  className: z.string
};
gl.propTypes = {
  className: z.string
};
ml.propTypes = {
  className: z.string,
  isActive: z.bool
};
hl.propTypes = {
  className: z.string
};
Ud.propTypes = {
  className: z.string
};
Jd.propTypes = {
  className: z.string
};
function Kd(e) {
  const t = A.useRef({ value: e, previous: e });
  return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function a4(e) {
  const [t, n] = A.useState(void 0);
  return Br(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const c = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, u;
        if ("borderBoxSize" in a) {
          const f = a.borderBoxSize, d = Array.isArray(f) ? f[0] : f;
          s = d.inlineSize, u = d.blockSize;
        } else
          s = e.offsetWidth, u = e.offsetHeight;
        n({ width: s, height: u });
      });
      return c.observe(e, { box: "border-box" }), () => c.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var s4 = "Checkbox", [dE, hV] = Ht(s4), [pE, gE] = dE(s4), qd = A.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: c,
      checked: o,
      defaultChecked: a,
      required: s,
      disabled: u,
      value: f = "on",
      onCheckedChange: d,
      form: p,
      ...m
    } = e, [b, y] = A.useState(null), C = pt(t, (R) => y(R)), h = A.useRef(!1), v = b ? p || !!b.closest("form") : !0, [I = !1, S] = qt({
      prop: o,
      defaultProp: a,
      onChange: d
    }), L = A.useRef(I);
    return A.useEffect(() => {
      const R = b == null ? void 0 : b.form;
      if (R) {
        const M = () => S(L.current);
        return R.addEventListener("reset", M), () => R.removeEventListener("reset", M);
      }
    }, [b, S]), /* @__PURE__ */ w.jsxs(pE, { scope: n, state: I, disabled: u, children: [
      /* @__PURE__ */ w.jsx(
        ke.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Fr(I) ? "mixed" : I,
          "aria-required": s,
          "data-state": t5(I),
          "data-disabled": u ? "" : void 0,
          disabled: u,
          value: f,
          ...m,
          ref: C,
          onKeyDown: Ae(e.onKeyDown, (R) => {
            R.key === "Enter" && R.preventDefault();
          }),
          onClick: Ae(e.onClick, (R) => {
            S((M) => Fr(M) ? !0 : !M), v && (h.current = R.isPropagationStopped(), h.current || R.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ w.jsx(
        mE,
        {
          control: b,
          bubbles: !h.current,
          name: c,
          value: f,
          checked: I,
          required: s,
          disabled: u,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Fr(a) ? !1 : a
        }
      )
    ] });
  }
);
qd.displayName = s4;
var Qd = "CheckboxIndicator", e5 = A.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: c, ...o } = e, a = gE(Qd, n);
    return /* @__PURE__ */ w.jsx(Tn, { present: c || Fr(a.state) || a.state === !0, children: /* @__PURE__ */ w.jsx(
      ke.span,
      {
        "data-state": t5(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
e5.displayName = Qd;
var mE = (e) => {
  const { control: t, checked: n, bubbles: c = !0, defaultChecked: o, ...a } = e, s = A.useRef(null), u = Kd(n), f = a4(t);
  A.useEffect(() => {
    const p = s.current, m = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(m, "checked").set;
    if (u !== n && y) {
      const C = new Event("click", { bubbles: c });
      p.indeterminate = Fr(n), y.call(p, Fr(n) ? !1 : n), p.dispatchEvent(C);
    }
  }, [u, n, c]);
  const d = A.useRef(Fr(n) ? !1 : n);
  return /* @__PURE__ */ w.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: o ?? d.current,
      ...a,
      tabIndex: -1,
      ref: s,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Fr(e) {
  return e === "indeterminate";
}
function t5(e) {
  return Fr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var hE = qd, vE = e5;
function bE(e, t) {
  if (e == null) return {};
  var n = {}, c = Object.keys(e), o, a;
  for (a = 0; a < c.length; a++)
    o = c[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var CE = ["color"], xE = /* @__PURE__ */ Ze(function(e, t) {
  var n = e.color, c = n === void 0 ? "currentColor" : n, o = bE(e, CE);
  return xe("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), xe("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: c,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const yE = "_Container_1swhn_405", IE = "_CheckboxRoot_1swhn_417", wE = "_CheckboxIndicator_1swhn_431", AE = "_Label_1swhn_436", SE = "_fadeIn_1swhn_1", _E = "_fadeOut_1swhn_1", EE = "_slideUpAndFade_1swhn_1", ME = "_slideRightAndFade_1swhn_1", LE = "_slideDownAndFade_1swhn_1", RE = "_slideLeftAndFade_1swhn_1", PE = "_slideDown_1swhn_1", TE = "_slideUp_1swhn_1", zE = "_rotateUp_1swhn_1", NE = "_rotateDown_1swhn_1", Ci = {
  Container: yE,
  CheckboxRoot: IE,
  CheckboxIndicator: wE,
  Label: AE,
  fadeIn: SE,
  fadeOut: _E,
  slideUpAndFade: EE,
  slideRightAndFade: ME,
  slideDownAndFade: LE,
  slideLeftAndFade: RE,
  slideDown: PE,
  slideUp: TE,
  rotateUp: zE,
  rotateDown: NE
};
function OE({ label: e = "" }) {
  return /* @__PURE__ */ w.jsxs("div", { className: `${Ci.Container}`, style: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ w.jsx(hE, { className: `${Ci.CheckboxRoot}`, children: /* @__PURE__ */ w.jsx(vE, { className: `${Ci.CheckboxIndicator}`, children: /* @__PURE__ */ w.jsx(xE, {}) }) }),
    /* @__PURE__ */ w.jsx("label", { className: `${Ci.Label}`, htmlFor: "c1", children: e })
  ] });
}
OE.propTypes = {
  label: z.string
};
function FE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wn(e);
  A.useEffect(() => {
    const c = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", c, { capture: !0 }), () => t.removeEventListener("keydown", c, { capture: !0 });
  }, [n, t]);
}
var DE = "DismissableLayer", vl = "dismissableLayer.update", $E = "dismissableLayer.pointerDownOutside", GE = "dismissableLayer.focusOutside", b6, n5 = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), va = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: c,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: u,
      ...f
    } = e, d = A.useContext(n5), [p, m] = A.useState(null), b = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = A.useState({}), C = pt(t, (O) => m(O)), h = Array.from(d.layers), [v] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), I = h.indexOf(v), S = p ? h.indexOf(p) : -1, L = d.layersWithOutsidePointerEventsDisabled.size > 0, R = S >= I, M = VE((O) => {
      const G = O.target, J = [...d.branches].some((ae) => ae.contains(G));
      !R || J || (o == null || o(O), s == null || s(O), O.defaultPrevented || u == null || u());
    }, b), $ = WE((O) => {
      const G = O.target;
      [...d.branches].some((ae) => ae.contains(G)) || (a == null || a(O), s == null || s(O), O.defaultPrevented || u == null || u());
    }, b);
    return FE((O) => {
      S === d.layers.size - 1 && (c == null || c(O), !O.defaultPrevented && u && (O.preventDefault(), u()));
    }, b), A.useEffect(() => {
      if (p)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (b6 = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(p)), d.layers.add(p), C6(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = b6);
        };
    }, [p, b, n, d]), A.useEffect(() => () => {
      p && (d.layers.delete(p), d.layersWithOutsidePointerEventsDisabled.delete(p), C6());
    }, [p, d]), A.useEffect(() => {
      const O = () => y({});
      return document.addEventListener(vl, O), () => document.removeEventListener(vl, O);
    }, []), /* @__PURE__ */ w.jsx(
      ke.div,
      {
        ...f,
        ref: C,
        style: {
          pointerEvents: L ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ae(e.onFocusCapture, $.onFocusCapture),
        onBlurCapture: Ae(e.onBlurCapture, $.onBlurCapture),
        onPointerDownCapture: Ae(
          e.onPointerDownCapture,
          M.onPointerDownCapture
        )
      }
    );
  }
);
va.displayName = DE;
var kE = "DismissableLayerBranch", BE = A.forwardRef((e, t) => {
  const n = A.useContext(n5), c = A.useRef(null), o = pt(t, c);
  return A.useEffect(() => {
    const a = c.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ w.jsx(ke.div, { ...e, ref: o });
});
BE.displayName = kE;
function VE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wn(e), c = A.useRef(!1), o = A.useRef(() => {
  });
  return A.useEffect(() => {
    const a = (u) => {
      if (u.target && !c.current) {
        let f = function() {
          r5(
            $E,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: u };
        u.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      c.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => c.current = !0
  };
}
function WE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wn(e), c = A.useRef(!1);
  return A.useEffect(() => {
    const o = (a) => {
      a.target && !c.current && r5(GE, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => c.current = !0,
    onBlurCapture: () => c.current = !1
  };
}
function C6() {
  const e = new CustomEvent(vl);
  document.dispatchEvent(e);
}
function r5(e, t, n, { discrete: c }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), c ? Pd(o, a) : o.dispatchEvent(a);
}
var ws = 0;
function c5() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? x6()), document.body.insertAdjacentElement("beforeend", e[1] ?? x6()), ws++, () => {
      ws === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ws--;
    };
  }, []);
}
function x6() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var As = "focusScope.autoFocusOnMount", Ss = "focusScope.autoFocusOnUnmount", y6 = { bubbles: !1, cancelable: !0 }, HE = "FocusScope", l4 = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: c = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [u, f] = A.useState(null), d = wn(o), p = wn(a), m = A.useRef(null), b = pt(t, (h) => f(h)), y = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (c) {
      let h = function(L) {
        if (y.paused || !u) return;
        const R = L.target;
        u.contains(R) ? m.current = R : zr(m.current, { select: !0 });
      }, v = function(L) {
        if (y.paused || !u) return;
        const R = L.relatedTarget;
        R !== null && (u.contains(R) || zr(m.current, { select: !0 }));
      }, I = function(L) {
        if (document.activeElement === document.body)
          for (const M of L)
            M.removedNodes.length > 0 && zr(u);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const S = new MutationObserver(I);
      return u && S.observe(u, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), S.disconnect();
      };
    }
  }, [c, u, y.paused]), A.useEffect(() => {
    if (u) {
      w6.add(y);
      const h = document.activeElement;
      if (!u.contains(h)) {
        const I = new CustomEvent(As, y6);
        u.addEventListener(As, d), u.dispatchEvent(I), I.defaultPrevented || (jE(JE(o5(u)), { select: !0 }), document.activeElement === h && zr(u));
      }
      return () => {
        u.removeEventListener(As, d), setTimeout(() => {
          const I = new CustomEvent(Ss, y6);
          u.addEventListener(Ss, p), u.dispatchEvent(I), I.defaultPrevented || zr(h ?? document.body, { select: !0 }), u.removeEventListener(Ss, p), w6.remove(y);
        }, 0);
      };
    }
  }, [u, d, p, y]);
  const C = A.useCallback(
    (h) => {
      if (!n && !c || y.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, I = document.activeElement;
      if (v && I) {
        const S = h.currentTarget, [L, R] = XE(S);
        L && R ? !h.shiftKey && I === R ? (h.preventDefault(), n && zr(L, { select: !0 })) : h.shiftKey && I === L && (h.preventDefault(), n && zr(R, { select: !0 })) : I === S && h.preventDefault();
      }
    },
    [n, c, y.paused]
  );
  return /* @__PURE__ */ w.jsx(ke.div, { tabIndex: -1, ...s, ref: b, onKeyDown: C });
});
l4.displayName = HE;
function jE(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const c of e)
    if (zr(c, { select: t }), document.activeElement !== n) return;
}
function XE(e) {
  const t = o5(e), n = I6(t, e), c = I6(t.reverse(), e);
  return [n, c];
}
function o5(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (c) => {
      const o = c.tagName === "INPUT" && c.type === "hidden";
      return c.disabled || c.hidden || o ? NodeFilter.FILTER_SKIP : c.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function I6(e, t) {
  for (const n of e)
    if (!ZE(n, { upTo: t })) return n;
}
function ZE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function YE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function zr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && YE(e) && t && e.select();
  }
}
var w6 = UE();
function UE() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = A6(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = A6(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function A6(e, t) {
  const n = [...e], c = n.indexOf(t);
  return c !== -1 && n.splice(c, 1), n;
}
function JE(e) {
  return e.filter((t) => t.tagName !== "A");
}
const KE = ["top", "right", "bottom", "left"], Vr = Math.min, sn = Math.max, ji = Math.round, xi = Math.floor, Vn = (e) => ({
  x: e,
  y: e
}), qE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, QE = {
  start: "end",
  end: "start"
};
function bl(e, t, n) {
  return sn(e, Vr(t, n));
}
function ur(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function fr(e) {
  return e.split("-")[0];
}
function sc(e) {
  return e.split("-")[1];
}
function u4(e) {
  return e === "x" ? "y" : "x";
}
function f4(e) {
  return e === "y" ? "height" : "width";
}
function Wr(e) {
  return ["top", "bottom"].includes(fr(e)) ? "y" : "x";
}
function d4(e) {
  return u4(Wr(e));
}
function eM(e, t, n) {
  n === void 0 && (n = !1);
  const c = sc(e), o = d4(e), a = f4(o);
  let s = o === "x" ? c === (n ? "end" : "start") ? "right" : "left" : c === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = Xi(s)), [s, Xi(s)];
}
function tM(e) {
  const t = Xi(e);
  return [Cl(e), t, Cl(t)];
}
function Cl(e) {
  return e.replace(/start|end/g, (t) => QE[t]);
}
function nM(e, t, n) {
  const c = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : c : t ? c : o;
    case "left":
    case "right":
      return t ? a : s;
    default:
      return [];
  }
}
function rM(e, t, n, c) {
  const o = sc(e);
  let a = nM(fr(e), n === "start", c);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map(Cl)))), a;
}
function Xi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => qE[t]);
}
function cM(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function i5(e) {
  return typeof e != "number" ? cM(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zi(e) {
  const {
    x: t,
    y: n,
    width: c,
    height: o
  } = e;
  return {
    width: c,
    height: o,
    top: n,
    left: t,
    right: t + c,
    bottom: n + o,
    x: t,
    y: n
  };
}
function S6(e, t, n) {
  let {
    reference: c,
    floating: o
  } = e;
  const a = Wr(t), s = d4(t), u = f4(s), f = fr(t), d = a === "y", p = c.x + c.width / 2 - o.width / 2, m = c.y + c.height / 2 - o.height / 2, b = c[u] / 2 - o[u] / 2;
  let y;
  switch (f) {
    case "top":
      y = {
        x: p,
        y: c.y - o.height
      };
      break;
    case "bottom":
      y = {
        x: p,
        y: c.y + c.height
      };
      break;
    case "right":
      y = {
        x: c.x + c.width,
        y: m
      };
      break;
    case "left":
      y = {
        x: c.x - o.width,
        y: m
      };
      break;
    default:
      y = {
        x: c.x,
        y: c.y
      };
  }
  switch (sc(t)) {
    case "start":
      y[s] -= b * (n && d ? -1 : 1);
      break;
    case "end":
      y[s] += b * (n && d ? -1 : 1);
      break;
  }
  return y;
}
const oM = async (e, t, n) => {
  const {
    placement: c = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, u = a.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: p,
    y: m
  } = S6(d, c, f), b = c, y = {}, C = 0;
  for (let h = 0; h < u.length; h++) {
    const {
      name: v,
      fn: I
    } = u[h], {
      x: S,
      y: L,
      data: R,
      reset: M
    } = await I({
      x: p,
      y: m,
      initialPlacement: c,
      placement: b,
      strategy: o,
      middlewareData: y,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = S ?? p, m = L ?? m, y = {
      ...y,
      [v]: {
        ...y[v],
        ...R
      }
    }, M && C <= 50 && (C++, typeof M == "object" && (M.placement && (b = M.placement), M.rects && (d = M.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : M.rects), {
      x: p,
      y: m
    } = S6(d, b, f)), h = -1);
  }
  return {
    x: p,
    y: m,
    placement: b,
    strategy: o,
    middlewareData: y
  };
};
async function to(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: c,
    y: o,
    platform: a,
    rects: s,
    elements: u,
    strategy: f
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: m = "floating",
    altBoundary: b = !1,
    padding: y = 0
  } = ur(t, e), C = i5(y), v = u[b ? m === "floating" ? "reference" : "floating" : m], I = Zi(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(u.floating)),
    boundary: d,
    rootBoundary: p,
    strategy: f
  })), S = m === "floating" ? {
    x: c,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, L = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u.floating)), R = await (a.isElement == null ? void 0 : a.isElement(L)) ? await (a.getScale == null ? void 0 : a.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, M = Zi(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: S,
    offsetParent: L,
    strategy: f
  }) : S);
  return {
    top: (I.top - M.top + C.top) / R.y,
    bottom: (M.bottom - I.bottom + C.bottom) / R.y,
    left: (I.left - M.left + C.left) / R.x,
    right: (M.right - I.right + C.right) / R.x
  };
}
const iM = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: c,
      placement: o,
      rects: a,
      platform: s,
      elements: u,
      middlewareData: f
    } = t, {
      element: d,
      padding: p = 0
    } = ur(e, t) || {};
    if (d == null)
      return {};
    const m = i5(p), b = {
      x: n,
      y: c
    }, y = d4(o), C = f4(y), h = await s.getDimensions(d), v = y === "y", I = v ? "top" : "left", S = v ? "bottom" : "right", L = v ? "clientHeight" : "clientWidth", R = a.reference[C] + a.reference[y] - b[y] - a.floating[C], M = b[y] - a.reference[y], $ = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let O = $ ? $[L] : 0;
    (!O || !await (s.isElement == null ? void 0 : s.isElement($))) && (O = u.floating[L] || a.floating[C]);
    const G = R / 2 - M / 2, J = O / 2 - h[C] / 2 - 1, ae = Vr(m[I], J), fe = Vr(m[S], J), U = ae, re = O - h[C] - fe, oe = O / 2 - h[C] / 2 + G, ue = bl(U, oe, re), te = !f.arrow && sc(o) != null && oe !== ue && a.reference[C] / 2 - (oe < U ? ae : fe) - h[C] / 2 < 0, se = te ? oe < U ? oe - U : oe - re : 0;
    return {
      [y]: b[y] + se,
      data: {
        [y]: ue,
        centerOffset: oe - ue - se,
        ...te && {
          alignmentOffset: se
        }
      },
      reset: te
    };
  }
}), aM = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, c;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: u,
        platform: f,
        elements: d
      } = t, {
        mainAxis: p = !0,
        crossAxis: m = !0,
        fallbackPlacements: b,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: h = !0,
        ...v
      } = ur(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const I = fr(o), S = Wr(u), L = fr(u) === u, R = await (f.isRTL == null ? void 0 : f.isRTL(d.floating)), M = b || (L || !h ? [Xi(u)] : tM(u)), $ = C !== "none";
      !b && $ && M.push(...rM(u, h, C, R));
      const O = [u, ...M], G = await to(t, v), J = [];
      let ae = ((c = a.flip) == null ? void 0 : c.overflows) || [];
      if (p && J.push(G[I]), m) {
        const oe = eM(o, s, R);
        J.push(G[oe[0]], G[oe[1]]);
      }
      if (ae = [...ae, {
        placement: o,
        overflows: J
      }], !J.every((oe) => oe <= 0)) {
        var fe, U;
        const oe = (((fe = a.flip) == null ? void 0 : fe.index) || 0) + 1, ue = O[oe];
        if (ue)
          return {
            data: {
              index: oe,
              overflows: ae
            },
            reset: {
              placement: ue
            }
          };
        let te = (U = ae.filter((se) => se.overflows[0] <= 0).sort((se, ee) => se.overflows[1] - ee.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!te)
          switch (y) {
            case "bestFit": {
              var re;
              const se = (re = ae.filter((ee) => {
                if ($) {
                  const q = Wr(ee.placement);
                  return q === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((ee) => [ee.placement, ee.overflows.filter((q) => q > 0).reduce((q, B) => q + B, 0)]).sort((ee, q) => ee[1] - q[1])[0]) == null ? void 0 : re[0];
              se && (te = se);
              break;
            }
            case "initialPlacement":
              te = u;
              break;
          }
        if (o !== te)
          return {
            reset: {
              placement: te
            }
          };
      }
      return {};
    }
  };
};
function _6(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function E6(e) {
  return KE.some((t) => e[t] >= 0);
}
const sM = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: c = "referenceHidden",
        ...o
      } = ur(e, t);
      switch (c) {
        case "referenceHidden": {
          const a = await to(t, {
            ...o,
            elementContext: "reference"
          }), s = _6(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: E6(s)
            }
          };
        }
        case "escaped": {
          const a = await to(t, {
            ...o,
            altBoundary: !0
          }), s = _6(a, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: E6(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function lM(e, t) {
  const {
    placement: n,
    platform: c,
    elements: o
  } = e, a = await (c.isRTL == null ? void 0 : c.isRTL(o.floating)), s = fr(n), u = sc(n), f = Wr(n) === "y", d = ["left", "top"].includes(s) ? -1 : 1, p = a && f ? -1 : 1, m = ur(t, e);
  let {
    mainAxis: b,
    crossAxis: y,
    alignmentAxis: C
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return u && typeof C == "number" && (y = u === "end" ? C * -1 : C), f ? {
    x: y * p,
    y: b * d
  } : {
    x: b * d,
    y: y * p
  };
}
const uM = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, c;
      const {
        x: o,
        y: a,
        placement: s,
        middlewareData: u
      } = t, f = await lM(t, e);
      return s === ((n = u.offset) == null ? void 0 : n.placement) && (c = u.arrow) != null && c.alignmentOffset ? {} : {
        x: o + f.x,
        y: a + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, fM = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: c,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: s = !1,
        limiter: u = {
          fn: (v) => {
            let {
              x: I,
              y: S
            } = v;
            return {
              x: I,
              y: S
            };
          }
        },
        ...f
      } = ur(e, t), d = {
        x: n,
        y: c
      }, p = await to(t, f), m = Wr(fr(o)), b = u4(m);
      let y = d[b], C = d[m];
      if (a) {
        const v = b === "y" ? "top" : "left", I = b === "y" ? "bottom" : "right", S = y + p[v], L = y - p[I];
        y = bl(S, y, L);
      }
      if (s) {
        const v = m === "y" ? "top" : "left", I = m === "y" ? "bottom" : "right", S = C + p[v], L = C - p[I];
        C = bl(S, C, L);
      }
      const h = u.fn({
        ...t,
        [b]: y,
        [m]: C
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - c,
          enabled: {
            [b]: a,
            [m]: s
          }
        }
      };
    }
  };
}, dM = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: c,
        placement: o,
        rects: a,
        middlewareData: s
      } = t, {
        offset: u = 0,
        mainAxis: f = !0,
        crossAxis: d = !0
      } = ur(e, t), p = {
        x: n,
        y: c
      }, m = Wr(o), b = u4(m);
      let y = p[b], C = p[m];
      const h = ur(u, t), v = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (f) {
        const L = b === "y" ? "height" : "width", R = a.reference[b] - a.floating[L] + v.mainAxis, M = a.reference[b] + a.reference[L] - v.mainAxis;
        y < R ? y = R : y > M && (y = M);
      }
      if (d) {
        var I, S;
        const L = b === "y" ? "width" : "height", R = ["top", "left"].includes(fr(o)), M = a.reference[m] - a.floating[L] + (R && ((I = s.offset) == null ? void 0 : I[m]) || 0) + (R ? 0 : v.crossAxis), $ = a.reference[m] + a.reference[L] + (R ? 0 : ((S = s.offset) == null ? void 0 : S[m]) || 0) - (R ? v.crossAxis : 0);
        C < M ? C = M : C > $ && (C = $);
      }
      return {
        [b]: y,
        [m]: C
      };
    }
  };
}, pM = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, c;
      const {
        placement: o,
        rects: a,
        platform: s,
        elements: u
      } = t, {
        apply: f = () => {
        },
        ...d
      } = ur(e, t), p = await to(t, d), m = fr(o), b = sc(o), y = Wr(o) === "y", {
        width: C,
        height: h
      } = a.floating;
      let v, I;
      m === "top" || m === "bottom" ? (v = m, I = b === (await (s.isRTL == null ? void 0 : s.isRTL(u.floating)) ? "start" : "end") ? "left" : "right") : (I = m, v = b === "end" ? "top" : "bottom");
      const S = h - p.top - p.bottom, L = C - p.left - p.right, R = Vr(h - p[v], S), M = Vr(C - p[I], L), $ = !t.middlewareData.shift;
      let O = R, G = M;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (G = L), (c = t.middlewareData.shift) != null && c.enabled.y && (O = S), $ && !b) {
        const ae = sn(p.left, 0), fe = sn(p.right, 0), U = sn(p.top, 0), re = sn(p.bottom, 0);
        y ? G = C - 2 * (ae !== 0 || fe !== 0 ? ae + fe : sn(p.left, p.right)) : O = h - 2 * (U !== 0 || re !== 0 ? U + re : sn(p.top, p.bottom));
      }
      await f({
        ...t,
        availableWidth: G,
        availableHeight: O
      });
      const J = await s.getDimensions(u.floating);
      return C !== J.width || h !== J.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ba() {
  return typeof window < "u";
}
function lc(e) {
  return a5(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ln(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Zn(e) {
  var t;
  return (t = (a5(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function a5(e) {
  return ba() ? e instanceof Node || e instanceof ln(e).Node : !1;
}
function Rn(e) {
  return ba() ? e instanceof Element || e instanceof ln(e).Element : !1;
}
function Xn(e) {
  return ba() ? e instanceof HTMLElement || e instanceof ln(e).HTMLElement : !1;
}
function M6(e) {
  return !ba() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ln(e).ShadowRoot;
}
function po(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: c,
    display: o
  } = Pn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + c + n) && !["inline", "contents"].includes(o);
}
function gM(e) {
  return ["table", "td", "th"].includes(lc(e));
}
function Ca(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function p4(e) {
  const t = g4(), n = Rn(e) ? Pn(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((c) => n[c] ? n[c] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((c) => (n.willChange || "").includes(c)) || ["paint", "layout", "strict", "content"].some((c) => (n.contain || "").includes(c));
}
function mM(e) {
  let t = Hr(e);
  for (; Xn(t) && !ec(t); ) {
    if (p4(t))
      return t;
    if (Ca(t))
      return null;
    t = Hr(t);
  }
  return null;
}
function g4() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ec(e) {
  return ["html", "body", "#document"].includes(lc(e));
}
function Pn(e) {
  return ln(e).getComputedStyle(e);
}
function xa(e) {
  return Rn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Hr(e) {
  if (lc(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    M6(e) && e.host || // Fallback.
    Zn(e)
  );
  return M6(t) ? t.host : t;
}
function s5(e) {
  const t = Hr(e);
  return ec(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xn(t) && po(t) ? t : s5(t);
}
function no(e, t, n) {
  var c;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = s5(e), a = o === ((c = e.ownerDocument) == null ? void 0 : c.body), s = ln(o);
  if (a) {
    const u = xl(s);
    return t.concat(s, s.visualViewport || [], po(o) ? o : [], u && n ? no(u) : []);
  }
  return t.concat(o, no(o, [], n));
}
function xl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function l5(e) {
  const t = Pn(e);
  let n = parseFloat(t.width) || 0, c = parseFloat(t.height) || 0;
  const o = Xn(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : c, u = ji(n) !== a || ji(c) !== s;
  return u && (n = a, c = s), {
    width: n,
    height: c,
    $: u
  };
}
function m4(e) {
  return Rn(e) ? e : e.contextElement;
}
function Y1(e) {
  const t = m4(e);
  if (!Xn(t))
    return Vn(1);
  const n = t.getBoundingClientRect(), {
    width: c,
    height: o,
    $: a
  } = l5(t);
  let s = (a ? ji(n.width) : n.width) / c, u = (a ? ji(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: s,
    y: u
  };
}
const hM = /* @__PURE__ */ Vn(0);
function u5(e) {
  const t = ln(e);
  return !g4() || !t.visualViewport ? hM : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function vM(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ln(e) ? !1 : t;
}
function u1(e, t, n, c) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = m4(e);
  let s = Vn(1);
  t && (c ? Rn(c) && (s = Y1(c)) : s = Y1(e));
  const u = vM(a, n, c) ? u5(a) : Vn(0);
  let f = (o.left + u.x) / s.x, d = (o.top + u.y) / s.y, p = o.width / s.x, m = o.height / s.y;
  if (a) {
    const b = ln(a), y = c && Rn(c) ? ln(c) : c;
    let C = b, h = xl(C);
    for (; h && c && y !== C; ) {
      const v = Y1(h), I = h.getBoundingClientRect(), S = Pn(h), L = I.left + (h.clientLeft + parseFloat(S.paddingLeft)) * v.x, R = I.top + (h.clientTop + parseFloat(S.paddingTop)) * v.y;
      f *= v.x, d *= v.y, p *= v.x, m *= v.y, f += L, d += R, C = ln(h), h = xl(C);
    }
  }
  return Zi({
    width: p,
    height: m,
    x: f,
    y: d
  });
}
function h4(e, t) {
  const n = xa(e).scrollLeft;
  return t ? t.left + n : u1(Zn(e)).left + n;
}
function f5(e, t, n) {
  n === void 0 && (n = !1);
  const c = e.getBoundingClientRect(), o = c.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    h4(e, c)
  )), a = c.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function bM(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: c,
    strategy: o
  } = e;
  const a = o === "fixed", s = Zn(c), u = t ? Ca(t.floating) : !1;
  if (c === s || u && a)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Vn(1);
  const p = Vn(0), m = Xn(c);
  if ((m || !m && !a) && ((lc(c) !== "body" || po(s)) && (f = xa(c)), Xn(c))) {
    const y = u1(c);
    d = Y1(c), p.x = y.x + c.clientLeft, p.y = y.y + c.clientTop;
  }
  const b = s && !m && !a ? f5(s, f, !0) : Vn(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - f.scrollLeft * d.x + p.x + b.x,
    y: n.y * d.y - f.scrollTop * d.y + p.y + b.y
  };
}
function CM(e) {
  return Array.from(e.getClientRects());
}
function xM(e) {
  const t = Zn(e), n = xa(e), c = e.ownerDocument.body, o = sn(t.scrollWidth, t.clientWidth, c.scrollWidth, c.clientWidth), a = sn(t.scrollHeight, t.clientHeight, c.scrollHeight, c.clientHeight);
  let s = -n.scrollLeft + h4(e);
  const u = -n.scrollTop;
  return Pn(c).direction === "rtl" && (s += sn(t.clientWidth, c.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: u
  };
}
function yM(e, t) {
  const n = ln(e), c = Zn(e), o = n.visualViewport;
  let a = c.clientWidth, s = c.clientHeight, u = 0, f = 0;
  if (o) {
    a = o.width, s = o.height;
    const d = g4();
    (!d || d && t === "fixed") && (u = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: u,
    y: f
  };
}
function IM(e, t) {
  const n = u1(e, !0, t === "fixed"), c = n.top + e.clientTop, o = n.left + e.clientLeft, a = Xn(e) ? Y1(e) : Vn(1), s = e.clientWidth * a.x, u = e.clientHeight * a.y, f = o * a.x, d = c * a.y;
  return {
    width: s,
    height: u,
    x: f,
    y: d
  };
}
function L6(e, t, n) {
  let c;
  if (t === "viewport")
    c = yM(e, n);
  else if (t === "document")
    c = xM(Zn(e));
  else if (Rn(t))
    c = IM(t, n);
  else {
    const o = u5(e);
    c = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Zi(c);
}
function d5(e, t) {
  const n = Hr(e);
  return n === t || !Rn(n) || ec(n) ? !1 : Pn(n).position === "fixed" || d5(n, t);
}
function wM(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let c = no(e, [], !1).filter((u) => Rn(u) && lc(u) !== "body"), o = null;
  const a = Pn(e).position === "fixed";
  let s = a ? Hr(e) : e;
  for (; Rn(s) && !ec(s); ) {
    const u = Pn(s), f = p4(s);
    !f && u.position === "fixed" && (o = null), (a ? !f && !o : !f && u.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || po(s) && !f && d5(e, s)) ? c = c.filter((p) => p !== s) : o = u, s = Hr(s);
  }
  return t.set(e, c), c;
}
function AM(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: c,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ca(t) ? [] : wM(t, this._c) : [].concat(n), c], u = s[0], f = s.reduce((d, p) => {
    const m = L6(t, p, o);
    return d.top = sn(m.top, d.top), d.right = Vr(m.right, d.right), d.bottom = Vr(m.bottom, d.bottom), d.left = sn(m.left, d.left), d;
  }, L6(t, u, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function SM(e) {
  const {
    width: t,
    height: n
  } = l5(e);
  return {
    width: t,
    height: n
  };
}
function _M(e, t, n) {
  const c = Xn(t), o = Zn(t), a = n === "fixed", s = u1(e, !0, a, t);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = Vn(0);
  if (c || !c && !a)
    if ((lc(t) !== "body" || po(o)) && (u = xa(t)), c) {
      const b = u1(t, !0, a, t);
      f.x = b.x + t.clientLeft, f.y = b.y + t.clientTop;
    } else o && (f.x = h4(o));
  const d = o && !c && !a ? f5(o, u) : Vn(0), p = s.left + u.scrollLeft - f.x - d.x, m = s.top + u.scrollTop - f.y - d.y;
  return {
    x: p,
    y: m,
    width: s.width,
    height: s.height
  };
}
function _s(e) {
  return Pn(e).position === "static";
}
function R6(e, t) {
  if (!Xn(e) || Pn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Zn(e) === n && (n = n.ownerDocument.body), n;
}
function p5(e, t) {
  const n = ln(e);
  if (Ca(e))
    return n;
  if (!Xn(e)) {
    let o = Hr(e);
    for (; o && !ec(o); ) {
      if (Rn(o) && !_s(o))
        return o;
      o = Hr(o);
    }
    return n;
  }
  let c = R6(e, t);
  for (; c && gM(c) && _s(c); )
    c = R6(c, t);
  return c && ec(c) && _s(c) && !p4(c) ? n : c || mM(e) || n;
}
const EM = async function(e) {
  const t = this.getOffsetParent || p5, n = this.getDimensions, c = await n(e.floating);
  return {
    reference: _M(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: c.width,
      height: c.height
    }
  };
};
function MM(e) {
  return Pn(e).direction === "rtl";
}
const LM = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bM,
  getDocumentElement: Zn,
  getClippingRect: AM,
  getOffsetParent: p5,
  getElementRects: EM,
  getClientRects: CM,
  getDimensions: SM,
  getScale: Y1,
  isElement: Rn,
  isRTL: MM
};
function g5(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function RM(e, t) {
  let n = null, c;
  const o = Zn(e);
  function a() {
    var u;
    clearTimeout(c), (u = n) == null || u.disconnect(), n = null;
  }
  function s(u, f) {
    u === void 0 && (u = !1), f === void 0 && (f = 1), a();
    const d = e.getBoundingClientRect(), {
      left: p,
      top: m,
      width: b,
      height: y
    } = d;
    if (u || t(), !b || !y)
      return;
    const C = xi(m), h = xi(o.clientWidth - (p + b)), v = xi(o.clientHeight - (m + y)), I = xi(p), L = {
      rootMargin: -C + "px " + -h + "px " + -v + "px " + -I + "px",
      threshold: sn(0, Vr(1, f)) || 1
    };
    let R = !0;
    function M($) {
      const O = $[0].intersectionRatio;
      if (O !== f) {
        if (!R)
          return s();
        O ? s(!1, O) : c = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !g5(d, e.getBoundingClientRect()) && s(), R = !1;
    }
    try {
      n = new IntersectionObserver(M, {
        ...L,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(M, L);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function v4(e, t, n, c) {
  c === void 0 && (c = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = c, d = m4(e), p = o || a ? [...d ? no(d) : [], ...no(t)] : [];
  p.forEach((I) => {
    o && I.addEventListener("scroll", n, {
      passive: !0
    }), a && I.addEventListener("resize", n);
  });
  const m = d && u ? RM(d, n) : null;
  let b = -1, y = null;
  s && (y = new ResizeObserver((I) => {
    let [S] = I;
    S && S.target === d && y && (y.unobserve(t), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var L;
      (L = y) == null || L.observe(t);
    })), n();
  }), d && !f && y.observe(d), y.observe(t));
  let C, h = f ? u1(e) : null;
  f && v();
  function v() {
    const I = u1(e);
    h && !g5(h, I) && n(), h = I, C = requestAnimationFrame(v);
  }
  return n(), () => {
    var I;
    p.forEach((S) => {
      o && S.removeEventListener("scroll", n), a && S.removeEventListener("resize", n);
    }), m == null || m(), (I = y) == null || I.disconnect(), y = null, f && cancelAnimationFrame(C);
  };
}
const PM = uM, TM = fM, zM = aM, NM = pM, OM = sM, P6 = iM, FM = dM, DM = (e, t, n) => {
  const c = /* @__PURE__ */ new Map(), o = {
    platform: LM,
    ...n
  }, a = {
    ...o.platform,
    _c: c
  };
  return oM(e, t, {
    ...o,
    platform: a
  });
};
var Ni = typeof document < "u" ? ia : ct;
function Yi(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, c, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (c = n; c-- !== 0; )
        if (!Yi(e[c], t[c]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (c = n; c-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[c]))
        return !1;
    for (c = n; c-- !== 0; ) {
      const a = o[c];
      if (!(a === "_owner" && e.$$typeof) && !Yi(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function m5(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function T6(e, t) {
  const n = m5(e);
  return Math.round(t * n) / n;
}
function Es(e) {
  const t = A.useRef(e);
  return Ni(() => {
    t.current = e;
  }), t;
}
function h5(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: c = [],
    platform: o,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: u = !0,
    whileElementsMounted: f,
    open: d
  } = e, [p, m] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [b, y] = A.useState(c);
  Yi(b, c) || y(c);
  const [C, h] = A.useState(null), [v, I] = A.useState(null), S = A.useCallback((ee) => {
    ee !== $.current && ($.current = ee, h(ee));
  }, []), L = A.useCallback((ee) => {
    ee !== O.current && (O.current = ee, I(ee));
  }, []), R = a || C, M = s || v, $ = A.useRef(null), O = A.useRef(null), G = A.useRef(p), J = f != null, ae = Es(f), fe = Es(o), U = Es(d), re = A.useCallback(() => {
    if (!$.current || !O.current)
      return;
    const ee = {
      placement: t,
      strategy: n,
      middleware: b
    };
    fe.current && (ee.platform = fe.current), DM($.current, O.current, ee).then((q) => {
      const B = {
        ...q,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: U.current !== !1
      };
      oe.current && !Yi(G.current, B) && (G.current = B, Bf.flushSync(() => {
        m(B);
      }));
    });
  }, [b, t, n, fe, U]);
  Ni(() => {
    d === !1 && G.current.isPositioned && (G.current.isPositioned = !1, m((ee) => ({
      ...ee,
      isPositioned: !1
    })));
  }, [d]);
  const oe = A.useRef(!1);
  Ni(() => (oe.current = !0, () => {
    oe.current = !1;
  }), []), Ni(() => {
    if (R && ($.current = R), M && (O.current = M), R && M) {
      if (ae.current)
        return ae.current(R, M, re);
      re();
    }
  }, [R, M, re, ae, J]);
  const ue = A.useMemo(() => ({
    reference: $,
    floating: O,
    setReference: S,
    setFloating: L
  }), [S, L]), te = A.useMemo(() => ({
    reference: R,
    floating: M
  }), [R, M]), se = A.useMemo(() => {
    const ee = {
      position: n,
      left: 0,
      top: 0
    };
    if (!te.floating)
      return ee;
    const q = T6(te.floating, p.x), B = T6(te.floating, p.y);
    return u ? {
      ...ee,
      transform: "translate(" + q + "px, " + B + "px)",
      ...m5(te.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: q,
      top: B
    };
  }, [n, u, te.floating, p.x, p.y]);
  return A.useMemo(() => ({
    ...p,
    update: re,
    refs: ue,
    elements: te,
    floatingStyles: se
  }), [p, re, ue, te, se]);
}
const $M = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: c,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return c && t(c) ? c.current != null ? P6({
        element: c.current,
        padding: o
      }).fn(n) : {} : c ? P6({
        element: c,
        padding: o
      }).fn(n) : {};
    }
  };
}, v5 = (e, t) => ({
  ...PM(e),
  options: [e, t]
}), b5 = (e, t) => ({
  ...TM(e),
  options: [e, t]
}), C5 = (e, t) => ({
  ...FM(e),
  options: [e, t]
}), x5 = (e, t) => ({
  ...zM(e),
  options: [e, t]
}), y5 = (e, t) => ({
  ...NM(e),
  options: [e, t]
}), I5 = (e, t) => ({
  ...OM(e),
  options: [e, t]
}), w5 = (e, t) => ({
  ...$M(e),
  options: [e, t]
});
var GM = "Arrow", A5 = A.forwardRef((e, t) => {
  const { children: n, width: c = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ w.jsx(
    ke.svg,
    {
      ...a,
      ref: t,
      width: c,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ w.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
A5.displayName = GM;
var kM = A5, b4 = "Popper", [S5, uc] = Ht(b4), [BM, _5] = S5(b4), E5 = (e) => {
  const { __scopePopper: t, children: n } = e, [c, o] = A.useState(null);
  return /* @__PURE__ */ w.jsx(BM, { scope: t, anchor: c, onAnchorChange: o, children: n });
};
E5.displayName = b4;
var M5 = "PopperAnchor", L5 = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: c, ...o } = e, a = _5(M5, n), s = A.useRef(null), u = pt(t, s);
    return A.useEffect(() => {
      a.onAnchorChange((c == null ? void 0 : c.current) || s.current);
    }), c ? null : /* @__PURE__ */ w.jsx(ke.div, { ...o, ref: u });
  }
);
L5.displayName = M5;
var C4 = "PopperContent", [VM, WM] = S5(C4), R5 = A.forwardRef(
  (e, t) => {
    var Z, ne, ge, me, we, j;
    const {
      __scopePopper: n,
      side: c = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: u = 0,
      avoidCollisions: f = !0,
      collisionBoundary: d = [],
      collisionPadding: p = 0,
      sticky: m = "partial",
      hideWhenDetached: b = !1,
      updatePositionStrategy: y = "optimized",
      onPlaced: C,
      ...h
    } = e, v = _5(C4, n), [I, S] = A.useState(null), L = pt(t, (Be) => S(Be)), [R, M] = A.useState(null), $ = a4(R), O = ($ == null ? void 0 : $.width) ?? 0, G = ($ == null ? void 0 : $.height) ?? 0, J = c + (a !== "center" ? "-" + a : ""), ae = typeof p == "number" ? p : { top: 0, right: 0, bottom: 0, left: 0, ...p }, fe = Array.isArray(d) ? d : [d], U = fe.length > 0, re = {
      padding: ae,
      boundary: fe.filter(jM),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: U
    }, { refs: oe, floatingStyles: ue, placement: te, isPositioned: se, middlewareData: ee } = h5({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: J,
      whileElementsMounted: (...Be) => v4(...Be, {
        animationFrame: y === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        v5({ mainAxis: o + G, alignmentAxis: s }),
        f && b5({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? C5() : void 0,
          ...re
        }),
        f && x5({ ...re }),
        y5({
          ...re,
          apply: ({ elements: Be, rects: Fe, availableWidth: ut, availableHeight: $t }) => {
            const { width: Ct, height: Yn } = Fe.reference, Qt = Be.floating.style;
            Qt.setProperty("--radix-popper-available-width", `${ut}px`), Qt.setProperty("--radix-popper-available-height", `${$t}px`), Qt.setProperty("--radix-popper-anchor-width", `${Ct}px`), Qt.setProperty("--radix-popper-anchor-height", `${Yn}px`);
          }
        }),
        R && w5({ element: R, padding: u }),
        XM({ arrowWidth: O, arrowHeight: G }),
        b && I5({ strategy: "referenceHidden", ...re })
      ]
    }), [q, B] = z5(te), X = wn(C);
    Br(() => {
      se && (X == null || X());
    }, [se, X]);
    const ie = (Z = ee.arrow) == null ? void 0 : Z.x, he = (ne = ee.arrow) == null ? void 0 : ne.y, le = ((ge = ee.arrow) == null ? void 0 : ge.centerOffset) !== 0, [ve, de] = A.useState();
    return Br(() => {
      I && de(window.getComputedStyle(I).zIndex);
    }, [I]), /* @__PURE__ */ w.jsx(
      "div",
      {
        ref: oe.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...ue,
          transform: se ? ue.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ve,
          "--radix-popper-transform-origin": [
            (me = ee.transformOrigin) == null ? void 0 : me.x,
            (we = ee.transformOrigin) == null ? void 0 : we.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((j = ee.hide) == null ? void 0 : j.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ w.jsx(
          VM,
          {
            scope: n,
            placedSide: q,
            onArrowChange: M,
            arrowX: ie,
            arrowY: he,
            shouldHideArrow: le,
            children: /* @__PURE__ */ w.jsx(
              ke.div,
              {
                "data-side": q,
                "data-align": B,
                ...h,
                ref: L,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: se ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
R5.displayName = C4;
var P5 = "PopperArrow", HM = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, T5 = A.forwardRef(function(t, n) {
  const { __scopePopper: c, ...o } = t, a = WM(P5, c), s = HM[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ w.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ w.jsx(
          kM,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
T5.displayName = P5;
function jM(e) {
  return e !== null;
}
var XM = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, I, S;
    const { placement: n, rects: c, middlewareData: o } = t, s = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, u = s ? 0 : e.arrowWidth, f = s ? 0 : e.arrowHeight, [d, p] = z5(n), m = { start: "0%", center: "50%", end: "100%" }[p], b = (((I = o.arrow) == null ? void 0 : I.x) ?? 0) + u / 2, y = (((S = o.arrow) == null ? void 0 : S.y) ?? 0) + f / 2;
    let C = "", h = "";
    return d === "bottom" ? (C = s ? m : `${b}px`, h = `${-f}px`) : d === "top" ? (C = s ? m : `${b}px`, h = `${c.floating.height + f}px`) : d === "right" ? (C = `${-f}px`, h = s ? m : `${y}px`) : d === "left" && (C = `${c.floating.width + f}px`, h = s ? m : `${y}px`), { data: { x: C, y: h } };
  }
});
function z5(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ya = E5, Ia = L5, x4 = R5, y4 = T5, ZM = "Portal", N5 = A.forwardRef((e, t) => {
  var u;
  const { container: n, ...c } = e, [o, a] = A.useState(!1);
  Br(() => a(!0), []);
  const s = n || o && ((u = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : u.body);
  return s ? Vf.createPortal(/* @__PURE__ */ w.jsx(ke.div, { ...c, ref: t }), s) : null;
});
N5.displayName = ZM;
var Ms = "rovingFocusGroup.onEntryFocus", YM = { bubbles: !1, cancelable: !0 }, wa = "RovingFocusGroup", [yl, O5, UM] = Ql(wa), [JM, Xr] = Ht(
  wa,
  [UM]
), [KM, qM] = JM(wa), F5 = A.forwardRef(
  (e, t) => /* @__PURE__ */ w.jsx(yl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w.jsx(yl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w.jsx(QM, { ...e, ref: t }) }) })
);
F5.displayName = wa;
var QM = A.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: c,
    loop: o = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: u,
    onCurrentTabStopIdChange: f,
    onEntryFocus: d,
    preventScrollOnEntryFocus: p = !1,
    ...m
  } = e, b = A.useRef(null), y = pt(t, b), C = ic(a), [h = null, v] = qt({
    prop: s,
    defaultProp: u,
    onChange: f
  }), [I, S] = A.useState(!1), L = wn(d), R = O5(n), M = A.useRef(!1), [$, O] = A.useState(0);
  return A.useEffect(() => {
    const G = b.current;
    if (G)
      return G.addEventListener(Ms, L), () => G.removeEventListener(Ms, L);
  }, [L]), /* @__PURE__ */ w.jsx(
    KM,
    {
      scope: n,
      orientation: c,
      dir: C,
      loop: o,
      currentTabStopId: h,
      onItemFocus: A.useCallback(
        (G) => v(G),
        [v]
      ),
      onItemShiftTab: A.useCallback(() => S(!0), []),
      onFocusableItemAdd: A.useCallback(
        () => O((G) => G + 1),
        []
      ),
      onFocusableItemRemove: A.useCallback(
        () => O((G) => G - 1),
        []
      ),
      children: /* @__PURE__ */ w.jsx(
        ke.div,
        {
          tabIndex: I || $ === 0 ? -1 : 0,
          "data-orientation": c,
          ...m,
          ref: y,
          style: { outline: "none", ...e.style },
          onMouseDown: Ae(e.onMouseDown, () => {
            M.current = !0;
          }),
          onFocus: Ae(e.onFocus, (G) => {
            const J = !M.current;
            if (G.target === G.currentTarget && J && !I) {
              const ae = new CustomEvent(Ms, YM);
              if (G.currentTarget.dispatchEvent(ae), !ae.defaultPrevented) {
                const fe = R().filter((te) => te.focusable), U = fe.find((te) => te.active), re = fe.find((te) => te.id === h), ue = [U, re, ...fe].filter(
                  Boolean
                ).map((te) => te.ref.current);
                G5(ue, p);
              }
            }
            M.current = !1;
          }),
          onBlur: Ae(e.onBlur, () => S(!1))
        }
      )
    }
  );
}), D5 = "RovingFocusGroupItem", $5 = A.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: c = !0,
      active: o = !1,
      tabStopId: a,
      ...s
    } = e, u = jn(), f = a || u, d = qM(D5, n), p = d.currentTabStopId === f, m = O5(n), { onFocusableItemAdd: b, onFocusableItemRemove: y } = d;
    return A.useEffect(() => {
      if (c)
        return b(), () => y();
    }, [c, b, y]), /* @__PURE__ */ w.jsx(
      yl.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: c,
        active: o,
        children: /* @__PURE__ */ w.jsx(
          ke.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: Ae(e.onMouseDown, (C) => {
              c ? d.onItemFocus(f) : C.preventDefault();
            }),
            onFocus: Ae(e.onFocus, () => d.onItemFocus(f)),
            onKeyDown: Ae(e.onKeyDown, (C) => {
              if (C.key === "Tab" && C.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (C.target !== C.currentTarget) return;
              const h = nL(C, d.orientation, d.dir);
              if (h !== void 0) {
                if (C.metaKey || C.ctrlKey || C.altKey || C.shiftKey) return;
                C.preventDefault();
                let I = m().filter((S) => S.focusable).map((S) => S.ref.current);
                if (h === "last") I.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && I.reverse();
                  const S = I.indexOf(C.currentTarget);
                  I = d.loop ? rL(I, S + 1) : I.slice(S + 1);
                }
                setTimeout(() => G5(I));
              }
            })
          }
        )
      }
    );
  }
);
$5.displayName = D5;
var eL = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function tL(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function nL(e, t, n) {
  const c = tL(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(c)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(c)))
    return eL[c];
}
function G5(e, t = !1) {
  const n = document.activeElement;
  for (const c of e)
    if (c === n || (c.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function rL(e, t) {
  return e.map((n, c) => e[(t + c) % e.length]);
}
var Aa = F5, Sa = $5, cL = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, $1 = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), Ii = {}, Ls = 0, k5 = function(e) {
  return e && (e.host || k5(e.parentNode));
}, oL = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var c = k5(n);
    return c && e.contains(c) ? c : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, iL = function(e, t, n, c) {
  var o = oL(t, Array.isArray(e) ? e : [e]);
  Ii[n] || (Ii[n] = /* @__PURE__ */ new WeakMap());
  var a = Ii[n], s = [], u = /* @__PURE__ */ new Set(), f = new Set(o), d = function(m) {
    !m || u.has(m) || (u.add(m), d(m.parentNode));
  };
  o.forEach(d);
  var p = function(m) {
    !m || f.has(m) || Array.prototype.forEach.call(m.children, function(b) {
      if (u.has(b))
        p(b);
      else
        try {
          var y = b.getAttribute(c), C = y !== null && y !== "false", h = ($1.get(b) || 0) + 1, v = (a.get(b) || 0) + 1;
          $1.set(b, h), a.set(b, v), s.push(b), h === 1 && C && yi.set(b, !0), v === 1 && b.setAttribute(n, "true"), C || b.setAttribute(c, "true");
        } catch (I) {
          console.error("aria-hidden: cannot operate on ", b, I);
        }
    });
  };
  return p(t), u.clear(), Ls++, function() {
    s.forEach(function(m) {
      var b = $1.get(m) - 1, y = a.get(m) - 1;
      $1.set(m, b), a.set(m, y), b || (yi.has(m) || m.removeAttribute(c), yi.delete(m)), y || m.removeAttribute(n);
    }), Ls--, Ls || ($1 = /* @__PURE__ */ new WeakMap(), $1 = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), Ii = {});
  };
}, I4 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var c = Array.from(Array.isArray(e) ? e : [e]), o = cL(e);
  return o ? (c.push.apply(c, Array.from(o.querySelectorAll("[aria-live]"))), iL(c, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Ot = function() {
  return Ot = Object.assign || function(t) {
    for (var n, c = 1, o = arguments.length; c < o; c++) {
      n = arguments[c];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ot.apply(this, arguments);
};
function w4(e, t) {
  var n = {};
  for (var c in e) Object.prototype.hasOwnProperty.call(e, c) && t.indexOf(c) < 0 && (n[c] = e[c]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, c = Object.getOwnPropertySymbols(e); o < c.length; o++)
      t.indexOf(c[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[o]) && (n[c[o]] = e[c[o]]);
  return n;
}
function B5(e, t, n) {
  if (n || arguments.length === 2) for (var c = 0, o = t.length, a; c < o; c++)
    (a || !(c in t)) && (a || (a = Array.prototype.slice.call(t, 0, c)), a[c] = t[c]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Kc = "right-scroll-bar-position", qc = "width-before-scroll-bar", aL = "with-scroll-bars-hidden", sL = "--removed-body-scroll-bar-size";
function Rs(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function lL(e, t) {
  var n = Ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(c) {
          var o = n.value;
          o !== c && (n.value = c, n.callback(c, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var uL = typeof window < "u" ? A.useLayoutEffect : A.useEffect, z6 = /* @__PURE__ */ new WeakMap();
function V5(e, t) {
  var n = lL(null, function(c) {
    return e.forEach(function(o) {
      return Rs(o, c);
    });
  });
  return uL(function() {
    var c = z6.get(n);
    if (c) {
      var o = new Set(c), a = new Set(e), s = n.current;
      o.forEach(function(u) {
        a.has(u) || Rs(u, null);
      }), a.forEach(function(u) {
        o.has(u) || Rs(u, s);
      });
    }
    z6.set(n, e);
  }, [e]), n;
}
function fL(e) {
  return e;
}
function dL(e, t) {
  t === void 0 && (t = fL);
  var n = [], c = !1, o = {
    read: function() {
      if (c)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, c);
      return n.push(s), function() {
        n = n.filter(function(u) {
          return u !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (c = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(u) {
          return a(u);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      c = !0;
      var s = [];
      if (n.length) {
        var u = n;
        n = [], u.forEach(a), s = n;
      }
      var f = function() {
        var p = s;
        s = [], p.forEach(a);
      }, d = function() {
        return Promise.resolve().then(f);
      };
      d(), n = {
        push: function(p) {
          s.push(p), d();
        },
        filter: function(p) {
          return s = s.filter(p), n;
        }
      };
    }
  };
  return o;
}
function W5(e) {
  e === void 0 && (e = {});
  var t = dL(null);
  return t.options = Ot({ async: !0, ssr: !1 }, e), t;
}
var H5 = function(e) {
  var t = e.sideCar, n = w4(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var c = t.read();
  if (!c)
    throw new Error("Sidecar medium not found");
  return A.createElement(c, Ot({}, n));
};
H5.isSideCarExport = !0;
function j5(e, t) {
  return e.useMedium(t), H5;
}
var X5 = W5(), Ps = function() {
}, _a = A.forwardRef(function(e, t) {
  var n = A.useRef(null), c = A.useState({
    onScrollCapture: Ps,
    onWheelCapture: Ps,
    onTouchMoveCapture: Ps
  }), o = c[0], a = c[1], s = e.forwardProps, u = e.children, f = e.className, d = e.removeScrollBar, p = e.enabled, m = e.shards, b = e.sideCar, y = e.noIsolation, C = e.inert, h = e.allowPinchZoom, v = e.as, I = v === void 0 ? "div" : v, S = e.gapMode, L = w4(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = b, M = V5([n, t]), $ = Ot(Ot({}, L), o);
  return A.createElement(
    A.Fragment,
    null,
    p && A.createElement(R, { sideCar: X5, removeScrollBar: d, shards: m, noIsolation: y, inert: C, setCallbacks: a, allowPinchZoom: !!h, lockRef: n, gapMode: S }),
    s ? A.cloneElement(A.Children.only(u), Ot(Ot({}, $), { ref: M })) : A.createElement(I, Ot({}, $, { className: f, ref: M }), u)
  );
});
_a.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_a.classNames = {
  fullWidth: qc,
  zeroRight: Kc
};
var pL = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function gL() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = pL();
  return t && e.setAttribute("nonce", t), e;
}
function mL(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function hL(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var vL = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = gL()) && (mL(t, n), hL(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, bL = function() {
  var e = vL();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, A4 = function() {
  var e = bL(), t = function(n) {
    var c = n.styles, o = n.dynamic;
    return e(c, o), null;
  };
  return t;
}, CL = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ts = function(e) {
  return parseInt(e || "", 10) || 0;
}, xL = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], c = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ts(n), Ts(c), Ts(o)];
}, yL = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return CL;
  var t = xL(e), n = document.documentElement.clientWidth, c = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, c - n + t[2] - t[0])
  };
}, IL = A4(), U1 = "data-scroll-locked", wL = function(e, t, n, c) {
  var o = e.left, a = e.top, s = e.right, u = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(aL, ` {
   overflow: hidden `).concat(c, `;
   padding-right: `).concat(u, "px ").concat(c, `;
  }
  body[`).concat(U1, `] {
    overflow: hidden `).concat(c, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(c, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(u, "px ").concat(c, `;
    `),
    n === "padding" && "padding-right: ".concat(u, "px ").concat(c, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Kc, ` {
    right: `).concat(u, "px ").concat(c, `;
  }
  
  .`).concat(qc, ` {
    margin-right: `).concat(u, "px ").concat(c, `;
  }
  
  .`).concat(Kc, " .").concat(Kc, ` {
    right: 0 `).concat(c, `;
  }
  
  .`).concat(qc, " .").concat(qc, ` {
    margin-right: 0 `).concat(c, `;
  }
  
  body[`).concat(U1, `] {
    `).concat(sL, ": ").concat(u, `px;
  }
`);
}, N6 = function() {
  var e = parseInt(document.body.getAttribute(U1) || "0", 10);
  return isFinite(e) ? e : 0;
}, AL = function() {
  A.useEffect(function() {
    return document.body.setAttribute(U1, (N6() + 1).toString()), function() {
      var e = N6() - 1;
      e <= 0 ? document.body.removeAttribute(U1) : document.body.setAttribute(U1, e.toString());
    };
  }, []);
}, Z5 = function(e) {
  var t = e.noRelative, n = e.noImportant, c = e.gapMode, o = c === void 0 ? "margin" : c;
  AL();
  var a = A.useMemo(function() {
    return yL(o);
  }, [o]);
  return A.createElement(IL, { styles: wL(a, !t, o, n ? "" : "!important") });
}, Il = !1;
if (typeof window < "u")
  try {
    var wi = Object.defineProperty({}, "passive", {
      get: function() {
        return Il = !0, !0;
      }
    });
    window.addEventListener("test", wi, wi), window.removeEventListener("test", wi, wi);
  } catch {
    Il = !1;
  }
var G1 = Il ? { passive: !1 } : !1, SL = function(e) {
  return e.tagName === "TEXTAREA";
}, Y5 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !SL(e) && n[t] === "visible")
  );
}, _L = function(e) {
  return Y5(e, "overflowY");
}, EL = function(e) {
  return Y5(e, "overflowX");
}, O6 = function(e, t) {
  var n = t.ownerDocument, c = t;
  do {
    typeof ShadowRoot < "u" && c instanceof ShadowRoot && (c = c.host);
    var o = U5(e, c);
    if (o) {
      var a = J5(e, c), s = a[1], u = a[2];
      if (s > u)
        return !0;
    }
    c = c.parentNode;
  } while (c && c !== n.body);
  return !1;
}, ML = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, c = e.clientHeight;
  return [
    t,
    n,
    c
  ];
}, LL = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, c = e.clientWidth;
  return [
    t,
    n,
    c
  ];
}, U5 = function(e, t) {
  return e === "v" ? _L(t) : EL(t);
}, J5 = function(e, t) {
  return e === "v" ? ML(t) : LL(t);
}, RL = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, PL = function(e, t, n, c, o) {
  var a = RL(e, window.getComputedStyle(t).direction), s = a * c, u = n.target, f = t.contains(u), d = !1, p = s > 0, m = 0, b = 0;
  do {
    var y = J5(e, u), C = y[0], h = y[1], v = y[2], I = h - v - a * C;
    (C || I) && U5(e, u) && (m += I, b += C), u instanceof ShadowRoot ? u = u.host : u = u.parentNode;
  } while (
    // portaled content
    !f && u !== document.body || // self content
    f && (t.contains(u) || t === u)
  );
  return (p && Math.abs(m) < 1 || !p && Math.abs(b) < 1) && (d = !0), d;
}, Ai = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, F6 = function(e) {
  return [e.deltaX, e.deltaY];
}, D6 = function(e) {
  return e && "current" in e ? e.current : e;
}, TL = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, zL = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, NL = 0, k1 = [];
function OL(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), c = A.useRef(), o = A.useState(NL++)[0], a = A.useState(A4)[0], s = A.useRef(e);
  A.useEffect(function() {
    s.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = B5([e.lockRef.current], (e.shards || []).map(D6), !0).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = A.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !s.current.allowPinchZoom;
    var I = Ai(h), S = n.current, L = "deltaX" in h ? h.deltaX : S[0] - I[0], R = "deltaY" in h ? h.deltaY : S[1] - I[1], M, $ = h.target, O = Math.abs(L) > Math.abs(R) ? "h" : "v";
    if ("touches" in h && O === "h" && $.type === "range")
      return !1;
    var G = O6(O, $);
    if (!G)
      return !0;
    if (G ? M = O : (M = O === "v" ? "h" : "v", G = O6(O, $)), !G)
      return !1;
    if (!c.current && "changedTouches" in h && (L || R) && (c.current = M), !M)
      return !0;
    var J = c.current || M;
    return PL(J, v, h, J === "h" ? L : R);
  }, []), f = A.useCallback(function(h) {
    var v = h;
    if (!(!k1.length || k1[k1.length - 1] !== a)) {
      var I = "deltaY" in v ? F6(v) : Ai(v), S = t.current.filter(function(M) {
        return M.name === v.type && (M.target === v.target || v.target === M.shadowParent) && TL(M.delta, I);
      })[0];
      if (S && S.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!S) {
        var L = (s.current.shards || []).map(D6).filter(Boolean).filter(function(M) {
          return M.contains(v.target);
        }), R = L.length > 0 ? u(v, L[0]) : !s.current.noIsolation;
        R && v.cancelable && v.preventDefault();
      }
    }
  }, []), d = A.useCallback(function(h, v, I, S) {
    var L = { name: h, delta: v, target: I, should: S, shadowParent: FL(I) };
    t.current.push(L), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== L;
      });
    }, 1);
  }, []), p = A.useCallback(function(h) {
    n.current = Ai(h), c.current = void 0;
  }, []), m = A.useCallback(function(h) {
    d(h.type, F6(h), h.target, u(h, e.lockRef.current));
  }, []), b = A.useCallback(function(h) {
    d(h.type, Ai(h), h.target, u(h, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return k1.push(a), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", f, G1), document.addEventListener("touchmove", f, G1), document.addEventListener("touchstart", p, G1), function() {
      k1 = k1.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", f, G1), document.removeEventListener("touchmove", f, G1), document.removeEventListener("touchstart", p, G1);
    };
  }, []);
  var y = e.removeScrollBar, C = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    C ? A.createElement(a, { styles: zL(o) }) : null,
    y ? A.createElement(Z5, { gapMode: e.gapMode }) : null
  );
}
function FL(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const DL = j5(X5, OL);
var S4 = A.forwardRef(function(e, t) {
  return A.createElement(_a, Ot({}, e, { ref: t, sideCar: DL }));
});
S4.classNames = _a.classNames;
var wl = ["Enter", " "], $L = ["ArrowDown", "PageUp", "Home"], K5 = ["ArrowUp", "PageDown", "End"], GL = [...$L, ...K5], kL = {
  ltr: [...wl, "ArrowRight"],
  rtl: [...wl, "ArrowLeft"]
}, BL = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, go = "Menu", [ro, VL, WL] = Ql(go), [d1, q5] = Ht(go, [
  WL,
  uc,
  Xr
]), mo = uc(), Q5 = Xr(), [e8, p1] = d1(go), [HL, ho] = d1(go), t8 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: c, dir: o, onOpenChange: a, modal: s = !0 } = e, u = mo(t), [f, d] = A.useState(null), p = A.useRef(!1), m = wn(a), b = ic(o);
  return A.useEffect(() => {
    const y = () => {
      p.current = !0, document.addEventListener("pointerdown", C, { capture: !0, once: !0 }), document.addEventListener("pointermove", C, { capture: !0, once: !0 });
    }, C = () => p.current = !1;
    return document.addEventListener("keydown", y, { capture: !0 }), () => {
      document.removeEventListener("keydown", y, { capture: !0 }), document.removeEventListener("pointerdown", C, { capture: !0 }), document.removeEventListener("pointermove", C, { capture: !0 });
    };
  }, []), /* @__PURE__ */ w.jsx(ya, { ...u, children: /* @__PURE__ */ w.jsx(
    e8,
    {
      scope: t,
      open: n,
      onOpenChange: m,
      content: f,
      onContentChange: d,
      children: /* @__PURE__ */ w.jsx(
        HL,
        {
          scope: t,
          onClose: A.useCallback(() => m(!1), [m]),
          isUsingKeyboardRef: p,
          dir: b,
          modal: s,
          children: c
        }
      )
    }
  ) });
};
t8.displayName = go;
var jL = "MenuAnchor", _4 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...c } = e, o = mo(n);
    return /* @__PURE__ */ w.jsx(Ia, { ...o, ...c, ref: t });
  }
);
_4.displayName = jL;
var XL = "MenuPortal", [vV, n8] = d1(XL, {
  forceMount: void 0
}), In = "MenuContent", [ZL, E4] = d1(In), r8 = A.forwardRef(
  (e, t) => {
    const n = n8(In, e.__scopeMenu), { forceMount: c = n.forceMount, ...o } = e, a = p1(In, e.__scopeMenu), s = ho(In, e.__scopeMenu);
    return /* @__PURE__ */ w.jsx(ro.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ w.jsx(Tn, { present: c || a.open, children: /* @__PURE__ */ w.jsx(ro.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ w.jsx(YL, { ...o, ref: t }) : /* @__PURE__ */ w.jsx(UL, { ...o, ref: t }) }) }) });
  }
), YL = A.forwardRef(
  (e, t) => {
    const n = p1(In, e.__scopeMenu), c = A.useRef(null), o = pt(t, c);
    return A.useEffect(() => {
      const a = c.current;
      if (a) return I4(a);
    }, []), /* @__PURE__ */ w.jsx(
      M4,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: Ae(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), UL = A.forwardRef((e, t) => {
  const n = p1(In, e.__scopeMenu);
  return /* @__PURE__ */ w.jsx(
    M4,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), M4 = A.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: c = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: u,
      onEntryFocus: f,
      onEscapeKeyDown: d,
      onPointerDownOutside: p,
      onFocusOutside: m,
      onInteractOutside: b,
      onDismiss: y,
      disableOutsideScroll: C,
      ...h
    } = e, v = p1(In, n), I = ho(In, n), S = mo(n), L = Q5(n), R = VL(n), [M, $] = A.useState(null), O = A.useRef(null), G = pt(t, O, v.onContentChange), J = A.useRef(0), ae = A.useRef(""), fe = A.useRef(0), U = A.useRef(null), re = A.useRef("right"), oe = A.useRef(0), ue = C ? S4 : A.Fragment, te = C ? { as: Q1, allowPinchZoom: !0 } : void 0, se = (q) => {
      var Z, ne;
      const B = ae.current + q, X = R().filter((ge) => !ge.disabled), ie = document.activeElement, he = (Z = X.find((ge) => ge.ref.current === ie)) == null ? void 0 : Z.textValue, le = X.map((ge) => ge.textValue), ve = aR(le, B, he), de = (ne = X.find((ge) => ge.textValue === ve)) == null ? void 0 : ne.ref.current;
      (function ge(me) {
        ae.current = me, window.clearTimeout(J.current), me !== "" && (J.current = window.setTimeout(() => ge(""), 1e3));
      })(B), de && setTimeout(() => de.focus());
    };
    A.useEffect(() => () => window.clearTimeout(J.current), []), c5();
    const ee = A.useCallback((q) => {
      var X, ie;
      return re.current === ((X = U.current) == null ? void 0 : X.side) && lR(q, (ie = U.current) == null ? void 0 : ie.area);
    }, []);
    return /* @__PURE__ */ w.jsx(
      ZL,
      {
        scope: n,
        searchRef: ae,
        onItemEnter: A.useCallback(
          (q) => {
            ee(q) && q.preventDefault();
          },
          [ee]
        ),
        onItemLeave: A.useCallback(
          (q) => {
            var B;
            ee(q) || ((B = O.current) == null || B.focus(), $(null));
          },
          [ee]
        ),
        onTriggerLeave: A.useCallback(
          (q) => {
            ee(q) && q.preventDefault();
          },
          [ee]
        ),
        pointerGraceTimerRef: fe,
        onPointerGraceIntentChange: A.useCallback((q) => {
          U.current = q;
        }, []),
        children: /* @__PURE__ */ w.jsx(ue, { ...te, children: /* @__PURE__ */ w.jsx(
          l4,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Ae(a, (q) => {
              var B;
              q.preventDefault(), (B = O.current) == null || B.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ w.jsx(
              va,
              {
                asChild: !0,
                disableOutsidePointerEvents: u,
                onEscapeKeyDown: d,
                onPointerDownOutside: p,
                onFocusOutside: m,
                onInteractOutside: b,
                onDismiss: y,
                children: /* @__PURE__ */ w.jsx(
                  Aa,
                  {
                    asChild: !0,
                    ...L,
                    dir: I.dir,
                    orientation: "vertical",
                    loop: c,
                    currentTabStopId: M,
                    onCurrentTabStopIdChange: $,
                    onEntryFocus: Ae(f, (q) => {
                      I.isUsingKeyboardRef.current || q.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ w.jsx(
                      x4,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": x8(v.open),
                        "data-radix-menu-content": "",
                        dir: I.dir,
                        ...S,
                        ...h,
                        ref: G,
                        style: { outline: "none", ...h.style },
                        onKeyDown: Ae(h.onKeyDown, (q) => {
                          const X = q.target.closest("[data-radix-menu-content]") === q.currentTarget, ie = q.ctrlKey || q.altKey || q.metaKey, he = q.key.length === 1;
                          X && (q.key === "Tab" && q.preventDefault(), !ie && he && se(q.key));
                          const le = O.current;
                          if (q.target !== le || !GL.includes(q.key)) return;
                          q.preventDefault();
                          const de = R().filter((Z) => !Z.disabled).map((Z) => Z.ref.current);
                          K5.includes(q.key) && de.reverse(), oR(de);
                        }),
                        onBlur: Ae(e.onBlur, (q) => {
                          q.currentTarget.contains(q.target) || (window.clearTimeout(J.current), ae.current = "");
                        }),
                        onPointerMove: Ae(
                          e.onPointerMove,
                          co((q) => {
                            const B = q.target, X = oe.current !== q.clientX;
                            if (q.currentTarget.contains(B) && X) {
                              const ie = q.clientX > oe.current ? "right" : "left";
                              re.current = ie, oe.current = q.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
r8.displayName = In;
var JL = "MenuGroup", L4 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...c } = e;
    return /* @__PURE__ */ w.jsx(ke.div, { role: "group", ...c, ref: t });
  }
);
L4.displayName = JL;
var KL = "MenuLabel", c8 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...c } = e;
    return /* @__PURE__ */ w.jsx(ke.div, { ...c, ref: t });
  }
);
c8.displayName = KL;
var Ui = "MenuItem", $6 = "menu.itemSelect", Ea = A.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: c, ...o } = e, a = A.useRef(null), s = ho(Ui, e.__scopeMenu), u = E4(Ui, e.__scopeMenu), f = pt(t, a), d = A.useRef(!1), p = () => {
      const m = a.current;
      if (!n && m) {
        const b = new CustomEvent($6, { bubbles: !0, cancelable: !0 });
        m.addEventListener($6, (y) => c == null ? void 0 : c(y), { once: !0 }), Pd(m, b), b.defaultPrevented ? d.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ w.jsx(
      o8,
      {
        ...o,
        ref: f,
        disabled: n,
        onClick: Ae(e.onClick, p),
        onPointerDown: (m) => {
          var b;
          (b = e.onPointerDown) == null || b.call(e, m), d.current = !0;
        },
        onPointerUp: Ae(e.onPointerUp, (m) => {
          var b;
          d.current || (b = m.currentTarget) == null || b.click();
        }),
        onKeyDown: Ae(e.onKeyDown, (m) => {
          const b = u.searchRef.current !== "";
          n || b && m.key === " " || wl.includes(m.key) && (m.currentTarget.click(), m.preventDefault());
        })
      }
    );
  }
);
Ea.displayName = Ui;
var o8 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: c = !1, textValue: o, ...a } = e, s = E4(Ui, n), u = Q5(n), f = A.useRef(null), d = pt(t, f), [p, m] = A.useState(!1), [b, y] = A.useState("");
    return A.useEffect(() => {
      const C = f.current;
      C && y((C.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ w.jsx(
      ro.ItemSlot,
      {
        scope: n,
        disabled: c,
        textValue: o ?? b,
        children: /* @__PURE__ */ w.jsx(Sa, { asChild: !0, ...u, focusable: !c, children: /* @__PURE__ */ w.jsx(
          ke.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": c || void 0,
            "data-disabled": c ? "" : void 0,
            ...a,
            ref: d,
            onPointerMove: Ae(
              e.onPointerMove,
              co((C) => {
                c ? s.onItemLeave(C) : (s.onItemEnter(C), C.defaultPrevented || C.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Ae(
              e.onPointerLeave,
              co((C) => s.onItemLeave(C))
            ),
            onFocus: Ae(e.onFocus, () => m(!0)),
            onBlur: Ae(e.onBlur, () => m(!1))
          }
        ) })
      }
    );
  }
), qL = "MenuCheckboxItem", i8 = A.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: c, ...o } = e;
    return /* @__PURE__ */ w.jsx(f8, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ w.jsx(
      Ea,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ji(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": T4(n),
        onSelect: Ae(
          o.onSelect,
          () => c == null ? void 0 : c(Ji(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
i8.displayName = qL;
var a8 = "MenuRadioGroup", [QL, eR] = d1(
  a8,
  { value: void 0, onValueChange: () => {
  } }
), s8 = A.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: c, ...o } = e, a = wn(c);
    return /* @__PURE__ */ w.jsx(QL, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ w.jsx(L4, { ...o, ref: t }) });
  }
);
s8.displayName = a8;
var l8 = "MenuRadioItem", u8 = A.forwardRef(
  (e, t) => {
    const { value: n, ...c } = e, o = eR(l8, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ w.jsx(f8, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ w.jsx(
      Ea,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...c,
        ref: t,
        "data-state": T4(a),
        onSelect: Ae(
          c.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
u8.displayName = l8;
var R4 = "MenuItemIndicator", [f8, tR] = d1(
  R4,
  { checked: !1 }
), d8 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: c, ...o } = e, a = tR(R4, n);
    return /* @__PURE__ */ w.jsx(
      Tn,
      {
        present: c || Ji(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ w.jsx(
          ke.span,
          {
            ...o,
            ref: t,
            "data-state": T4(a.checked)
          }
        )
      }
    );
  }
);
d8.displayName = R4;
var nR = "MenuSeparator", p8 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...c } = e;
    return /* @__PURE__ */ w.jsx(
      ke.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...c,
        ref: t
      }
    );
  }
);
p8.displayName = nR;
var rR = "MenuArrow", g8 = A.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...c } = e, o = mo(n);
    return /* @__PURE__ */ w.jsx(y4, { ...o, ...c, ref: t });
  }
);
g8.displayName = rR;
var P4 = "MenuSub", [cR, m8] = d1(P4), h8 = (e) => {
  const { __scopeMenu: t, children: n, open: c = !1, onOpenChange: o } = e, a = p1(P4, t), s = mo(t), [u, f] = A.useState(null), [d, p] = A.useState(null), m = wn(o);
  return A.useEffect(() => (a.open === !1 && m(!1), () => m(!1)), [a.open, m]), /* @__PURE__ */ w.jsx(ya, { ...s, children: /* @__PURE__ */ w.jsx(
    e8,
    {
      scope: t,
      open: c,
      onOpenChange: m,
      content: d,
      onContentChange: p,
      children: /* @__PURE__ */ w.jsx(
        cR,
        {
          scope: t,
          contentId: jn(),
          triggerId: jn(),
          trigger: u,
          onTriggerChange: f,
          children: n
        }
      )
    }
  ) });
};
h8.displayName = P4;
var Xc = "MenuSubTrigger", v8 = A.forwardRef(
  (e, t) => {
    const n = p1(Xc, e.__scopeMenu), c = ho(Xc, e.__scopeMenu), o = m8(Xc, e.__scopeMenu), a = E4(Xc, e.__scopeMenu), s = A.useRef(null), { pointerGraceTimerRef: u, onPointerGraceIntentChange: f } = a, d = { __scopeMenu: e.__scopeMenu }, p = A.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return A.useEffect(() => p, [p]), A.useEffect(() => {
      const m = u.current;
      return () => {
        window.clearTimeout(m), f(null);
      };
    }, [u, f]), /* @__PURE__ */ w.jsx(_4, { asChild: !0, ...d, children: /* @__PURE__ */ w.jsx(
      o8,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": x8(n.open),
        ...e,
        ref: ga(t, o.onTriggerChange),
        onClick: (m) => {
          var b;
          (b = e.onClick) == null || b.call(e, m), !(e.disabled || m.defaultPrevented) && (m.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: Ae(
          e.onPointerMove,
          co((m) => {
            a.onItemEnter(m), !m.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: Ae(
          e.onPointerLeave,
          co((m) => {
            var y, C;
            p();
            const b = (y = n.content) == null ? void 0 : y.getBoundingClientRect();
            if (b) {
              const h = (C = n.content) == null ? void 0 : C.dataset.side, v = h === "right", I = v ? -5 : 5, S = b[v ? "left" : "right"], L = b[v ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: m.clientX + I, y: m.clientY },
                  { x: S, y: b.top },
                  { x: L, y: b.top },
                  { x: L, y: b.bottom },
                  { x: S, y: b.bottom }
                ],
                side: h
              }), window.clearTimeout(u.current), u.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(m), m.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Ae(e.onKeyDown, (m) => {
          var y;
          const b = a.searchRef.current !== "";
          e.disabled || b && m.key === " " || kL[c.dir].includes(m.key) && (n.onOpenChange(!0), (y = n.content) == null || y.focus(), m.preventDefault());
        })
      }
    ) });
  }
);
v8.displayName = Xc;
var b8 = "MenuSubContent", C8 = A.forwardRef(
  (e, t) => {
    const n = n8(In, e.__scopeMenu), { forceMount: c = n.forceMount, ...o } = e, a = p1(In, e.__scopeMenu), s = ho(In, e.__scopeMenu), u = m8(b8, e.__scopeMenu), f = A.useRef(null), d = pt(t, f);
    return /* @__PURE__ */ w.jsx(ro.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ w.jsx(Tn, { present: c || a.open, children: /* @__PURE__ */ w.jsx(ro.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ w.jsx(
      M4,
      {
        id: u.contentId,
        "aria-labelledby": u.triggerId,
        ...o,
        ref: d,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          var m;
          s.isUsingKeyboardRef.current && ((m = f.current) == null || m.focus()), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: Ae(e.onFocusOutside, (p) => {
          p.target !== u.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: Ae(e.onEscapeKeyDown, (p) => {
          s.onClose(), p.preventDefault();
        }),
        onKeyDown: Ae(e.onKeyDown, (p) => {
          var y;
          const m = p.currentTarget.contains(p.target), b = BL[s.dir].includes(p.key);
          m && b && (a.onOpenChange(!1), (y = u.trigger) == null || y.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
C8.displayName = b8;
function x8(e) {
  return e ? "open" : "closed";
}
function Ji(e) {
  return e === "indeterminate";
}
function T4(e) {
  return Ji(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function oR(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function iR(e, t) {
  return e.map((n, c) => e[(t + c) % e.length]);
}
function aR(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = iR(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((d) => d !== n));
  const f = s.find(
    (d) => d.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function sR(e, t) {
  const { x: n, y: c } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const u = t[a].x, f = t[a].y, d = t[s].x, p = t[s].y;
    f > c != p > c && n < (d - u) * (c - f) / (p - f) + u && (o = !o);
  }
  return o;
}
function lR(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return sR(n, t);
}
function co(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var uR = t8, fR = _4, dR = r8, pR = L4, gR = c8, mR = Ea, hR = i8, vR = s8, bR = u8, CR = d8, xR = p8, yR = g8, IR = h8, wR = v8, AR = C8, z4 = "DropdownMenu", [SR, bV] = Ht(
  z4,
  [q5]
), jt = q5(), [_R, y8] = SR(z4), I8 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: c,
    open: o,
    defaultOpen: a,
    onOpenChange: s,
    modal: u = !0
  } = e, f = jt(t), d = A.useRef(null), [p = !1, m] = qt({
    prop: o,
    defaultProp: a,
    onChange: s
  });
  return /* @__PURE__ */ w.jsx(
    _R,
    {
      scope: t,
      triggerId: jn(),
      triggerRef: d,
      contentId: jn(),
      open: p,
      onOpenChange: m,
      onOpenToggle: A.useCallback(() => m((b) => !b), [m]),
      modal: u,
      children: /* @__PURE__ */ w.jsx(uR, { ...f, open: p, onOpenChange: m, dir: c, modal: u, children: n })
    }
  );
};
I8.displayName = z4;
var w8 = "DropdownMenuTrigger", A8 = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: c = !1, ...o } = e, a = y8(w8, n), s = jt(n);
    return /* @__PURE__ */ w.jsx(fR, { asChild: !0, ...s, children: /* @__PURE__ */ w.jsx(
      ke.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": c ? "" : void 0,
        disabled: c,
        ...o,
        ref: ga(t, a.triggerRef),
        onPointerDown: Ae(e.onPointerDown, (u) => {
          !c && u.button === 0 && u.ctrlKey === !1 && (a.onOpenToggle(), a.open || u.preventDefault());
        }),
        onKeyDown: Ae(e.onKeyDown, (u) => {
          c || (["Enter", " "].includes(u.key) && a.onOpenToggle(), u.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(u.key) && u.preventDefault());
        })
      }
    ) });
  }
);
A8.displayName = w8;
var S8 = "DropdownMenuContent", _8 = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...c } = e, o = y8(S8, n), a = jt(n), s = A.useRef(!1);
    return /* @__PURE__ */ w.jsx(
      dR,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...c,
        ref: t,
        onCloseAutoFocus: Ae(e.onCloseAutoFocus, (u) => {
          var f;
          s.current || (f = o.triggerRef.current) == null || f.focus(), s.current = !1, u.preventDefault();
        }),
        onInteractOutside: Ae(e.onInteractOutside, (u) => {
          const f = u.detail.originalEvent, d = f.button === 0 && f.ctrlKey === !0, p = f.button === 2 || d;
          (!o.modal || p) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
_8.displayName = S8;
var ER = "DropdownMenuGroup", MR = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
    return /* @__PURE__ */ w.jsx(pR, { ...o, ...c, ref: t });
  }
);
MR.displayName = ER;
var LR = "DropdownMenuLabel", E8 = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
    return /* @__PURE__ */ w.jsx(gR, { ...o, ...c, ref: t });
  }
);
E8.displayName = LR;
var RR = "DropdownMenuItem", M8 = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
    return /* @__PURE__ */ w.jsx(mR, { ...o, ...c, ref: t });
  }
);
M8.displayName = RR;
var PR = "DropdownMenuCheckboxItem", TR = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(hR, { ...o, ...c, ref: t });
});
TR.displayName = PR;
var zR = "DropdownMenuRadioGroup", NR = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(vR, { ...o, ...c, ref: t });
});
NR.displayName = zR;
var OR = "DropdownMenuRadioItem", FR = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(bR, { ...o, ...c, ref: t });
});
FR.displayName = OR;
var DR = "DropdownMenuItemIndicator", $R = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(CR, { ...o, ...c, ref: t });
});
$R.displayName = DR;
var GR = "DropdownMenuSeparator", L8 = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(xR, { ...o, ...c, ref: t });
});
L8.displayName = GR;
var kR = "DropdownMenuArrow", BR = A.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
    return /* @__PURE__ */ w.jsx(yR, { ...o, ...c, ref: t });
  }
);
BR.displayName = kR;
var VR = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: c, onOpenChange: o, defaultOpen: a } = e, s = jt(t), [u = !1, f] = qt({
    prop: c,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ w.jsx(IR, { ...s, open: u, onOpenChange: f, children: n });
}, WR = "DropdownMenuSubTrigger", HR = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(wR, { ...o, ...c, ref: t });
});
HR.displayName = WR;
var jR = "DropdownMenuSubContent", R8 = A.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...c } = e, o = jt(n);
  return /* @__PURE__ */ w.jsx(
    AR,
    {
      ...o,
      ...c,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
R8.displayName = jR;
var XR = I8, ZR = A8, YR = _8, UR = E8, P8 = M8, JR = L8, KR = VR, qR = R8;
const QR = "_dropdownMenuTrigger_kz59u_2", eP = "_dropdownMenuContent_kz59u_11", tP = "_fadeIn_kz59u_1", nP = "_fadeOut_kz59u_1", rP = "_dropdownMenuItem_kz59u_26", cP = "_dropdownMenuItemIsActive_kz59u_27", oP = "_dropdownMenuLabel_kz59u_28", iP = "_dropdownMenuTitle_kz59u_29", aP = "_dropdownMenuSeparator_kz59u_130", dr = {
  dropdownMenuTrigger: QR,
  dropdownMenuContent: eP,
  fadeIn: tP,
  fadeOut: nP,
  dropdownMenuItem: rP,
  dropdownMenuItemIsActive: cP,
  dropdownMenuLabel: oP,
  dropdownMenuTitle: iP,
  dropdownMenuSeparator: aP
};
var N4 = "Radio", [sP, T8] = Ht(N4), [lP, uP] = sP(N4), z8 = A.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: c,
      checked: o = !1,
      required: a,
      disabled: s,
      value: u = "on",
      onCheck: f,
      form: d,
      ...p
    } = e, [m, b] = A.useState(null), y = pt(t, (v) => b(v)), C = A.useRef(!1), h = m ? d || !!m.closest("form") : !0;
    return /* @__PURE__ */ w.jsxs(lP, { scope: n, checked: o, disabled: s, children: [
      /* @__PURE__ */ w.jsx(
        ke.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": F8(o),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: u,
          ...p,
          ref: y,
          onClick: Ae(e.onClick, (v) => {
            o || f == null || f(), h && (C.current = v.isPropagationStopped(), C.current || v.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ w.jsx(
        fP,
        {
          control: m,
          bubbles: !C.current,
          name: c,
          value: u,
          checked: o,
          required: a,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
z8.displayName = N4;
var N8 = "RadioIndicator", O8 = A.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: c, ...o } = e, a = uP(N8, n);
    return /* @__PURE__ */ w.jsx(Tn, { present: c || a.checked, children: /* @__PURE__ */ w.jsx(
      ke.span,
      {
        "data-state": F8(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
O8.displayName = N8;
var fP = (e) => {
  const { control: t, checked: n, bubbles: c = !0, ...o } = e, a = A.useRef(null), s = Kd(n), u = a4(t);
  return A.useEffect(() => {
    const f = a.current, d = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && m) {
      const b = new Event("click", { bubbles: c });
      m.call(f, n), f.dispatchEvent(b);
    }
  }, [s, n, c]), /* @__PURE__ */ w.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...u,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function F8(e) {
  return e ? "checked" : "unchecked";
}
var dP = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], O4 = "RadioGroup", [pP, CV] = Ht(O4, [
  Xr,
  T8
]), D8 = Xr(), $8 = T8(), [gP, mP] = pP(O4), G8 = A.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: c,
      defaultValue: o,
      value: a,
      required: s = !1,
      disabled: u = !1,
      orientation: f,
      dir: d,
      loop: p = !0,
      onValueChange: m,
      ...b
    } = e, y = D8(n), C = ic(d), [h, v] = qt({
      prop: a,
      defaultProp: o,
      onChange: m
    });
    return /* @__PURE__ */ w.jsx(
      gP,
      {
        scope: n,
        name: c,
        required: s,
        disabled: u,
        value: h,
        onValueChange: v,
        children: /* @__PURE__ */ w.jsx(
          Aa,
          {
            asChild: !0,
            ...y,
            orientation: f,
            dir: C,
            loop: p,
            children: /* @__PURE__ */ w.jsx(
              ke.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": f,
                "data-disabled": u ? "" : void 0,
                dir: C,
                ...b,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
G8.displayName = O4;
var k8 = "RadioGroupItem", B8 = A.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: c, ...o } = e, a = mP(k8, n), s = a.disabled || c, u = D8(n), f = $8(n), d = A.useRef(null), p = pt(t, d), m = a.value === o.value, b = A.useRef(!1);
    return A.useEffect(() => {
      const y = (h) => {
        dP.includes(h.key) && (b.current = !0);
      }, C = () => b.current = !1;
      return document.addEventListener("keydown", y), document.addEventListener("keyup", C), () => {
        document.removeEventListener("keydown", y), document.removeEventListener("keyup", C);
      };
    }, []), /* @__PURE__ */ w.jsx(
      Sa,
      {
        asChild: !0,
        ...u,
        focusable: !s,
        active: m,
        children: /* @__PURE__ */ w.jsx(
          z8,
          {
            disabled: s,
            required: a.required,
            checked: m,
            ...f,
            ...o,
            name: a.name,
            ref: p,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: Ae((y) => {
              y.key === "Enter" && y.preventDefault();
            }),
            onFocus: Ae(o.onFocus, () => {
              var y;
              b.current && ((y = d.current) == null || y.click());
            })
          }
        )
      }
    );
  }
);
B8.displayName = k8;
var hP = "RadioGroupIndicator", V8 = A.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...c } = e, o = $8(n);
    return /* @__PURE__ */ w.jsx(O8, { ...o, ...c, ref: t });
  }
);
V8.displayName = hP;
var vP = G8, bP = B8, CP = V8;
const xP = "_radioGroupItem_16q93_89", yP = "_fadeOut_16q93_1", IP = "_fadeIn_16q93_1", wP = "_slideUpAndFade_16q93_1", AP = "_slideRightAndFade_16q93_1", SP = "_slideDownAndFade_16q93_1", _P = "_slideLeftAndFade_16q93_1", EP = "_slideDown_16q93_1", MP = "_slideUp_16q93_1", LP = "_rotateUp_16q93_1", RP = "_rotateDown_16q93_1", W8 = {
  radioGroupItem: xP,
  fadeOut: yP,
  fadeIn: IP,
  slideUpAndFade: wP,
  slideRightAndFade: AP,
  slideDownAndFade: SP,
  slideLeftAndFade: _P,
  slideDown: EP,
  slideUp: MP,
  rotateUp: LP,
  rotateDown: RP
};
function xV({ ...e }) {
  return /* @__PURE__ */ w.jsx(vP, { ...e });
}
function H8({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(bP, { ...t, className: `${W8.radioGroupItem} ${e}` });
}
function PP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(CP, { ...t, className: `${W8.radioGroupIndicator} ${e}` });
}
H8.propTypes = {
  className: z.string
};
PP.propTypes = {
  className: z.string
};
function TP({ ...e }) {
  return /* @__PURE__ */ w.jsx(XR, { ...e });
}
function zP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(ZR, { ...t, className: `${dr.dropdownMenuTrigger} ${e}` });
}
function NP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(KR, { ...t, className: `${dr.dropdownMenuContent} ${e}` });
}
function OP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(qR, { ...t, className: `${dr.dropdownMenuContent} ${e}` });
}
function FP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(YR, { ...t, className: `${dr.dropdownMenuContent} ${e}` });
}
function DP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(UR, { ...t, className: `${dr.dropdownMenuLabel} ${e}` });
}
function $P({ className: e = "", isActive: t, value: n, onSelect: c, ...o }) {
  const a = (s) => {
    c({
      event: s,
      value: n
    });
  };
  return /* @__PURE__ */ w.jsx(
    P8,
    {
      onSelect: a,
      ...o,
      className: t ? `${dr.dropdownMenuItemIsActive} ${e}` : `${dr.dropdownMenuItem} ${e}`
    }
  );
}
function GP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(P8, { ...t, className: `${dr.dropdownMenuTitle} ${e}` });
}
function kP({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(JR, { ...t, className: `${dr.dropdownMenuSeparator} ${e}` });
}
TP.propTypes = {
  className: z.string
};
zP.propTypes = {
  className: z.string
};
NP.propTypes = {
  className: z.string
};
OP.propTypes = {
  className: z.string
};
FP.propTypes = {
  className: z.string
};
DP.propTypes = {
  className: z.string
};
$P.propTypes = {
  className: z.string,
  isActive: z.bool,
  value: z.string,
  onSelect: z.func
};
GP.propTypes = {
  className: z.string
};
H8.propTypes = {
  className: z.string
};
kP.propTypes = {
  className: z.string
};
const BP = "_ListContent_1gw22_90", VP = "_ListLabel_1gw22_95", WP = "_ListTitle_1gw22_96", HP = "_ListItem_1gw22_97", jP = "_title_1gw22_143", XP = "_isActive_1gw22_178", ZP = "_ListSeparator_1gw22_186", YP = "_fadeIn_1gw22_1", UP = "_fadeOut_1gw22_1", JP = "_slideUpAndFade_1gw22_1", KP = "_slideRightAndFade_1gw22_1", qP = "_slideDownAndFade_1gw22_1", QP = "_slideLeftAndFade_1gw22_1", eT = "_slideDown_1gw22_1", tT = "_slideUp_1gw22_1", nT = "_rotateUp_1gw22_1", rT = "_rotateDown_1gw22_1", Or = {
  ListContent: BP,
  ListLabel: VP,
  ListTitle: WP,
  ListItem: HP,
  title: jP,
  isActive: XP,
  ListSeparator: ZP,
  fadeIn: YP,
  fadeOut: UP,
  slideUpAndFade: JP,
  slideRightAndFade: KP,
  slideDownAndFade: qP,
  slideLeftAndFade: QP,
  slideDown: eT,
  slideUp: tT,
  rotateUp: nT,
  rotateDown: rT
}, Zr = {
  eventType: "click",
  componentTypes: {
    optionSelected: "option-selected",
    click: "click",
    focus: "focus"
  }
}, g1 = "anodot_common", cT = (e, t) => {
  if (!e)
    return "undefined";
  const n = {}, c = e.indexOf("?");
  c > 0 && (n["?"] = c);
  const a = (n["?"] ? e.slice(0, n["?"]) : e).replace("#!/r/", "").replace("#!/", "");
  return a.endsWith("/") ? a.slice(0, -1) : a;
}, oT = (e) => ({
  hash: e,
  pageName: cT(e)
}), jr = (e, t, n, c = Zr.eventType) => {
  window.analytics && window.analytics.track && typeof window.analytics.track == "function" && window.analytics.track(c, {
    type: n,
    id: e,
    value: t,
    ...oT(window.location.hash)
  });
};
function iT({ value: e, icon: t = "", className: n = "", ...c }) {
  return /* @__PURE__ */ w.jsxs("div", { ...c, className: `${Or.ListTitle} ${n}`, children: [
    t,
    /* @__PURE__ */ w.jsx("span", { children: e })
  ] });
}
function aT({ value: e, icon: t = "", className: n = "", ...c }) {
  return /* @__PURE__ */ w.jsxs("div", { ...c, className: `${Or.ListLabel} ${n}`, children: [
    t,
    /* @__PURE__ */ w.jsx("span", { children: e })
  ] });
}
function sT({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx("div", { ...t, className: `${Or.ListSeparator} ${e}` });
}
function lT({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx("ul", { ...t, className: `${e} ${Or.ListContent}` });
}
function uT({ className: e = "", isActive: t, isDisabled: n, value: c, onSelect: o, iconName: a, id: s = "", ...u }) {
  const { optionSelected: f } = Zr.componentTypes, d = je(), p = Wt(() => {
    let b = Or.ListItem;
    return t && (b += ` ${Or.isActive}`), n && (b += ` ${Or.isDisabled}`), b;
  }, [t, n]), m = (b) => {
    o({
      event: b,
      value: c
    }), jr(d.current.id, c, f);
  };
  return /* @__PURE__ */ w.jsxs(
    "li",
    {
      id: `${g1}_list_item${s ? `_${s}` : ""}`,
      ref: d,
      className: `${e} ${p}`,
      onClick: m,
      ...u,
      children: [
        !!a && /* @__PURE__ */ w.jsx(Hn, { iconName: a }),
        /* @__PURE__ */ w.jsx("span", { className: Or.title, children: c })
      ]
    }
  );
}
iT.propTypes = {
  value: z.string.isRequired,
  icon: z.element,
  className: z.string
};
aT.propTypes = {
  value: z.string.isRequired,
  icon: z.element,
  className: z.string
};
sT.propTypes = {
  className: z.string
};
lT.propTypes = {
  className: z.string
};
uT.propTypes = {
  value: z.string.isRequired,
  isActive: z.bool,
  isDisabled: z.bool,
  onSelect: z.func,
  icon: z.element,
  className: z.string,
  id: z.string,
  iconName: z.string
};
var F4 = "Popover", [j8, yV] = Ht(F4, [
  uc
]), vo = uc(), [fT, Yr] = j8(F4), X8 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: c,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !1
  } = e, u = vo(t), f = A.useRef(null), [d, p] = A.useState(!1), [m = !1, b] = qt({
    prop: c,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ w.jsx(ya, { ...u, children: /* @__PURE__ */ w.jsx(
    fT,
    {
      scope: t,
      contentId: jn(),
      triggerRef: f,
      open: m,
      onOpenChange: b,
      onOpenToggle: A.useCallback(() => b((y) => !y), [b]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: A.useCallback(() => p(!0), []),
      onCustomAnchorRemove: A.useCallback(() => p(!1), []),
      modal: s,
      children: n
    }
  ) });
};
X8.displayName = F4;
var Z8 = "PopoverAnchor", Y8 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...c } = e, o = Yr(Z8, n), a = vo(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: u } = o;
    return A.useEffect(() => (s(), () => u()), [s, u]), /* @__PURE__ */ w.jsx(Ia, { ...a, ...c, ref: t });
  }
);
Y8.displayName = Z8;
var U8 = "PopoverTrigger", J8 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...c } = e, o = Yr(U8, n), a = vo(n), s = pt(t, o.triggerRef), u = /* @__PURE__ */ w.jsx(
      ke.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": n7(o.open),
        ...c,
        ref: s,
        onClick: Ae(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? u : /* @__PURE__ */ w.jsx(Ia, { asChild: !0, ...a, children: u });
  }
);
J8.displayName = U8;
var D4 = "PopoverPortal", [dT, pT] = j8(D4, {
  forceMount: void 0
}), K8 = (e) => {
  const { __scopePopover: t, forceMount: n, children: c, container: o } = e, a = Yr(D4, t);
  return /* @__PURE__ */ w.jsx(dT, { scope: t, forceMount: n, children: /* @__PURE__ */ w.jsx(Tn, { present: n || a.open, children: /* @__PURE__ */ w.jsx(N5, { asChild: !0, container: o, children: c }) }) });
};
K8.displayName = D4;
var tc = "PopoverContent", q8 = A.forwardRef(
  (e, t) => {
    const n = pT(tc, e.__scopePopover), { forceMount: c = n.forceMount, ...o } = e, a = Yr(tc, e.__scopePopover);
    return /* @__PURE__ */ w.jsx(Tn, { present: c || a.open, children: a.modal ? /* @__PURE__ */ w.jsx(gT, { ...o, ref: t }) : /* @__PURE__ */ w.jsx(mT, { ...o, ref: t }) });
  }
);
q8.displayName = tc;
var gT = A.forwardRef(
  (e, t) => {
    const n = Yr(tc, e.__scopePopover), c = A.useRef(null), o = pt(t, c), a = A.useRef(!1);
    return A.useEffect(() => {
      const s = c.current;
      if (s) return I4(s);
    }, []), /* @__PURE__ */ w.jsx(S4, { as: Q1, allowPinchZoom: !0, children: /* @__PURE__ */ w.jsx(
      Q8,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ae(e.onCloseAutoFocus, (s) => {
          var u;
          s.preventDefault(), a.current || (u = n.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: Ae(
          e.onPointerDownOutside,
          (s) => {
            const u = s.detail.originalEvent, f = u.button === 0 && u.ctrlKey === !0, d = u.button === 2 || f;
            a.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Ae(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), mT = A.forwardRef(
  (e, t) => {
    const n = Yr(tc, e.__scopePopover), c = A.useRef(!1), o = A.useRef(!1);
    return /* @__PURE__ */ w.jsx(
      Q8,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, u;
          (s = e.onCloseAutoFocus) == null || s.call(e, a), a.defaultPrevented || (c.current || (u = n.triggerRef.current) == null || u.focus(), a.preventDefault()), c.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, a), a.defaultPrevented || (c.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Q8 = A.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: c,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: u,
      onPointerDownOutside: f,
      onFocusOutside: d,
      onInteractOutside: p,
      ...m
    } = e, b = Yr(tc, n), y = vo(n);
    return c5(), /* @__PURE__ */ w.jsx(
      l4,
      {
        asChild: !0,
        loop: !0,
        trapped: c,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ w.jsx(
          va,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: p,
            onEscapeKeyDown: u,
            onPointerDownOutside: f,
            onFocusOutside: d,
            onDismiss: () => b.onOpenChange(!1),
            children: /* @__PURE__ */ w.jsx(
              x4,
              {
                "data-state": n7(b.open),
                role: "dialog",
                id: b.contentId,
                ...y,
                ...m,
                ref: t,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), e7 = "PopoverClose", hT = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...c } = e, o = Yr(e7, n);
    return /* @__PURE__ */ w.jsx(
      ke.button,
      {
        type: "button",
        ...c,
        ref: t,
        onClick: Ae(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
hT.displayName = e7;
var vT = "PopoverArrow", t7 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...c } = e, o = vo(n);
    return /* @__PURE__ */ w.jsx(y4, { ...o, ...c, ref: t });
  }
);
t7.displayName = vT;
function n7(e) {
  return e ? "open" : "closed";
}
var bT = X8, CT = Y8, xT = J8, yT = q8, IT = t7;
const wT = "_popoverTrigger_1kpq9_405", AT = "_popoverContent_1kpq9_413", ST = "_fadeIn_1kpq9_1", _T = "_fadeOut_1kpq9_1", ET = "_popoverPortal_1kpq9_430", MT = "_slideUpAndFade_1kpq9_1", LT = "_slideRightAndFade_1kpq9_1", RT = "_slideDownAndFade_1kpq9_1", PT = "_slideLeftAndFade_1kpq9_1", TT = "_slideDown_1kpq9_1", zT = "_slideUp_1kpq9_1", NT = "_rotateUp_1kpq9_1", OT = "_rotateDown_1kpq9_1", bo = {
  popoverTrigger: wT,
  popoverContent: AT,
  fadeIn: ST,
  fadeOut: _T,
  popoverPortal: ET,
  slideUpAndFade: MT,
  slideRightAndFade: LT,
  slideDownAndFade: RT,
  slideLeftAndFade: PT,
  slideDown: TT,
  slideUp: zT,
  rotateUp: NT,
  rotateDown: OT
};
function Ma({ ...e }) {
  return /* @__PURE__ */ w.jsx(bT, { ...e });
}
function La({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(xT, { ...t, className: `${e} ${bo.popoverTrigger}` });
}
function FT({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(CT, { ...t, className: `${e} ${bo.popoverAnchor}` });
}
function Ra({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(yT, { ...t, className: `${e} ${bo.popoverContent}` });
}
function DT({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(K8, { ...t, className: `${e} ${bo.popoverPortal}` });
}
function $T({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(IT, { ...t, className: `${e} ${bo.popoverArrow}` });
}
Ma.propTypes = {
  className: z.string
};
La.propTypes = {
  className: z.string
};
FT.propTypes = {
  className: z.string
};
Ra.propTypes = {
  className: z.string
};
DT.propTypes = {
  className: z.string
};
$T.propTypes = {
  className: z.string
};
var $4 = "Progress", G4 = 100, [GT, IV] = Ht($4), [kT, BT] = GT($4), r7 = A.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: c = null,
      max: o,
      getValueLabel: a = VT,
      ...s
    } = e;
    (o || o === 0) && !G6(o) && console.error(WT(`${o}`, "Progress"));
    const u = G6(o) ? o : G4;
    c !== null && !k6(c, u) && console.error(HT(`${c}`, "Progress"));
    const f = k6(c, u) ? c : null, d = Ki(f) ? a(f, u) : void 0;
    return /* @__PURE__ */ w.jsx(kT, { scope: n, value: f, max: u, children: /* @__PURE__ */ w.jsx(
      ke.div,
      {
        "aria-valuemax": u,
        "aria-valuemin": 0,
        "aria-valuenow": Ki(f) ? f : void 0,
        "aria-valuetext": d,
        role: "progressbar",
        "data-state": i7(f, u),
        "data-value": f ?? void 0,
        "data-max": u,
        ...s,
        ref: t
      }
    ) });
  }
);
r7.displayName = $4;
var c7 = "ProgressIndicator", o7 = A.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...c } = e, o = BT(c7, n);
    return /* @__PURE__ */ w.jsx(
      ke.div,
      {
        "data-state": i7(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...c,
        ref: t
      }
    );
  }
);
o7.displayName = c7;
function VT(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function i7(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Ki(e) {
  return typeof e == "number";
}
function G6(e) {
  return Ki(e) && !isNaN(e) && e > 0;
}
function k6(e, t) {
  return Ki(e) && !isNaN(e) && e <= t && e >= 0;
}
function WT(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${G4}\`.`;
}
function HT(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${G4} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var jT = r7, XT = o7;
const ZT = "_ProgressRoot_19mxi_405", YT = "_ProgressIndicator_19mxi_415", UT = "_fadeIn_19mxi_1", JT = "_fadeOut_19mxi_1", KT = "_slideUpAndFade_19mxi_1", qT = "_slideRightAndFade_19mxi_1", QT = "_slideDownAndFade_19mxi_1", ez = "_slideLeftAndFade_19mxi_1", tz = "_slideDown_19mxi_1", nz = "_slideUp_19mxi_1", rz = "_rotateUp_19mxi_1", cz = "_rotateDown_19mxi_1", B6 = {
  ProgressRoot: ZT,
  ProgressIndicator: YT,
  fadeIn: UT,
  fadeOut: JT,
  slideUpAndFade: KT,
  slideRightAndFade: qT,
  slideDownAndFade: QT,
  slideLeftAndFade: ez,
  slideDown: tz,
  slideUp: nz,
  rotateUp: rz,
  rotateDown: cz
};
function oz({ classes: e = {}, value: t, color: n, height: c = 10, backgroundColor: o, max: a = 100 }) {
  const s = Math.min(t, a);
  return /* @__PURE__ */ w.jsx("div", { className: e.container || "", children: /* @__PURE__ */ w.jsx(
    jT,
    {
      className: `${e.root || ""} ${B6.ProgressRoot}`,
      value: s,
      style: { height: c, backgroundColor: o },
      children: /* @__PURE__ */ w.jsx(
        XT,
        {
          className: `${e.indicator || ""} ${B6.ProgressIndicator}`,
          style: { transform: `translateX(-${100 - s}%)`, backgroundColor: n }
        }
      )
    }
  ) });
}
oz.propTypes = {
  classes: z.object,
  value: z.number.isRequired,
  max: z.number,
  color: z.string,
  height: z.string,
  backgroundColor: z.string
};
function ce() {
  return ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) ({}).hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, ce.apply(null, arguments);
}
function V6(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function St(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function k4(e, t = []) {
  let n = [];
  function c(a, s) {
    const u = /* @__PURE__ */ K1(s), f = n.length;
    n = [
      ...n,
      s
    ];
    function d(m) {
      const { scope: b, children: y, ...C } = m, h = (b == null ? void 0 : b[e][f]) || u, v = Wt(
        () => C,
        Object.values(C)
      );
      return /* @__PURE__ */ xe(h.Provider, {
        value: v
      }, y);
    }
    function p(m, b) {
      const y = (b == null ? void 0 : b[e][f]) || u, C = lo(y);
      if (C) return C;
      if (s !== void 0) return s;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return d.displayName = a + "Provider", [
      d,
      p
    ];
  }
  const o = () => {
    const a = n.map((s) => /* @__PURE__ */ K1(s));
    return function(u) {
      const f = (u == null ? void 0 : u[e]) || a;
      return Wt(
        () => ({
          [`__scope${e}`]: {
            ...u,
            [e]: f
          }
        }),
        [
          u,
          f
        ]
      );
    };
  };
  return o.scopeName = e, [
    c,
    iz(o, ...t)
  ];
}
function iz(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const c = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const s = c.reduce((u, { useScope: f, scopeName: d }) => {
        const m = f(a)[`__scope${d}`];
        return {
          ...u,
          ...m
        };
      }, {});
      return Wt(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function az(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function a7(...e) {
  return (t) => e.forEach(
    (n) => az(n, t)
  );
}
function Dt(...e) {
  return qe(a7(...e), e);
}
const oo = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...c } = e, o = Bn.toArray(n), a = o.find(lz);
  if (a) {
    const s = a.props.children, u = o.map((f) => f === a ? Bn.count(s) > 1 ? Bn.only(null) : /* @__PURE__ */ Dr(s) ? s.props.children : null : f);
    return /* @__PURE__ */ xe(Al, ce({}, c, {
      ref: t
    }), /* @__PURE__ */ Dr(s) ? /* @__PURE__ */ aa(s, void 0, u) : null);
  }
  return /* @__PURE__ */ xe(Al, ce({}, c, {
    ref: t
  }), n);
});
oo.displayName = "Slot";
const Al = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...c } = e;
  return /* @__PURE__ */ Dr(n) ? /* @__PURE__ */ aa(n, {
    ...uz(c, n.props),
    ref: t ? a7(t, n.ref) : n.ref
  }) : Bn.count(n) > 1 ? Bn.only(null) : null;
});
Al.displayName = "SlotClone";
const sz = ({ children: e }) => /* @__PURE__ */ xe(a1, null, e);
function lz(e) {
  return /* @__PURE__ */ Dr(e) && e.type === sz;
}
function uz(e, t) {
  const n = {
    ...t
  };
  for (const c in t) {
    const o = e[c], a = t[c];
    /^on[A-Z]/.test(c) ? o && a ? n[c] = (...u) => {
      a(...u), o(...u);
    } : o && (n[c] = o) : c === "style" ? n[c] = {
      ...o,
      ...a
    } : c === "className" && (n[c] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function fz(e) {
  const t = e + "CollectionProvider", [n, c] = k4(t), [o, a] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (y) => {
    const { scope: C, children: h } = y, v = Te.useRef(null), I = Te.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Te.createElement(o, {
      scope: C,
      itemMap: I,
      collectionRef: v
    }, h);
  }, u = e + "CollectionSlot", f = /* @__PURE__ */ Te.forwardRef((y, C) => {
    const { scope: h, children: v } = y, I = a(u, h), S = Dt(C, I.collectionRef);
    return /* @__PURE__ */ Te.createElement(oo, {
      ref: S
    }, v);
  }), d = e + "CollectionItemSlot", p = "data-radix-collection-item", m = /* @__PURE__ */ Te.forwardRef((y, C) => {
    const { scope: h, children: v, ...I } = y, S = Te.useRef(null), L = Dt(C, S), R = a(d, h);
    return Te.useEffect(() => (R.itemMap.set(S, {
      ref: S,
      ...I
    }), () => void R.itemMap.delete(S))), /* @__PURE__ */ Te.createElement(oo, {
      [p]: "",
      ref: L
    }, v);
  });
  function b(y) {
    const C = a(e + "CollectionConsumer", y);
    return Te.useCallback(() => {
      const v = C.collectionRef.current;
      if (!v) return [];
      const I = Array.from(v.querySelectorAll(`[${p}]`));
      return Array.from(C.itemMap.values()).sort(
        (R, M) => I.indexOf(R.ref.current) - I.indexOf(M.ref.current)
      );
    }, [
      C.collectionRef,
      C.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: f,
      ItemSlot: m
    },
    b,
    c
  ];
}
const dz = /* @__PURE__ */ K1(void 0);
function pz(e) {
  const t = lo(dz);
  return e || t || "ltr";
}
const gz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Pt = gz.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze((c, o) => {
    const { asChild: a, ...s } = c, u = a ? oo : t;
    return ct(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ xe(u, ce({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function mz(e, t) {
  e && KC(
    () => e.dispatchEvent(t)
  );
}
function pr(e) {
  const t = je(e);
  return ct(() => {
    t.current = e;
  }), Wt(
    () => (...n) => {
      var c;
      return (c = t.current) === null || c === void 0 ? void 0 : c.call(t, ...n);
    },
    []
  );
}
function hz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pr(e);
  ct(() => {
    const c = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", c), () => t.removeEventListener("keydown", c);
  }, [
    n,
    t
  ]);
}
const Sl = "dismissableLayer.update", vz = "dismissableLayer.pointerDownOutside", bz = "dismissableLayer.focusOutside";
let W6;
const Cz = /* @__PURE__ */ K1({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), xz = /* @__PURE__ */ Ze((e, t) => {
  var n;
  const { disableOutsidePointerEvents: c = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: s, onInteractOutside: u, onDismiss: f, ...d } = e, p = lo(Cz), [m, b] = Ne(null), y = (n = m == null ? void 0 : m.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, C] = Ne({}), h = Dt(
    t,
    (G) => b(G)
  ), v = Array.from(p.layers), [I] = [
    ...p.layersWithOutsidePointerEventsDisabled
  ].slice(-1), S = v.indexOf(I), L = m ? v.indexOf(m) : -1, R = p.layersWithOutsidePointerEventsDisabled.size > 0, M = L >= S, $ = yz((G) => {
    const J = G.target, ae = [
      ...p.branches
    ].some(
      (fe) => fe.contains(J)
    );
    !M || ae || (a == null || a(G), u == null || u(G), G.defaultPrevented || f == null || f());
  }, y), O = Iz((G) => {
    const J = G.target;
    [
      ...p.branches
    ].some(
      (fe) => fe.contains(J)
    ) || (s == null || s(G), u == null || u(G), G.defaultPrevented || f == null || f());
  }, y);
  return hz((G) => {
    L === p.layers.size - 1 && (o == null || o(G), !G.defaultPrevented && f && (G.preventDefault(), f()));
  }, y), ct(() => {
    if (m)
      return c && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (W6 = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), H6(), () => {
        c && p.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = W6);
      };
  }, [
    m,
    y,
    c,
    p
  ]), ct(() => () => {
    m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), H6());
  }, [
    m,
    p
  ]), ct(() => {
    const G = () => C({});
    return document.addEventListener(Sl, G), () => document.removeEventListener(Sl, G);
  }, []), /* @__PURE__ */ xe(Pt.div, ce({}, d, {
    ref: h,
    style: {
      pointerEvents: R ? M ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: St(e.onFocusCapture, O.onFocusCapture),
    onBlurCapture: St(e.onBlurCapture, O.onBlurCapture),
    onPointerDownCapture: St(e.onPointerDownCapture, $.onPointerDownCapture)
  }));
});
function yz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pr(e), c = je(!1), o = je(() => {
  });
  return ct(() => {
    const a = (u) => {
      if (u.target && !c.current) {
        let d = function() {
          s7(vz, n, f, {
            discrete: !0
          });
        };
        const f = {
          originalEvent: u
        };
        u.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, {
          once: !0
        })) : d();
      }
      c.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => c.current = !0
  };
}
function Iz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = pr(e), c = je(!1);
  return ct(() => {
    const o = (a) => {
      a.target && !c.current && s7(bz, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => c.current = !0,
    onBlurCapture: () => c.current = !1
  };
}
function H6() {
  const e = new CustomEvent(Sl);
  document.dispatchEvent(e);
}
function s7(e, t, n, { discrete: c }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), c ? mz(o, a) : o.dispatchEvent(a);
}
let zs = 0;
function wz() {
  ct(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : j6()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : j6()), zs++, () => {
      zs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (c) => c.remove()
      ), zs--;
    };
  }, []);
}
function j6() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Ns = "focusScope.autoFocusOnMount", Os = "focusScope.autoFocusOnUnmount", X6 = {
  bubbles: !1,
  cancelable: !0
}, Az = /* @__PURE__ */ Ze((e, t) => {
  const { loop: n = !1, trapped: c = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...s } = e, [u, f] = Ne(null), d = pr(o), p = pr(a), m = je(null), b = Dt(
    t,
    (h) => f(h)
  ), y = je({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ct(() => {
    if (c) {
      let h = function(L) {
        if (y.paused || !u) return;
        const R = L.target;
        u.contains(R) ? m.current = R : Nr(m.current, {
          select: !0
        });
      }, v = function(L) {
        if (y.paused || !u) return;
        const R = L.relatedTarget;
        R !== null && (u.contains(R) || Nr(m.current, {
          select: !0
        }));
      }, I = function(L) {
        const R = document.activeElement;
        for (const M of L)
          M.removedNodes.length > 0 && (u != null && u.contains(R) || Nr(u));
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const S = new MutationObserver(I);
      return u && S.observe(u, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), S.disconnect();
      };
    }
  }, [
    c,
    u,
    y.paused
  ]), ct(() => {
    if (u) {
      Y6.add(y);
      const h = document.activeElement;
      if (!u.contains(h)) {
        const I = new CustomEvent(Ns, X6);
        u.addEventListener(Ns, d), u.dispatchEvent(I), I.defaultPrevented || (Sz(Rz(l7(u)), {
          select: !0
        }), document.activeElement === h && Nr(u));
      }
      return () => {
        u.removeEventListener(Ns, d), setTimeout(() => {
          const I = new CustomEvent(Os, X6);
          u.addEventListener(Os, p), u.dispatchEvent(I), I.defaultPrevented || Nr(h ?? document.body, {
            select: !0
          }), u.removeEventListener(Os, p), Y6.remove(y);
        }, 0);
      };
    }
  }, [
    u,
    d,
    p,
    y
  ]);
  const C = qe((h) => {
    if (!n && !c || y.paused) return;
    const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, I = document.activeElement;
    if (v && I) {
      const S = h.currentTarget, [L, R] = _z(S);
      L && R ? !h.shiftKey && I === R ? (h.preventDefault(), n && Nr(L, {
        select: !0
      })) : h.shiftKey && I === L && (h.preventDefault(), n && Nr(R, {
        select: !0
      })) : I === S && h.preventDefault();
    }
  }, [
    n,
    c,
    y.paused
  ]);
  return /* @__PURE__ */ xe(Pt.div, ce({
    tabIndex: -1
  }, s, {
    ref: b,
    onKeyDown: C
  }));
});
function Sz(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const c of e)
    if (Nr(c, {
      select: t
    }), document.activeElement !== n) return;
}
function _z(e) {
  const t = l7(e), n = Z6(t, e), c = Z6(t.reverse(), e);
  return [
    n,
    c
  ];
}
function l7(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (c) => {
      const o = c.tagName === "INPUT" && c.type === "hidden";
      return c.disabled || c.hidden || o ? NodeFilter.FILTER_SKIP : c.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Z6(e, t) {
  for (const n of e)
    if (!Ez(n, {
      upTo: t
    })) return n;
}
function Ez(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Mz(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Nr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Mz(e) && t && e.select();
  }
}
const Y6 = Lz();
function Lz() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = U6(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = U6(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function U6(e, t) {
  const n = [
    ...e
  ], c = n.indexOf(t);
  return c !== -1 && n.splice(c, 1), n;
}
function Rz(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const An = globalThis != null && globalThis.document ? ia : () => {
}, Pz = A.useId || (() => {
});
let Tz = 0;
function B4(e) {
  const [t, n] = A.useState(Pz());
  return An(() => {
    e || n(
      (c) => c ?? String(Tz++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function zz(e) {
  const [t, n] = Ne(void 0);
  return An(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const c = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length) return;
        const a = o[0];
        let s, u;
        if ("borderBoxSize" in a) {
          const f = a.borderBoxSize, d = Array.isArray(f) ? f[0] : f;
          s = d.inlineSize, u = d.blockSize;
        } else
          s = e.offsetWidth, u = e.offsetHeight;
        n({
          width: s,
          height: u
        });
      });
      return c.observe(e, {
        box: "border-box"
      }), () => c.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const u7 = "Popper", [f7, d7] = k4(u7), [Nz, p7] = f7(u7), Oz = (e) => {
  const { __scopePopper: t, children: n } = e, [c, o] = Ne(null);
  return /* @__PURE__ */ xe(Nz, {
    scope: t,
    anchor: c,
    onAnchorChange: o
  }, n);
}, Fz = "PopperAnchor", Dz = /* @__PURE__ */ Ze((e, t) => {
  const { __scopePopper: n, virtualRef: c, ...o } = e, a = p7(Fz, n), s = je(null), u = Dt(t, s);
  return ct(() => {
    a.onAnchorChange((c == null ? void 0 : c.current) || s.current);
  }), c ? null : /* @__PURE__ */ xe(Pt.div, ce({}, o, {
    ref: u
  }));
}), g7 = "PopperContent", [$z, wV] = f7(g7), Gz = /* @__PURE__ */ Ze((e, t) => {
  var n, c, o, a, s, u, f, d;
  const { __scopePopper: p, side: m = "bottom", sideOffset: b = 0, align: y = "center", alignOffset: C = 0, arrowPadding: h = 0, collisionBoundary: v = [], collisionPadding: I = 0, sticky: S = "partial", hideWhenDetached: L = !1, avoidCollisions: R = !0, onPlaced: M, ...$ } = e, O = p7(g7, p), [G, J] = Ne(null), ae = Dt(
    t,
    (Fe) => J(Fe)
  ), [fe, U] = Ne(null), re = zz(fe), oe = (n = re == null ? void 0 : re.width) !== null && n !== void 0 ? n : 0, ue = (c = re == null ? void 0 : re.height) !== null && c !== void 0 ? c : 0, te = m + (y !== "center" ? "-" + y : ""), se = typeof I == "number" ? I : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...I
  }, ee = Array.isArray(v) ? v : [
    v
  ], q = ee.length > 0, B = {
    padding: se,
    boundary: ee.filter(kz),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: q
  }, { refs: X, floatingStyles: ie, placement: he, isPositioned: le, middlewareData: ve } = h5({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: te,
    whileElementsMounted: v4,
    elements: {
      reference: O.anchor
    },
    middleware: [
      v5({
        mainAxis: b + ue,
        alignmentAxis: C
      }),
      R && b5({
        mainAxis: !0,
        crossAxis: !1,
        limiter: S === "partial" ? C5() : void 0,
        ...B
      }),
      R && x5({
        ...B
      }),
      y5({
        ...B,
        apply: ({ elements: Fe, rects: ut, availableWidth: $t, availableHeight: Ct }) => {
          const { width: Yn, height: Qt } = ut.reference, dn = Fe.floating.style;
          dn.setProperty("--radix-popper-available-width", `${$t}px`), dn.setProperty("--radix-popper-available-height", `${Ct}px`), dn.setProperty("--radix-popper-anchor-width", `${Yn}px`), dn.setProperty("--radix-popper-anchor-height", `${Qt}px`);
        }
      }),
      fe && w5({
        element: fe,
        padding: h
      }),
      Bz({
        arrowWidth: oe,
        arrowHeight: ue
      }),
      L && I5({
        strategy: "referenceHidden"
      })
    ]
  }), [de, Z] = m7(he), ne = pr(M);
  An(() => {
    le && (ne == null || ne());
  }, [
    le,
    ne
  ]);
  const ge = (o = ve.arrow) === null || o === void 0 ? void 0 : o.x, me = (a = ve.arrow) === null || a === void 0 ? void 0 : a.y, we = ((s = ve.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [j, Be] = Ne();
  return An(() => {
    G && Be(window.getComputedStyle(G).zIndex);
  }, [
    G
  ]), /* @__PURE__ */ xe("div", {
    ref: X.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...ie,
      transform: le ? ie.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: j,
      "--radix-popper-transform-origin": [
        (u = ve.transformOrigin) === null || u === void 0 ? void 0 : u.x,
        (f = ve.transformOrigin) === null || f === void 0 ? void 0 : f.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ xe($z, {
    scope: p,
    placedSide: de,
    onArrowChange: U,
    arrowX: ge,
    arrowY: me,
    shouldHideArrow: we
  }, /* @__PURE__ */ xe(Pt.div, ce({
    "data-side": de,
    "data-align": Z
  }, $, {
    ref: ae,
    style: {
      ...$.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: le ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (d = ve.hide) !== null && d !== void 0 && d.referenceHidden ? 0 : void 0
    }
  }))));
});
function kz(e) {
  return e !== null;
}
const Bz = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, c, o, a, s;
    const { placement: u, rects: f, middlewareData: d } = t, m = ((n = d.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, b = m ? 0 : e.arrowWidth, y = m ? 0 : e.arrowHeight, [C, h] = m7(u), v = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[h], I = ((c = (o = d.arrow) === null || o === void 0 ? void 0 : o.x) !== null && c !== void 0 ? c : 0) + b / 2, S = ((a = (s = d.arrow) === null || s === void 0 ? void 0 : s.y) !== null && a !== void 0 ? a : 0) + y / 2;
    let L = "", R = "";
    return C === "bottom" ? (L = m ? v : `${I}px`, R = `${-y}px`) : C === "top" ? (L = m ? v : `${I}px`, R = `${f.floating.height + y}px`) : C === "right" ? (L = `${-y}px`, R = m ? v : `${S}px`) : C === "left" && (L = `${f.floating.width + y}px`, R = m ? v : `${S}px`), {
      data: {
        x: L,
        y: R
      }
    };
  }
});
function m7(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Vz = Oz, Wz = Dz, Hz = Gz, jz = /* @__PURE__ */ Ze((e, t) => {
  var n;
  const { container: c = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return c ? /* @__PURE__ */ Vf.createPortal(/* @__PURE__ */ xe(Pt.div, ce({}, o, {
    ref: t
  })), c) : null;
});
function J6({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [c, o] = Xz({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, s = a ? e : c, u = pr(n), f = qe((d) => {
    if (a) {
      const m = typeof d == "function" ? d(e) : d;
      m !== e && u(m);
    } else o(d);
  }, [
    a,
    e,
    o,
    u
  ]);
  return [
    s,
    f
  ];
}
function Xz({ defaultProp: e, onChange: t }) {
  const n = Ne(e), [c] = n, o = je(c), a = pr(t);
  return ct(() => {
    o.current !== c && (a(c), o.current = c);
  }, [
    c,
    o,
    a
  ]), n;
}
function Zz(e) {
  const t = je({
    value: e,
    previous: e
  });
  return Wt(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function Yz(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Uz(...e) {
  return (t) => e.forEach(
    (n) => Yz(n, t)
  );
}
const h7 = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...c } = e, o = Bn.toArray(n), a = o.find(Kz);
  if (a) {
    const s = a.props.children, u = o.map((f) => f === a ? Bn.count(s) > 1 ? Bn.only(null) : /* @__PURE__ */ Dr(s) ? s.props.children : null : f);
    return /* @__PURE__ */ xe(_l, ce({}, c, {
      ref: t
    }), /* @__PURE__ */ Dr(s) ? /* @__PURE__ */ aa(s, void 0, u) : null);
  }
  return /* @__PURE__ */ xe(_l, ce({}, c, {
    ref: t
  }), n);
});
h7.displayName = "Slot";
const _l = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...c } = e;
  return /* @__PURE__ */ Dr(n) ? /* @__PURE__ */ aa(n, {
    ...qz(c, n.props),
    ref: t ? Uz(t, n.ref) : n.ref
  }) : Bn.count(n) > 1 ? Bn.only(null) : null;
});
_l.displayName = "SlotClone";
const Jz = ({ children: e }) => /* @__PURE__ */ xe(a1, null, e);
function Kz(e) {
  return /* @__PURE__ */ Dr(e) && e.type === Jz;
}
function qz(e, t) {
  const n = {
    ...t
  };
  for (const c in t) {
    const o = e[c], a = t[c];
    /^on[A-Z]/.test(c) ? o && a ? n[c] = (...u) => {
      a(...u), o(...u);
    } : o && (n[c] = o) : c === "style" ? n[c] = {
      ...o,
      ...a
    } : c === "className" && (n[c] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Qz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], eN = Qz.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze((c, o) => {
    const { asChild: a, ...s } = c, u = a ? h7 : t;
    return ct(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ xe(u, ce({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), tN = /* @__PURE__ */ Ze((e, t) => /* @__PURE__ */ xe(eN.span, ce({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
})));
var v7 = W5(), Fs = function() {
}, Pa = A.forwardRef(function(e, t) {
  var n = A.useRef(null), c = A.useState({
    onScrollCapture: Fs,
    onWheelCapture: Fs,
    onTouchMoveCapture: Fs
  }), o = c[0], a = c[1], s = e.forwardProps, u = e.children, f = e.className, d = e.removeScrollBar, p = e.enabled, m = e.shards, b = e.sideCar, y = e.noIsolation, C = e.inert, h = e.allowPinchZoom, v = e.as, I = v === void 0 ? "div" : v, S = w4(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), L = b, R = V5([n, t]), M = Ot(Ot({}, S), o);
  return A.createElement(
    A.Fragment,
    null,
    p && A.createElement(L, { sideCar: v7, removeScrollBar: d, shards: m, noIsolation: y, inert: C, setCallbacks: a, allowPinchZoom: !!h, lockRef: n }),
    s ? A.cloneElement(A.Children.only(u), Ot(Ot({}, M), { ref: R })) : A.createElement(I, Ot({}, M, { className: f, ref: R }), u)
  );
});
Pa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Pa.classNames = {
  fullWidth: qc,
  zeroRight: Kc
};
var El = !1;
if (typeof window < "u")
  try {
    var Si = Object.defineProperty({}, "passive", {
      get: function() {
        return El = !0, !0;
      }
    });
    window.addEventListener("test", Si, Si), window.removeEventListener("test", Si, Si);
  } catch {
    El = !1;
  }
var B1 = El ? { passive: !1 } : !1, nN = function(e) {
  return e.tagName === "TEXTAREA";
}, b7 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !nN(e) && n[t] === "visible")
  );
}, rN = function(e) {
  return b7(e, "overflowY");
}, cN = function(e) {
  return b7(e, "overflowX");
}, K6 = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var c = C7(e, n);
    if (c) {
      var o = x7(e, n), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, oN = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, c = e.clientHeight;
  return [
    t,
    n,
    c
  ];
}, iN = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, c = e.clientWidth;
  return [
    t,
    n,
    c
  ];
}, C7 = function(e, t) {
  return e === "v" ? rN(t) : cN(t);
}, x7 = function(e, t) {
  return e === "v" ? oN(t) : iN(t);
}, aN = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, sN = function(e, t, n, c, o) {
  var a = aN(e, window.getComputedStyle(t).direction), s = a * c, u = n.target, f = t.contains(u), d = !1, p = s > 0, m = 0, b = 0;
  do {
    var y = x7(e, u), C = y[0], h = y[1], v = y[2], I = h - v - a * C;
    (C || I) && C7(e, u) && (m += I, b += C), u = u.parentNode;
  } while (
    // portaled content
    !f && u !== document.body || // self content
    f && (t.contains(u) || t === u)
  );
  return (p && m === 0 || !p && b === 0) && (d = !0), d;
}, _i = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, q6 = function(e) {
  return [e.deltaX, e.deltaY];
}, Q6 = function(e) {
  return e && "current" in e ? e.current : e;
}, lN = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, uN = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, fN = 0, V1 = [];
function dN(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), c = A.useRef(), o = A.useState(fN++)[0], a = A.useState(function() {
    return A4();
  })[0], s = A.useRef(e);
  A.useEffect(function() {
    s.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = B5([e.lockRef.current], (e.shards || []).map(Q6), !0).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = A.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2)
      return !s.current.allowPinchZoom;
    var I = _i(h), S = n.current, L = "deltaX" in h ? h.deltaX : S[0] - I[0], R = "deltaY" in h ? h.deltaY : S[1] - I[1], M, $ = h.target, O = Math.abs(L) > Math.abs(R) ? "h" : "v";
    if ("touches" in h && O === "h" && $.type === "range")
      return !1;
    var G = K6(O, $);
    if (!G)
      return !0;
    if (G ? M = O : (M = O === "v" ? "h" : "v", G = K6(O, $)), !G)
      return !1;
    if (!c.current && "changedTouches" in h && (L || R) && (c.current = M), !M)
      return !0;
    var J = c.current || M;
    return sN(J, v, h, J === "h" ? L : R);
  }, []), f = A.useCallback(function(h) {
    var v = h;
    if (!(!V1.length || V1[V1.length - 1] !== a)) {
      var I = "deltaY" in v ? q6(v) : _i(v), S = t.current.filter(function(M) {
        return M.name === v.type && M.target === v.target && lN(M.delta, I);
      })[0];
      if (S && S.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!S) {
        var L = (s.current.shards || []).map(Q6).filter(Boolean).filter(function(M) {
          return M.contains(v.target);
        }), R = L.length > 0 ? u(v, L[0]) : !s.current.noIsolation;
        R && v.cancelable && v.preventDefault();
      }
    }
  }, []), d = A.useCallback(function(h, v, I, S) {
    var L = { name: h, delta: v, target: I, should: S };
    t.current.push(L), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== L;
      });
    }, 1);
  }, []), p = A.useCallback(function(h) {
    n.current = _i(h), c.current = void 0;
  }, []), m = A.useCallback(function(h) {
    d(h.type, q6(h), h.target, u(h, e.lockRef.current));
  }, []), b = A.useCallback(function(h) {
    d(h.type, _i(h), h.target, u(h, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return V1.push(a), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", f, B1), document.addEventListener("touchmove", f, B1), document.addEventListener("touchstart", p, B1), function() {
      V1 = V1.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", f, B1), document.removeEventListener("touchmove", f, B1), document.removeEventListener("touchstart", p, B1);
    };
  }, []);
  var y = e.removeScrollBar, C = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    C ? A.createElement(a, { styles: uN(o) }) : null,
    y ? A.createElement(Z5, { gapMode: "margin" }) : null
  );
}
const pN = j5(v7, dN);
var y7 = A.forwardRef(function(e, t) {
  return A.createElement(Pa, Ot({}, e, { ref: t, sideCar: pN }));
});
y7.classNames = Pa.classNames;
const gN = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], mN = [
  " ",
  "Enter"
], Ta = "Select", [za, Na, hN] = fz(Ta), [fc, AV] = k4(Ta, [
  hN,
  d7
]), V4 = d7(), [vN, m1] = fc(Ta), [bN, CN] = fc(Ta), xN = (e) => {
  const { __scopeSelect: t, children: n, open: c, defaultOpen: o, onOpenChange: a, value: s, defaultValue: u, onValueChange: f, dir: d, name: p, autoComplete: m, disabled: b, required: y } = e, C = V4(t), [h, v] = Ne(null), [I, S] = Ne(null), [L, R] = Ne(!1), M = pz(d), [$ = !1, O] = J6({
    prop: c,
    defaultProp: o,
    onChange: a
  }), [G, J] = J6({
    prop: s,
    defaultProp: u,
    onChange: f
  }), ae = je(null), fe = h ? !!h.closest("form") : !0, [U, re] = Ne(/* @__PURE__ */ new Set()), oe = Array.from(U).map(
    (ue) => ue.props.value
  ).join(";");
  return /* @__PURE__ */ xe(Vz, C, /* @__PURE__ */ xe(vN, {
    required: y,
    scope: t,
    trigger: h,
    onTriggerChange: v,
    valueNode: I,
    onValueNodeChange: S,
    valueNodeHasChildren: L,
    onValueNodeHasChildrenChange: R,
    contentId: B4(),
    value: G,
    onValueChange: J,
    open: $,
    onOpenChange: O,
    dir: M,
    triggerPointerDownPosRef: ae,
    disabled: b
  }, /* @__PURE__ */ xe(za.Provider, {
    scope: t
  }, /* @__PURE__ */ xe(bN, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: qe((ue) => {
      re(
        (te) => new Set(te).add(ue)
      );
    }, []),
    onNativeOptionRemove: qe((ue) => {
      re((te) => {
        const se = new Set(te);
        return se.delete(ue), se;
      });
    }, [])
  }, n)), fe ? /* @__PURE__ */ xe(S7, {
    key: oe,
    "aria-hidden": !0,
    required: y,
    tabIndex: -1,
    name: p,
    autoComplete: m,
    value: G,
    onChange: (ue) => J(ue.target.value),
    disabled: b
  }, G === void 0 ? /* @__PURE__ */ xe("option", {
    value: ""
  }) : null, Array.from(U)) : null));
}, yN = "SelectTrigger", IN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, disabled: c = !1, ...o } = e, a = V4(n), s = m1(yN, n), u = s.disabled || c, f = Dt(t, s.onTriggerChange), d = Na(n), [p, m, b] = _7((C) => {
    const h = d().filter(
      (S) => !S.disabled
    ), v = h.find(
      (S) => S.value === s.value
    ), I = E7(h, C, v);
    I !== void 0 && s.onValueChange(I.value);
  }), y = () => {
    u || (s.onOpenChange(!0), b());
  };
  return /* @__PURE__ */ xe(Wz, ce({
    asChild: !0
  }, a), /* @__PURE__ */ xe(Pt.button, ce({
    type: "button",
    role: "combobox",
    "aria-controls": s.contentId,
    "aria-expanded": s.open,
    "aria-required": s.required,
    "aria-autocomplete": "none",
    dir: s.dir,
    "data-state": s.open ? "open" : "closed",
    disabled: u,
    "data-disabled": u ? "" : void 0,
    "data-placeholder": s.value === void 0 ? "" : void 0
  }, o, {
    ref: f,
    onClick: St(o.onClick, (C) => {
      C.currentTarget.focus();
    }),
    onPointerDown: St(o.onPointerDown, (C) => {
      const h = C.target;
      h.hasPointerCapture(C.pointerId) && h.releasePointerCapture(C.pointerId), C.button === 0 && C.ctrlKey === !1 && (y(), s.triggerPointerDownPosRef.current = {
        x: Math.round(C.pageX),
        y: Math.round(C.pageY)
      }, C.preventDefault());
    }),
    onKeyDown: St(o.onKeyDown, (C) => {
      const h = p.current !== "";
      !(C.ctrlKey || C.altKey || C.metaKey) && C.key.length === 1 && m(C.key), !(h && C.key === " ") && gN.includes(C.key) && (y(), C.preventDefault());
    })
  })));
}), wN = "SelectValue", AN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, className: c, style: o, children: a, placeholder: s, ...u } = e, f = m1(wN, n), { onValueNodeHasChildrenChange: d } = f, p = a !== void 0, m = Dt(t, f.onValueNodeChange);
  return An(() => {
    d(p);
  }, [
    d,
    p
  ]), /* @__PURE__ */ xe(Pt.span, ce({}, u, {
    ref: m,
    style: {
      pointerEvents: "none"
    }
  }), f.value === void 0 && s !== void 0 ? s : a);
}), SN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, children: c, ...o } = e;
  return /* @__PURE__ */ xe(Pt.span, ce({
    "aria-hidden": !0
  }, o, {
    ref: t
  }), c || "▼");
}), _N = (e) => /* @__PURE__ */ xe(jz, ce({
  asChild: !0
}, e)), nc = "SelectContent", EN = /* @__PURE__ */ Ze((e, t) => {
  const n = m1(nc, e.__scopeSelect), [c, o] = Ne();
  if (An(() => {
    o(new DocumentFragment());
  }, []), !n.open) {
    const a = c;
    return a ? /* @__PURE__ */ $l(/* @__PURE__ */ xe(I7, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ xe(za.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ xe("div", null, e.children))), a) : null;
  }
  return /* @__PURE__ */ xe(MN, ce({}, e, {
    ref: t
  }));
}), ir = 10, [I7, h1] = fc(nc), MN = /* @__PURE__ */ Ze((e, t) => {
  const {
    __scopeSelect: n,
    position: c = "item-aligned",
    onCloseAutoFocus: o,
    onEscapeKeyDown: a,
    onPointerDownOutside: s,
    side: u,
    sideOffset: f,
    align: d,
    alignOffset: p,
    arrowPadding: m,
    collisionBoundary: b,
    collisionPadding: y,
    sticky: C,
    hideWhenDetached: h,
    avoidCollisions: v,
    //
    ...I
  } = e, S = m1(nc, n), [L, R] = Ne(null), [M, $] = Ne(null), O = Dt(
    t,
    (Z) => R(Z)
  ), [G, J] = Ne(null), [ae, fe] = Ne(null), U = Na(n), [re, oe] = Ne(!1), ue = je(!1);
  ct(() => {
    if (L) return I4(L);
  }, [
    L
  ]), wz();
  const te = qe((Z) => {
    const [ne, ...ge] = U().map(
      (j) => j.ref.current
    ), [me] = ge.slice(-1), we = document.activeElement;
    for (const j of Z)
      if (j === we || (j == null || j.scrollIntoView({
        block: "nearest"
      }), j === ne && M && (M.scrollTop = 0), j === me && M && (M.scrollTop = M.scrollHeight), j == null || j.focus(), document.activeElement !== we)) return;
  }, [
    U,
    M
  ]), se = qe(
    () => te([
      G,
      L
    ]),
    [
      te,
      G,
      L
    ]
  );
  ct(() => {
    re && se();
  }, [
    re,
    se
  ]);
  const { onOpenChange: ee, triggerPointerDownPosRef: q } = S;
  ct(() => {
    if (L) {
      let Z = {
        x: 0,
        y: 0
      };
      const ne = (me) => {
        var we, j, Be, Fe;
        Z = {
          x: Math.abs(Math.round(me.pageX) - ((we = (j = q.current) === null || j === void 0 ? void 0 : j.x) !== null && we !== void 0 ? we : 0)),
          y: Math.abs(Math.round(me.pageY) - ((Be = (Fe = q.current) === null || Fe === void 0 ? void 0 : Fe.y) !== null && Be !== void 0 ? Be : 0))
        };
      }, ge = (me) => {
        Z.x <= 10 && Z.y <= 10 ? me.preventDefault() : L.contains(me.target) || ee(!1), document.removeEventListener("pointermove", ne), q.current = null;
      };
      return q.current !== null && (document.addEventListener("pointermove", ne), document.addEventListener("pointerup", ge, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", ne), document.removeEventListener("pointerup", ge, {
          capture: !0
        });
      };
    }
  }, [
    L,
    ee,
    q
  ]), ct(() => {
    const Z = () => ee(!1);
    return window.addEventListener("blur", Z), window.addEventListener("resize", Z), () => {
      window.removeEventListener("blur", Z), window.removeEventListener("resize", Z);
    };
  }, [
    ee
  ]);
  const [B, X] = _7((Z) => {
    const ne = U().filter(
      (we) => !we.disabled
    ), ge = ne.find(
      (we) => we.ref.current === document.activeElement
    ), me = E7(ne, Z, ge);
    me && setTimeout(
      () => me.ref.current.focus()
    );
  }), ie = qe((Z, ne, ge) => {
    const me = !ue.current && !ge;
    (S.value !== void 0 && S.value === ne || me) && (J(Z), me && (ue.current = !0));
  }, [
    S.value
  ]), he = qe(
    () => L == null ? void 0 : L.focus(),
    [
      L
    ]
  ), le = qe((Z, ne, ge) => {
    const me = !ue.current && !ge;
    (S.value !== void 0 && S.value === ne || me) && fe(Z);
  }, [
    S.value
  ]), ve = c === "popper" ? ef : LN, de = ve === ef ? {
    side: u,
    sideOffset: f,
    align: d,
    alignOffset: p,
    arrowPadding: m,
    collisionBoundary: b,
    collisionPadding: y,
    sticky: C,
    hideWhenDetached: h,
    avoidCollisions: v
  } : {};
  return /* @__PURE__ */ xe(I7, {
    scope: n,
    content: L,
    viewport: M,
    onViewportChange: $,
    itemRefCallback: ie,
    selectedItem: G,
    onItemLeave: he,
    itemTextRefCallback: le,
    focusSelectedItem: se,
    selectedItemText: ae,
    position: c,
    isPositioned: re,
    searchRef: B
  }, /* @__PURE__ */ xe(y7, {
    as: oo,
    allowPinchZoom: !0
  }, /* @__PURE__ */ xe(Az, {
    asChild: !0,
    trapped: S.open,
    onMountAutoFocus: (Z) => {
      Z.preventDefault();
    },
    onUnmountAutoFocus: St(o, (Z) => {
      var ne;
      (ne = S.trigger) === null || ne === void 0 || ne.focus({
        preventScroll: !0
      }), Z.preventDefault();
    })
  }, /* @__PURE__ */ xe(xz, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: a,
    onPointerDownOutside: s,
    onFocusOutside: (Z) => Z.preventDefault(),
    onDismiss: () => S.onOpenChange(!1)
  }, /* @__PURE__ */ xe(ve, ce({
    role: "listbox",
    id: S.contentId,
    "data-state": S.open ? "open" : "closed",
    dir: S.dir,
    onContextMenu: (Z) => Z.preventDefault()
  }, I, de, {
    onPlaced: () => oe(!0),
    ref: O,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...I.style
    },
    onKeyDown: St(I.onKeyDown, (Z) => {
      const ne = Z.ctrlKey || Z.altKey || Z.metaKey;
      if (Z.key === "Tab" && Z.preventDefault(), !ne && Z.key.length === 1 && X(Z.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(Z.key)) {
        let me = U().filter(
          (we) => !we.disabled
        ).map(
          (we) => we.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(Z.key) && (me = me.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(Z.key)) {
          const we = Z.target, j = me.indexOf(we);
          me = me.slice(j + 1);
        }
        setTimeout(
          () => te(me)
        ), Z.preventDefault();
      }
    })
  }))))));
}), LN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, onPlaced: c, ...o } = e, a = m1(nc, n), s = h1(nc, n), [u, f] = Ne(null), [d, p] = Ne(null), m = Dt(
    t,
    (O) => p(O)
  ), b = Na(n), y = je(!1), C = je(!0), { viewport: h, selectedItem: v, selectedItemText: I, focusSelectedItem: S } = s, L = qe(() => {
    if (a.trigger && a.valueNode && u && d && h && v && I) {
      const O = a.trigger.getBoundingClientRect(), G = d.getBoundingClientRect(), J = a.valueNode.getBoundingClientRect(), ae = I.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const we = ae.left - G.left, j = J.left - we, Be = O.left - j, Fe = O.width + Be, ut = Math.max(Fe, G.width), $t = window.innerWidth - ir, Ct = V6(j, [
          ir,
          $t - ut
        ]);
        u.style.minWidth = Fe + "px", u.style.left = Ct + "px";
      } else {
        const we = G.right - ae.right, j = window.innerWidth - J.right - we, Be = window.innerWidth - O.right - j, Fe = O.width + Be, ut = Math.max(Fe, G.width), $t = window.innerWidth - ir, Ct = V6(j, [
          ir,
          $t - ut
        ]);
        u.style.minWidth = Fe + "px", u.style.right = Ct + "px";
      }
      const fe = b(), U = window.innerHeight - ir * 2, re = h.scrollHeight, oe = window.getComputedStyle(d), ue = parseInt(oe.borderTopWidth, 10), te = parseInt(oe.paddingTop, 10), se = parseInt(oe.borderBottomWidth, 10), ee = parseInt(oe.paddingBottom, 10), q = ue + te + re + ee + se, B = Math.min(v.offsetHeight * 5, q), X = window.getComputedStyle(h), ie = parseInt(X.paddingTop, 10), he = parseInt(X.paddingBottom, 10), le = O.top + O.height / 2 - ir, ve = U - le, de = v.offsetHeight / 2, Z = v.offsetTop + de, ne = ue + te + Z, ge = q - ne;
      if (ne <= le) {
        const we = v === fe[fe.length - 1].ref.current;
        u.style.bottom = "0px";
        const j = d.clientHeight - h.offsetTop - h.offsetHeight, Be = Math.max(ve, de + (we ? he : 0) + j + se), Fe = ne + Be;
        u.style.height = Fe + "px";
      } else {
        const we = v === fe[0].ref.current;
        u.style.top = "0px";
        const Be = Math.max(le, ue + h.offsetTop + (we ? ie : 0) + de) + ge;
        u.style.height = Be + "px", h.scrollTop = ne - le + h.offsetTop;
      }
      u.style.margin = `${ir}px 0`, u.style.minHeight = B + "px", u.style.maxHeight = U + "px", c == null || c(), requestAnimationFrame(
        () => y.current = !0
      );
    }
  }, [
    b,
    a.trigger,
    a.valueNode,
    u,
    d,
    h,
    v,
    I,
    a.dir,
    c
  ]);
  An(
    () => L(),
    [
      L
    ]
  );
  const [R, M] = Ne();
  An(() => {
    d && M(window.getComputedStyle(d).zIndex);
  }, [
    d
  ]);
  const $ = qe((O) => {
    O && C.current === !0 && (L(), S == null || S(), C.current = !1);
  }, [
    L,
    S
  ]);
  return /* @__PURE__ */ xe(RN, {
    scope: n,
    contentWrapper: u,
    shouldExpandOnScrollRef: y,
    onScrollButtonChange: $
  }, /* @__PURE__ */ xe("div", {
    ref: f,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: R
    }
  }, /* @__PURE__ */ xe(Pt.div, ce({}, o, {
    ref: m,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...o.style
    }
  }))));
}), ef = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, align: c = "start", collisionPadding: o = ir, ...a } = e, s = V4(n);
  return /* @__PURE__ */ xe(Hz, ce({}, s, a, {
    ref: t,
    align: c,
    collisionPadding: o,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...a.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [RN, W4] = fc(nc, {}), tf = "SelectViewport", PN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, ...c } = e, o = h1(tf, n), a = W4(tf, n), s = Dt(t, o.onViewportChange), u = je(0);
  return /* @__PURE__ */ xe(a1, null, /* @__PURE__ */ xe("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ xe(za.Slot, {
    scope: n
  }, /* @__PURE__ */ xe(Pt.div, ce({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, c, {
    ref: s,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...c.style
    },
    onScroll: St(c.onScroll, (f) => {
      const d = f.currentTarget, { contentWrapper: p, shouldExpandOnScrollRef: m } = a;
      if (m != null && m.current && p) {
        const b = Math.abs(u.current - d.scrollTop);
        if (b > 0) {
          const y = window.innerHeight - ir * 2, C = parseFloat(p.style.minHeight), h = parseFloat(p.style.height), v = Math.max(C, h);
          if (v < y) {
            const I = v + b, S = Math.min(y, I), L = I - S;
            p.style.height = S + "px", p.style.bottom === "0px" && (d.scrollTop = L > 0 ? L : 0, p.style.justifyContent = "flex-end");
          }
        }
      }
      u.current = d.scrollTop;
    })
  }))));
}), TN = "SelectGroup", [zN, NN] = fc(TN), ON = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, ...c } = e, o = B4();
  return /* @__PURE__ */ xe(zN, {
    scope: n,
    id: o
  }, /* @__PURE__ */ xe(Pt.div, ce({
    role: "group",
    "aria-labelledby": o
  }, c, {
    ref: t
  })));
}), FN = "SelectLabel", DN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, ...c } = e, o = NN(FN, n);
  return /* @__PURE__ */ xe(Pt.div, ce({
    id: o.id
  }, c, {
    ref: t
  }));
}), Ml = "SelectItem", [$N, w7] = fc(Ml), GN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, value: c, disabled: o = !1, textValue: a, ...s } = e, u = m1(Ml, n), f = h1(Ml, n), d = u.value === c, [p, m] = Ne(a ?? ""), [b, y] = Ne(!1), C = Dt(t, (I) => {
    var S;
    return (S = f.itemRefCallback) === null || S === void 0 ? void 0 : S.call(f, I, c, o);
  }), h = B4(), v = () => {
    o || (u.onValueChange(c), u.onOpenChange(!1));
  };
  return /* @__PURE__ */ xe($N, {
    scope: n,
    value: c,
    disabled: o,
    textId: h,
    isSelected: d,
    onItemTextChange: qe((I) => {
      m((S) => {
        var L;
        return S || ((L = I == null ? void 0 : I.textContent) !== null && L !== void 0 ? L : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ xe(za.ItemSlot, {
    scope: n,
    value: c,
    disabled: o,
    textValue: p
  }, /* @__PURE__ */ xe(Pt.div, ce({
    role: "option",
    "aria-labelledby": h,
    "data-highlighted": b ? "" : void 0,
    "aria-selected": d && b,
    "data-state": d ? "checked" : "unchecked",
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0,
    tabIndex: o ? void 0 : -1
  }, s, {
    ref: C,
    onFocus: St(
      s.onFocus,
      () => y(!0)
    ),
    onBlur: St(
      s.onBlur,
      () => y(!1)
    ),
    onPointerUp: St(s.onPointerUp, v),
    onPointerMove: St(s.onPointerMove, (I) => {
      if (o) {
        var S;
        (S = f.onItemLeave) === null || S === void 0 || S.call(f);
      } else
        I.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: St(s.onPointerLeave, (I) => {
      if (I.currentTarget === document.activeElement) {
        var S;
        (S = f.onItemLeave) === null || S === void 0 || S.call(f);
      }
    }),
    onKeyDown: St(s.onKeyDown, (I) => {
      var S;
      ((S = f.searchRef) === null || S === void 0 ? void 0 : S.current) !== "" && I.key === " " || (mN.includes(I.key) && v(), I.key === " " && I.preventDefault());
    })
  }))));
}), Ei = "SelectItemText", kN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, className: c, style: o, ...a } = e, s = m1(Ei, n), u = h1(Ei, n), f = w7(Ei, n), d = CN(Ei, n), [p, m] = Ne(null), b = Dt(
    t,
    (I) => m(I),
    f.onItemTextChange,
    (I) => {
      var S;
      return (S = u.itemTextRefCallback) === null || S === void 0 ? void 0 : S.call(u, I, f.value, f.disabled);
    }
  ), y = p == null ? void 0 : p.textContent, C = Wt(
    () => /* @__PURE__ */ xe("option", {
      key: f.value,
      value: f.value,
      disabled: f.disabled
    }, y),
    [
      f.disabled,
      f.value,
      y
    ]
  ), { onNativeOptionAdd: h, onNativeOptionRemove: v } = d;
  return An(() => (h(C), () => v(C)), [
    h,
    v,
    C
  ]), /* @__PURE__ */ xe(a1, null, /* @__PURE__ */ xe(Pt.span, ce({
    id: f.textId
  }, a, {
    ref: b
  })), f.isSelected && s.valueNode && !s.valueNodeHasChildren ? /* @__PURE__ */ $l(a.children, s.valueNode) : null);
}), BN = "SelectItemIndicator", VN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, ...c } = e;
  return w7(BN, n).isSelected ? /* @__PURE__ */ xe(Pt.span, ce({
    "aria-hidden": !0
  }, c, {
    ref: t
  })) : null;
}), nf = "SelectScrollUpButton", WN = /* @__PURE__ */ Ze((e, t) => {
  const n = h1(nf, e.__scopeSelect), c = W4(nf, e.__scopeSelect), [o, a] = Ne(!1), s = Dt(t, c.onScrollButtonChange);
  return An(() => {
    if (n.viewport && n.isPositioned) {
      let f = function() {
        const d = u.scrollTop > 0;
        a(d);
      };
      const u = n.viewport;
      return f(), u.addEventListener("scroll", f), () => u.removeEventListener("scroll", f);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), o ? /* @__PURE__ */ xe(A7, ce({}, e, {
    ref: s,
    onAutoScroll: () => {
      const { viewport: u, selectedItem: f } = n;
      u && f && (u.scrollTop = u.scrollTop - f.offsetHeight);
    }
  })) : null;
}), rf = "SelectScrollDownButton", HN = /* @__PURE__ */ Ze((e, t) => {
  const n = h1(rf, e.__scopeSelect), c = W4(rf, e.__scopeSelect), [o, a] = Ne(!1), s = Dt(t, c.onScrollButtonChange);
  return An(() => {
    if (n.viewport && n.isPositioned) {
      let f = function() {
        const d = u.scrollHeight - u.clientHeight, p = Math.ceil(u.scrollTop) < d;
        a(p);
      };
      const u = n.viewport;
      return f(), u.addEventListener("scroll", f), () => u.removeEventListener("scroll", f);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), o ? /* @__PURE__ */ xe(A7, ce({}, e, {
    ref: s,
    onAutoScroll: () => {
      const { viewport: u, selectedItem: f } = n;
      u && f && (u.scrollTop = u.scrollTop + f.offsetHeight);
    }
  })) : null;
}), A7 = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, onAutoScroll: c, ...o } = e, a = h1("SelectScrollButton", n), s = je(null), u = Na(n), f = qe(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return ct(() => () => f(), [
    f
  ]), An(() => {
    var d;
    const p = u().find(
      (m) => m.ref.current === document.activeElement
    );
    p == null || (d = p.ref.current) === null || d === void 0 || d.scrollIntoView({
      block: "nearest"
    });
  }, [
    u
  ]), /* @__PURE__ */ xe(Pt.div, ce({
    "aria-hidden": !0
  }, o, {
    ref: t,
    style: {
      flexShrink: 0,
      ...o.style
    },
    onPointerDown: St(o.onPointerDown, () => {
      s.current === null && (s.current = window.setInterval(c, 50));
    }),
    onPointerMove: St(o.onPointerMove, () => {
      var d;
      (d = a.onItemLeave) === null || d === void 0 || d.call(a), s.current === null && (s.current = window.setInterval(c, 50));
    }),
    onPointerLeave: St(o.onPointerLeave, () => {
      f();
    })
  }));
}), jN = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeSelect: n, ...c } = e;
  return /* @__PURE__ */ xe(Pt.div, ce({
    "aria-hidden": !0
  }, c, {
    ref: t
  }));
}), S7 = /* @__PURE__ */ Ze((e, t) => {
  const { value: n, ...c } = e, o = je(null), a = Dt(t, o), s = Zz(n);
  return ct(() => {
    const u = o.current, f = window.HTMLSelectElement.prototype, p = Object.getOwnPropertyDescriptor(f, "value").set;
    if (s !== n && p) {
      const m = new Event("change", {
        bubbles: !0
      });
      p.call(u, n), u.dispatchEvent(m);
    }
  }, [
    s,
    n
  ]), /* @__PURE__ */ xe(tN, {
    asChild: !0
  }, /* @__PURE__ */ xe("select", ce({}, c, {
    ref: a,
    defaultValue: n
  })));
});
S7.displayName = "BubbleSelect";
function _7(e) {
  const t = pr(e), n = je(""), c = je(0), o = qe((s) => {
    const u = n.current + s;
    t(u), function f(d) {
      n.current = d, window.clearTimeout(c.current), d !== "" && (c.current = window.setTimeout(
        () => f(""),
        1e3
      ));
    }(u);
  }, [
    t
  ]), a = qe(() => {
    n.current = "", window.clearTimeout(c.current);
  }, []);
  return ct(() => () => window.clearTimeout(c.current), []), [
    n,
    o,
    a
  ];
}
function E7(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (d) => d === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = XN(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter(
    (d) => d !== n
  ));
  const f = s.find(
    (d) => d.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function XN(e, t) {
  return e.map(
    (n, c) => e[(t + c) % e.length]
  );
}
const ZN = xN, YN = IN, UN = AN, JN = _N, KN = EN, qN = PN, QN = ON, eO = DN, tO = GN, nO = kN, rO = VN, cO = WN, oO = HN, iO = jN, aO = "_trigger_1jinc_405", sO = "_content_1jinc_429", lO = "_viewport_1jinc_437", uO = "_item_1jinc_441", fO = "_label_1jinc_472", dO = "_itemIndicator_1jinc_485", pO = "_separator_1jinc_489", gO = "_scrollButton_1jinc_495", mO = "_fadeIn_1jinc_1", hO = "_fadeOut_1jinc_1", vO = "_slideUpAndFade_1jinc_1", bO = "_slideRightAndFade_1jinc_1", CO = "_slideDownAndFade_1jinc_1", xO = "_slideLeftAndFade_1jinc_1", yO = "_slideDown_1jinc_1", IO = "_slideUp_1jinc_1", wO = "_rotateUp_1jinc_1", AO = "_rotateDown_1jinc_1", hr = {
  trigger: aO,
  content: sO,
  viewport: lO,
  item: uO,
  label: fO,
  itemIndicator: dO,
  separator: pO,
  scrollButton: gO,
  fadeIn: mO,
  fadeOut: hO,
  slideUpAndFade: vO,
  slideRightAndFade: bO,
  slideDownAndFade: CO,
  slideLeftAndFade: xO,
  slideDown: yO,
  slideUp: IO,
  rotateUp: wO,
  rotateDown: AO
};
function SO({ ...e }) {
  return /* @__PURE__ */ w.jsx(ZN, { ...e });
}
function _O({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(YN, { ...t, className: `${e} ${hr.trigger}` });
}
function EO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(UN, { ...t, className: `${e}` });
}
function MO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(KN, { ...t, className: `${e} ${hr.content}` });
}
function LO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(JN, { ...t, className: `${e} ` });
}
function RO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(qN, { ...t, className: `${e} ${hr.viewport}` });
}
function PO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(QN, { ...t, className: `${e} ` });
}
function TO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(SN, { ...t, className: `${e} ` });
}
function zO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(eO, { ...t, className: `${e} ${hr.label}` });
}
function NO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(tO, { ...t, className: `${e} ${hr.item}` });
}
function OO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(nO, { ...t, className: `${e} ` });
}
function FO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(rO, { ...t, className: `${e} ${hr.itemIndicator}` });
}
function DO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(iO, { ...t, className: `${e} ${hr.separator}` });
}
function $O({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(cO, { ...t, className: `${e} ${hr.scrollButton}` });
}
function GO({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(oO, { ...t, className: `${e} ${hr.scrollButton}` });
}
SO.propTypes = {
  className: z.string
};
_O.propTypes = {
  className: z.string
};
EO.propTypes = {
  className: z.string
};
MO.propTypes = {
  className: z.string
};
LO.propTypes = {
  className: z.string
};
RO.propTypes = {
  className: z.string
};
PO.propTypes = {
  className: z.string
};
TO.propTypes = {
  className: z.string
};
zO.propTypes = {
  className: z.string
};
NO.propTypes = {
  className: z.string
};
OO.propTypes = {
  className: z.string
};
FO.propTypes = {
  className: z.string
};
DO.propTypes = {
  className: z.string
};
$O.propTypes = {
  className: z.string
};
GO.propTypes = {
  className: z.string
};
var kO = "VisuallyHidden", M7 = A.forwardRef(
  (e, t) => /* @__PURE__ */ w.jsx(
    ke.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
M7.displayName = kO;
var BO = M7, [Oa, SV] = Ht("Tooltip", [
  uc
]), Fa = uc(), L7 = "TooltipProvider", VO = 700, Ll = "tooltip.open", [WO, H4] = Oa(L7), R7 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = VO,
    skipDelayDuration: c = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, [s, u] = A.useState(!0), f = A.useRef(!1), d = A.useRef(0);
  return A.useEffect(() => {
    const p = d.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ w.jsx(
    WO,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: A.useCallback(() => {
        window.clearTimeout(d.current), u(!1);
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => u(!0),
          c
        );
      }, [c]),
      isPointerInTransitRef: f,
      onPointerInTransitChange: A.useCallback((p) => {
        f.current = p;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
R7.displayName = L7;
var Da = "Tooltip", [HO, $a] = Oa(Da), P7 = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: c,
    defaultOpen: o = !1,
    onOpenChange: a,
    disableHoverableContent: s,
    delayDuration: u
  } = e, f = H4(Da, e.__scopeTooltip), d = Fa(t), [p, m] = A.useState(null), b = jn(), y = A.useRef(0), C = s ?? f.disableHoverableContent, h = u ?? f.delayDuration, v = A.useRef(!1), [I = !1, S] = qt({
    prop: c,
    defaultProp: o,
    onChange: (O) => {
      O ? (f.onOpen(), document.dispatchEvent(new CustomEvent(Ll))) : f.onClose(), a == null || a(O);
    }
  }), L = A.useMemo(() => I ? v.current ? "delayed-open" : "instant-open" : "closed", [I]), R = A.useCallback(() => {
    window.clearTimeout(y.current), y.current = 0, v.current = !1, S(!0);
  }, [S]), M = A.useCallback(() => {
    window.clearTimeout(y.current), y.current = 0, S(!1);
  }, [S]), $ = A.useCallback(() => {
    window.clearTimeout(y.current), y.current = window.setTimeout(() => {
      v.current = !0, S(!0), y.current = 0;
    }, h);
  }, [h, S]);
  return A.useEffect(() => () => {
    y.current && (window.clearTimeout(y.current), y.current = 0);
  }, []), /* @__PURE__ */ w.jsx(ya, { ...d, children: /* @__PURE__ */ w.jsx(
    HO,
    {
      scope: t,
      contentId: b,
      open: I,
      stateAttribute: L,
      trigger: p,
      onTriggerChange: m,
      onTriggerEnter: A.useCallback(() => {
        f.isOpenDelayed ? $() : R();
      }, [f.isOpenDelayed, $, R]),
      onTriggerLeave: A.useCallback(() => {
        C ? M() : (window.clearTimeout(y.current), y.current = 0);
      }, [M, C]),
      onOpen: R,
      onClose: M,
      disableHoverableContent: C,
      children: n
    }
  ) });
};
P7.displayName = Da;
var Rl = "TooltipTrigger", T7 = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...c } = e, o = $a(Rl, n), a = H4(Rl, n), s = Fa(n), u = A.useRef(null), f = pt(t, u, o.onTriggerChange), d = A.useRef(!1), p = A.useRef(!1), m = A.useCallback(() => d.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", m), [m]), /* @__PURE__ */ w.jsx(Ia, { asChild: !0, ...s, children: /* @__PURE__ */ w.jsx(
      ke.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...c,
        ref: f,
        onPointerMove: Ae(e.onPointerMove, (b) => {
          b.pointerType !== "touch" && !p.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: Ae(e.onPointerLeave, () => {
          o.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: Ae(e.onPointerDown, () => {
          d.current = !0, document.addEventListener("pointerup", m, { once: !0 });
        }),
        onFocus: Ae(e.onFocus, () => {
          d.current || o.onOpen();
        }),
        onBlur: Ae(e.onBlur, o.onClose),
        onClick: Ae(e.onClick, o.onClose)
      }
    ) });
  }
);
T7.displayName = Rl;
var jO = "TooltipPortal", [_V, XO] = Oa(jO, {
  forceMount: void 0
}), rc = "TooltipContent", z7 = A.forwardRef(
  (e, t) => {
    const n = XO(rc, e.__scopeTooltip), { forceMount: c = n.forceMount, side: o = "top", ...a } = e, s = $a(rc, e.__scopeTooltip);
    return /* @__PURE__ */ w.jsx(Tn, { present: c || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ w.jsx(N7, { side: o, ...a, ref: t }) : /* @__PURE__ */ w.jsx(ZO, { side: o, ...a, ref: t }) });
  }
), ZO = A.forwardRef((e, t) => {
  const n = $a(rc, e.__scopeTooltip), c = H4(rc, e.__scopeTooltip), o = A.useRef(null), a = pt(t, o), [s, u] = A.useState(null), { trigger: f, onClose: d } = n, p = o.current, { onPointerInTransitChange: m } = c, b = A.useCallback(() => {
    u(null), m(!1);
  }, [m]), y = A.useCallback(
    (C, h) => {
      const v = C.currentTarget, I = { x: C.clientX, y: C.clientY }, S = JO(I, v.getBoundingClientRect()), L = KO(I, S), R = qO(h.getBoundingClientRect()), M = eF([...L, ...R]);
      u(M), m(!0);
    },
    [m]
  );
  return A.useEffect(() => () => b(), [b]), A.useEffect(() => {
    if (f && p) {
      const C = (v) => y(v, p), h = (v) => y(v, f);
      return f.addEventListener("pointerleave", C), p.addEventListener("pointerleave", h), () => {
        f.removeEventListener("pointerleave", C), p.removeEventListener("pointerleave", h);
      };
    }
  }, [f, p, y, b]), A.useEffect(() => {
    if (s) {
      const C = (h) => {
        const v = h.target, I = { x: h.clientX, y: h.clientY }, S = (f == null ? void 0 : f.contains(v)) || (p == null ? void 0 : p.contains(v)), L = !QO(I, s);
        S ? b() : L && (b(), d());
      };
      return document.addEventListener("pointermove", C), () => document.removeEventListener("pointermove", C);
    }
  }, [f, p, s, d, b]), /* @__PURE__ */ w.jsx(N7, { ...e, ref: a });
}), [YO, UO] = Oa(Da, { isInside: !1 }), N7 = A.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: c,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      ...u
    } = e, f = $a(rc, n), d = Fa(n), { onClose: p } = f;
    return A.useEffect(() => (document.addEventListener(Ll, p), () => document.removeEventListener(Ll, p)), [p]), A.useEffect(() => {
      if (f.trigger) {
        const m = (b) => {
          const y = b.target;
          y != null && y.contains(f.trigger) && p();
        };
        return window.addEventListener("scroll", m, { capture: !0 }), () => window.removeEventListener("scroll", m, { capture: !0 });
      }
    }, [f.trigger, p]), /* @__PURE__ */ w.jsx(
      va,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: s,
        onFocusOutside: (m) => m.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ w.jsxs(
          x4,
          {
            "data-state": f.stateAttribute,
            ...d,
            ...u,
            ref: t,
            style: {
              ...u.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ w.jsx(Rd, { children: c }),
              /* @__PURE__ */ w.jsx(YO, { scope: n, isInside: !0, children: /* @__PURE__ */ w.jsx(BO, { id: f.contentId, role: "tooltip", children: o || c }) })
            ]
          }
        )
      }
    );
  }
);
z7.displayName = rc;
var O7 = "TooltipArrow", F7 = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...c } = e, o = Fa(n);
    return UO(
      O7,
      n
    ).isInside ? null : /* @__PURE__ */ w.jsx(y4, { ...o, ...c, ref: t });
  }
);
F7.displayName = O7;
function JO(e, t) {
  const n = Math.abs(t.top - e.y), c = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, c, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case c:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function KO(e, t, n = 5) {
  const c = [];
  switch (t) {
    case "top":
      c.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      c.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      c.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      c.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return c;
}
function qO(e) {
  const { top: t, right: n, bottom: c, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: c },
    { x: o, y: c }
  ];
}
function QO(e, t) {
  const { x: n, y: c } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const u = t[a].x, f = t[a].y, d = t[s].x, p = t[s].y;
    f > c != p > c && n < (d - u) * (c - f) / (p - f) + u && (o = !o);
  }
  return o;
}
function eF(e) {
  const t = e.slice();
  return t.sort((n, c) => n.x < c.x ? -1 : n.x > c.x ? 1 : n.y < c.y ? -1 : n.y > c.y ? 1 : 0), tF(t);
}
function tF(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let c = 0; c < e.length; c++) {
    const o = e[c];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], s = t[t.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let c = e.length - 1; c >= 0; c--) {
    const o = e[c];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], s = n[n.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var nF = R7, rF = P7, cF = T7, oF = z7, iF = F7;
const aF = "_tooltipContent_161b0_90", sF = "_slideDownAndFade_161b0_1", lF = "_slideLeftAndFade_161b0_1", uF = "_slideUpAndFade_161b0_1", fF = "_slideRightAndFade_161b0_1", dF = "_tooltipArrow_161b0_115", pF = "_fadeIn_161b0_1", gF = "_fadeOut_161b0_1", mF = "_slideDown_161b0_1", hF = "_slideUp_161b0_1", vF = "_rotateUp_161b0_1", bF = "_rotateDown_161b0_1", D7 = {
  tooltipContent: aF,
  slideDownAndFade: sF,
  slideLeftAndFade: lF,
  slideUpAndFade: uF,
  slideRightAndFade: fF,
  tooltipArrow: dF,
  fadeIn: pF,
  fadeOut: gF,
  slideDown: mF,
  slideUp: hF,
  rotateUp: vF,
  rotateDown: bF
};
function $7({ children: e, ...t }) {
  return /* @__PURE__ */ w.jsx(nF, { ...t, children: e });
}
function CF({ ...e }) {
  return /* @__PURE__ */ w.jsx(rF, { ...e });
}
function xF({ ...e }) {
  return /* @__PURE__ */ w.jsx(cF, { ...e });
}
function yF({ className: e, ...t }) {
  return /* @__PURE__ */ w.jsx(oF, { ...t, className: `${D7.tooltipContent} ${e || ""}` });
}
function IF({ ...e }) {
  return /* @__PURE__ */ w.jsx(iF, { ...e, className: D7.tooltipArrow });
}
function v1({
  noArrow: e,
  children: t,
  content: n,
  side: c = "top",
  contentClassName: o = ""
}) {
  return n ? /* @__PURE__ */ w.jsx($7, { children: /* @__PURE__ */ w.jsxs(CF, { children: [
    /* @__PURE__ */ w.jsx(xF, { asChild: !0, children: /* @__PURE__ */ w.jsx("span", { style: { display: "flex" }, children: t }) }),
    /* @__PURE__ */ w.jsxs(yF, { side: c, sideOffset: 9, className: o, children: [
      typeof n == "string" ? /* @__PURE__ */ w.jsx("div", { dangerouslySetInnerHTML: { __html: n } }) : n,
      !e && /* @__PURE__ */ w.jsx(IF, {})
    ] })
  ] }) }) : t;
}
$7.propTypes = {
  children: z.element.isRequired
};
v1.propTypes = {
  children: z.any,
  content: z.oneOfType([z.string, z.node]),
  noArrow: z.bool,
  side: z.string,
  contentClassName: z.string
};
const wF = "_selectMultiButton_1m5le_2", AF = "_select_1m5le_2", SF = "_iconCaretDown_1m5le_21", _F = "_labelContainer_1m5le_25", EF = "_selectedCount_1m5le_29", MF = "_tooltipBody_1m5le_33", LF = "_tooltipContent_1m5le_40", Tr = {
  selectMultiButton: wF,
  select: AF,
  iconCaretDown: SF,
  labelContainer: _F,
  selectedCount: EF,
  tooltipBody: MF,
  tooltipContent: LF
};
function G7({
  containerProps: e,
  label: t = "",
  isSelectMenuOpen: n,
  selectedOptions: c = [],
  hideTooltip: o,
  onButtonClick: a
}) {
  const s = () => /* @__PURE__ */ w.jsxs(
    "div",
    {
      className: `${Tr.selectMultiButton} ${n || c.length > 0 ? Tr.select : ""}`,
      onClick: a,
      ...e,
      children: [
        /* @__PURE__ */ w.jsx("div", { className: Tr.labelContainer, children: t ? /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
          t,
          /* @__PURE__ */ w.jsx("div", { className: Tr.selectedCount, children: c.length ? `(${c.length})` : "" })
        ] }) : /* @__PURE__ */ w.jsx("div", { className: Tr.selectedCount, children: c.map((u) => u.label).join(", ") }) }),
        /* @__PURE__ */ w.jsx(Hn, { iconName: yn.caretDown.name, className: Tr.iconCaretDown })
      ]
    }
  );
  return (c == null ? void 0 : c.length) > 0 && !o && !n ? /* @__PURE__ */ w.jsx(
    v1,
    {
      contentClassName: Tr.tooltipBody,
      noArrow: !0,
      side: "bottom",
      content: /* @__PURE__ */ w.jsxs("div", { className: Tr.tooltipContent, children: [
        c.slice(0, 10).map((u) => /* @__PURE__ */ w.jsx("div", { children: u.label }, u.label)),
        c.length > 10 && /* @__PURE__ */ w.jsxs("div", { children: [
          "And ",
          c.length - 10,
          " more..."
        ] })
      ] }),
      children: s()
    }
  ) : s();
}
G7.propTypes = {
  label: z.string,
  isSelectMenuOpen: z.bool,
  containerProps: z.object.isRequired,
  selectedOptions: z.array,
  onButtonClick: z.func,
  hideTooltip: z.bool
};
function f1(e) {
  "@babel/helpers - typeof";
  return f1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f1(e);
}
function RF(e, t) {
  if (f1(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var c = n.call(e, t || "default");
    if (f1(c) != "object") return c;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function k7(e) {
  var t = RF(e, "string");
  return f1(t) == "symbol" ? t : t + "";
}
function Zc(e, t, n) {
  return (t = k7(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function cf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function _e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cf(Object(n), !0).forEach(function(c) {
      Zc(e, c, n[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cf(Object(n)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(n, c));
    });
  }
  return e;
}
function PF(e) {
  if (Array.isArray(e)) return e;
}
function TF(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var c, o, a, s, u = [], f = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        f = !1;
      } else for (; !(f = (c = a.call(n)).done) && (u.push(c.value), u.length !== t); f = !0) ;
    } catch (p) {
      d = !0, o = p;
    } finally {
      try {
        if (!f && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (d) throw o;
      }
    }
    return u;
  }
}
function Pl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, c = Array(t); n < t; n++) c[n] = e[n];
  return c;
}
function B7(e, t) {
  if (e) {
    if (typeof e == "string") return Pl(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pl(e, t) : void 0;
  }
}
function zF() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ar(e, t) {
  return PF(e) || TF(e, t) || B7(e, t) || zF();
}
function NF(e, t) {
  if (e == null) return {};
  var n = {};
  for (var c in e) if ({}.hasOwnProperty.call(e, c)) {
    if (t.includes(c)) continue;
    n[c] = e[c];
  }
  return n;
}
function vr(e, t) {
  if (e == null) return {};
  var n, c, o = NF(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (c = 0; c < a.length; c++) n = a[c], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var OF = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function FF(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, c = e.defaultMenuIsOpen, o = c === void 0 ? !1 : c, a = e.defaultValue, s = a === void 0 ? null : a, u = e.inputValue, f = e.menuIsOpen, d = e.onChange, p = e.onInputChange, m = e.onMenuClose, b = e.onMenuOpen, y = e.value, C = vr(e, OF), h = Ne(u !== void 0 ? u : n), v = ar(h, 2), I = v[0], S = v[1], L = Ne(f !== void 0 ? f : o), R = ar(L, 2), M = R[0], $ = R[1], O = Ne(y !== void 0 ? y : s), G = ar(O, 2), J = G[0], ae = G[1], fe = qe(function(ee, q) {
    typeof d == "function" && d(ee, q), ae(ee);
  }, [d]), U = qe(function(ee, q) {
    var B;
    typeof p == "function" && (B = p(ee, q)), S(B !== void 0 ? B : ee);
  }, [p]), re = qe(function() {
    typeof b == "function" && b(), $(!0);
  }, [b]), oe = qe(function() {
    typeof m == "function" && m(), $(!1);
  }, [m]), ue = u !== void 0 ? u : I, te = f !== void 0 ? f : M, se = y !== void 0 ? y : J;
  return _e(_e({}, C), {}, {
    inputValue: ue,
    menuIsOpen: te,
    onChange: fe,
    onInputChange: U,
    onMenuClose: oe,
    onMenuOpen: re,
    value: se
  });
}
function DF(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function of(e, t) {
  for (var n = 0; n < t.length; n++) {
    var c = t[n];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(e, k7(c.key), c);
  }
}
function $F(e, t, n) {
  return of(e.prototype, t), of(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function qi(e, t) {
  return qi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, c) {
    return n.__proto__ = c, n;
  }, qi(e, t);
}
function GF(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && qi(e, t);
}
function Qi(e) {
  return Qi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Qi(e);
}
function V7() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (V7 = function() {
    return !!e;
  })();
}
function Tl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kF(e, t) {
  if (t && (f1(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Tl(e);
}
function BF(e) {
  var t = V7();
  return function() {
    var n, c = Qi(e);
    if (t) {
      var o = Qi(this).constructor;
      n = Reflect.construct(c, arguments, o);
    } else n = c.apply(this, arguments);
    return kF(this, n);
  };
}
function VF(e) {
  if (Array.isArray(e)) return Pl(e);
}
function WF(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function HF() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function j4(e) {
  return VF(e) || WF(e) || B7(e) || HF();
}
function jF(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function XF(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var ZF = /* @__PURE__ */ function() {
  function e(n) {
    var c = this;
    this._insertTag = function(o) {
      var a;
      c.tags.length === 0 ? c.insertionPoint ? a = c.insertionPoint.nextSibling : c.prepend ? a = c.container.firstChild : a = c.before : a = c.tags[c.tags.length - 1].nextSibling, c.container.insertBefore(o, a), c.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(c) {
    c.forEach(this._insertTag);
  }, t.insert = function(c) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(XF(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = jF(o);
      try {
        a.insertRule(c, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(c));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(c) {
      var o;
      return (o = c.parentNode) == null ? void 0 : o.removeChild(c);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Nt = "-ms-", ea = "-moz-", Je = "-webkit-", W7 = "comm", X4 = "rule", Z4 = "decl", YF = "@import", H7 = "@keyframes", UF = "@layer", JF = Math.abs, Ga = String.fromCharCode, KF = Object.assign;
function qF(e, t) {
  return Lt(e, 0) ^ 45 ? (((t << 2 ^ Lt(e, 0)) << 2 ^ Lt(e, 1)) << 2 ^ Lt(e, 2)) << 2 ^ Lt(e, 3) : 0;
}
function j7(e) {
  return e.trim();
}
function QF(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ke(e, t, n) {
  return e.replace(t, n);
}
function zl(e, t) {
  return e.indexOf(t);
}
function Lt(e, t) {
  return e.charCodeAt(t) | 0;
}
function io(e, t, n) {
  return e.slice(t, n);
}
function Dn(e) {
  return e.length;
}
function Y4(e) {
  return e.length;
}
function Mi(e, t) {
  return t.push(e), e;
}
function eD(e, t) {
  return e.map(t).join("");
}
var ka = 1, cc = 1, X7 = 0, Kt = 0, xt = 0, dc = "";
function Ba(e, t, n, c, o, a, s) {
  return { value: e, root: t, parent: n, type: c, props: o, children: a, line: ka, column: cc, length: s, return: "" };
}
function Vc(e, t) {
  return KF(Ba("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function tD() {
  return xt;
}
function nD() {
  return xt = Kt > 0 ? Lt(dc, --Kt) : 0, cc--, xt === 10 && (cc = 1, ka--), xt;
}
function un() {
  return xt = Kt < X7 ? Lt(dc, Kt++) : 0, cc++, xt === 10 && (cc = 1, ka++), xt;
}
function Wn() {
  return Lt(dc, Kt);
}
function Oi() {
  return Kt;
}
function Co(e, t) {
  return io(dc, e, t);
}
function ao(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Z7(e) {
  return ka = cc = 1, X7 = Dn(dc = e), Kt = 0, [];
}
function Y7(e) {
  return dc = "", e;
}
function Fi(e) {
  return j7(Co(Kt - 1, Nl(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rD(e) {
  for (; (xt = Wn()) && xt < 33; )
    un();
  return ao(e) > 2 || ao(xt) > 3 ? "" : " ";
}
function cD(e, t) {
  for (; --t && un() && !(xt < 48 || xt > 102 || xt > 57 && xt < 65 || xt > 70 && xt < 97); )
    ;
  return Co(e, Oi() + (t < 6 && Wn() == 32 && un() == 32));
}
function Nl(e) {
  for (; un(); )
    switch (xt) {
      // ] ) " '
      case e:
        return Kt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Nl(xt);
        break;
      // (
      case 40:
        e === 41 && Nl(e);
        break;
      // \
      case 92:
        un();
        break;
    }
  return Kt;
}
function oD(e, t) {
  for (; un() && e + xt !== 57; )
    if (e + xt === 84 && Wn() === 47)
      break;
  return "/*" + Co(t, Kt - 1) + "*" + Ga(e === 47 ? e : un());
}
function iD(e) {
  for (; !ao(Wn()); )
    un();
  return Co(e, Kt);
}
function aD(e) {
  return Y7(Di("", null, null, null, [""], e = Z7(e), 0, [0], e));
}
function Di(e, t, n, c, o, a, s, u, f) {
  for (var d = 0, p = 0, m = s, b = 0, y = 0, C = 0, h = 1, v = 1, I = 1, S = 0, L = "", R = o, M = a, $ = c, O = L; v; )
    switch (C = S, S = un()) {
      // (
      case 40:
        if (C != 108 && Lt(O, m - 1) == 58) {
          zl(O += Ke(Fi(S), "&", "&\f"), "&\f") != -1 && (I = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += Fi(S);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += rD(C);
        break;
      // \
      case 92:
        O += cD(Oi() - 1, 7);
        continue;
      // /
      case 47:
        switch (Wn()) {
          case 42:
          case 47:
            Mi(sD(oD(un(), Oi()), t, n), f);
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * h:
        u[d++] = Dn(O) * I;
      // } ; \0
      case 125 * h:
      case 59:
      case 0:
        switch (S) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + p:
            I == -1 && (O = Ke(O, /\f/g, "")), y > 0 && Dn(O) - m && Mi(y > 32 ? sf(O + ";", c, n, m - 1) : sf(Ke(O, " ", "") + ";", c, n, m - 2), f);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (Mi($ = af(O, t, n, d, p, o, u, L, R = [], M = [], m), a), S === 123)
              if (p === 0)
                Di(O, t, $, $, R, a, m, u, M);
              else
                switch (b === 99 && Lt(O, 3) === 110 ? 100 : b) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Di(e, $, $, c && Mi(af(e, $, $, 0, 0, o, u, L, o, R = [], m), M), o, M, m, u, c ? R : M);
                    break;
                  default:
                    Di(O, $, $, $, [""], M, 0, u, M);
                }
        }
        d = p = y = 0, h = I = 1, L = O = "", m = s;
        break;
      // :
      case 58:
        m = 1 + Dn(O), y = C;
      default:
        if (h < 1) {
          if (S == 123)
            --h;
          else if (S == 125 && h++ == 0 && nD() == 125)
            continue;
        }
        switch (O += Ga(S), S * h) {
          // &
          case 38:
            I = p > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            u[d++] = (Dn(O) - 1) * I, I = 1;
            break;
          // @
          case 64:
            Wn() === 45 && (O += Fi(un())), b = Wn(), p = m = Dn(L = O += iD(Oi())), S++;
            break;
          // -
          case 45:
            C === 45 && Dn(O) == 2 && (h = 0);
        }
    }
  return a;
}
function af(e, t, n, c, o, a, s, u, f, d, p) {
  for (var m = o - 1, b = o === 0 ? a : [""], y = Y4(b), C = 0, h = 0, v = 0; C < c; ++C)
    for (var I = 0, S = io(e, m + 1, m = JF(h = s[C])), L = e; I < y; ++I)
      (L = j7(h > 0 ? b[I] + " " + S : Ke(S, /&\f/g, b[I]))) && (f[v++] = L);
  return Ba(e, t, n, o === 0 ? X4 : u, f, d, p);
}
function sD(e, t, n) {
  return Ba(e, t, n, W7, Ga(tD()), io(e, 2, -2), 0);
}
function sf(e, t, n, c) {
  return Ba(e, t, n, Z4, io(e, 0, c), io(e, c + 1, -1), c);
}
function J1(e, t) {
  for (var n = "", c = Y4(e), o = 0; o < c; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function lD(e, t, n, c) {
  switch (e.type) {
    case UF:
      if (e.children.length) break;
    case YF:
    case Z4:
      return e.return = e.return || e.value;
    case W7:
      return "";
    case H7:
      return e.return = e.value + "{" + J1(e.children, c) + "}";
    case X4:
      e.value = e.props.join(",");
  }
  return Dn(n = J1(e.children, c)) ? e.return = e.value + "{" + n + "}" : "";
}
function uD(e) {
  var t = Y4(e);
  return function(n, c, o, a) {
    for (var s = "", u = 0; u < t; u++)
      s += e[u](n, c, o, a) || "";
    return s;
  };
}
function fD(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function dD(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var pD = function(t, n, c) {
  for (var o = 0, a = 0; o = a, a = Wn(), o === 38 && a === 12 && (n[c] = 1), !ao(a); )
    un();
  return Co(t, Kt);
}, gD = function(t, n) {
  var c = -1, o = 44;
  do
    switch (ao(o)) {
      case 0:
        o === 38 && Wn() === 12 && (n[c] = 1), t[c] += pD(Kt - 1, n, c);
        break;
      case 2:
        t[c] += Fi(o);
        break;
      case 4:
        if (o === 44) {
          t[++c] = Wn() === 58 ? "&\f" : "", n[c] = t[c].length;
          break;
        }
      // fallthrough
      default:
        t[c] += Ga(o);
    }
  while (o = un());
  return t;
}, mD = function(t, n) {
  return Y7(gD(Z7(t), n));
}, lf = /* @__PURE__ */ new WeakMap(), hD = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, c = t.parent, o = t.column === c.column && t.line === c.line; c.type !== "rule"; )
      if (c = c.parent, !c) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !lf.get(c)) && !o) {
      lf.set(t, !0);
      for (var a = [], s = mD(n, a), u = c.props, f = 0, d = 0; f < s.length; f++)
        for (var p = 0; p < u.length; p++, d++)
          t.props[d] = a[f] ? s[f].replace(/&\f/g, u[p]) : u[p] + " " + s[f];
    }
  }
}, vD = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function U7(e, t) {
  switch (qF(e, t)) {
    // color-adjust
    case 5103:
      return Je + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Je + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Je + e + ea + e + Nt + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Je + e + Nt + e + e;
    // order
    case 6165:
      return Je + e + Nt + "flex-" + e + e;
    // align-items
    case 5187:
      return Je + e + Ke(e, /(\w+).+(:[^]+)/, Je + "box-$1$2" + Nt + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Je + e + Nt + "flex-item-" + Ke(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Je + e + Nt + "flex-line-pack" + Ke(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Je + e + Nt + Ke(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Je + e + Nt + Ke(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Je + "box-" + Ke(e, "-grow", "") + Je + e + Nt + Ke(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Je + Ke(e, /([^-])(transform)/g, "$1" + Je + "$2") + e;
    // cursor
    case 6187:
      return Ke(Ke(Ke(e, /(zoom-|grab)/, Je + "$1"), /(image-set)/, Je + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Ke(e, /(image-set\([^]*)/, Je + "$1$`$1");
    // justify-content
    case 4968:
      return Ke(Ke(e, /(.+:)(flex-)?(.*)/, Je + "box-pack:$3" + Nt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Je + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ke(e, /(.+)-inline(.+)/, Je + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Dn(e) - 1 - t > 6) switch (Lt(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Lt(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Ke(e, /(.+:)(.+)-([^]+)/, "$1" + Je + "$2-$3$1" + ea + (Lt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~zl(e, "stretch") ? U7(Ke(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Lt(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Lt(e, Dn(e) - 3 - (~zl(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Ke(e, ":", ":" + Je) + e;
        // (inline-)?fl(e)x
        case 101:
          return Ke(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Je + (Lt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Je + "$2$3$1" + Nt + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Lt(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Je + e + Nt + Ke(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Je + e + Nt + Ke(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Je + e + Nt + Ke(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Je + e + Nt + e + e;
  }
  return e;
}
var bD = function(t, n, c, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Z4:
      t.return = U7(t.value, t.length);
      break;
    case H7:
      return J1([Vc(t, {
        value: Ke(t.value, "@", "@" + Je)
      })], o);
    case X4:
      if (t.length) return eD(t.props, function(a) {
        switch (QF(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return J1([Vc(t, {
              props: [Ke(a, /:(read-\w+)/, ":" + ea + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return J1([Vc(t, {
              props: [Ke(a, /:(plac\w+)/, ":" + Je + "input-$1")]
            }), Vc(t, {
              props: [Ke(a, /:(plac\w+)/, ":" + ea + "$1")]
            }), Vc(t, {
              props: [Ke(a, /:(plac\w+)/, Nt + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, CD = [bD], xD = function(t) {
  var n = t.key;
  if (n === "css") {
    var c = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(c, function(h) {
      var v = h.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || CD, a = {}, s, u = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(h) {
      for (var v = h.getAttribute("data-emotion").split(" "), I = 1; I < v.length; I++)
        a[v[I]] = !0;
      u.push(h);
    }
  );
  var f, d = [hD, vD];
  {
    var p, m = [lD, fD(function(h) {
      p.insert(h);
    })], b = uD(d.concat(o, m)), y = function(v) {
      return J1(aD(v), b);
    };
    f = function(v, I, S, L) {
      p = S, y(v ? v + "{" + I.styles + "}" : I.styles), L && (C.inserted[I.name] = !0);
    };
  }
  var C = {
    key: n,
    sheet: new ZF({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: f
  };
  return C.sheet.hydrate(u), C;
}, Ds, uf;
function yD() {
  if (uf) return Ds;
  uf = 1;
  var e = Gl(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, c = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, a = {};
  a[e.ForwardRef] = c, a[e.Memo] = o;
  function s(C) {
    return e.isMemo(C) ? o : a[C.$$typeof] || t;
  }
  var u = Object.defineProperty, f = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, m = Object.getPrototypeOf, b = Object.prototype;
  function y(C, h, v) {
    if (typeof h != "string") {
      if (b) {
        var I = m(h);
        I && I !== b && y(C, I, v);
      }
      var S = f(h);
      d && (S = S.concat(d(h)));
      for (var L = s(C), R = s(h), M = 0; M < S.length; ++M) {
        var $ = S[M];
        if (!n[$] && !(v && v[$]) && !(R && R[$]) && !(L && L[$])) {
          var O = p(h, $);
          try {
            u(C, $, O);
          } catch {
          }
        }
      }
    }
    return C;
  }
  return Ds = y, Ds;
}
yD();
var ID = !0;
function wD(e, t, n) {
  var c = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (c += o + " ");
  }), c;
}
var J7 = function(t, n, c) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (c === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  ID === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, AD = function(t, n, c) {
  J7(t, n, c);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function SD(e) {
  for (var t = 0, n, c = 0, o = e.length; o >= 4; ++c, o -= 4)
    n = e.charCodeAt(c) & 255 | (e.charCodeAt(++c) & 255) << 8 | (e.charCodeAt(++c) & 255) << 16 | (e.charCodeAt(++c) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(c + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(c + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(c) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var _D = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ED = /[A-Z]|^ms/g, MD = /_EMO_([^_]+?)_([^]*?)_EMO_/g, K7 = function(t) {
  return t.charCodeAt(1) === 45;
}, ff = function(t) {
  return t != null && typeof t != "boolean";
}, $s = /* @__PURE__ */ dD(function(e) {
  return K7(e) ? e : e.replace(ED, "-$&").toLowerCase();
}), df = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(MD, function(c, o, a) {
          return $n = {
            name: o,
            styles: a,
            next: $n
          }, o;
        });
  }
  return _D[t] !== 1 && !K7(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function so(e, t, n) {
  if (n == null)
    return "";
  var c = n;
  if (c.__emotion_styles !== void 0)
    return c;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return $n = {
          name: o.name,
          styles: o.styles,
          next: $n
        }, o.name;
      var a = n;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            $n = {
              name: s.name,
              styles: s.styles,
              next: $n
            }, s = s.next;
        var u = a.styles + ";";
        return u;
      }
      return LD(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var f = $n, d = n(e);
        return $n = f, so(e, t, d);
      }
      break;
    }
  }
  var p = n;
  return p;
}
function LD(e, t, n) {
  var c = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      c += so(e, t, n[o]) + ";";
  else
    for (var a in n) {
      var s = n[a];
      if (typeof s != "object") {
        var u = s;
        ff(u) && (c += $s(a) + ":" + df(a, u) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && t == null)
        for (var f = 0; f < s.length; f++)
          ff(s[f]) && (c += $s(a) + ":" + df(a, s[f]) + ";");
      else {
        var d = so(e, t, s);
        switch (a) {
          case "animation":
          case "animationName": {
            c += $s(a) + ":" + d + ";";
            break;
          }
          default:
            c += a + "{" + d + "}";
        }
      }
    }
  return c;
}
var pf = /label:\s*([^\s;{]+)\s*(;|$)/g, $n;
function q7(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var c = !0, o = "";
  $n = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    c = !1, o += so(n, t, a);
  else {
    var s = a;
    o += s[0];
  }
  for (var u = 1; u < e.length; u++)
    if (o += so(n, t, e[u]), c) {
      var f = a;
      o += f[u];
    }
  pf.lastIndex = 0;
  for (var d = "", p; (p = pf.exec(o)) !== null; )
    d += "-" + p[1];
  var m = SD(o) + d;
  return {
    name: m,
    styles: o,
    next: $n
  };
}
var RD = function(t) {
  return t();
}, PD = A.useInsertionEffect ? A.useInsertionEffect : !1, TD = PD || RD, Q7 = /* @__PURE__ */ A.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ xD({
    key: "css"
  }) : null
);
Q7.Provider;
var zD = function(t) {
  return /* @__PURE__ */ Ze(function(n, c) {
    var o = lo(Q7);
    return t(n, o, c);
  });
}, ND = /* @__PURE__ */ A.createContext({}), U4 = {}.hasOwnProperty, Ol = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", OD = function(t, n) {
  var c = {};
  for (var o in n)
    U4.call(n, o) && (c[o] = n[o]);
  return c[Ol] = t, c;
}, FD = function(t) {
  var n = t.cache, c = t.serialized, o = t.isStringTag;
  return J7(n, c, o), TD(function() {
    return AD(n, c, o);
  }), null;
}, DD = /* @__PURE__ */ zD(function(e, t, n) {
  var c = e.css;
  typeof c == "string" && t.registered[c] !== void 0 && (c = t.registered[c]);
  var o = e[Ol], a = [c], s = "";
  typeof e.className == "string" ? s = wD(t.registered, a, e.className) : e.className != null && (s = e.className + " ");
  var u = q7(a, void 0, A.useContext(ND));
  s += t.key + "-" + u.name;
  var f = {};
  for (var d in e)
    U4.call(e, d) && d !== "css" && d !== Ol && (f[d] = e[d]);
  return f.className = s, n && (f.ref = n), /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(FD, {
    cache: t,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ A.createElement(o, f));
}), $D = DD, Se = function(t, n) {
  var c = arguments;
  if (n == null || !U4.call(n, "css"))
    return A.createElement.apply(void 0, c);
  var o = c.length, a = new Array(o);
  a[0] = $D, a[1] = OD(t, n);
  for (var s = 2; s < o; s++)
    a[s] = c[s];
  return A.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(Se);
function J4() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return q7(t);
}
function GD() {
  var e = J4.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function kD(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
var Fl = ia, BD = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], ta = function() {
};
function VD(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function WD(e, t) {
  for (var n = arguments.length, c = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    c[o - 2] = arguments[o];
  var a = [].concat(c);
  if (t && e)
    for (var s in t)
      t.hasOwnProperty(s) && t[s] && a.push("".concat(VD(e, s)));
  return a.filter(function(u) {
    return u;
  }).map(function(u) {
    return String(u).trim();
  }).join(" ");
}
var gf = function(t) {
  return qD(t) ? t.filter(Boolean) : f1(t) === "object" && t !== null ? [t] : [];
}, e9 = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = vr(t, BD);
  return _e({}, n);
}, ht = function(t, n, c) {
  var o = t.cx, a = t.getStyles, s = t.getClassNames, u = t.className;
  return {
    css: a(n, t),
    className: o(c ?? {}, s(n, t), u)
  };
};
function Va(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function HD(e) {
  return Va(e) ? window.innerHeight : e.clientHeight;
}
function t9(e) {
  return Va(e) ? window.pageYOffset : e.scrollTop;
}
function na(e, t) {
  if (Va(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function jD(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", c = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && c.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function XD(e, t, n, c) {
  return n * ((e = e / c - 1) * e * e + 1) + t;
}
function Li(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ta, o = t9(e), a = t - o, s = 10, u = 0;
  function f() {
    u += s;
    var d = XD(u, o, a, n);
    na(e, d), u < n ? window.requestAnimationFrame(f) : c(e);
  }
  f();
}
function mf(e, t) {
  var n = e.getBoundingClientRect(), c = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  c.bottom + o > n.bottom ? na(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : c.top - o < n.top && na(e, Math.max(t.offsetTop - o, 0));
}
function ZD(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function hf() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function YD() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var n9 = !1, UD = {
  get passive() {
    return n9 = !0;
  }
}, Ri = typeof window < "u" ? window : {};
Ri.addEventListener && Ri.removeEventListener && (Ri.addEventListener("p", ta, UD), Ri.removeEventListener("p", ta, !1));
var JD = n9;
function KD(e) {
  return e != null;
}
function qD(e) {
  return Array.isArray(e);
}
function Pi(e, t, n) {
  return e ? t : n;
}
var QD = function(t) {
  for (var n = arguments.length, c = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    c[o - 1] = arguments[o];
  var a = Object.entries(t).filter(function(s) {
    var u = ar(s, 1), f = u[0];
    return !c.includes(f);
  });
  return a.reduce(function(s, u) {
    var f = ar(u, 2), d = f[0], p = f[1];
    return s[d] = p, s;
  }, {});
}, e$ = ["children", "innerProps"], t$ = ["children", "innerProps"];
function n$(e) {
  var t = e.maxHeight, n = e.menuEl, c = e.minHeight, o = e.placement, a = e.shouldScroll, s = e.isFixedPosition, u = e.controlHeight, f = jD(n), d = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return d;
  var p = f.getBoundingClientRect(), m = p.height, b = n.getBoundingClientRect(), y = b.bottom, C = b.height, h = b.top, v = n.offsetParent.getBoundingClientRect(), I = v.top, S = s ? window.innerHeight : HD(f), L = t9(f), R = parseInt(getComputedStyle(n).marginBottom, 10), M = parseInt(getComputedStyle(n).marginTop, 10), $ = I - M, O = S - h, G = $ + L, J = m - L - h, ae = y - S + L + R, fe = L + h - M, U = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (O >= C)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (J >= C && !s)
        return a && Li(f, ae, U), {
          placement: "bottom",
          maxHeight: t
        };
      if (!s && J >= c || s && O >= c) {
        a && Li(f, ae, U);
        var re = s ? O - R : J - R;
        return {
          placement: "bottom",
          maxHeight: re
        };
      }
      if (o === "auto" || s) {
        var oe = t, ue = s ? $ : G;
        return ue >= c && (oe = Math.min(ue - R - u, t)), {
          placement: "top",
          maxHeight: oe
        };
      }
      if (o === "bottom")
        return a && na(f, ae), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if ($ >= C)
        return {
          placement: "top",
          maxHeight: t
        };
      if (G >= C && !s)
        return a && Li(f, fe, U), {
          placement: "top",
          maxHeight: t
        };
      if (!s && G >= c || s && $ >= c) {
        var te = t;
        return (!s && G >= c || s && $ >= c) && (te = s ? $ - M : G - M), a && Li(f, fe, U), {
          placement: "top",
          maxHeight: te
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return d;
}
function r$(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var r9 = function(t) {
  return t === "auto" ? "bottom" : t;
}, c$ = function(t, n) {
  var c, o = t.placement, a = t.theme, s = a.borderRadius, u = a.spacing, f = a.colors;
  return _e((c = {
    label: "menu"
  }, Zc(c, r$(o), "100%"), Zc(c, "position", "absolute"), Zc(c, "width", "100%"), Zc(c, "zIndex", 1), c), n ? {} : {
    backgroundColor: f.neutral0,
    borderRadius: s,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: u.menuGutter,
    marginTop: u.menuGutter
  });
}, c9 = /* @__PURE__ */ K1(null), o$ = function(t) {
  var n = t.children, c = t.minMenuHeight, o = t.maxMenuHeight, a = t.menuPlacement, s = t.menuPosition, u = t.menuShouldScrollIntoView, f = t.theme, d = lo(c9) || {}, p = d.setPortalPlacement, m = je(null), b = Ne(o), y = ar(b, 2), C = y[0], h = y[1], v = Ne(null), I = ar(v, 2), S = I[0], L = I[1], R = f.spacing.controlHeight;
  return Fl(function() {
    var M = m.current;
    if (M) {
      var $ = s === "fixed", O = u && !$, G = n$({
        maxHeight: o,
        menuEl: M,
        minHeight: c,
        placement: a,
        shouldScroll: O,
        isFixedPosition: $,
        controlHeight: R
      });
      h(G.maxHeight), L(G.placement), p == null || p(G.placement);
    }
  }, [o, a, s, u, c, p, R]), n({
    ref: m,
    placerProps: _e(_e({}, t), {}, {
      placement: S || r9(a),
      maxHeight: C
    })
  });
}, i$ = function(t) {
  var n = t.children, c = t.innerRef, o = t.innerProps;
  return Se("div", ce({}, ht(t, "menu", {
    menu: !0
  }), {
    ref: c
  }, o), n);
}, a$ = i$, s$ = function(t, n) {
  var c = t.maxHeight, o = t.theme.spacing.baseUnit;
  return _e({
    maxHeight: c,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, l$ = function(t) {
  var n = t.children, c = t.innerProps, o = t.innerRef, a = t.isMulti;
  return Se("div", ce({}, ht(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, c), n);
}, o9 = function(t, n) {
  var c = t.theme, o = c.spacing.baseUnit, a = c.colors;
  return _e({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, u$ = o9, f$ = o9, d$ = function(t) {
  var n = t.children, c = n === void 0 ? "No options" : n, o = t.innerProps, a = vr(t, e$);
  return Se("div", ce({}, ht(_e(_e({}, a), {}, {
    children: c,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), c);
}, p$ = function(t) {
  var n = t.children, c = n === void 0 ? "Loading..." : n, o = t.innerProps, a = vr(t, t$);
  return Se("div", ce({}, ht(_e(_e({}, a), {}, {
    children: c,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), c);
}, g$ = function(t) {
  var n = t.rect, c = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: c,
    width: n.width,
    zIndex: 1
  };
}, m$ = function(t) {
  var n = t.appendTo, c = t.children, o = t.controlElement, a = t.innerProps, s = t.menuPlacement, u = t.menuPosition, f = je(null), d = je(null), p = Ne(r9(s)), m = ar(p, 2), b = m[0], y = m[1], C = Wt(function() {
    return {
      setPortalPlacement: y
    };
  }, []), h = Ne(null), v = ar(h, 2), I = v[0], S = v[1], L = qe(function() {
    if (o) {
      var O = ZD(o), G = u === "fixed" ? 0 : window.pageYOffset, J = O[b] + G;
      (J !== (I == null ? void 0 : I.offset) || O.left !== (I == null ? void 0 : I.rect.left) || O.width !== (I == null ? void 0 : I.rect.width)) && S({
        offset: J,
        rect: O
      });
    }
  }, [o, u, b, I == null ? void 0 : I.offset, I == null ? void 0 : I.rect.left, I == null ? void 0 : I.rect.width]);
  Fl(function() {
    L();
  }, [L]);
  var R = qe(function() {
    typeof d.current == "function" && (d.current(), d.current = null), o && f.current && (d.current = v4(o, f.current, L, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, L]);
  Fl(function() {
    R();
  }, [R]);
  var M = qe(function(O) {
    f.current = O, R();
  }, [R]);
  if (!n && u !== "fixed" || !I) return null;
  var $ = Se("div", ce({
    ref: M
  }, ht(_e(_e({}, t), {}, {
    offset: I.offset,
    position: u,
    rect: I.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), c);
  return Se(c9.Provider, {
    value: C
  }, n ? /* @__PURE__ */ $l($, n) : $);
}, h$ = function(t) {
  var n = t.isDisabled, c = t.isRtl;
  return {
    label: "container",
    direction: c ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, v$ = function(t) {
  var n = t.children, c = t.innerProps, o = t.isDisabled, a = t.isRtl;
  return Se("div", ce({}, ht(t, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), c), n);
}, b$ = function(t, n) {
  var c = t.theme.spacing, o = t.isMulti, a = t.hasValue, s = t.selectProps.controlShouldRenderValue;
  return _e({
    alignItems: "center",
    display: o && a && s ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(c.baseUnit / 2, "px ").concat(c.baseUnit * 2, "px")
  });
}, C$ = function(t) {
  var n = t.children, c = t.innerProps, o = t.isMulti, a = t.hasValue;
  return Se("div", ce({}, ht(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), c), n);
}, x$ = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, y$ = function(t) {
  var n = t.children, c = t.innerProps;
  return Se("div", ce({}, ht(t, "indicatorsContainer", {
    indicators: !0
  }), c), n);
}, vf, I$ = ["size"], w$ = ["innerProps", "isRtl", "size"];
function A$() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var S$ = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCSSIsImZpbGUiOiJpbmRpY2F0b3JzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3gsIGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgQ29tbW9uUHJvcHNBbmRDbGFzc05hbWUsXG4gIENTU09iamVjdFdpdGhMYWJlbCxcbiAgR3JvdXBCYXNlLFxufSBmcm9tICcuLi90eXBlcyc7XG5pbXBvcnQgeyBnZXRTdHlsZVByb3BzIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgSWNvbnNcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBTdmcgPSAoe1xuICBzaXplLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzdmcnXSAmIHsgc2l6ZTogbnVtYmVyIH0pID0+IChcbiAgPHN2Z1xuICAgIGhlaWdodD17c2l6ZX1cbiAgICB3aWR0aD17c2l6ZX1cbiAgICB2aWV3Qm94PVwiMCAwIDIwIDIwXCJcbiAgICBhcmlhLWhpZGRlbj1cInRydWVcIlxuICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICBjc3M9e3tcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgZmlsbDogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBsaW5lSGVpZ2h0OiAxLFxuICAgICAgc3Ryb2tlOiAnY3VycmVudENvbG9yJyxcbiAgICAgIHN0cm9rZVdpZHRoOiAwLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IHR5cGUgQ3Jvc3NJY29uUHJvcHMgPSBKU1guSW50cmluc2ljRWxlbWVudHNbJ3N2ZyddICYgeyBzaXplPzogbnVtYmVyIH07XG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBDcm9zc0ljb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNMTQuMzQ4IDE0Ljg0OWMtMC40NjkgMC40NjktMS4yMjkgMC40NjktMS42OTcgMGwtMi42NTEtMy4wMzAtMi42NTEgMy4wMjljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDAtMC40NjktMC40NjktMC40NjktMS4yMjkgMC0xLjY5N2wyLjc1OC0zLjE1LTIuNzU5LTMuMTUyYy0wLjQ2OS0wLjQ2OS0wLjQ2OS0xLjIyOCAwLTEuNjk3czEuMjI4LTAuNDY5IDEuNjk3IDBsMi42NTIgMy4wMzEgMi42NTEtMy4wMzFjMC40NjktMC40NjkgMS4yMjgtMC40NjkgMS42OTcgMHMwLjQ2OSAxLjIyOSAwIDEuNjk3bC0yLjc1OCAzLjE1MiAyLjc1OCAzLjE1YzAuNDY5IDAuNDY5IDAuNDY5IDEuMjI5IDAgMS42OTh6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuZXhwb3J0IHR5cGUgRG93bkNoZXZyb25Qcm9wcyA9IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3ZnJ10gJiB7IHNpemU/OiBudW1iZXIgfTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogRG93bkNoZXZyb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNNC41MTYgNy41NDhjMC40MzYtMC40NDYgMS4wNDMtMC40ODEgMS41NzYgMGwzLjkwOCAzLjc0NyAzLjkwOC0zLjc0N2MwLjUzMy0wLjQ4MSAxLjE0MS0wLjQ0NiAxLjU3NCAwIDAuNDM2IDAuNDQ1IDAuNDA4IDEuMTk3IDAgMS42MTUtMC40MDYgMC40MTgtNC42OTUgNC41MDItNC42OTUgNC41MDItMC4yMTcgMC4yMjMtMC41MDIgMC4zMzUtMC43ODcgMC4zMzVzLTAuNTctMC4xMTItMC43ODktMC4zMzVjMCAwLTQuMjg3LTQuMDg0LTQuNjk1LTQuNTAycy0wLjQzNi0xLjE3IDAtMS42MTV6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgQnV0dG9uc1xuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbmV4cG9ydCBpbnRlcmZhY2UgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIC8qKiBUaGUgY2hpbGRyZW4gdG8gYmUgcmVuZGVyZWQgaW5zaWRlIHRoZSBpbmRpY2F0b3IuICovXG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xuICAvKiogUHJvcHMgdGhhdCB3aWxsIGJlIHBhc3NlZCBvbiB0byB0aGUgY2hpbGRyZW4uICovXG4gIGlubmVyUHJvcHM6IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snZGl2J107XG4gIC8qKiBUaGUgZm9jdXNlZCBzdGF0ZSBvZiB0aGUgc2VsZWN0LiAqL1xuICBpc0ZvY3VzZWQ6IGJvb2xlYW47XG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW47XG59XG5cbmNvbnN0IGJhc2VDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0ZvY3VzZWQsXG4gICAgdGhlbWU6IHtcbiAgICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICAgIGNvbG9ycyxcbiAgICB9LFxuICB9OlxuICAgIHwgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuICAgIHwgQ2xlYXJJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPixcbiAgdW5zdHlsZWQ6IGJvb2xlYW5cbik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvckNvbnRhaW5lcicsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcbiAgLi4uKHVuc3R5bGVkXG4gICAgPyB7fVxuICAgIDoge1xuICAgICAgICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gICAgICAgIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgICAgICAgJzpob3Zlcic6IHtcbiAgICAgICAgICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw4MCA6IGNvbG9ycy5uZXV0cmFsNDAsXG4gICAgICAgIH0sXG4gICAgICB9KSxcbn0pO1xuXG5leHBvcnQgY29uc3QgZHJvcGRvd25JbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IERyb3Bkb3duSW5kaWNhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKHByb3BzLCAnZHJvcGRvd25JbmRpY2F0b3InLCB7XG4gICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgJ2Ryb3Bkb3duLWluZGljYXRvcic6IHRydWUsXG4gICAgICB9KX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8RG93bkNoZXZyb24gLz59XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgaW50ZXJmYWNlIENsZWFySW5kaWNhdG9yUHJvcHM8XG4gIE9wdGlvbiA9IHVua25vd24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuID0gYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPiA9IEdyb3VwQmFzZTxPcHRpb24+XG4+IGV4dGVuZHMgQ29tbW9uUHJvcHNBbmRDbGFzc05hbWU8T3B0aW9uLCBJc011bHRpLCBHcm91cD4ge1xuICAvKiogVGhlIGNoaWxkcmVuIHRvIGJlIHJlbmRlcmVkIGluc2lkZSB0aGUgaW5kaWNhdG9yLiAqL1xuICBjaGlsZHJlbj86IFJlYWN0Tm9kZTtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgY2xlYXJJbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IENsZWFySW5kaWNhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogQ2xlYXJJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKHByb3BzLCAnY2xlYXJJbmRpY2F0b3InLCB7XG4gICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgJ2NsZWFyLWluZGljYXRvcic6IHRydWUsXG4gICAgICB9KX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5leHBvcnQgaW50ZXJmYWNlIEluZGljYXRvclNlcGFyYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhbjtcbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpbm5lclByb3BzPzogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ107XG59XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0Rpc2FibGVkLFxuICAgIHRoZW1lOiB7XG4gICAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gICAgICBjb2xvcnMsXG4gICAgfSxcbiAgfTogSW5kaWNhdG9yU2VwYXJhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4sXG4gIHVuc3R5bGVkOiBib29sZWFuXG4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdpbmRpY2F0b3JTZXBhcmF0b3InLFxuICBhbGlnblNlbGY6ICdzdHJldGNoJyxcbiAgd2lkdGg6IDEsXG4gIC4uLih1bnN0eWxlZFxuICAgID8ge31cbiAgICA6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0Rpc2FibGVkID8gY29sb3JzLm5ldXRyYWwxMCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gICAgICAgIG1hcmdpbkJvdHRvbTogYmFzZVVuaXQgKiAyLFxuICAgICAgICBtYXJnaW5Ub3A6IGJhc2VVbml0ICogMixcbiAgICAgIH0pLFxufSk7XG5cbmV4cG9ydCBjb25zdCBJbmRpY2F0b3JTZXBhcmF0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBJbmRpY2F0b3JTZXBhcmF0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgey4uLmdldFN0eWxlUHJvcHMocHJvcHMsICdpbmRpY2F0b3JTZXBhcmF0b3InLCB7XG4gICAgICAgICdpbmRpY2F0b3Itc2VwYXJhdG9yJzogdHJ1ZSxcbiAgICAgIH0pfVxuICAgIC8+XG4gICk7XG59O1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIExvYWRpbmdcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBsb2FkaW5nRG90QW5pbWF0aW9ucyA9IGtleWZyYW1lc2BcbiAgMCUsIDgwJSwgMTAwJSB7IG9wYWNpdHk6IDA7IH1cbiAgNDAlIHsgb3BhY2l0eTogMTsgfVxuYDtcblxuZXhwb3J0IGNvbnN0IGxvYWRpbmdJbmRpY2F0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0ZvY3VzZWQsXG4gICAgc2l6ZSxcbiAgICB0aGVtZToge1xuICAgICAgY29sb3JzLFxuICAgICAgc3BhY2luZzogeyBiYXNlVW5pdCB9LFxuICAgIH0sXG4gIH06IExvYWRpbmdJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPixcbiAgdW5zdHlsZWQ6IGJvb2xlYW5cbik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2xvYWRpbmdJbmRpY2F0b3InLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHRyYW5zaXRpb246ICdjb2xvciAxNTBtcycsXG4gIGFsaWduU2VsZjogJ2NlbnRlcicsXG4gIGZvbnRTaXplOiBzaXplLFxuICBsaW5lSGVpZ2h0OiAxLFxuICBtYXJnaW5SaWdodDogc2l6ZSxcbiAgdGV4dEFsaWduOiAnY2VudGVyJyxcbiAgdmVydGljYWxBbGlnbjogJ21pZGRsZScsXG4gIC4uLih1bnN0eWxlZFxuICAgID8ge31cbiAgICA6IHtcbiAgICAgICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICAgICAgICBwYWRkaW5nOiBiYXNlVW5pdCAqIDIsXG4gICAgICB9KSxcbn0pO1xuXG5pbnRlcmZhY2UgTG9hZGluZ0RvdFByb3BzIHtcbiAgZGVsYXk6IG51bWJlcjtcbiAgb2Zmc2V0OiBib29sZWFuO1xufVxuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogTG9hZGluZ0RvdFByb3BzKSA9PiAoXG4gIDxzcGFuXG4gICAgY3NzPXt7XG4gICAgICBhbmltYXRpb246IGAke2xvYWRpbmdEb3RBbmltYXRpb25zfSAxcyBlYXNlLWluLW91dCAke2RlbGF5fW1zIGluZmluaXRlO2AsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICdjdXJyZW50Q29sb3InLFxuICAgICAgYm9yZGVyUmFkaXVzOiAnMWVtJyxcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgbWFyZ2luTGVmdDogb2Zmc2V0ID8gJzFlbScgOiB1bmRlZmluZWQsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTG9hZGluZ0luZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc0Rpc2FibGVkOiBib29sZWFuO1xuICAvKiogU2V0IHNpemUgb2YgdGhlIGNvbnRhaW5lci4gKi9cbiAgc2l6ZTogbnVtYmVyO1xufVxuZXhwb3J0IGNvbnN0IExvYWRpbmdJbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpbm5lclByb3BzLFxuICBpc1J0bCxcbiAgc2l6ZSA9IDQsXG4gIC4uLnJlc3RQcm9wc1xufTogTG9hZGluZ0luZGljYXRvclByb3BzPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgey4uLmdldFN0eWxlUHJvcHMoXG4gICAgICAgIHsgLi4ucmVzdFByb3BzLCBpbm5lclByb3BzLCBpc1J0bCwgc2l6ZSB9LFxuICAgICAgICAnbG9hZGluZ0luZGljYXRvcicsXG4gICAgICAgIHtcbiAgICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICAgJ2xvYWRpbmctaW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXswfSBvZmZzZXQ9e2lzUnRsfSAvPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezE2MH0gb2Zmc2V0IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MzIwfSBvZmZzZXQ9eyFpc1J0bH0gLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG4iXX0= */",
  toString: A$
}, i9 = function(t) {
  var n = t.size, c = vr(t, I$);
  return Se("svg", ce({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: S$
  }, c));
}, K4 = function(t) {
  return Se(i9, ce({
    size: 20
  }, t), Se("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, a9 = function(t) {
  return Se(i9, ce({
    size: 20
  }, t), Se("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, s9 = function(t, n) {
  var c = t.isFocused, o = t.theme, a = o.spacing.baseUnit, s = o.colors;
  return _e({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: c ? s.neutral60 : s.neutral20,
    padding: a * 2,
    ":hover": {
      color: c ? s.neutral80 : s.neutral40
    }
  });
}, _$ = s9, E$ = function(t) {
  var n = t.children, c = t.innerProps;
  return Se("div", ce({}, ht(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), c), n || Se(a9, null));
}, M$ = s9, L$ = function(t) {
  var n = t.children, c = t.innerProps;
  return Se("div", ce({}, ht(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), c), n || Se(K4, null));
}, R$ = function(t, n) {
  var c = t.isDisabled, o = t.theme, a = o.spacing.baseUnit, s = o.colors;
  return _e({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: c ? s.neutral10 : s.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, P$ = function(t) {
  var n = t.innerProps;
  return Se("span", ce({}, n, ht(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, T$ = GD(vf || (vf = kD([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), z$ = function(t, n) {
  var c = t.isFocused, o = t.size, a = t.theme, s = a.colors, u = a.spacing.baseUnit;
  return _e({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: c ? s.neutral60 : s.neutral20,
    padding: u * 2
  });
}, Gs = function(t) {
  var n = t.delay, c = t.offset;
  return Se("span", {
    css: /* @__PURE__ */ J4({
      animation: "".concat(T$, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: c ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, N$ = function(t) {
  var n = t.innerProps, c = t.isRtl, o = t.size, a = o === void 0 ? 4 : o, s = vr(t, w$);
  return Se("div", ce({}, ht(_e(_e({}, s), {}, {
    innerProps: n,
    isRtl: c,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), Se(Gs, {
    delay: 0,
    offset: c
  }), Se(Gs, {
    delay: 160,
    offset: !0
  }), Se(Gs, {
    delay: 320,
    offset: !c
  }));
}, O$ = function(t, n) {
  var c = t.isDisabled, o = t.isFocused, a = t.theme, s = a.colors, u = a.borderRadius, f = a.spacing;
  return _e({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: f.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: c ? s.neutral5 : s.neutral0,
    borderColor: c ? s.neutral10 : o ? s.primary : s.neutral20,
    borderRadius: u,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(s.primary) : void 0,
    "&:hover": {
      borderColor: o ? s.primary : s.neutral30
    }
  });
}, F$ = function(t) {
  var n = t.children, c = t.isDisabled, o = t.isFocused, a = t.innerRef, s = t.innerProps, u = t.menuIsOpen;
  return Se("div", ce({
    ref: a
  }, ht(t, "control", {
    control: !0,
    "control--is-disabled": c,
    "control--is-focused": o,
    "control--menu-is-open": u
  }), s, {
    "aria-disabled": c || void 0
  }), n);
}, D$ = F$, $$ = ["data"], G$ = function(t, n) {
  var c = t.theme.spacing;
  return n ? {} : {
    paddingBottom: c.baseUnit * 2,
    paddingTop: c.baseUnit * 2
  };
}, k$ = function(t) {
  var n = t.children, c = t.cx, o = t.getStyles, a = t.getClassNames, s = t.Heading, u = t.headingProps, f = t.innerProps, d = t.label, p = t.theme, m = t.selectProps;
  return Se("div", ce({}, ht(t, "group", {
    group: !0
  }), f), Se(s, ce({}, u, {
    selectProps: m,
    theme: p,
    getStyles: o,
    getClassNames: a,
    cx: c
  }), d), Se("div", null, n));
}, B$ = function(t, n) {
  var c = t.theme, o = c.colors, a = c.spacing;
  return _e({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, V$ = function(t) {
  var n = e9(t);
  n.data;
  var c = vr(n, $$);
  return Se("div", ce({}, ht(t, "groupHeading", {
    "group-heading": !0
  }), c));
}, W$ = k$, H$ = ["innerRef", "isDisabled", "isHidden", "inputClassName"], j$ = function(t, n) {
  var c = t.isDisabled, o = t.value, a = t.theme, s = a.spacing, u = a.colors;
  return _e(_e({
    visibility: c ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, X$), n ? {} : {
    margin: s.baseUnit / 2,
    paddingBottom: s.baseUnit / 2,
    paddingTop: s.baseUnit / 2,
    color: u.neutral80
  });
}, l9 = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, X$ = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _e({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, l9)
}, Z$ = function(t) {
  return _e({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, l9);
}, Y$ = function(t) {
  var n = t.cx, c = t.value, o = e9(t), a = o.innerRef, s = o.isDisabled, u = o.isHidden, f = o.inputClassName, d = vr(o, H$);
  return Se("div", ce({}, ht(t, "input", {
    "input-container": !0
  }), {
    "data-value": c || ""
  }), Se("input", ce({
    className: n({
      input: !0
    }, f),
    ref: a,
    style: Z$(u),
    disabled: s
  }, d)));
}, U$ = Y$, J$ = function(t, n) {
  var c = t.theme, o = c.spacing, a = c.borderRadius, s = c.colors;
  return _e({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: s.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, K$ = function(t, n) {
  var c = t.theme, o = c.borderRadius, a = c.colors, s = t.cropWithEllipsis;
  return _e({
    overflow: "hidden",
    textOverflow: s || s === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, q$ = function(t, n) {
  var c = t.theme, o = c.spacing, a = c.borderRadius, s = c.colors, u = t.isFocused;
  return _e({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: u ? s.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: s.dangerLight,
      color: s.danger
    }
  });
}, u9 = function(t) {
  var n = t.children, c = t.innerProps;
  return Se("div", c, n);
}, Q$ = u9, eG = u9;
function tG(e) {
  var t = e.children, n = e.innerProps;
  return Se("div", ce({
    role: "button"
  }, n), t || Se(K4, {
    size: 14
  }));
}
var nG = function(t) {
  var n = t.children, c = t.components, o = t.data, a = t.innerProps, s = t.isDisabled, u = t.removeProps, f = t.selectProps, d = c.Container, p = c.Label, m = c.Remove;
  return Se(d, {
    data: o,
    innerProps: _e(_e({}, ht(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": s
    })), a),
    selectProps: f
  }, Se(p, {
    data: o,
    innerProps: _e({}, ht(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: f
  }, n), Se(m, {
    data: o,
    innerProps: _e(_e({}, ht(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, u),
    selectProps: f
  }));
}, rG = nG, cG = function(t, n) {
  var c = t.isDisabled, o = t.isFocused, a = t.isSelected, s = t.theme, u = s.spacing, f = s.colors;
  return _e({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? f.primary : o ? f.primary25 : "transparent",
    color: c ? f.neutral20 : a ? f.neutral0 : "inherit",
    padding: "".concat(u.baseUnit * 2, "px ").concat(u.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: c ? void 0 : a ? f.primary : f.primary50
    }
  });
}, oG = function(t) {
  var n = t.children, c = t.isDisabled, o = t.isFocused, a = t.isSelected, s = t.innerRef, u = t.innerProps;
  return Se("div", ce({}, ht(t, "option", {
    option: !0,
    "option--is-disabled": c,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: s,
    "aria-disabled": c
  }, u), n);
}, iG = oG, aG = function(t, n) {
  var c = t.theme, o = c.spacing, a = c.colors;
  return _e({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, sG = function(t) {
  var n = t.children, c = t.innerProps;
  return Se("div", ce({}, ht(t, "placeholder", {
    placeholder: !0
  }), c), n);
}, lG = sG, uG = function(t, n) {
  var c = t.isDisabled, o = t.theme, a = o.spacing, s = o.colors;
  return _e({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: c ? s.neutral40 : s.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, fG = function(t) {
  var n = t.children, c = t.isDisabled, o = t.innerProps;
  return Se("div", ce({}, ht(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": c
  }), o), n);
}, dG = fG, ra = {
  ClearIndicator: L$,
  Control: D$,
  DropdownIndicator: E$,
  DownChevron: a9,
  CrossIcon: K4,
  Group: W$,
  GroupHeading: V$,
  IndicatorsContainer: y$,
  IndicatorSeparator: P$,
  Input: U$,
  LoadingIndicator: N$,
  Menu: a$,
  MenuList: l$,
  MenuPortal: m$,
  LoadingMessage: p$,
  NoOptionsMessage: d$,
  MultiValue: rG,
  MultiValueContainer: Q$,
  MultiValueLabel: eG,
  MultiValueRemove: tG,
  Option: iG,
  Placeholder: lG,
  SelectContainer: v$,
  SingleValue: dG,
  ValueContainer: C$
}, pG = function(t) {
  return _e(_e({}, ra), t.components);
}, bf = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function gG(e, t) {
  return !!(e === t || bf(e) && bf(t));
}
function mG(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!gG(e[n], t[n]))
      return !1;
  return !0;
}
function hG(e, t) {
  t === void 0 && (t = mG);
  var n = null;
  function c() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, o);
    return n = {
      lastResult: s,
      lastArgs: o,
      lastThis: this
    }, s;
  }
  return c.clear = function() {
    n = null;
  }, c;
}
function vG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var bG = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: vG
}, CG = function(t) {
  return Se("span", ce({
    css: bG
  }, t));
}, Cf = CG, xG = {
  guidance: function(t) {
    var n = t.isSearchable, c = t.isMulti, o = t.tabSelectsValue, a = t.context, s = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return s ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(c ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, c = t.label, o = c === void 0 ? "" : c, a = t.labels, s = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return s ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, c = t.focused, o = t.options, a = t.label, s = a === void 0 ? "" : a, u = t.selectValue, f = t.isDisabled, d = t.isSelected, p = t.isAppleDevice, m = function(h, v) {
      return h && h.length ? "".concat(h.indexOf(v) + 1, " of ").concat(h.length) : "";
    };
    if (n === "value" && u)
      return "value ".concat(s, " focused, ").concat(m(u, c), ".");
    if (n === "menu" && p) {
      var b = f ? " disabled" : "", y = "".concat(d ? " selected" : "").concat(b);
      return "".concat(s).concat(y, ", ").concat(m(o, c), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, c = t.resultsMessage;
    return "".concat(c).concat(n ? " for search term " + n : "", ".");
  }
}, yG = function(t) {
  var n = t.ariaSelection, c = t.focusedOption, o = t.focusedValue, a = t.focusableOptions, s = t.isFocused, u = t.selectValue, f = t.selectProps, d = t.id, p = t.isAppleDevice, m = f.ariaLiveMessages, b = f.getOptionLabel, y = f.inputValue, C = f.isMulti, h = f.isOptionDisabled, v = f.isSearchable, I = f.menuIsOpen, S = f.options, L = f.screenReaderStatus, R = f.tabSelectsValue, M = f.isLoading, $ = f["aria-label"], O = f["aria-live"], G = Wt(function() {
    return _e(_e({}, xG), m || {});
  }, [m]), J = Wt(function() {
    var ue = "";
    if (n && G.onChange) {
      var te = n.option, se = n.options, ee = n.removedValue, q = n.removedValues, B = n.value, X = function(ne) {
        return Array.isArray(ne) ? null : ne;
      }, ie = ee || te || X(B), he = ie ? b(ie) : "", le = se || q || void 0, ve = le ? le.map(b) : [], de = _e({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ie && h(ie, u),
        label: he,
        labels: ve
      }, n);
      ue = G.onChange(de);
    }
    return ue;
  }, [n, G, h, u, b]), ae = Wt(function() {
    var ue = "", te = c || o, se = !!(c && u && u.includes(c));
    if (te && G.onFocus) {
      var ee = {
        focused: te,
        label: b(te),
        isDisabled: h(te, u),
        isSelected: se,
        options: a,
        context: te === c ? "menu" : "value",
        selectValue: u,
        isAppleDevice: p
      };
      ue = G.onFocus(ee);
    }
    return ue;
  }, [c, o, b, h, G, a, u, p]), fe = Wt(function() {
    var ue = "";
    if (I && S.length && !M && G.onFilter) {
      var te = L({
        count: a.length
      });
      ue = G.onFilter({
        inputValue: y,
        resultsMessage: te
      });
    }
    return ue;
  }, [a, y, I, G, S, L, M]), U = (n == null ? void 0 : n.action) === "initial-input-focus", re = Wt(function() {
    var ue = "";
    if (G.guidance) {
      var te = o ? "value" : I ? "menu" : "input";
      ue = G.guidance({
        "aria-label": $,
        context: te,
        isDisabled: c && h(c, u),
        isMulti: C,
        isSearchable: v,
        tabSelectsValue: R,
        isInitialFocus: U
      });
    }
    return ue;
  }, [$, c, o, C, h, v, I, G, u, R, U]), oe = Se(a1, null, Se("span", {
    id: "aria-selection"
  }, J), Se("span", {
    id: "aria-focused"
  }, ae), Se("span", {
    id: "aria-results"
  }, fe), Se("span", {
    id: "aria-guidance"
  }, re));
  return Se(a1, null, Se(Cf, {
    id: d
  }, U && oe), Se(Cf, {
    "aria-live": O,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, s && !U && oe));
}, IG = yG, Dl = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], wG = new RegExp("[" + Dl.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), f9 = {};
for (var ks = 0; ks < Dl.length; ks++)
  for (var Bs = Dl[ks], Vs = 0; Vs < Bs.letters.length; Vs++)
    f9[Bs.letters[Vs]] = Bs.base;
var d9 = function(t) {
  return t.replace(wG, function(n) {
    return f9[n];
  });
}, AG = hG(d9), xf = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, SG = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, _G = function(t) {
  return function(n, c) {
    if (n.data.__isNew__) return !0;
    var o = _e({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: SG,
      trim: !0,
      matchFrom: "any"
    }, t), a = o.ignoreCase, s = o.ignoreAccents, u = o.stringify, f = o.trim, d = o.matchFrom, p = f ? xf(c) : c, m = f ? xf(u(n)) : u(n);
    return a && (p = p.toLowerCase(), m = m.toLowerCase()), s && (p = AG(p), m = d9(m)), d === "start" ? m.substr(0, p.length) === p : m.indexOf(p) > -1;
  };
}, EG = ["innerRef"];
function MG(e) {
  var t = e.innerRef, n = vr(e, EG), c = QD(n, "onExited", "in", "enter", "exit", "appear");
  return Se("input", ce({
    ref: t
  }, c, {
    css: /* @__PURE__ */ J4({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var LG = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function RG(e) {
  var t = e.isEnabled, n = e.onBottomArrive, c = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, s = je(!1), u = je(!1), f = je(0), d = je(null), p = qe(function(v, I) {
    if (d.current !== null) {
      var S = d.current, L = S.scrollTop, R = S.scrollHeight, M = S.clientHeight, $ = d.current, O = I > 0, G = R - M - L, J = !1;
      G > I && s.current && (c && c(v), s.current = !1), O && u.current && (a && a(v), u.current = !1), O && I > G ? (n && !s.current && n(v), $.scrollTop = R, J = !0, s.current = !0) : !O && -I > L && (o && !u.current && o(v), $.scrollTop = 0, J = !0, u.current = !0), J && LG(v);
    }
  }, [n, c, o, a]), m = qe(function(v) {
    p(v, v.deltaY);
  }, [p]), b = qe(function(v) {
    f.current = v.changedTouches[0].clientY;
  }, []), y = qe(function(v) {
    var I = f.current - v.changedTouches[0].clientY;
    p(v, I);
  }, [p]), C = qe(function(v) {
    if (v) {
      var I = JD ? {
        passive: !1
      } : !1;
      v.addEventListener("wheel", m, I), v.addEventListener("touchstart", b, I), v.addEventListener("touchmove", y, I);
    }
  }, [y, b, m]), h = qe(function(v) {
    v && (v.removeEventListener("wheel", m, !1), v.removeEventListener("touchstart", b, !1), v.removeEventListener("touchmove", y, !1));
  }, [y, b, m]);
  return ct(function() {
    if (t) {
      var v = d.current;
      return C(v), function() {
        h(v);
      };
    }
  }, [t, C, h]), function(v) {
    d.current = v;
  };
}
var yf = ["boxSizing", "height", "overflow", "paddingRight", "position"], If = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function wf(e) {
  e.cancelable && e.preventDefault();
}
function Af(e) {
  e.stopPropagation();
}
function Sf() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function _f() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Ef = !!(typeof window < "u" && window.document && window.document.createElement), Wc = 0, W1 = {
  capture: !1,
  passive: !1
};
function PG(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, c = n === void 0 ? !0 : n, o = je({}), a = je(null), s = qe(function(f) {
    if (Ef) {
      var d = document.body, p = d && d.style;
      if (c && yf.forEach(function(C) {
        var h = p && p[C];
        o.current[C] = h;
      }), c && Wc < 1) {
        var m = parseInt(o.current.paddingRight, 10) || 0, b = document.body ? document.body.clientWidth : 0, y = window.innerWidth - b + m || 0;
        Object.keys(If).forEach(function(C) {
          var h = If[C];
          p && (p[C] = h);
        }), p && (p.paddingRight = "".concat(y, "px"));
      }
      d && _f() && (d.addEventListener("touchmove", wf, W1), f && (f.addEventListener("touchstart", Sf, W1), f.addEventListener("touchmove", Af, W1))), Wc += 1;
    }
  }, [c]), u = qe(function(f) {
    if (Ef) {
      var d = document.body, p = d && d.style;
      Wc = Math.max(Wc - 1, 0), c && Wc < 1 && yf.forEach(function(m) {
        var b = o.current[m];
        p && (p[m] = b);
      }), d && _f() && (d.removeEventListener("touchmove", wf, W1), f && (f.removeEventListener("touchstart", Sf, W1), f.removeEventListener("touchmove", Af, W1)));
    }
  }, [c]);
  return ct(function() {
    if (t) {
      var f = a.current;
      return s(f), function() {
        u(f);
      };
    }
  }, [t, s, u]), function(f) {
    a.current = f;
  };
}
function TG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var zG = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, NG = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: TG
};
function OG(e) {
  var t = e.children, n = e.lockEnabled, c = e.captureEnabled, o = c === void 0 ? !0 : c, a = e.onBottomArrive, s = e.onBottomLeave, u = e.onTopArrive, f = e.onTopLeave, d = RG({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: s,
    onTopArrive: u,
    onTopLeave: f
  }), p = PG({
    isEnabled: n
  }), m = function(y) {
    d(y), p(y);
  };
  return Se(a1, null, n && Se("div", {
    onClick: zG,
    css: NG
  }), t(m));
}
function FG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var DG = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: FG
}, $G = function(t) {
  var n = t.name, c = t.onFocus;
  return Se("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: c,
    css: DG,
    value: "",
    onChange: function() {
    }
  });
}, GG = $G;
function q4(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function kG() {
  return q4(/^iPhone/i);
}
function p9() {
  return q4(/^Mac/i);
}
function BG() {
  return q4(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  p9() && navigator.maxTouchPoints > 1;
}
function VG() {
  return kG() || BG();
}
function WG() {
  return p9() || VG();
}
var HG = function(t) {
  return t.label;
}, jG = function(t) {
  return t.label;
}, XG = function(t) {
  return t.value;
}, ZG = function(t) {
  return !!t.isDisabled;
}, YG = {
  clearIndicator: M$,
  container: h$,
  control: O$,
  dropdownIndicator: _$,
  group: G$,
  groupHeading: B$,
  indicatorsContainer: x$,
  indicatorSeparator: R$,
  input: j$,
  loadingIndicator: z$,
  loadingMessage: f$,
  menu: c$,
  menuList: s$,
  menuPortal: g$,
  multiValue: J$,
  multiValueLabel: K$,
  multiValueRemove: q$,
  noOptionsMessage: u$,
  option: cG,
  placeholder: aG,
  singleValue: uG,
  valueContainer: b$
}, UG = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, JG = 4, g9 = 4, KG = 38, qG = g9 * 2, QG = {
  baseUnit: g9,
  controlHeight: KG,
  menuGutter: qG
}, Ws = {
  borderRadius: JG,
  colors: UG,
  spacing: QG
}, ek = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: hf(),
  captureMenuScroll: !hf(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: _G(),
  formatGroupLabel: HG,
  getOptionLabel: jG,
  getOptionValue: XG,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: ZG,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !YD(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Mf(e, t, n, c) {
  var o = v9(e, t, n), a = b9(e, t, n), s = h9(e, t), u = ca(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: a,
    label: s,
    value: u,
    index: c
  };
}
function $i(e, t) {
  return e.options.map(function(n, c) {
    if ("options" in n) {
      var o = n.options.map(function(s, u) {
        return Mf(e, s, t, u);
      }).filter(function(s) {
        return Rf(e, s);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: c
      } : void 0;
    }
    var a = Mf(e, n, t, c);
    return Rf(e, a) ? a : void 0;
  }).filter(KD);
}
function m9(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, j4(n.options.map(function(c) {
      return c.data;
    }))) : t.push(n.data), t;
  }, []);
}
function Lf(e, t) {
  return e.reduce(function(n, c) {
    return c.type === "group" ? n.push.apply(n, j4(c.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(c.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: c.data,
      id: "".concat(t, "-").concat(c.index)
    }), n;
  }, []);
}
function tk(e, t) {
  return m9($i(e, t));
}
function Rf(e, t) {
  var n = e.inputValue, c = n === void 0 ? "" : n, o = t.data, a = t.isSelected, s = t.label, u = t.value;
  return (!x9(e) || !a) && C9(e, {
    label: s,
    value: u,
    data: o
  }, c);
}
function nk(e, t) {
  var n = e.focusedValue, c = e.selectValue, o = c.indexOf(n);
  if (o > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function rk(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var Hs = function(t, n) {
  var c, o = (c = t.find(function(a) {
    return a.data === n;
  })) === null || c === void 0 ? void 0 : c.id;
  return o || null;
}, h9 = function(t, n) {
  return t.getOptionLabel(n);
}, ca = function(t, n) {
  return t.getOptionValue(n);
};
function v9(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function b9(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var c = ca(e, t);
  return n.some(function(o) {
    return ca(e, o) === c;
  });
}
function C9(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var x9 = function(t) {
  var n = t.hideSelectedOptions, c = t.isMulti;
  return n === void 0 ? c : n;
}, ck = 1, y9 = /* @__PURE__ */ function(e) {
  GF(n, e);
  var t = BF(n);
  function n(c) {
    var o;
    if (DF(this, n), o = t.call(this, c), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = WG(), o.controlRef = null, o.getControlRef = function(f) {
      o.controlRef = f;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(f) {
      o.focusedOptionRef = f;
    }, o.menuListRef = null, o.getMenuListRef = function(f) {
      o.menuListRef = f;
    }, o.inputRef = null, o.getInputRef = function(f) {
      o.inputRef = f;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(f, d) {
      var p = o.props, m = p.onChange, b = p.name;
      d.name = b, o.ariaOnChange(f, d), m(f, d);
    }, o.setValue = function(f, d, p) {
      var m = o.props, b = m.closeMenuOnSelect, y = m.isMulti, C = m.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: C
      }), b && (o.setState({
        inputIsHiddenAfterUpdate: !y
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(f, {
        action: d,
        option: p
      });
    }, o.selectOption = function(f) {
      var d = o.props, p = d.blurInputOnSelect, m = d.isMulti, b = d.name, y = o.state.selectValue, C = m && o.isOptionSelected(f, y), h = o.isOptionDisabled(f, y);
      if (C) {
        var v = o.getOptionValue(f);
        o.setValue(y.filter(function(I) {
          return o.getOptionValue(I) !== v;
        }), "deselect-option", f);
      } else if (!h)
        m ? o.setValue([].concat(j4(y), [f]), "select-option", f) : o.setValue(f, "select-option");
      else {
        o.ariaOnChange(f, {
          action: "select-option",
          option: f,
          name: b
        });
        return;
      }
      p && o.blurInput();
    }, o.removeValue = function(f) {
      var d = o.props.isMulti, p = o.state.selectValue, m = o.getOptionValue(f), b = p.filter(function(C) {
        return o.getOptionValue(C) !== m;
      }), y = Pi(d, b, b[0] || null);
      o.onChange(y, {
        action: "remove-value",
        removedValue: f
      }), o.focusInput();
    }, o.clearValue = function() {
      var f = o.state.selectValue;
      o.onChange(Pi(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: f
      });
    }, o.popValue = function() {
      var f = o.props.isMulti, d = o.state.selectValue, p = d[d.length - 1], m = d.slice(0, d.length - 1), b = Pi(f, m, m[0] || null);
      p && o.onChange(b, {
        action: "pop-value",
        removedValue: p
      });
    }, o.getFocusedOptionId = function(f) {
      return Hs(o.state.focusableOptionsWithIds, f);
    }, o.getFocusableOptionsWithIds = function() {
      return Lf($i(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var f = arguments.length, d = new Array(f), p = 0; p < f; p++)
        d[p] = arguments[p];
      return WD.apply(void 0, [o.props.classNamePrefix].concat(d));
    }, o.getOptionLabel = function(f) {
      return h9(o.props, f);
    }, o.getOptionValue = function(f) {
      return ca(o.props, f);
    }, o.getStyles = function(f, d) {
      var p = o.props.unstyled, m = YG[f](d, p);
      m.boxSizing = "border-box";
      var b = o.props.styles[f];
      return b ? b(m, d) : m;
    }, o.getClassNames = function(f, d) {
      var p, m;
      return (p = (m = o.props.classNames)[f]) === null || p === void 0 ? void 0 : p.call(m, d);
    }, o.getElementId = function(f) {
      return "".concat(o.state.instancePrefix, "-").concat(f);
    }, o.getComponents = function() {
      return pG(o.props);
    }, o.buildCategorizedOptions = function() {
      return $i(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return m9(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(f, d) {
      o.setState({
        ariaSelection: _e({
          value: f
        }, d)
      });
    }, o.onMenuMouseDown = function(f) {
      f.button === 0 && (f.stopPropagation(), f.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(f) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(f) {
      if (!f.defaultPrevented) {
        var d = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? f.target.tagName !== "INPUT" && f.target.tagName !== "TEXTAREA" && o.onMenuClose() : d && o.openMenu("first") : (d && (o.openAfterFocus = !0), o.focusInput()), f.target.tagName !== "INPUT" && f.target.tagName !== "TEXTAREA" && f.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(f) {
      if (!(f && f.type === "mousedown" && f.button !== 0) && !o.props.isDisabled) {
        var d = o.props, p = d.isMulti, m = d.menuIsOpen;
        o.focusInput(), m ? (o.setState({
          inputIsHiddenAfterUpdate: !p
        }), o.onMenuClose()) : o.openMenu("first"), f.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(f) {
      f && f.type === "mousedown" && f.button !== 0 || (o.clearValue(), f.preventDefault(), o.openAfterFocus = !1, f.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(f) {
      typeof o.props.closeMenuOnScroll == "boolean" ? f.target instanceof HTMLElement && Va(f.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(f) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(f) {
      var d = f.touches, p = d && d.item(0);
      p && (o.initialTouchX = p.clientX, o.initialTouchY = p.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(f) {
      var d = f.touches, p = d && d.item(0);
      if (p) {
        var m = Math.abs(p.clientX - o.initialTouchX), b = Math.abs(p.clientY - o.initialTouchY), y = 5;
        o.userIsDragging = m > y || b > y;
      }
    }, o.onTouchEnd = function(f) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(f.target) && o.menuListRef && !o.menuListRef.contains(f.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(f) {
      o.userIsDragging || o.onControlMouseDown(f);
    }, o.onClearIndicatorTouchEnd = function(f) {
      o.userIsDragging || o.onClearIndicatorMouseDown(f);
    }, o.onDropdownIndicatorTouchEnd = function(f) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(f);
    }, o.handleInputChange = function(f) {
      var d = o.props.inputValue, p = f.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(p, {
        action: "input-change",
        prevInputValue: d
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(f) {
      o.props.onFocus && o.props.onFocus(f), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(f) {
      var d = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(f), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: d
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(f) {
      if (!(o.blockOptionHover || o.state.focusedOption === f)) {
        var d = o.getFocusableOptions(), p = d.indexOf(f);
        o.setState({
          focusedOption: f,
          focusedOptionId: p > -1 ? o.getFocusedOptionId(f) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return x9(o.props);
    }, o.onValueInputFocus = function(f) {
      f.preventDefault(), f.stopPropagation(), o.focus();
    }, o.onKeyDown = function(f) {
      var d = o.props, p = d.isMulti, m = d.backspaceRemovesValue, b = d.escapeClearsValue, y = d.inputValue, C = d.isClearable, h = d.isDisabled, v = d.menuIsOpen, I = d.onKeyDown, S = d.tabSelectsValue, L = d.openMenuOnFocus, R = o.state, M = R.focusedOption, $ = R.focusedValue, O = R.selectValue;
      if (!h && !(typeof I == "function" && (I(f), f.defaultPrevented))) {
        switch (o.blockOptionHover = !0, f.key) {
          case "ArrowLeft":
            if (!p || y) return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!p || y) return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (y) return;
            if ($)
              o.removeValue($);
            else {
              if (!m) return;
              p ? o.popValue() : C && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || f.shiftKey || !v || !S || !M || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            L && o.isOptionSelected(M, O))
              return;
            o.selectOption(M);
            break;
          case "Enter":
            if (f.keyCode === 229)
              break;
            if (v) {
              if (!M || o.isComposing) return;
              o.selectOption(M);
              break;
            }
            return;
          case "Escape":
            v ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: y
            }), o.onMenuClose()) : C && b && o.clearValue();
            break;
          case " ":
            if (y)
              return;
            if (!v) {
              o.openMenu("first");
              break;
            }
            if (!M) return;
            o.selectOption(M);
            break;
          case "ArrowUp":
            v ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            v ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!v) return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!v) return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!v) return;
            o.focusOption("first");
            break;
          case "End":
            if (!v) return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        f.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++ck), o.state.selectValue = gf(c.value), c.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), s = o.buildFocusableOptions(), u = s.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = s[u], o.state.focusedOptionId = Hs(a, s[u]);
    }
    return o;
  }
  return $F(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && mf(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, s = a.isDisabled, u = a.menuIsOpen, f = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (f && !s && o.isDisabled || // ensure focus is on the Input when the menu opens
      f && u && !o.menuIsOpen) && this.focusInput(), f && s && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !f && !s && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (mf(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, s = this.state, u = s.selectValue, f = s.isFocused, d = this.buildFocusableOptions(), p = o === "first" ? 0 : d.length - 1;
      if (!this.props.isMulti) {
        var m = d.indexOf(u[0]);
        m > -1 && (p = m);
      }
      this.scrollToFocusedOptionOnUpdate = !(f && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: d[p],
        focusedOptionId: this.getFocusedOptionId(d[p])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, s = a.selectValue, u = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var f = s.indexOf(u);
        u || (f = -1);
        var d = s.length - 1, p = -1;
        if (s.length) {
          switch (o) {
            case "previous":
              f === 0 ? p = 0 : f === -1 ? p = d : p = f - 1;
              break;
            case "next":
              f > -1 && f < d && (p = f + 1);
              break;
          }
          this.setState({
            inputIsHidden: p !== -1,
            focusedValue: s[p]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, s = this.state.focusedOption, u = this.getFocusableOptions();
      if (u.length) {
        var f = 0, d = u.indexOf(s);
        s || (d = -1), o === "up" ? f = d > 0 ? d - 1 : u.length - 1 : o === "down" ? f = (d + 1) % u.length : o === "pageup" ? (f = d - a, f < 0 && (f = 0)) : o === "pagedown" ? (f = d + a, f > u.length - 1 && (f = u.length - 1)) : o === "last" && (f = u.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: u[f],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(u[f])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Ws) : _e(_e({}, Ws), this.props.theme) : Ws;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, s = this.getStyles, u = this.getClassNames, f = this.getValue, d = this.selectOption, p = this.setValue, m = this.props, b = m.isMulti, y = m.isRtl, C = m.options, h = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: s,
        getClassNames: u,
        getValue: f,
        hasValue: h,
        isMulti: b,
        isRtl: y,
        options: C,
        selectOption: d,
        selectProps: m,
        setValue: p,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, s = o.isMulti;
      return a === void 0 ? s : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return v9(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return b9(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return C9(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var s = this.props.inputValue, u = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: s,
          selectValue: u
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, s = o.isSearchable, u = o.inputId, f = o.inputValue, d = o.tabIndex, p = o.form, m = o.menuIsOpen, b = o.required, y = this.getComponents(), C = y.Input, h = this.state, v = h.inputIsHidden, I = h.ariaSelection, S = this.commonProps, L = u || this.getElementId("input"), R = _e(_e(_e({
          "aria-autocomplete": "list",
          "aria-expanded": m,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": b,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, m && {
          "aria-controls": this.getElementId("listbox")
        }), !s && {
          "aria-readonly": !0
        }), this.hasValue() ? (I == null ? void 0 : I.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return s ? /* @__PURE__ */ A.createElement(C, ce({}, S, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: L,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: v,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: d,
          form: p,
          type: "text",
          value: f
        }, R)) : /* @__PURE__ */ A.createElement(MG, ce({
          id: L,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: ta,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: d,
          inputMode: "none",
          form: p,
          value: ""
        }, R));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), s = a.MultiValue, u = a.MultiValueContainer, f = a.MultiValueLabel, d = a.MultiValueRemove, p = a.SingleValue, m = a.Placeholder, b = this.commonProps, y = this.props, C = y.controlShouldRenderValue, h = y.isDisabled, v = y.isMulti, I = y.inputValue, S = y.placeholder, L = this.state, R = L.selectValue, M = L.focusedValue, $ = L.isFocused;
      if (!this.hasValue() || !C)
        return I ? null : /* @__PURE__ */ A.createElement(m, ce({}, b, {
          key: "placeholder",
          isDisabled: h,
          isFocused: $,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), S);
      if (v)
        return R.map(function(G, J) {
          var ae = G === M, fe = "".concat(o.getOptionLabel(G), "-").concat(o.getOptionValue(G));
          return /* @__PURE__ */ A.createElement(s, ce({}, b, {
            components: {
              Container: u,
              Label: f,
              Remove: d
            },
            isFocused: ae,
            isDisabled: h,
            key: fe,
            index: J,
            removeProps: {
              onClick: function() {
                return o.removeValue(G);
              },
              onTouchEnd: function() {
                return o.removeValue(G);
              },
              onMouseDown: function(re) {
                re.preventDefault();
              }
            },
            data: G
          }), o.formatOptionLabel(G, "value"));
        });
      if (I)
        return null;
      var O = R[0];
      return /* @__PURE__ */ A.createElement(p, ce({}, b, {
        data: O,
        isDisabled: h
      }), this.formatOptionLabel(O, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, s = this.commonProps, u = this.props, f = u.isDisabled, d = u.isLoading, p = this.state.isFocused;
      if (!this.isClearable() || !a || f || !this.hasValue() || d)
        return null;
      var m = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, ce({}, s, {
        innerProps: m,
        isFocused: p
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, s = this.commonProps, u = this.props, f = u.isDisabled, d = u.isLoading, p = this.state.isFocused;
      if (!a || !d) return null;
      var m = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, ce({}, s, {
        innerProps: m,
        isDisabled: f,
        isFocused: p
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, s = o.IndicatorSeparator;
      if (!a || !s) return null;
      var u = this.commonProps, f = this.props.isDisabled, d = this.state.isFocused;
      return /* @__PURE__ */ A.createElement(s, ce({}, u, {
        isDisabled: f,
        isFocused: d
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a) return null;
      var s = this.commonProps, u = this.props.isDisabled, f = this.state.isFocused, d = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, ce({}, s, {
        innerProps: d,
        isDisabled: u,
        isFocused: f
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), s = a.Group, u = a.GroupHeading, f = a.Menu, d = a.MenuList, p = a.MenuPortal, m = a.LoadingMessage, b = a.NoOptionsMessage, y = a.Option, C = this.commonProps, h = this.state.focusedOption, v = this.props, I = v.captureMenuScroll, S = v.inputValue, L = v.isLoading, R = v.loadingMessage, M = v.minMenuHeight, $ = v.maxMenuHeight, O = v.menuIsOpen, G = v.menuPlacement, J = v.menuPosition, ae = v.menuPortalTarget, fe = v.menuShouldBlockScroll, U = v.menuShouldScrollIntoView, re = v.noOptionsMessage, oe = v.onMenuScrollToTop, ue = v.onMenuScrollToBottom;
      if (!O) return null;
      var te = function(he, le) {
        var ve = he.type, de = he.data, Z = he.isDisabled, ne = he.isSelected, ge = he.label, me = he.value, we = h === de, j = Z ? void 0 : function() {
          return o.onOptionHover(de);
        }, Be = Z ? void 0 : function() {
          return o.selectOption(de);
        }, Fe = "".concat(o.getElementId("option"), "-").concat(le), ut = {
          id: Fe,
          onClick: Be,
          onMouseMove: j,
          onMouseOver: j,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : ne
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ A.createElement(y, ce({}, C, {
          innerProps: ut,
          data: de,
          isDisabled: Z,
          isSelected: ne,
          key: Fe,
          label: ge,
          type: ve,
          value: me,
          isFocused: we,
          innerRef: we ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(he.data, "menu"));
      }, se;
      if (this.hasOptions())
        se = this.getCategorizedOptions().map(function(ie) {
          if (ie.type === "group") {
            var he = ie.data, le = ie.options, ve = ie.index, de = "".concat(o.getElementId("group"), "-").concat(ve), Z = "".concat(de, "-heading");
            return /* @__PURE__ */ A.createElement(s, ce({}, C, {
              key: de,
              data: he,
              options: le,
              Heading: u,
              headingProps: {
                id: Z,
                data: ie.data
              },
              label: o.formatGroupLabel(ie.data)
            }), ie.options.map(function(ne) {
              return te(ne, "".concat(ve, "-").concat(ne.index));
            }));
          } else if (ie.type === "option")
            return te(ie, "".concat(ie.index));
        });
      else if (L) {
        var ee = R({
          inputValue: S
        });
        if (ee === null) return null;
        se = /* @__PURE__ */ A.createElement(m, C, ee);
      } else {
        var q = re({
          inputValue: S
        });
        if (q === null) return null;
        se = /* @__PURE__ */ A.createElement(b, C, q);
      }
      var B = {
        minMenuHeight: M,
        maxMenuHeight: $,
        menuPlacement: G,
        menuPosition: J,
        menuShouldScrollIntoView: U
      }, X = /* @__PURE__ */ A.createElement(o$, ce({}, C, B), function(ie) {
        var he = ie.ref, le = ie.placerProps, ve = le.placement, de = le.maxHeight;
        return /* @__PURE__ */ A.createElement(f, ce({}, C, B, {
          innerRef: he,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: L,
          placement: ve
        }), /* @__PURE__ */ A.createElement(OG, {
          captureEnabled: I,
          onTopArrive: oe,
          onBottomArrive: ue,
          lockEnabled: fe
        }, function(Z) {
          return /* @__PURE__ */ A.createElement(d, ce({}, C, {
            innerRef: function(ge) {
              o.getMenuListRef(ge), Z(ge);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": C.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: L,
            maxHeight: de,
            focusedOption: h
          }), se);
        }));
      });
      return ae || J === "fixed" ? /* @__PURE__ */ A.createElement(p, ce({}, C, {
        appendTo: ae,
        controlElement: this.controlRef,
        menuPlacement: G,
        menuPosition: J
      }), X) : X;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, s = a.delimiter, u = a.isDisabled, f = a.isMulti, d = a.name, p = a.required, m = this.state.selectValue;
      if (p && !this.hasValue() && !u)
        return /* @__PURE__ */ A.createElement(GG, {
          name: d,
          onFocus: this.onValueInputFocus
        });
      if (!(!d || u))
        if (f)
          if (s) {
            var b = m.map(function(h) {
              return o.getOptionValue(h);
            }).join(s);
            return /* @__PURE__ */ A.createElement("input", {
              name: d,
              type: "hidden",
              value: b
            });
          } else {
            var y = m.length > 0 ? m.map(function(h, v) {
              return /* @__PURE__ */ A.createElement("input", {
                key: "i-".concat(v),
                name: d,
                type: "hidden",
                value: o.getOptionValue(h)
              });
            }) : /* @__PURE__ */ A.createElement("input", {
              name: d,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ A.createElement("div", null, y);
          }
        else {
          var C = m[0] ? this.getOptionValue(m[0]) : "";
          return /* @__PURE__ */ A.createElement("input", {
            name: d,
            type: "hidden",
            value: C
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, s = a.ariaSelection, u = a.focusedOption, f = a.focusedValue, d = a.isFocused, p = a.selectValue, m = this.getFocusableOptions();
      return /* @__PURE__ */ A.createElement(IG, ce({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: s,
        focusedOption: u,
        focusedValue: f,
        isFocused: d,
        selectValue: p,
        focusableOptions: m,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, s = o.IndicatorsContainer, u = o.SelectContainer, f = o.ValueContainer, d = this.props, p = d.className, m = d.id, b = d.isDisabled, y = d.menuIsOpen, C = this.state.isFocused, h = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ A.createElement(u, ce({}, h, {
        className: p,
        innerProps: {
          id: m,
          onKeyDown: this.onKeyDown
        },
        isDisabled: b,
        isFocused: C
      }), this.renderLiveRegion(), /* @__PURE__ */ A.createElement(a, ce({}, h, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: b,
        isFocused: C,
        menuIsOpen: y
      }), /* @__PURE__ */ A.createElement(f, ce({}, h, {
        isDisabled: b
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ A.createElement(s, ce({}, h, {
        isDisabled: b
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var s = a.prevProps, u = a.clearFocusValueOnUpdate, f = a.inputIsHiddenAfterUpdate, d = a.ariaSelection, p = a.isFocused, m = a.prevWasFocused, b = a.instancePrefix, y = o.options, C = o.value, h = o.menuIsOpen, v = o.inputValue, I = o.isMulti, S = gf(C), L = {};
      if (s && (C !== s.value || y !== s.options || h !== s.menuIsOpen || v !== s.inputValue)) {
        var R = h ? tk(o, S) : [], M = h ? Lf($i(o, S), "".concat(b, "-option")) : [], $ = u ? nk(a, S) : null, O = rk(a, R), G = Hs(M, O);
        L = {
          selectValue: S,
          focusedOption: O,
          focusedOptionId: G,
          focusableOptionsWithIds: M,
          focusedValue: $,
          clearFocusValueOnUpdate: !1
        };
      }
      var J = f != null && o !== s ? {
        inputIsHidden: f,
        inputIsHiddenAfterUpdate: void 0
      } : {}, ae = d, fe = p && m;
      return p && !fe && (ae = {
        value: Pi(I, S, S[0] || null),
        options: S,
        action: "initial-input-focus"
      }, fe = !m), (d == null ? void 0 : d.action) === "initial-input-focus" && (ae = null), _e(_e(_e({}, L), J), {}, {
        prevProps: o,
        ariaSelection: ae,
        prevWasFocused: fe
      });
    }
  }]), n;
}(YC);
y9.defaultProps = ek;
var ok = /* @__PURE__ */ Ze(function(e, t) {
  var n = FF(e);
  return /* @__PURE__ */ A.createElement(y9, ce({
    ref: t
  }, n));
}), ik = ok, Yc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var ak = Yc.exports, Pf;
function sk() {
  return Pf || (Pf = 1, function(e, t) {
    (function() {
      var n, c = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", u = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", d = 500, p = "__lodash_placeholder__", m = 1, b = 2, y = 4, C = 1, h = 2, v = 1, I = 2, S = 4, L = 8, R = 16, M = 32, $ = 64, O = 128, G = 256, J = 512, ae = 30, fe = "...", U = 800, re = 16, oe = 1, ue = 2, te = 3, se = 1 / 0, ee = 9007199254740991, q = 17976931348623157e292, B = NaN, X = 4294967295, ie = X - 1, he = X >>> 1, le = [
        ["ary", O],
        ["bind", v],
        ["bindKey", I],
        ["curry", L],
        ["curryRight", R],
        ["flip", J],
        ["partial", M],
        ["partialRight", $],
        ["rearg", G]
      ], ve = "[object Arguments]", de = "[object Array]", Z = "[object AsyncFunction]", ne = "[object Boolean]", ge = "[object Date]", me = "[object DOMException]", we = "[object Error]", j = "[object Function]", Be = "[object GeneratorFunction]", Fe = "[object Map]", ut = "[object Number]", $t = "[object Null]", Ct = "[object Object]", Yn = "[object Promise]", Qt = "[object Proxy]", dn = "[object RegExp]", en = "[object Set]", Un = "[object String]", b1 = "[object Symbol]", ja = "[object Undefined]", br = "[object WeakMap]", xo = "[object WeakSet]", Cr = "[object ArrayBuffer]", xr = "[object DataView]", C1 = "[object Float32Array]", x1 = "[object Float64Array]", gc = "[object Int8Array]", mc = "[object Int16Array]", hc = "[object Int32Array]", vc = "[object Uint8Array]", bc = "[object Uint8ClampedArray]", Cc = "[object Uint16Array]", xc = "[object Uint32Array]", yc = /\b__p \+= '';/g, yo = /\b(__p \+=) '' \+/g, yr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, y1 = /&(?:amp|lt|gt|quot|#39);/g, I1 = /[&<>"']/g, Io = RegExp(y1.source), Xa = RegExp(I1.source), wo = /<%-([\s\S]+?)%>/g, Za = /<%([\s\S]+?)%>/g, Ic = /<%=([\s\S]+?)%>/g, Ao = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ya = /^\w*$/, Ua = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, w1 = /[\\^$.*+?()[\]{}|]/g, So = RegExp(w1.source), wc = /^\s+/, Ja = /\s/, Ka = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, qa = /\{\n\/\* \[wrapped with (.+)\] \*/, T = /,? & /, K = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, be = /[()=,{}\[\]\/\s]/, Re = /\\(\\)?/g, Ye = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Qe = /\w*$/, We = /^[-+]0x[0-9a-f]+$/i, Ge = /^0b[01]+$/i, _t = /^\[object .+?Constructor\]$/, ft = /^0o[0-7]+$/i, gt = /^(?:0|[1-9]\d*)$/, Xt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Sn = /($^)/, Jn = /['\n\r\u2028\u2029\\]/g, yt = "\\ud800-\\udfff", Ac = "\\u0300-\\u036f", Qa = "\\ufe20-\\ufe2f", e2 = "\\u20d0-\\u20ff", r0 = Ac + Qa + e2, c0 = "\\u2700-\\u27bf", o0 = "a-z\\xdf-\\xf6\\xf8-\\xff", H9 = "\\xac\\xb1\\xd7\\xf7", j9 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", X9 = "\\u2000-\\u206f", Z9 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", i0 = "A-Z\\xc0-\\xd6\\xd8-\\xde", a0 = "\\ufe0e\\ufe0f", s0 = H9 + j9 + X9 + Z9, t2 = "['’]", Y9 = "[" + yt + "]", l0 = "[" + s0 + "]", _o = "[" + r0 + "]", u0 = "\\d+", U9 = "[" + c0 + "]", f0 = "[" + o0 + "]", d0 = "[^" + yt + s0 + u0 + c0 + o0 + i0 + "]", n2 = "\\ud83c[\\udffb-\\udfff]", J9 = "(?:" + _o + "|" + n2 + ")", p0 = "[^" + yt + "]", r2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", c2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", A1 = "[" + i0 + "]", g0 = "\\u200d", m0 = "(?:" + f0 + "|" + d0 + ")", K9 = "(?:" + A1 + "|" + d0 + ")", h0 = "(?:" + t2 + "(?:d|ll|m|re|s|t|ve))?", v0 = "(?:" + t2 + "(?:D|LL|M|RE|S|T|VE))?", b0 = J9 + "?", C0 = "[" + a0 + "]?", q9 = "(?:" + g0 + "(?:" + [p0, r2, c2].join("|") + ")" + C0 + b0 + ")*", Q9 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ep = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", x0 = C0 + b0 + q9, tp = "(?:" + [U9, r2, c2].join("|") + ")" + x0, np = "(?:" + [p0 + _o + "?", _o, r2, c2, Y9].join("|") + ")", rp = RegExp(t2, "g"), cp = RegExp(_o, "g"), o2 = RegExp(n2 + "(?=" + n2 + ")|" + np + x0, "g"), op = RegExp([
        A1 + "?" + f0 + "+" + h0 + "(?=" + [l0, A1, "$"].join("|") + ")",
        K9 + "+" + v0 + "(?=" + [l0, A1 + m0, "$"].join("|") + ")",
        A1 + "?" + m0 + "+" + h0,
        A1 + "+" + v0,
        ep,
        Q9,
        u0,
        tp
      ].join("|"), "g"), ip = RegExp("[" + g0 + yt + r0 + a0 + "]"), ap = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, sp = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], lp = -1, at = {};
      at[C1] = at[x1] = at[gc] = at[mc] = at[hc] = at[vc] = at[bc] = at[Cc] = at[xc] = !0, at[ve] = at[de] = at[Cr] = at[ne] = at[xr] = at[ge] = at[we] = at[j] = at[Fe] = at[ut] = at[Ct] = at[dn] = at[en] = at[Un] = at[br] = !1;
      var it = {};
      it[ve] = it[de] = it[Cr] = it[xr] = it[ne] = it[ge] = it[C1] = it[x1] = it[gc] = it[mc] = it[hc] = it[Fe] = it[ut] = it[Ct] = it[dn] = it[en] = it[Un] = it[b1] = it[vc] = it[bc] = it[Cc] = it[xc] = !0, it[we] = it[j] = it[br] = !1;
      var up = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, fp = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, dp = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, pp = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, gp = parseFloat, mp = parseInt, y0 = typeof di == "object" && di && di.Object === Object && di, hp = typeof self == "object" && self && self.Object === Object && self, Et = y0 || hp || Function("return this")(), i2 = t && !t.nodeType && t, Ur = i2 && !0 && e && !e.nodeType && e, I0 = Ur && Ur.exports === i2, a2 = I0 && y0.process, pn = function() {
        try {
          var F = Ur && Ur.require && Ur.require("util").types;
          return F || a2 && a2.binding && a2.binding("util");
        } catch {
        }
      }(), w0 = pn && pn.isArrayBuffer, A0 = pn && pn.isDate, S0 = pn && pn.isMap, _0 = pn && pn.isRegExp, E0 = pn && pn.isSet, M0 = pn && pn.isTypedArray;
      function tn(F, V, k) {
        switch (k.length) {
          case 0:
            return F.call(V);
          case 1:
            return F.call(V, k[0]);
          case 2:
            return F.call(V, k[0], k[1]);
          case 3:
            return F.call(V, k[0], k[1], k[2]);
        }
        return F.apply(V, k);
      }
      function vp(F, V, k, Ce) {
        for (var Pe = -1, Ue = F == null ? 0 : F.length; ++Pe < Ue; ) {
          var It = F[Pe];
          V(Ce, It, k(It), F);
        }
        return Ce;
      }
      function gn(F, V) {
        for (var k = -1, Ce = F == null ? 0 : F.length; ++k < Ce && V(F[k], k, F) !== !1; )
          ;
        return F;
      }
      function bp(F, V) {
        for (var k = F == null ? 0 : F.length; k-- && V(F[k], k, F) !== !1; )
          ;
        return F;
      }
      function L0(F, V) {
        for (var k = -1, Ce = F == null ? 0 : F.length; ++k < Ce; )
          if (!V(F[k], k, F))
            return !1;
        return !0;
      }
      function Ir(F, V) {
        for (var k = -1, Ce = F == null ? 0 : F.length, Pe = 0, Ue = []; ++k < Ce; ) {
          var It = F[k];
          V(It, k, F) && (Ue[Pe++] = It);
        }
        return Ue;
      }
      function Eo(F, V) {
        var k = F == null ? 0 : F.length;
        return !!k && S1(F, V, 0) > -1;
      }
      function s2(F, V, k) {
        for (var Ce = -1, Pe = F == null ? 0 : F.length; ++Ce < Pe; )
          if (k(V, F[Ce]))
            return !0;
        return !1;
      }
      function lt(F, V) {
        for (var k = -1, Ce = F == null ? 0 : F.length, Pe = Array(Ce); ++k < Ce; )
          Pe[k] = V(F[k], k, F);
        return Pe;
      }
      function wr(F, V) {
        for (var k = -1, Ce = V.length, Pe = F.length; ++k < Ce; )
          F[Pe + k] = V[k];
        return F;
      }
      function l2(F, V, k, Ce) {
        var Pe = -1, Ue = F == null ? 0 : F.length;
        for (Ce && Ue && (k = F[++Pe]); ++Pe < Ue; )
          k = V(k, F[Pe], Pe, F);
        return k;
      }
      function Cp(F, V, k, Ce) {
        var Pe = F == null ? 0 : F.length;
        for (Ce && Pe && (k = F[--Pe]); Pe--; )
          k = V(k, F[Pe], Pe, F);
        return k;
      }
      function u2(F, V) {
        for (var k = -1, Ce = F == null ? 0 : F.length; ++k < Ce; )
          if (V(F[k], k, F))
            return !0;
        return !1;
      }
      var xp = f2("length");
      function yp(F) {
        return F.split("");
      }
      function Ip(F) {
        return F.match(K) || [];
      }
      function R0(F, V, k) {
        var Ce;
        return k(F, function(Pe, Ue, It) {
          if (V(Pe, Ue, It))
            return Ce = Ue, !1;
        }), Ce;
      }
      function Mo(F, V, k, Ce) {
        for (var Pe = F.length, Ue = k + (Ce ? 1 : -1); Ce ? Ue-- : ++Ue < Pe; )
          if (V(F[Ue], Ue, F))
            return Ue;
        return -1;
      }
      function S1(F, V, k) {
        return V === V ? Np(F, V, k) : Mo(F, P0, k);
      }
      function wp(F, V, k, Ce) {
        for (var Pe = k - 1, Ue = F.length; ++Pe < Ue; )
          if (Ce(F[Pe], V))
            return Pe;
        return -1;
      }
      function P0(F) {
        return F !== F;
      }
      function T0(F, V) {
        var k = F == null ? 0 : F.length;
        return k ? p2(F, V) / k : B;
      }
      function f2(F) {
        return function(V) {
          return V == null ? n : V[F];
        };
      }
      function d2(F) {
        return function(V) {
          return F == null ? n : F[V];
        };
      }
      function z0(F, V, k, Ce, Pe) {
        return Pe(F, function(Ue, It, ot) {
          k = Ce ? (Ce = !1, Ue) : V(k, Ue, It, ot);
        }), k;
      }
      function Ap(F, V) {
        var k = F.length;
        for (F.sort(V); k--; )
          F[k] = F[k].value;
        return F;
      }
      function p2(F, V) {
        for (var k, Ce = -1, Pe = F.length; ++Ce < Pe; ) {
          var Ue = V(F[Ce]);
          Ue !== n && (k = k === n ? Ue : k + Ue);
        }
        return k;
      }
      function g2(F, V) {
        for (var k = -1, Ce = Array(F); ++k < F; )
          Ce[k] = V(k);
        return Ce;
      }
      function Sp(F, V) {
        return lt(V, function(k) {
          return [k, F[k]];
        });
      }
      function N0(F) {
        return F && F.slice(0, $0(F) + 1).replace(wc, "");
      }
      function nn(F) {
        return function(V) {
          return F(V);
        };
      }
      function m2(F, V) {
        return lt(V, function(k) {
          return F[k];
        });
      }
      function Sc(F, V) {
        return F.has(V);
      }
      function O0(F, V) {
        for (var k = -1, Ce = F.length; ++k < Ce && S1(V, F[k], 0) > -1; )
          ;
        return k;
      }
      function F0(F, V) {
        for (var k = F.length; k-- && S1(V, F[k], 0) > -1; )
          ;
        return k;
      }
      function _p(F, V) {
        for (var k = F.length, Ce = 0; k--; )
          F[k] === V && ++Ce;
        return Ce;
      }
      var Ep = d2(up), Mp = d2(fp);
      function Lp(F) {
        return "\\" + pp[F];
      }
      function Rp(F, V) {
        return F == null ? n : F[V];
      }
      function _1(F) {
        return ip.test(F);
      }
      function Pp(F) {
        return ap.test(F);
      }
      function Tp(F) {
        for (var V, k = []; !(V = F.next()).done; )
          k.push(V.value);
        return k;
      }
      function h2(F) {
        var V = -1, k = Array(F.size);
        return F.forEach(function(Ce, Pe) {
          k[++V] = [Pe, Ce];
        }), k;
      }
      function D0(F, V) {
        return function(k) {
          return F(V(k));
        };
      }
      function Ar(F, V) {
        for (var k = -1, Ce = F.length, Pe = 0, Ue = []; ++k < Ce; ) {
          var It = F[k];
          (It === V || It === p) && (F[k] = p, Ue[Pe++] = k);
        }
        return Ue;
      }
      function Lo(F) {
        var V = -1, k = Array(F.size);
        return F.forEach(function(Ce) {
          k[++V] = Ce;
        }), k;
      }
      function zp(F) {
        var V = -1, k = Array(F.size);
        return F.forEach(function(Ce) {
          k[++V] = [Ce, Ce];
        }), k;
      }
      function Np(F, V, k) {
        for (var Ce = k - 1, Pe = F.length; ++Ce < Pe; )
          if (F[Ce] === V)
            return Ce;
        return -1;
      }
      function Op(F, V, k) {
        for (var Ce = k + 1; Ce--; )
          if (F[Ce] === V)
            return Ce;
        return Ce;
      }
      function E1(F) {
        return _1(F) ? Dp(F) : xp(F);
      }
      function _n(F) {
        return _1(F) ? $p(F) : yp(F);
      }
      function $0(F) {
        for (var V = F.length; V-- && Ja.test(F.charAt(V)); )
          ;
        return V;
      }
      var Fp = d2(dp);
      function Dp(F) {
        for (var V = o2.lastIndex = 0; o2.test(F); )
          ++V;
        return V;
      }
      function $p(F) {
        return F.match(o2) || [];
      }
      function Gp(F) {
        return F.match(op) || [];
      }
      var kp = function F(V) {
        V = V == null ? Et : M1.defaults(Et.Object(), V, M1.pick(Et, sp));
        var k = V.Array, Ce = V.Date, Pe = V.Error, Ue = V.Function, It = V.Math, ot = V.Object, v2 = V.RegExp, Bp = V.String, mn = V.TypeError, Ro = k.prototype, Vp = Ue.prototype, L1 = ot.prototype, Po = V["__core-js_shared__"], To = Vp.toString, rt = L1.hasOwnProperty, Wp = 0, G0 = function() {
          var r = /[^.]+$/.exec(Po && Po.keys && Po.keys.IE_PROTO || "");
          return r ? "Symbol(src)_1." + r : "";
        }(), zo = L1.toString, Hp = To.call(ot), jp = Et._, Xp = v2(
          "^" + To.call(rt).replace(w1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), No = I0 ? V.Buffer : n, Sr = V.Symbol, Oo = V.Uint8Array, k0 = No ? No.allocUnsafe : n, Fo = D0(ot.getPrototypeOf, ot), B0 = ot.create, V0 = L1.propertyIsEnumerable, Do = Ro.splice, W0 = Sr ? Sr.isConcatSpreadable : n, _c = Sr ? Sr.iterator : n, Jr = Sr ? Sr.toStringTag : n, $o = function() {
          try {
            var r = t1(ot, "defineProperty");
            return r({}, "", {}), r;
          } catch {
          }
        }(), Zp = V.clearTimeout !== Et.clearTimeout && V.clearTimeout, Yp = Ce && Ce.now !== Et.Date.now && Ce.now, Up = V.setTimeout !== Et.setTimeout && V.setTimeout, Go = It.ceil, ko = It.floor, b2 = ot.getOwnPropertySymbols, Jp = No ? No.isBuffer : n, H0 = V.isFinite, Kp = Ro.join, qp = D0(ot.keys, ot), wt = It.max, Tt = It.min, Qp = Ce.now, eg = V.parseInt, j0 = It.random, tg = Ro.reverse, C2 = t1(V, "DataView"), Ec = t1(V, "Map"), x2 = t1(V, "Promise"), R1 = t1(V, "Set"), Mc = t1(V, "WeakMap"), Lc = t1(ot, "create"), Bo = Mc && new Mc(), P1 = {}, ng = n1(C2), rg = n1(Ec), cg = n1(x2), og = n1(R1), ig = n1(Mc), Vo = Sr ? Sr.prototype : n, Rc = Vo ? Vo.valueOf : n, X0 = Vo ? Vo.toString : n;
        function _(r) {
          if (mt(r) && !ze(r) && !(r instanceof He)) {
            if (r instanceof hn)
              return r;
            if (rt.call(r, "__wrapped__"))
              return Zu(r);
          }
          return new hn(r);
        }
        var T1 = /* @__PURE__ */ function() {
          function r() {
          }
          return function(i) {
            if (!dt(i))
              return {};
            if (B0)
              return B0(i);
            r.prototype = i;
            var l = new r();
            return r.prototype = n, l;
          };
        }();
        function Wo() {
        }
        function hn(r, i) {
          this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = n;
        }
        _.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: wo,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Za,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Ic,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _
          }
        }, _.prototype = Wo.prototype, _.prototype.constructor = _, hn.prototype = T1(Wo.prototype), hn.prototype.constructor = hn;
        function He(r) {
          this.__wrapped__ = r, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
        }
        function ag() {
          var r = new He(this.__wrapped__);
          return r.__actions__ = Zt(this.__actions__), r.__dir__ = this.__dir__, r.__filtered__ = this.__filtered__, r.__iteratees__ = Zt(this.__iteratees__), r.__takeCount__ = this.__takeCount__, r.__views__ = Zt(this.__views__), r;
        }
        function sg() {
          if (this.__filtered__) {
            var r = new He(this);
            r.__dir__ = -1, r.__filtered__ = !0;
          } else
            r = this.clone(), r.__dir__ *= -1;
          return r;
        }
        function lg() {
          var r = this.__wrapped__.value(), i = this.__dir__, l = ze(r), g = i < 0, x = l ? r.length : 0, E = ym(0, x, this.__views__), P = E.start, N = E.end, D = N - P, W = g ? N : P - 1, H = this.__iteratees__, Y = H.length, pe = 0, ye = Tt(D, this.__takeCount__);
          if (!l || !g && x == D && ye == D)
            return hu(r, this.__actions__);
          var Me = [];
          e:
            for (; D-- && pe < ye; ) {
              W += i;
              for (var De = -1, Le = r[W]; ++De < Y; ) {
                var Ve = H[De], Xe = Ve.iteratee, on = Ve.type, Bt = Xe(Le);
                if (on == ue)
                  Le = Bt;
                else if (!Bt) {
                  if (on == oe)
                    continue e;
                  break e;
                }
              }
              Me[pe++] = Le;
            }
          return Me;
        }
        He.prototype = T1(Wo.prototype), He.prototype.constructor = He;
        function Kr(r) {
          var i = -1, l = r == null ? 0 : r.length;
          for (this.clear(); ++i < l; ) {
            var g = r[i];
            this.set(g[0], g[1]);
          }
        }
        function ug() {
          this.__data__ = Lc ? Lc(null) : {}, this.size = 0;
        }
        function fg(r) {
          var i = this.has(r) && delete this.__data__[r];
          return this.size -= i ? 1 : 0, i;
        }
        function dg(r) {
          var i = this.__data__;
          if (Lc) {
            var l = i[r];
            return l === f ? n : l;
          }
          return rt.call(i, r) ? i[r] : n;
        }
        function pg(r) {
          var i = this.__data__;
          return Lc ? i[r] !== n : rt.call(i, r);
        }
        function gg(r, i) {
          var l = this.__data__;
          return this.size += this.has(r) ? 0 : 1, l[r] = Lc && i === n ? f : i, this;
        }
        Kr.prototype.clear = ug, Kr.prototype.delete = fg, Kr.prototype.get = dg, Kr.prototype.has = pg, Kr.prototype.set = gg;
        function Kn(r) {
          var i = -1, l = r == null ? 0 : r.length;
          for (this.clear(); ++i < l; ) {
            var g = r[i];
            this.set(g[0], g[1]);
          }
        }
        function mg() {
          this.__data__ = [], this.size = 0;
        }
        function hg(r) {
          var i = this.__data__, l = Ho(i, r);
          if (l < 0)
            return !1;
          var g = i.length - 1;
          return l == g ? i.pop() : Do.call(i, l, 1), --this.size, !0;
        }
        function vg(r) {
          var i = this.__data__, l = Ho(i, r);
          return l < 0 ? n : i[l][1];
        }
        function bg(r) {
          return Ho(this.__data__, r) > -1;
        }
        function Cg(r, i) {
          var l = this.__data__, g = Ho(l, r);
          return g < 0 ? (++this.size, l.push([r, i])) : l[g][1] = i, this;
        }
        Kn.prototype.clear = mg, Kn.prototype.delete = hg, Kn.prototype.get = vg, Kn.prototype.has = bg, Kn.prototype.set = Cg;
        function qn(r) {
          var i = -1, l = r == null ? 0 : r.length;
          for (this.clear(); ++i < l; ) {
            var g = r[i];
            this.set(g[0], g[1]);
          }
        }
        function xg() {
          this.size = 0, this.__data__ = {
            hash: new Kr(),
            map: new (Ec || Kn)(),
            string: new Kr()
          };
        }
        function yg(r) {
          var i = ni(this, r).delete(r);
          return this.size -= i ? 1 : 0, i;
        }
        function Ig(r) {
          return ni(this, r).get(r);
        }
        function wg(r) {
          return ni(this, r).has(r);
        }
        function Ag(r, i) {
          var l = ni(this, r), g = l.size;
          return l.set(r, i), this.size += l.size == g ? 0 : 1, this;
        }
        qn.prototype.clear = xg, qn.prototype.delete = yg, qn.prototype.get = Ig, qn.prototype.has = wg, qn.prototype.set = Ag;
        function qr(r) {
          var i = -1, l = r == null ? 0 : r.length;
          for (this.__data__ = new qn(); ++i < l; )
            this.add(r[i]);
        }
        function Sg(r) {
          return this.__data__.set(r, f), this;
        }
        function _g(r) {
          return this.__data__.has(r);
        }
        qr.prototype.add = qr.prototype.push = Sg, qr.prototype.has = _g;
        function En(r) {
          var i = this.__data__ = new Kn(r);
          this.size = i.size;
        }
        function Eg() {
          this.__data__ = new Kn(), this.size = 0;
        }
        function Mg(r) {
          var i = this.__data__, l = i.delete(r);
          return this.size = i.size, l;
        }
        function Lg(r) {
          return this.__data__.get(r);
        }
        function Rg(r) {
          return this.__data__.has(r);
        }
        function Pg(r, i) {
          var l = this.__data__;
          if (l instanceof Kn) {
            var g = l.__data__;
            if (!Ec || g.length < o - 1)
              return g.push([r, i]), this.size = ++l.size, this;
            l = this.__data__ = new qn(g);
          }
          return l.set(r, i), this.size = l.size, this;
        }
        En.prototype.clear = Eg, En.prototype.delete = Mg, En.prototype.get = Lg, En.prototype.has = Rg, En.prototype.set = Pg;
        function Z0(r, i) {
          var l = ze(r), g = !l && r1(r), x = !l && !g && Rr(r), E = !l && !g && !x && F1(r), P = l || g || x || E, N = P ? g2(r.length, Bp) : [], D = N.length;
          for (var W in r)
            (i || rt.call(r, W)) && !(P && // Safari 9 has enumerable `arguments.length` in strict mode.
            (W == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            x && (W == "offset" || W == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            E && (W == "buffer" || W == "byteLength" || W == "byteOffset") || // Skip index properties.
            nr(W, D))) && N.push(W);
          return N;
        }
        function Y0(r) {
          var i = r.length;
          return i ? r[P2(0, i - 1)] : n;
        }
        function Tg(r, i) {
          return ri(Zt(r), Qr(i, 0, r.length));
        }
        function zg(r) {
          return ri(Zt(r));
        }
        function y2(r, i, l) {
          (l !== n && !Mn(r[i], l) || l === n && !(i in r)) && Qn(r, i, l);
        }
        function Pc(r, i, l) {
          var g = r[i];
          (!(rt.call(r, i) && Mn(g, l)) || l === n && !(i in r)) && Qn(r, i, l);
        }
        function Ho(r, i) {
          for (var l = r.length; l--; )
            if (Mn(r[l][0], i))
              return l;
          return -1;
        }
        function Ng(r, i, l, g) {
          return _r(r, function(x, E, P) {
            i(g, x, l(x), P);
          }), g;
        }
        function U0(r, i) {
          return r && Nn(i, At(i), r);
        }
        function Og(r, i) {
          return r && Nn(i, Ut(i), r);
        }
        function Qn(r, i, l) {
          i == "__proto__" && $o ? $o(r, i, {
            configurable: !0,
            enumerable: !0,
            value: l,
            writable: !0
          }) : r[i] = l;
        }
        function I2(r, i) {
          for (var l = -1, g = i.length, x = k(g), E = r == null; ++l < g; )
            x[l] = E ? n : ns(r, i[l]);
          return x;
        }
        function Qr(r, i, l) {
          return r === r && (l !== n && (r = r <= l ? r : l), i !== n && (r = r >= i ? r : i)), r;
        }
        function vn(r, i, l, g, x, E) {
          var P, N = i & m, D = i & b, W = i & y;
          if (l && (P = x ? l(r, g, x, E) : l(r)), P !== n)
            return P;
          if (!dt(r))
            return r;
          var H = ze(r);
          if (H) {
            if (P = wm(r), !N)
              return Zt(r, P);
          } else {
            var Y = zt(r), pe = Y == j || Y == Be;
            if (Rr(r))
              return Cu(r, N);
            if (Y == Ct || Y == ve || pe && !x) {
              if (P = D || pe ? {} : $u(r), !N)
                return D ? dm(r, Og(P, r)) : fm(r, U0(P, r));
            } else {
              if (!it[Y])
                return x ? r : {};
              P = Am(r, Y, N);
            }
          }
          E || (E = new En());
          var ye = E.get(r);
          if (ye)
            return ye;
          E.set(r, P), p3(r) ? r.forEach(function(Le) {
            P.add(vn(Le, i, l, Le, r, E));
          }) : f3(r) && r.forEach(function(Le, Ve) {
            P.set(Ve, vn(Le, i, l, Ve, r, E));
          });
          var Me = W ? D ? V2 : B2 : D ? Ut : At, De = H ? n : Me(r);
          return gn(De || r, function(Le, Ve) {
            De && (Ve = Le, Le = r[Ve]), Pc(P, Ve, vn(Le, i, l, Ve, r, E));
          }), P;
        }
        function Fg(r) {
          var i = At(r);
          return function(l) {
            return J0(l, r, i);
          };
        }
        function J0(r, i, l) {
          var g = l.length;
          if (r == null)
            return !g;
          for (r = ot(r); g--; ) {
            var x = l[g], E = i[x], P = r[x];
            if (P === n && !(x in r) || !E(P))
              return !1;
          }
          return !0;
        }
        function K0(r, i, l) {
          if (typeof r != "function")
            throw new mn(s);
          return $c(function() {
            r.apply(n, l);
          }, i);
        }
        function Tc(r, i, l, g) {
          var x = -1, E = Eo, P = !0, N = r.length, D = [], W = i.length;
          if (!N)
            return D;
          l && (i = lt(i, nn(l))), g ? (E = s2, P = !1) : i.length >= o && (E = Sc, P = !1, i = new qr(i));
          e:
            for (; ++x < N; ) {
              var H = r[x], Y = l == null ? H : l(H);
              if (H = g || H !== 0 ? H : 0, P && Y === Y) {
                for (var pe = W; pe--; )
                  if (i[pe] === Y)
                    continue e;
                D.push(H);
              } else E(i, Y, g) || D.push(H);
            }
          return D;
        }
        var _r = Au(zn), q0 = Au(A2, !0);
        function Dg(r, i) {
          var l = !0;
          return _r(r, function(g, x, E) {
            return l = !!i(g, x, E), l;
          }), l;
        }
        function jo(r, i, l) {
          for (var g = -1, x = r.length; ++g < x; ) {
            var E = r[g], P = i(E);
            if (P != null && (N === n ? P === P && !cn(P) : l(P, N)))
              var N = P, D = E;
          }
          return D;
        }
        function $g(r, i, l, g) {
          var x = r.length;
          for (l = Oe(l), l < 0 && (l = -l > x ? 0 : x + l), g = g === n || g > x ? x : Oe(g), g < 0 && (g += x), g = l > g ? 0 : m3(g); l < g; )
            r[l++] = i;
          return r;
        }
        function Q0(r, i) {
          var l = [];
          return _r(r, function(g, x, E) {
            i(g, x, E) && l.push(g);
          }), l;
        }
        function Mt(r, i, l, g, x) {
          var E = -1, P = r.length;
          for (l || (l = _m), x || (x = []); ++E < P; ) {
            var N = r[E];
            i > 0 && l(N) ? i > 1 ? Mt(N, i - 1, l, g, x) : wr(x, N) : g || (x[x.length] = N);
          }
          return x;
        }
        var w2 = Su(), eu = Su(!0);
        function zn(r, i) {
          return r && w2(r, i, At);
        }
        function A2(r, i) {
          return r && eu(r, i, At);
        }
        function Xo(r, i) {
          return Ir(i, function(l) {
            return rr(r[l]);
          });
        }
        function e1(r, i) {
          i = Mr(i, r);
          for (var l = 0, g = i.length; r != null && l < g; )
            r = r[On(i[l++])];
          return l && l == g ? r : n;
        }
        function tu(r, i, l) {
          var g = i(r);
          return ze(r) ? g : wr(g, l(r));
        }
        function Gt(r) {
          return r == null ? r === n ? ja : $t : Jr && Jr in ot(r) ? xm(r) : zm(r);
        }
        function S2(r, i) {
          return r > i;
        }
        function Gg(r, i) {
          return r != null && rt.call(r, i);
        }
        function kg(r, i) {
          return r != null && i in ot(r);
        }
        function Bg(r, i, l) {
          return r >= Tt(i, l) && r < wt(i, l);
        }
        function _2(r, i, l) {
          for (var g = l ? s2 : Eo, x = r[0].length, E = r.length, P = E, N = k(E), D = 1 / 0, W = []; P--; ) {
            var H = r[P];
            P && i && (H = lt(H, nn(i))), D = Tt(H.length, D), N[P] = !l && (i || x >= 120 && H.length >= 120) ? new qr(P && H) : n;
          }
          H = r[0];
          var Y = -1, pe = N[0];
          e:
            for (; ++Y < x && W.length < D; ) {
              var ye = H[Y], Me = i ? i(ye) : ye;
              if (ye = l || ye !== 0 ? ye : 0, !(pe ? Sc(pe, Me) : g(W, Me, l))) {
                for (P = E; --P; ) {
                  var De = N[P];
                  if (!(De ? Sc(De, Me) : g(r[P], Me, l)))
                    continue e;
                }
                pe && pe.push(Me), W.push(ye);
              }
            }
          return W;
        }
        function Vg(r, i, l, g) {
          return zn(r, function(x, E, P) {
            i(g, l(x), E, P);
          }), g;
        }
        function zc(r, i, l) {
          i = Mr(i, r), r = Vu(r, i);
          var g = r == null ? r : r[On(Cn(i))];
          return g == null ? n : tn(g, r, l);
        }
        function nu(r) {
          return mt(r) && Gt(r) == ve;
        }
        function Wg(r) {
          return mt(r) && Gt(r) == Cr;
        }
        function Hg(r) {
          return mt(r) && Gt(r) == ge;
        }
        function Nc(r, i, l, g, x) {
          return r === i ? !0 : r == null || i == null || !mt(r) && !mt(i) ? r !== r && i !== i : jg(r, i, l, g, Nc, x);
        }
        function jg(r, i, l, g, x, E) {
          var P = ze(r), N = ze(i), D = P ? de : zt(r), W = N ? de : zt(i);
          D = D == ve ? Ct : D, W = W == ve ? Ct : W;
          var H = D == Ct, Y = W == Ct, pe = D == W;
          if (pe && Rr(r)) {
            if (!Rr(i))
              return !1;
            P = !0, H = !1;
          }
          if (pe && !H)
            return E || (E = new En()), P || F1(r) ? Ou(r, i, l, g, x, E) : bm(r, i, D, l, g, x, E);
          if (!(l & C)) {
            var ye = H && rt.call(r, "__wrapped__"), Me = Y && rt.call(i, "__wrapped__");
            if (ye || Me) {
              var De = ye ? r.value() : r, Le = Me ? i.value() : i;
              return E || (E = new En()), x(De, Le, l, g, E);
            }
          }
          return pe ? (E || (E = new En()), Cm(r, i, l, g, x, E)) : !1;
        }
        function Xg(r) {
          return mt(r) && zt(r) == Fe;
        }
        function E2(r, i, l, g) {
          var x = l.length, E = x, P = !g;
          if (r == null)
            return !E;
          for (r = ot(r); x--; ) {
            var N = l[x];
            if (P && N[2] ? N[1] !== r[N[0]] : !(N[0] in r))
              return !1;
          }
          for (; ++x < E; ) {
            N = l[x];
            var D = N[0], W = r[D], H = N[1];
            if (P && N[2]) {
              if (W === n && !(D in r))
                return !1;
            } else {
              var Y = new En();
              if (g)
                var pe = g(W, H, D, r, i, Y);
              if (!(pe === n ? Nc(H, W, C | h, g, Y) : pe))
                return !1;
            }
          }
          return !0;
        }
        function ru(r) {
          if (!dt(r) || Mm(r))
            return !1;
          var i = rr(r) ? Xp : _t;
          return i.test(n1(r));
        }
        function Zg(r) {
          return mt(r) && Gt(r) == dn;
        }
        function Yg(r) {
          return mt(r) && zt(r) == en;
        }
        function Ug(r) {
          return mt(r) && li(r.length) && !!at[Gt(r)];
        }
        function cu(r) {
          return typeof r == "function" ? r : r == null ? Jt : typeof r == "object" ? ze(r) ? au(r[0], r[1]) : iu(r) : _3(r);
        }
        function M2(r) {
          if (!Dc(r))
            return qp(r);
          var i = [];
          for (var l in ot(r))
            rt.call(r, l) && l != "constructor" && i.push(l);
          return i;
        }
        function Jg(r) {
          if (!dt(r))
            return Tm(r);
          var i = Dc(r), l = [];
          for (var g in r)
            g == "constructor" && (i || !rt.call(r, g)) || l.push(g);
          return l;
        }
        function L2(r, i) {
          return r < i;
        }
        function ou(r, i) {
          var l = -1, g = Yt(r) ? k(r.length) : [];
          return _r(r, function(x, E, P) {
            g[++l] = i(x, E, P);
          }), g;
        }
        function iu(r) {
          var i = H2(r);
          return i.length == 1 && i[0][2] ? ku(i[0][0], i[0][1]) : function(l) {
            return l === r || E2(l, r, i);
          };
        }
        function au(r, i) {
          return X2(r) && Gu(i) ? ku(On(r), i) : function(l) {
            var g = ns(l, r);
            return g === n && g === i ? rs(l, r) : Nc(i, g, C | h);
          };
        }
        function Zo(r, i, l, g, x) {
          r !== i && w2(i, function(E, P) {
            if (x || (x = new En()), dt(E))
              Kg(r, i, P, l, Zo, g, x);
            else {
              var N = g ? g(Y2(r, P), E, P + "", r, i, x) : n;
              N === n && (N = E), y2(r, P, N);
            }
          }, Ut);
        }
        function Kg(r, i, l, g, x, E, P) {
          var N = Y2(r, l), D = Y2(i, l), W = P.get(D);
          if (W) {
            y2(r, l, W);
            return;
          }
          var H = E ? E(N, D, l + "", r, i, P) : n, Y = H === n;
          if (Y) {
            var pe = ze(D), ye = !pe && Rr(D), Me = !pe && !ye && F1(D);
            H = D, pe || ye || Me ? ze(N) ? H = N : vt(N) ? H = Zt(N) : ye ? (Y = !1, H = Cu(D, !0)) : Me ? (Y = !1, H = xu(D, !0)) : H = [] : Gc(D) || r1(D) ? (H = N, r1(N) ? H = h3(N) : (!dt(N) || rr(N)) && (H = $u(D))) : Y = !1;
          }
          Y && (P.set(D, H), x(H, D, g, E, P), P.delete(D)), y2(r, l, H);
        }
        function su(r, i) {
          var l = r.length;
          if (l)
            return i += i < 0 ? l : 0, nr(i, l) ? r[i] : n;
        }
        function lu(r, i, l) {
          i.length ? i = lt(i, function(E) {
            return ze(E) ? function(P) {
              return e1(P, E.length === 1 ? E[0] : E);
            } : E;
          }) : i = [Jt];
          var g = -1;
          i = lt(i, nn(Ee()));
          var x = ou(r, function(E, P, N) {
            var D = lt(i, function(W) {
              return W(E);
            });
            return { criteria: D, index: ++g, value: E };
          });
          return Ap(x, function(E, P) {
            return um(E, P, l);
          });
        }
        function qg(r, i) {
          return uu(r, i, function(l, g) {
            return rs(r, g);
          });
        }
        function uu(r, i, l) {
          for (var g = -1, x = i.length, E = {}; ++g < x; ) {
            var P = i[g], N = e1(r, P);
            l(N, P) && Oc(E, Mr(P, r), N);
          }
          return E;
        }
        function Qg(r) {
          return function(i) {
            return e1(i, r);
          };
        }
        function R2(r, i, l, g) {
          var x = g ? wp : S1, E = -1, P = i.length, N = r;
          for (r === i && (i = Zt(i)), l && (N = lt(r, nn(l))); ++E < P; )
            for (var D = 0, W = i[E], H = l ? l(W) : W; (D = x(N, H, D, g)) > -1; )
              N !== r && Do.call(N, D, 1), Do.call(r, D, 1);
          return r;
        }
        function fu(r, i) {
          for (var l = r ? i.length : 0, g = l - 1; l--; ) {
            var x = i[l];
            if (l == g || x !== E) {
              var E = x;
              nr(x) ? Do.call(r, x, 1) : N2(r, x);
            }
          }
          return r;
        }
        function P2(r, i) {
          return r + ko(j0() * (i - r + 1));
        }
        function em(r, i, l, g) {
          for (var x = -1, E = wt(Go((i - r) / (l || 1)), 0), P = k(E); E--; )
            P[g ? E : ++x] = r, r += l;
          return P;
        }
        function T2(r, i) {
          var l = "";
          if (!r || i < 1 || i > ee)
            return l;
          do
            i % 2 && (l += r), i = ko(i / 2), i && (r += r);
          while (i);
          return l;
        }
        function $e(r, i) {
          return U2(Bu(r, i, Jt), r + "");
        }
        function tm(r) {
          return Y0(D1(r));
        }
        function nm(r, i) {
          var l = D1(r);
          return ri(l, Qr(i, 0, l.length));
        }
        function Oc(r, i, l, g) {
          if (!dt(r))
            return r;
          i = Mr(i, r);
          for (var x = -1, E = i.length, P = E - 1, N = r; N != null && ++x < E; ) {
            var D = On(i[x]), W = l;
            if (D === "__proto__" || D === "constructor" || D === "prototype")
              return r;
            if (x != P) {
              var H = N[D];
              W = g ? g(H, D, N) : n, W === n && (W = dt(H) ? H : nr(i[x + 1]) ? [] : {});
            }
            Pc(N, D, W), N = N[D];
          }
          return r;
        }
        var du = Bo ? function(r, i) {
          return Bo.set(r, i), r;
        } : Jt, rm = $o ? function(r, i) {
          return $o(r, "toString", {
            configurable: !0,
            enumerable: !1,
            value: os(i),
            writable: !0
          });
        } : Jt;
        function cm(r) {
          return ri(D1(r));
        }
        function bn(r, i, l) {
          var g = -1, x = r.length;
          i < 0 && (i = -i > x ? 0 : x + i), l = l > x ? x : l, l < 0 && (l += x), x = i > l ? 0 : l - i >>> 0, i >>>= 0;
          for (var E = k(x); ++g < x; )
            E[g] = r[g + i];
          return E;
        }
        function om(r, i) {
          var l;
          return _r(r, function(g, x, E) {
            return l = i(g, x, E), !l;
          }), !!l;
        }
        function Yo(r, i, l) {
          var g = 0, x = r == null ? g : r.length;
          if (typeof i == "number" && i === i && x <= he) {
            for (; g < x; ) {
              var E = g + x >>> 1, P = r[E];
              P !== null && !cn(P) && (l ? P <= i : P < i) ? g = E + 1 : x = E;
            }
            return x;
          }
          return z2(r, i, Jt, l);
        }
        function z2(r, i, l, g) {
          var x = 0, E = r == null ? 0 : r.length;
          if (E === 0)
            return 0;
          i = l(i);
          for (var P = i !== i, N = i === null, D = cn(i), W = i === n; x < E; ) {
            var H = ko((x + E) / 2), Y = l(r[H]), pe = Y !== n, ye = Y === null, Me = Y === Y, De = cn(Y);
            if (P)
              var Le = g || Me;
            else W ? Le = Me && (g || pe) : N ? Le = Me && pe && (g || !ye) : D ? Le = Me && pe && !ye && (g || !De) : ye || De ? Le = !1 : Le = g ? Y <= i : Y < i;
            Le ? x = H + 1 : E = H;
          }
          return Tt(E, ie);
        }
        function pu(r, i) {
          for (var l = -1, g = r.length, x = 0, E = []; ++l < g; ) {
            var P = r[l], N = i ? i(P) : P;
            if (!l || !Mn(N, D)) {
              var D = N;
              E[x++] = P === 0 ? 0 : P;
            }
          }
          return E;
        }
        function gu(r) {
          return typeof r == "number" ? r : cn(r) ? B : +r;
        }
        function rn(r) {
          if (typeof r == "string")
            return r;
          if (ze(r))
            return lt(r, rn) + "";
          if (cn(r))
            return X0 ? X0.call(r) : "";
          var i = r + "";
          return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
        }
        function Er(r, i, l) {
          var g = -1, x = Eo, E = r.length, P = !0, N = [], D = N;
          if (l)
            P = !1, x = s2;
          else if (E >= o) {
            var W = i ? null : hm(r);
            if (W)
              return Lo(W);
            P = !1, x = Sc, D = new qr();
          } else
            D = i ? [] : N;
          e:
            for (; ++g < E; ) {
              var H = r[g], Y = i ? i(H) : H;
              if (H = l || H !== 0 ? H : 0, P && Y === Y) {
                for (var pe = D.length; pe--; )
                  if (D[pe] === Y)
                    continue e;
                i && D.push(Y), N.push(H);
              } else x(D, Y, l) || (D !== N && D.push(Y), N.push(H));
            }
          return N;
        }
        function N2(r, i) {
          return i = Mr(i, r), r = Vu(r, i), r == null || delete r[On(Cn(i))];
        }
        function mu(r, i, l, g) {
          return Oc(r, i, l(e1(r, i)), g);
        }
        function Uo(r, i, l, g) {
          for (var x = r.length, E = g ? x : -1; (g ? E-- : ++E < x) && i(r[E], E, r); )
            ;
          return l ? bn(r, g ? 0 : E, g ? E + 1 : x) : bn(r, g ? E + 1 : 0, g ? x : E);
        }
        function hu(r, i) {
          var l = r;
          return l instanceof He && (l = l.value()), l2(i, function(g, x) {
            return x.func.apply(x.thisArg, wr([g], x.args));
          }, l);
        }
        function O2(r, i, l) {
          var g = r.length;
          if (g < 2)
            return g ? Er(r[0]) : [];
          for (var x = -1, E = k(g); ++x < g; )
            for (var P = r[x], N = -1; ++N < g; )
              N != x && (E[x] = Tc(E[x] || P, r[N], i, l));
          return Er(Mt(E, 1), i, l);
        }
        function vu(r, i, l) {
          for (var g = -1, x = r.length, E = i.length, P = {}; ++g < x; ) {
            var N = g < E ? i[g] : n;
            l(P, r[g], N);
          }
          return P;
        }
        function F2(r) {
          return vt(r) ? r : [];
        }
        function D2(r) {
          return typeof r == "function" ? r : Jt;
        }
        function Mr(r, i) {
          return ze(r) ? r : X2(r, i) ? [r] : Xu(et(r));
        }
        var im = $e;
        function Lr(r, i, l) {
          var g = r.length;
          return l = l === n ? g : l, !i && l >= g ? r : bn(r, i, l);
        }
        var bu = Zp || function(r) {
          return Et.clearTimeout(r);
        };
        function Cu(r, i) {
          if (i)
            return r.slice();
          var l = r.length, g = k0 ? k0(l) : new r.constructor(l);
          return r.copy(g), g;
        }
        function $2(r) {
          var i = new r.constructor(r.byteLength);
          return new Oo(i).set(new Oo(r)), i;
        }
        function am(r, i) {
          var l = i ? $2(r.buffer) : r.buffer;
          return new r.constructor(l, r.byteOffset, r.byteLength);
        }
        function sm(r) {
          var i = new r.constructor(r.source, Qe.exec(r));
          return i.lastIndex = r.lastIndex, i;
        }
        function lm(r) {
          return Rc ? ot(Rc.call(r)) : {};
        }
        function xu(r, i) {
          var l = i ? $2(r.buffer) : r.buffer;
          return new r.constructor(l, r.byteOffset, r.length);
        }
        function yu(r, i) {
          if (r !== i) {
            var l = r !== n, g = r === null, x = r === r, E = cn(r), P = i !== n, N = i === null, D = i === i, W = cn(i);
            if (!N && !W && !E && r > i || E && P && D && !N && !W || g && P && D || !l && D || !x)
              return 1;
            if (!g && !E && !W && r < i || W && l && x && !g && !E || N && l && x || !P && x || !D)
              return -1;
          }
          return 0;
        }
        function um(r, i, l) {
          for (var g = -1, x = r.criteria, E = i.criteria, P = x.length, N = l.length; ++g < P; ) {
            var D = yu(x[g], E[g]);
            if (D) {
              if (g >= N)
                return D;
              var W = l[g];
              return D * (W == "desc" ? -1 : 1);
            }
          }
          return r.index - i.index;
        }
        function Iu(r, i, l, g) {
          for (var x = -1, E = r.length, P = l.length, N = -1, D = i.length, W = wt(E - P, 0), H = k(D + W), Y = !g; ++N < D; )
            H[N] = i[N];
          for (; ++x < P; )
            (Y || x < E) && (H[l[x]] = r[x]);
          for (; W--; )
            H[N++] = r[x++];
          return H;
        }
        function wu(r, i, l, g) {
          for (var x = -1, E = r.length, P = -1, N = l.length, D = -1, W = i.length, H = wt(E - N, 0), Y = k(H + W), pe = !g; ++x < H; )
            Y[x] = r[x];
          for (var ye = x; ++D < W; )
            Y[ye + D] = i[D];
          for (; ++P < N; )
            (pe || x < E) && (Y[ye + l[P]] = r[x++]);
          return Y;
        }
        function Zt(r, i) {
          var l = -1, g = r.length;
          for (i || (i = k(g)); ++l < g; )
            i[l] = r[l];
          return i;
        }
        function Nn(r, i, l, g) {
          var x = !l;
          l || (l = {});
          for (var E = -1, P = i.length; ++E < P; ) {
            var N = i[E], D = g ? g(l[N], r[N], N, l, r) : n;
            D === n && (D = r[N]), x ? Qn(l, N, D) : Pc(l, N, D);
          }
          return l;
        }
        function fm(r, i) {
          return Nn(r, j2(r), i);
        }
        function dm(r, i) {
          return Nn(r, Fu(r), i);
        }
        function Jo(r, i) {
          return function(l, g) {
            var x = ze(l) ? vp : Ng, E = i ? i() : {};
            return x(l, r, Ee(g, 2), E);
          };
        }
        function z1(r) {
          return $e(function(i, l) {
            var g = -1, x = l.length, E = x > 1 ? l[x - 1] : n, P = x > 2 ? l[2] : n;
            for (E = r.length > 3 && typeof E == "function" ? (x--, E) : n, P && kt(l[0], l[1], P) && (E = x < 3 ? n : E, x = 1), i = ot(i); ++g < x; ) {
              var N = l[g];
              N && r(i, N, g, E);
            }
            return i;
          });
        }
        function Au(r, i) {
          return function(l, g) {
            if (l == null)
              return l;
            if (!Yt(l))
              return r(l, g);
            for (var x = l.length, E = i ? x : -1, P = ot(l); (i ? E-- : ++E < x) && g(P[E], E, P) !== !1; )
              ;
            return l;
          };
        }
        function Su(r) {
          return function(i, l, g) {
            for (var x = -1, E = ot(i), P = g(i), N = P.length; N--; ) {
              var D = P[r ? N : ++x];
              if (l(E[D], D, E) === !1)
                break;
            }
            return i;
          };
        }
        function pm(r, i, l) {
          var g = i & v, x = Fc(r);
          function E() {
            var P = this && this !== Et && this instanceof E ? x : r;
            return P.apply(g ? l : this, arguments);
          }
          return E;
        }
        function _u(r) {
          return function(i) {
            i = et(i);
            var l = _1(i) ? _n(i) : n, g = l ? l[0] : i.charAt(0), x = l ? Lr(l, 1).join("") : i.slice(1);
            return g[r]() + x;
          };
        }
        function N1(r) {
          return function(i) {
            return l2(A3(w3(i).replace(rp, "")), r, "");
          };
        }
        function Fc(r) {
          return function() {
            var i = arguments;
            switch (i.length) {
              case 0:
                return new r();
              case 1:
                return new r(i[0]);
              case 2:
                return new r(i[0], i[1]);
              case 3:
                return new r(i[0], i[1], i[2]);
              case 4:
                return new r(i[0], i[1], i[2], i[3]);
              case 5:
                return new r(i[0], i[1], i[2], i[3], i[4]);
              case 6:
                return new r(i[0], i[1], i[2], i[3], i[4], i[5]);
              case 7:
                return new r(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
            }
            var l = T1(r.prototype), g = r.apply(l, i);
            return dt(g) ? g : l;
          };
        }
        function gm(r, i, l) {
          var g = Fc(r);
          function x() {
            for (var E = arguments.length, P = k(E), N = E, D = O1(x); N--; )
              P[N] = arguments[N];
            var W = E < 3 && P[0] !== D && P[E - 1] !== D ? [] : Ar(P, D);
            if (E -= W.length, E < l)
              return Pu(
                r,
                i,
                Ko,
                x.placeholder,
                n,
                P,
                W,
                n,
                n,
                l - E
              );
            var H = this && this !== Et && this instanceof x ? g : r;
            return tn(H, this, P);
          }
          return x;
        }
        function Eu(r) {
          return function(i, l, g) {
            var x = ot(i);
            if (!Yt(i)) {
              var E = Ee(l, 3);
              i = At(i), l = function(N) {
                return E(x[N], N, x);
              };
            }
            var P = r(i, l, g);
            return P > -1 ? x[E ? i[P] : P] : n;
          };
        }
        function Mu(r) {
          return tr(function(i) {
            var l = i.length, g = l, x = hn.prototype.thru;
            for (r && i.reverse(); g--; ) {
              var E = i[g];
              if (typeof E != "function")
                throw new mn(s);
              if (x && !P && ti(E) == "wrapper")
                var P = new hn([], !0);
            }
            for (g = P ? g : l; ++g < l; ) {
              E = i[g];
              var N = ti(E), D = N == "wrapper" ? W2(E) : n;
              D && Z2(D[0]) && D[1] == (O | L | M | G) && !D[4].length && D[9] == 1 ? P = P[ti(D[0])].apply(P, D[3]) : P = E.length == 1 && Z2(E) ? P[N]() : P.thru(E);
            }
            return function() {
              var W = arguments, H = W[0];
              if (P && W.length == 1 && ze(H))
                return P.plant(H).value();
              for (var Y = 0, pe = l ? i[Y].apply(this, W) : H; ++Y < l; )
                pe = i[Y].call(this, pe);
              return pe;
            };
          });
        }
        function Ko(r, i, l, g, x, E, P, N, D, W) {
          var H = i & O, Y = i & v, pe = i & I, ye = i & (L | R), Me = i & J, De = pe ? n : Fc(r);
          function Le() {
            for (var Ve = arguments.length, Xe = k(Ve), on = Ve; on--; )
              Xe[on] = arguments[on];
            if (ye)
              var Bt = O1(Le), an = _p(Xe, Bt);
            if (g && (Xe = Iu(Xe, g, x, ye)), E && (Xe = wu(Xe, E, P, ye)), Ve -= an, ye && Ve < W) {
              var bt = Ar(Xe, Bt);
              return Pu(
                r,
                i,
                Ko,
                Le.placeholder,
                l,
                Xe,
                bt,
                N,
                D,
                W - Ve
              );
            }
            var Ln = Y ? l : this, or = pe ? Ln[r] : r;
            return Ve = Xe.length, N ? Xe = Nm(Xe, N) : Me && Ve > 1 && Xe.reverse(), H && D < Ve && (Xe.length = D), this && this !== Et && this instanceof Le && (or = De || Fc(or)), or.apply(Ln, Xe);
          }
          return Le;
        }
        function Lu(r, i) {
          return function(l, g) {
            return Vg(l, r, i(g), {});
          };
        }
        function qo(r, i) {
          return function(l, g) {
            var x;
            if (l === n && g === n)
              return i;
            if (l !== n && (x = l), g !== n) {
              if (x === n)
                return g;
              typeof l == "string" || typeof g == "string" ? (l = rn(l), g = rn(g)) : (l = gu(l), g = gu(g)), x = r(l, g);
            }
            return x;
          };
        }
        function G2(r) {
          return tr(function(i) {
            return i = lt(i, nn(Ee())), $e(function(l) {
              var g = this;
              return r(i, function(x) {
                return tn(x, g, l);
              });
            });
          });
        }
        function Qo(r, i) {
          i = i === n ? " " : rn(i);
          var l = i.length;
          if (l < 2)
            return l ? T2(i, r) : i;
          var g = T2(i, Go(r / E1(i)));
          return _1(i) ? Lr(_n(g), 0, r).join("") : g.slice(0, r);
        }
        function mm(r, i, l, g) {
          var x = i & v, E = Fc(r);
          function P() {
            for (var N = -1, D = arguments.length, W = -1, H = g.length, Y = k(H + D), pe = this && this !== Et && this instanceof P ? E : r; ++W < H; )
              Y[W] = g[W];
            for (; D--; )
              Y[W++] = arguments[++N];
            return tn(pe, x ? l : this, Y);
          }
          return P;
        }
        function Ru(r) {
          return function(i, l, g) {
            return g && typeof g != "number" && kt(i, l, g) && (l = g = n), i = cr(i), l === n ? (l = i, i = 0) : l = cr(l), g = g === n ? i < l ? 1 : -1 : cr(g), em(i, l, g, r);
          };
        }
        function ei(r) {
          return function(i, l) {
            return typeof i == "string" && typeof l == "string" || (i = xn(i), l = xn(l)), r(i, l);
          };
        }
        function Pu(r, i, l, g, x, E, P, N, D, W) {
          var H = i & L, Y = H ? P : n, pe = H ? n : P, ye = H ? E : n, Me = H ? n : E;
          i |= H ? M : $, i &= ~(H ? $ : M), i & S || (i &= -4);
          var De = [
            r,
            i,
            x,
            ye,
            Y,
            Me,
            pe,
            N,
            D,
            W
          ], Le = l.apply(n, De);
          return Z2(r) && Wu(Le, De), Le.placeholder = g, Hu(Le, r, i);
        }
        function k2(r) {
          var i = It[r];
          return function(l, g) {
            if (l = xn(l), g = g == null ? 0 : Tt(Oe(g), 292), g && H0(l)) {
              var x = (et(l) + "e").split("e"), E = i(x[0] + "e" + (+x[1] + g));
              return x = (et(E) + "e").split("e"), +(x[0] + "e" + (+x[1] - g));
            }
            return i(l);
          };
        }
        var hm = R1 && 1 / Lo(new R1([, -0]))[1] == se ? function(r) {
          return new R1(r);
        } : ss;
        function Tu(r) {
          return function(i) {
            var l = zt(i);
            return l == Fe ? h2(i) : l == en ? zp(i) : Sp(i, r(i));
          };
        }
        function er(r, i, l, g, x, E, P, N) {
          var D = i & I;
          if (!D && typeof r != "function")
            throw new mn(s);
          var W = g ? g.length : 0;
          if (W || (i &= -97, g = x = n), P = P === n ? P : wt(Oe(P), 0), N = N === n ? N : Oe(N), W -= x ? x.length : 0, i & $) {
            var H = g, Y = x;
            g = x = n;
          }
          var pe = D ? n : W2(r), ye = [
            r,
            i,
            l,
            g,
            x,
            H,
            Y,
            E,
            P,
            N
          ];
          if (pe && Pm(ye, pe), r = ye[0], i = ye[1], l = ye[2], g = ye[3], x = ye[4], N = ye[9] = ye[9] === n ? D ? 0 : r.length : wt(ye[9] - W, 0), !N && i & (L | R) && (i &= -25), !i || i == v)
            var Me = pm(r, i, l);
          else i == L || i == R ? Me = gm(r, i, N) : (i == M || i == (v | M)) && !x.length ? Me = mm(r, i, l, g) : Me = Ko.apply(n, ye);
          var De = pe ? du : Wu;
          return Hu(De(Me, ye), r, i);
        }
        function zu(r, i, l, g) {
          return r === n || Mn(r, L1[l]) && !rt.call(g, l) ? i : r;
        }
        function Nu(r, i, l, g, x, E) {
          return dt(r) && dt(i) && (E.set(i, r), Zo(r, i, n, Nu, E), E.delete(i)), r;
        }
        function vm(r) {
          return Gc(r) ? n : r;
        }
        function Ou(r, i, l, g, x, E) {
          var P = l & C, N = r.length, D = i.length;
          if (N != D && !(P && D > N))
            return !1;
          var W = E.get(r), H = E.get(i);
          if (W && H)
            return W == i && H == r;
          var Y = -1, pe = !0, ye = l & h ? new qr() : n;
          for (E.set(r, i), E.set(i, r); ++Y < N; ) {
            var Me = r[Y], De = i[Y];
            if (g)
              var Le = P ? g(De, Me, Y, i, r, E) : g(Me, De, Y, r, i, E);
            if (Le !== n) {
              if (Le)
                continue;
              pe = !1;
              break;
            }
            if (ye) {
              if (!u2(i, function(Ve, Xe) {
                if (!Sc(ye, Xe) && (Me === Ve || x(Me, Ve, l, g, E)))
                  return ye.push(Xe);
              })) {
                pe = !1;
                break;
              }
            } else if (!(Me === De || x(Me, De, l, g, E))) {
              pe = !1;
              break;
            }
          }
          return E.delete(r), E.delete(i), pe;
        }
        function bm(r, i, l, g, x, E, P) {
          switch (l) {
            case xr:
              if (r.byteLength != i.byteLength || r.byteOffset != i.byteOffset)
                return !1;
              r = r.buffer, i = i.buffer;
            case Cr:
              return !(r.byteLength != i.byteLength || !E(new Oo(r), new Oo(i)));
            case ne:
            case ge:
            case ut:
              return Mn(+r, +i);
            case we:
              return r.name == i.name && r.message == i.message;
            case dn:
            case Un:
              return r == i + "";
            case Fe:
              var N = h2;
            case en:
              var D = g & C;
              if (N || (N = Lo), r.size != i.size && !D)
                return !1;
              var W = P.get(r);
              if (W)
                return W == i;
              g |= h, P.set(r, i);
              var H = Ou(N(r), N(i), g, x, E, P);
              return P.delete(r), H;
            case b1:
              if (Rc)
                return Rc.call(r) == Rc.call(i);
          }
          return !1;
        }
        function Cm(r, i, l, g, x, E) {
          var P = l & C, N = B2(r), D = N.length, W = B2(i), H = W.length;
          if (D != H && !P)
            return !1;
          for (var Y = D; Y--; ) {
            var pe = N[Y];
            if (!(P ? pe in i : rt.call(i, pe)))
              return !1;
          }
          var ye = E.get(r), Me = E.get(i);
          if (ye && Me)
            return ye == i && Me == r;
          var De = !0;
          E.set(r, i), E.set(i, r);
          for (var Le = P; ++Y < D; ) {
            pe = N[Y];
            var Ve = r[pe], Xe = i[pe];
            if (g)
              var on = P ? g(Xe, Ve, pe, i, r, E) : g(Ve, Xe, pe, r, i, E);
            if (!(on === n ? Ve === Xe || x(Ve, Xe, l, g, E) : on)) {
              De = !1;
              break;
            }
            Le || (Le = pe == "constructor");
          }
          if (De && !Le) {
            var Bt = r.constructor, an = i.constructor;
            Bt != an && "constructor" in r && "constructor" in i && !(typeof Bt == "function" && Bt instanceof Bt && typeof an == "function" && an instanceof an) && (De = !1);
          }
          return E.delete(r), E.delete(i), De;
        }
        function tr(r) {
          return U2(Bu(r, n, Ju), r + "");
        }
        function B2(r) {
          return tu(r, At, j2);
        }
        function V2(r) {
          return tu(r, Ut, Fu);
        }
        var W2 = Bo ? function(r) {
          return Bo.get(r);
        } : ss;
        function ti(r) {
          for (var i = r.name + "", l = P1[i], g = rt.call(P1, i) ? l.length : 0; g--; ) {
            var x = l[g], E = x.func;
            if (E == null || E == r)
              return x.name;
          }
          return i;
        }
        function O1(r) {
          var i = rt.call(_, "placeholder") ? _ : r;
          return i.placeholder;
        }
        function Ee() {
          var r = _.iteratee || is;
          return r = r === is ? cu : r, arguments.length ? r(arguments[0], arguments[1]) : r;
        }
        function ni(r, i) {
          var l = r.__data__;
          return Em(i) ? l[typeof i == "string" ? "string" : "hash"] : l.map;
        }
        function H2(r) {
          for (var i = At(r), l = i.length; l--; ) {
            var g = i[l], x = r[g];
            i[l] = [g, x, Gu(x)];
          }
          return i;
        }
        function t1(r, i) {
          var l = Rp(r, i);
          return ru(l) ? l : n;
        }
        function xm(r) {
          var i = rt.call(r, Jr), l = r[Jr];
          try {
            r[Jr] = n;
            var g = !0;
          } catch {
          }
          var x = zo.call(r);
          return g && (i ? r[Jr] = l : delete r[Jr]), x;
        }
        var j2 = b2 ? function(r) {
          return r == null ? [] : (r = ot(r), Ir(b2(r), function(i) {
            return V0.call(r, i);
          }));
        } : ls, Fu = b2 ? function(r) {
          for (var i = []; r; )
            wr(i, j2(r)), r = Fo(r);
          return i;
        } : ls, zt = Gt;
        (C2 && zt(new C2(new ArrayBuffer(1))) != xr || Ec && zt(new Ec()) != Fe || x2 && zt(x2.resolve()) != Yn || R1 && zt(new R1()) != en || Mc && zt(new Mc()) != br) && (zt = function(r) {
          var i = Gt(r), l = i == Ct ? r.constructor : n, g = l ? n1(l) : "";
          if (g)
            switch (g) {
              case ng:
                return xr;
              case rg:
                return Fe;
              case cg:
                return Yn;
              case og:
                return en;
              case ig:
                return br;
            }
          return i;
        });
        function ym(r, i, l) {
          for (var g = -1, x = l.length; ++g < x; ) {
            var E = l[g], P = E.size;
            switch (E.type) {
              case "drop":
                r += P;
                break;
              case "dropRight":
                i -= P;
                break;
              case "take":
                i = Tt(i, r + P);
                break;
              case "takeRight":
                r = wt(r, i - P);
                break;
            }
          }
          return { start: r, end: i };
        }
        function Im(r) {
          var i = r.match(qa);
          return i ? i[1].split(T) : [];
        }
        function Du(r, i, l) {
          i = Mr(i, r);
          for (var g = -1, x = i.length, E = !1; ++g < x; ) {
            var P = On(i[g]);
            if (!(E = r != null && l(r, P)))
              break;
            r = r[P];
          }
          return E || ++g != x ? E : (x = r == null ? 0 : r.length, !!x && li(x) && nr(P, x) && (ze(r) || r1(r)));
        }
        function wm(r) {
          var i = r.length, l = new r.constructor(i);
          return i && typeof r[0] == "string" && rt.call(r, "index") && (l.index = r.index, l.input = r.input), l;
        }
        function $u(r) {
          return typeof r.constructor == "function" && !Dc(r) ? T1(Fo(r)) : {};
        }
        function Am(r, i, l) {
          var g = r.constructor;
          switch (i) {
            case Cr:
              return $2(r);
            case ne:
            case ge:
              return new g(+r);
            case xr:
              return am(r, l);
            case C1:
            case x1:
            case gc:
            case mc:
            case hc:
            case vc:
            case bc:
            case Cc:
            case xc:
              return xu(r, l);
            case Fe:
              return new g();
            case ut:
            case Un:
              return new g(r);
            case dn:
              return sm(r);
            case en:
              return new g();
            case b1:
              return lm(r);
          }
        }
        function Sm(r, i) {
          var l = i.length;
          if (!l)
            return r;
          var g = l - 1;
          return i[g] = (l > 1 ? "& " : "") + i[g], i = i.join(l > 2 ? ", " : " "), r.replace(Ka, `{
/* [wrapped with ` + i + `] */
`);
        }
        function _m(r) {
          return ze(r) || r1(r) || !!(W0 && r && r[W0]);
        }
        function nr(r, i) {
          var l = typeof r;
          return i = i ?? ee, !!i && (l == "number" || l != "symbol" && gt.test(r)) && r > -1 && r % 1 == 0 && r < i;
        }
        function kt(r, i, l) {
          if (!dt(l))
            return !1;
          var g = typeof i;
          return (g == "number" ? Yt(l) && nr(i, l.length) : g == "string" && i in l) ? Mn(l[i], r) : !1;
        }
        function X2(r, i) {
          if (ze(r))
            return !1;
          var l = typeof r;
          return l == "number" || l == "symbol" || l == "boolean" || r == null || cn(r) ? !0 : Ya.test(r) || !Ao.test(r) || i != null && r in ot(i);
        }
        function Em(r) {
          var i = typeof r;
          return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? r !== "__proto__" : r === null;
        }
        function Z2(r) {
          var i = ti(r), l = _[i];
          if (typeof l != "function" || !(i in He.prototype))
            return !1;
          if (r === l)
            return !0;
          var g = W2(l);
          return !!g && r === g[0];
        }
        function Mm(r) {
          return !!G0 && G0 in r;
        }
        var Lm = Po ? rr : us;
        function Dc(r) {
          var i = r && r.constructor, l = typeof i == "function" && i.prototype || L1;
          return r === l;
        }
        function Gu(r) {
          return r === r && !dt(r);
        }
        function ku(r, i) {
          return function(l) {
            return l == null ? !1 : l[r] === i && (i !== n || r in ot(l));
          };
        }
        function Rm(r) {
          var i = ai(r, function(g) {
            return l.size === d && l.clear(), g;
          }), l = i.cache;
          return i;
        }
        function Pm(r, i) {
          var l = r[1], g = i[1], x = l | g, E = x < (v | I | O), P = g == O && l == L || g == O && l == G && r[7].length <= i[8] || g == (O | G) && i[7].length <= i[8] && l == L;
          if (!(E || P))
            return r;
          g & v && (r[2] = i[2], x |= l & v ? 0 : S);
          var N = i[3];
          if (N) {
            var D = r[3];
            r[3] = D ? Iu(D, N, i[4]) : N, r[4] = D ? Ar(r[3], p) : i[4];
          }
          return N = i[5], N && (D = r[5], r[5] = D ? wu(D, N, i[6]) : N, r[6] = D ? Ar(r[5], p) : i[6]), N = i[7], N && (r[7] = N), g & O && (r[8] = r[8] == null ? i[8] : Tt(r[8], i[8])), r[9] == null && (r[9] = i[9]), r[0] = i[0], r[1] = x, r;
        }
        function Tm(r) {
          var i = [];
          if (r != null)
            for (var l in ot(r))
              i.push(l);
          return i;
        }
        function zm(r) {
          return zo.call(r);
        }
        function Bu(r, i, l) {
          return i = wt(i === n ? r.length - 1 : i, 0), function() {
            for (var g = arguments, x = -1, E = wt(g.length - i, 0), P = k(E); ++x < E; )
              P[x] = g[i + x];
            x = -1;
            for (var N = k(i + 1); ++x < i; )
              N[x] = g[x];
            return N[i] = l(P), tn(r, this, N);
          };
        }
        function Vu(r, i) {
          return i.length < 2 ? r : e1(r, bn(i, 0, -1));
        }
        function Nm(r, i) {
          for (var l = r.length, g = Tt(i.length, l), x = Zt(r); g--; ) {
            var E = i[g];
            r[g] = nr(E, l) ? x[E] : n;
          }
          return r;
        }
        function Y2(r, i) {
          if (!(i === "constructor" && typeof r[i] == "function") && i != "__proto__")
            return r[i];
        }
        var Wu = ju(du), $c = Up || function(r, i) {
          return Et.setTimeout(r, i);
        }, U2 = ju(rm);
        function Hu(r, i, l) {
          var g = i + "";
          return U2(r, Sm(g, Om(Im(g), l)));
        }
        function ju(r) {
          var i = 0, l = 0;
          return function() {
            var g = Qp(), x = re - (g - l);
            if (l = g, x > 0) {
              if (++i >= U)
                return arguments[0];
            } else
              i = 0;
            return r.apply(n, arguments);
          };
        }
        function ri(r, i) {
          var l = -1, g = r.length, x = g - 1;
          for (i = i === n ? g : i; ++l < i; ) {
            var E = P2(l, x), P = r[E];
            r[E] = r[l], r[l] = P;
          }
          return r.length = i, r;
        }
        var Xu = Rm(function(r) {
          var i = [];
          return r.charCodeAt(0) === 46 && i.push(""), r.replace(Ua, function(l, g, x, E) {
            i.push(x ? E.replace(Re, "$1") : g || l);
          }), i;
        });
        function On(r) {
          if (typeof r == "string" || cn(r))
            return r;
          var i = r + "";
          return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
        }
        function n1(r) {
          if (r != null) {
            try {
              return To.call(r);
            } catch {
            }
            try {
              return r + "";
            } catch {
            }
          }
          return "";
        }
        function Om(r, i) {
          return gn(le, function(l) {
            var g = "_." + l[0];
            i & l[1] && !Eo(r, g) && r.push(g);
          }), r.sort();
        }
        function Zu(r) {
          if (r instanceof He)
            return r.clone();
          var i = new hn(r.__wrapped__, r.__chain__);
          return i.__actions__ = Zt(r.__actions__), i.__index__ = r.__index__, i.__values__ = r.__values__, i;
        }
        function Fm(r, i, l) {
          (l ? kt(r, i, l) : i === n) ? i = 1 : i = wt(Oe(i), 0);
          var g = r == null ? 0 : r.length;
          if (!g || i < 1)
            return [];
          for (var x = 0, E = 0, P = k(Go(g / i)); x < g; )
            P[E++] = bn(r, x, x += i);
          return P;
        }
        function Dm(r) {
          for (var i = -1, l = r == null ? 0 : r.length, g = 0, x = []; ++i < l; ) {
            var E = r[i];
            E && (x[g++] = E);
          }
          return x;
        }
        function $m() {
          var r = arguments.length;
          if (!r)
            return [];
          for (var i = k(r - 1), l = arguments[0], g = r; g--; )
            i[g - 1] = arguments[g];
          return wr(ze(l) ? Zt(l) : [l], Mt(i, 1));
        }
        var Gm = $e(function(r, i) {
          return vt(r) ? Tc(r, Mt(i, 1, vt, !0)) : [];
        }), km = $e(function(r, i) {
          var l = Cn(i);
          return vt(l) && (l = n), vt(r) ? Tc(r, Mt(i, 1, vt, !0), Ee(l, 2)) : [];
        }), Bm = $e(function(r, i) {
          var l = Cn(i);
          return vt(l) && (l = n), vt(r) ? Tc(r, Mt(i, 1, vt, !0), n, l) : [];
        });
        function Vm(r, i, l) {
          var g = r == null ? 0 : r.length;
          return g ? (i = l || i === n ? 1 : Oe(i), bn(r, i < 0 ? 0 : i, g)) : [];
        }
        function Wm(r, i, l) {
          var g = r == null ? 0 : r.length;
          return g ? (i = l || i === n ? 1 : Oe(i), i = g - i, bn(r, 0, i < 0 ? 0 : i)) : [];
        }
        function Hm(r, i) {
          return r && r.length ? Uo(r, Ee(i, 3), !0, !0) : [];
        }
        function jm(r, i) {
          return r && r.length ? Uo(r, Ee(i, 3), !0) : [];
        }
        function Xm(r, i, l, g) {
          var x = r == null ? 0 : r.length;
          return x ? (l && typeof l != "number" && kt(r, i, l) && (l = 0, g = x), $g(r, i, l, g)) : [];
        }
        function Yu(r, i, l) {
          var g = r == null ? 0 : r.length;
          if (!g)
            return -1;
          var x = l == null ? 0 : Oe(l);
          return x < 0 && (x = wt(g + x, 0)), Mo(r, Ee(i, 3), x);
        }
        function Uu(r, i, l) {
          var g = r == null ? 0 : r.length;
          if (!g)
            return -1;
          var x = g - 1;
          return l !== n && (x = Oe(l), x = l < 0 ? wt(g + x, 0) : Tt(x, g - 1)), Mo(r, Ee(i, 3), x, !0);
        }
        function Ju(r) {
          var i = r == null ? 0 : r.length;
          return i ? Mt(r, 1) : [];
        }
        function Zm(r) {
          var i = r == null ? 0 : r.length;
          return i ? Mt(r, se) : [];
        }
        function Ym(r, i) {
          var l = r == null ? 0 : r.length;
          return l ? (i = i === n ? 1 : Oe(i), Mt(r, i)) : [];
        }
        function Um(r) {
          for (var i = -1, l = r == null ? 0 : r.length, g = {}; ++i < l; ) {
            var x = r[i];
            g[x[0]] = x[1];
          }
          return g;
        }
        function Ku(r) {
          return r && r.length ? r[0] : n;
        }
        function Jm(r, i, l) {
          var g = r == null ? 0 : r.length;
          if (!g)
            return -1;
          var x = l == null ? 0 : Oe(l);
          return x < 0 && (x = wt(g + x, 0)), S1(r, i, x);
        }
        function Km(r) {
          var i = r == null ? 0 : r.length;
          return i ? bn(r, 0, -1) : [];
        }
        var qm = $e(function(r) {
          var i = lt(r, F2);
          return i.length && i[0] === r[0] ? _2(i) : [];
        }), Qm = $e(function(r) {
          var i = Cn(r), l = lt(r, F2);
          return i === Cn(l) ? i = n : l.pop(), l.length && l[0] === r[0] ? _2(l, Ee(i, 2)) : [];
        }), eh = $e(function(r) {
          var i = Cn(r), l = lt(r, F2);
          return i = typeof i == "function" ? i : n, i && l.pop(), l.length && l[0] === r[0] ? _2(l, n, i) : [];
        });
        function th(r, i) {
          return r == null ? "" : Kp.call(r, i);
        }
        function Cn(r) {
          var i = r == null ? 0 : r.length;
          return i ? r[i - 1] : n;
        }
        function nh(r, i, l) {
          var g = r == null ? 0 : r.length;
          if (!g)
            return -1;
          var x = g;
          return l !== n && (x = Oe(l), x = x < 0 ? wt(g + x, 0) : Tt(x, g - 1)), i === i ? Op(r, i, x) : Mo(r, P0, x, !0);
        }
        function rh(r, i) {
          return r && r.length ? su(r, Oe(i)) : n;
        }
        var ch = $e(qu);
        function qu(r, i) {
          return r && r.length && i && i.length ? R2(r, i) : r;
        }
        function oh(r, i, l) {
          return r && r.length && i && i.length ? R2(r, i, Ee(l, 2)) : r;
        }
        function ih(r, i, l) {
          return r && r.length && i && i.length ? R2(r, i, n, l) : r;
        }
        var ah = tr(function(r, i) {
          var l = r == null ? 0 : r.length, g = I2(r, i);
          return fu(r, lt(i, function(x) {
            return nr(x, l) ? +x : x;
          }).sort(yu)), g;
        });
        function sh(r, i) {
          var l = [];
          if (!(r && r.length))
            return l;
          var g = -1, x = [], E = r.length;
          for (i = Ee(i, 3); ++g < E; ) {
            var P = r[g];
            i(P, g, r) && (l.push(P), x.push(g));
          }
          return fu(r, x), l;
        }
        function J2(r) {
          return r == null ? r : tg.call(r);
        }
        function lh(r, i, l) {
          var g = r == null ? 0 : r.length;
          return g ? (l && typeof l != "number" && kt(r, i, l) ? (i = 0, l = g) : (i = i == null ? 0 : Oe(i), l = l === n ? g : Oe(l)), bn(r, i, l)) : [];
        }
        function uh(r, i) {
          return Yo(r, i);
        }
        function fh(r, i, l) {
          return z2(r, i, Ee(l, 2));
        }
        function dh(r, i) {
          var l = r == null ? 0 : r.length;
          if (l) {
            var g = Yo(r, i);
            if (g < l && Mn(r[g], i))
              return g;
          }
          return -1;
        }
        function ph(r, i) {
          return Yo(r, i, !0);
        }
        function gh(r, i, l) {
          return z2(r, i, Ee(l, 2), !0);
        }
        function mh(r, i) {
          var l = r == null ? 0 : r.length;
          if (l) {
            var g = Yo(r, i, !0) - 1;
            if (Mn(r[g], i))
              return g;
          }
          return -1;
        }
        function hh(r) {
          return r && r.length ? pu(r) : [];
        }
        function vh(r, i) {
          return r && r.length ? pu(r, Ee(i, 2)) : [];
        }
        function bh(r) {
          var i = r == null ? 0 : r.length;
          return i ? bn(r, 1, i) : [];
        }
        function Ch(r, i, l) {
          return r && r.length ? (i = l || i === n ? 1 : Oe(i), bn(r, 0, i < 0 ? 0 : i)) : [];
        }
        function xh(r, i, l) {
          var g = r == null ? 0 : r.length;
          return g ? (i = l || i === n ? 1 : Oe(i), i = g - i, bn(r, i < 0 ? 0 : i, g)) : [];
        }
        function yh(r, i) {
          return r && r.length ? Uo(r, Ee(i, 3), !1, !0) : [];
        }
        function Ih(r, i) {
          return r && r.length ? Uo(r, Ee(i, 3)) : [];
        }
        var wh = $e(function(r) {
          return Er(Mt(r, 1, vt, !0));
        }), Ah = $e(function(r) {
          var i = Cn(r);
          return vt(i) && (i = n), Er(Mt(r, 1, vt, !0), Ee(i, 2));
        }), Sh = $e(function(r) {
          var i = Cn(r);
          return i = typeof i == "function" ? i : n, Er(Mt(r, 1, vt, !0), n, i);
        });
        function _h(r) {
          return r && r.length ? Er(r) : [];
        }
        function Eh(r, i) {
          return r && r.length ? Er(r, Ee(i, 2)) : [];
        }
        function Mh(r, i) {
          return i = typeof i == "function" ? i : n, r && r.length ? Er(r, n, i) : [];
        }
        function K2(r) {
          if (!(r && r.length))
            return [];
          var i = 0;
          return r = Ir(r, function(l) {
            if (vt(l))
              return i = wt(l.length, i), !0;
          }), g2(i, function(l) {
            return lt(r, f2(l));
          });
        }
        function Qu(r, i) {
          if (!(r && r.length))
            return [];
          var l = K2(r);
          return i == null ? l : lt(l, function(g) {
            return tn(i, n, g);
          });
        }
        var Lh = $e(function(r, i) {
          return vt(r) ? Tc(r, i) : [];
        }), Rh = $e(function(r) {
          return O2(Ir(r, vt));
        }), Ph = $e(function(r) {
          var i = Cn(r);
          return vt(i) && (i = n), O2(Ir(r, vt), Ee(i, 2));
        }), Th = $e(function(r) {
          var i = Cn(r);
          return i = typeof i == "function" ? i : n, O2(Ir(r, vt), n, i);
        }), zh = $e(K2);
        function Nh(r, i) {
          return vu(r || [], i || [], Pc);
        }
        function Oh(r, i) {
          return vu(r || [], i || [], Oc);
        }
        var Fh = $e(function(r) {
          var i = r.length, l = i > 1 ? r[i - 1] : n;
          return l = typeof l == "function" ? (r.pop(), l) : n, Qu(r, l);
        });
        function e3(r) {
          var i = _(r);
          return i.__chain__ = !0, i;
        }
        function Dh(r, i) {
          return i(r), r;
        }
        function ci(r, i) {
          return i(r);
        }
        var $h = tr(function(r) {
          var i = r.length, l = i ? r[0] : 0, g = this.__wrapped__, x = function(E) {
            return I2(E, r);
          };
          return i > 1 || this.__actions__.length || !(g instanceof He) || !nr(l) ? this.thru(x) : (g = g.slice(l, +l + (i ? 1 : 0)), g.__actions__.push({
            func: ci,
            args: [x],
            thisArg: n
          }), new hn(g, this.__chain__).thru(function(E) {
            return i && !E.length && E.push(n), E;
          }));
        });
        function Gh() {
          return e3(this);
        }
        function kh() {
          return new hn(this.value(), this.__chain__);
        }
        function Bh() {
          this.__values__ === n && (this.__values__ = g3(this.value()));
          var r = this.__index__ >= this.__values__.length, i = r ? n : this.__values__[this.__index__++];
          return { done: r, value: i };
        }
        function Vh() {
          return this;
        }
        function Wh(r) {
          for (var i, l = this; l instanceof Wo; ) {
            var g = Zu(l);
            g.__index__ = 0, g.__values__ = n, i ? x.__wrapped__ = g : i = g;
            var x = g;
            l = l.__wrapped__;
          }
          return x.__wrapped__ = r, i;
        }
        function Hh() {
          var r = this.__wrapped__;
          if (r instanceof He) {
            var i = r;
            return this.__actions__.length && (i = new He(this)), i = i.reverse(), i.__actions__.push({
              func: ci,
              args: [J2],
              thisArg: n
            }), new hn(i, this.__chain__);
          }
          return this.thru(J2);
        }
        function jh() {
          return hu(this.__wrapped__, this.__actions__);
        }
        var Xh = Jo(function(r, i, l) {
          rt.call(r, l) ? ++r[l] : Qn(r, l, 1);
        });
        function Zh(r, i, l) {
          var g = ze(r) ? L0 : Dg;
          return l && kt(r, i, l) && (i = n), g(r, Ee(i, 3));
        }
        function Yh(r, i) {
          var l = ze(r) ? Ir : Q0;
          return l(r, Ee(i, 3));
        }
        var Uh = Eu(Yu), Jh = Eu(Uu);
        function Kh(r, i) {
          return Mt(oi(r, i), 1);
        }
        function qh(r, i) {
          return Mt(oi(r, i), se);
        }
        function Qh(r, i, l) {
          return l = l === n ? 1 : Oe(l), Mt(oi(r, i), l);
        }
        function t3(r, i) {
          var l = ze(r) ? gn : _r;
          return l(r, Ee(i, 3));
        }
        function n3(r, i) {
          var l = ze(r) ? bp : q0;
          return l(r, Ee(i, 3));
        }
        var ev = Jo(function(r, i, l) {
          rt.call(r, l) ? r[l].push(i) : Qn(r, l, [i]);
        });
        function tv(r, i, l, g) {
          r = Yt(r) ? r : D1(r), l = l && !g ? Oe(l) : 0;
          var x = r.length;
          return l < 0 && (l = wt(x + l, 0)), ui(r) ? l <= x && r.indexOf(i, l) > -1 : !!x && S1(r, i, l) > -1;
        }
        var nv = $e(function(r, i, l) {
          var g = -1, x = typeof i == "function", E = Yt(r) ? k(r.length) : [];
          return _r(r, function(P) {
            E[++g] = x ? tn(i, P, l) : zc(P, i, l);
          }), E;
        }), rv = Jo(function(r, i, l) {
          Qn(r, l, i);
        });
        function oi(r, i) {
          var l = ze(r) ? lt : ou;
          return l(r, Ee(i, 3));
        }
        function cv(r, i, l, g) {
          return r == null ? [] : (ze(i) || (i = i == null ? [] : [i]), l = g ? n : l, ze(l) || (l = l == null ? [] : [l]), lu(r, i, l));
        }
        var ov = Jo(function(r, i, l) {
          r[l ? 0 : 1].push(i);
        }, function() {
          return [[], []];
        });
        function iv(r, i, l) {
          var g = ze(r) ? l2 : z0, x = arguments.length < 3;
          return g(r, Ee(i, 4), l, x, _r);
        }
        function av(r, i, l) {
          var g = ze(r) ? Cp : z0, x = arguments.length < 3;
          return g(r, Ee(i, 4), l, x, q0);
        }
        function sv(r, i) {
          var l = ze(r) ? Ir : Q0;
          return l(r, si(Ee(i, 3)));
        }
        function lv(r) {
          var i = ze(r) ? Y0 : tm;
          return i(r);
        }
        function uv(r, i, l) {
          (l ? kt(r, i, l) : i === n) ? i = 1 : i = Oe(i);
          var g = ze(r) ? Tg : nm;
          return g(r, i);
        }
        function fv(r) {
          var i = ze(r) ? zg : cm;
          return i(r);
        }
        function dv(r) {
          if (r == null)
            return 0;
          if (Yt(r))
            return ui(r) ? E1(r) : r.length;
          var i = zt(r);
          return i == Fe || i == en ? r.size : M2(r).length;
        }
        function pv(r, i, l) {
          var g = ze(r) ? u2 : om;
          return l && kt(r, i, l) && (i = n), g(r, Ee(i, 3));
        }
        var gv = $e(function(r, i) {
          if (r == null)
            return [];
          var l = i.length;
          return l > 1 && kt(r, i[0], i[1]) ? i = [] : l > 2 && kt(i[0], i[1], i[2]) && (i = [i[0]]), lu(r, Mt(i, 1), []);
        }), ii = Yp || function() {
          return Et.Date.now();
        };
        function mv(r, i) {
          if (typeof i != "function")
            throw new mn(s);
          return r = Oe(r), function() {
            if (--r < 1)
              return i.apply(this, arguments);
          };
        }
        function r3(r, i, l) {
          return i = l ? n : i, i = r && i == null ? r.length : i, er(r, O, n, n, n, n, i);
        }
        function c3(r, i) {
          var l;
          if (typeof i != "function")
            throw new mn(s);
          return r = Oe(r), function() {
            return --r > 0 && (l = i.apply(this, arguments)), r <= 1 && (i = n), l;
          };
        }
        var q2 = $e(function(r, i, l) {
          var g = v;
          if (l.length) {
            var x = Ar(l, O1(q2));
            g |= M;
          }
          return er(r, g, i, l, x);
        }), o3 = $e(function(r, i, l) {
          var g = v | I;
          if (l.length) {
            var x = Ar(l, O1(o3));
            g |= M;
          }
          return er(i, g, r, l, x);
        });
        function i3(r, i, l) {
          i = l ? n : i;
          var g = er(r, L, n, n, n, n, n, i);
          return g.placeholder = i3.placeholder, g;
        }
        function a3(r, i, l) {
          i = l ? n : i;
          var g = er(r, R, n, n, n, n, n, i);
          return g.placeholder = a3.placeholder, g;
        }
        function s3(r, i, l) {
          var g, x, E, P, N, D, W = 0, H = !1, Y = !1, pe = !0;
          if (typeof r != "function")
            throw new mn(s);
          i = xn(i) || 0, dt(l) && (H = !!l.leading, Y = "maxWait" in l, E = Y ? wt(xn(l.maxWait) || 0, i) : E, pe = "trailing" in l ? !!l.trailing : pe);
          function ye(bt) {
            var Ln = g, or = x;
            return g = x = n, W = bt, P = r.apply(or, Ln), P;
          }
          function Me(bt) {
            return W = bt, N = $c(Ve, i), H ? ye(bt) : P;
          }
          function De(bt) {
            var Ln = bt - D, or = bt - W, E3 = i - Ln;
            return Y ? Tt(E3, E - or) : E3;
          }
          function Le(bt) {
            var Ln = bt - D, or = bt - W;
            return D === n || Ln >= i || Ln < 0 || Y && or >= E;
          }
          function Ve() {
            var bt = ii();
            if (Le(bt))
              return Xe(bt);
            N = $c(Ve, De(bt));
          }
          function Xe(bt) {
            return N = n, pe && g ? ye(bt) : (g = x = n, P);
          }
          function on() {
            N !== n && bu(N), W = 0, g = D = x = N = n;
          }
          function Bt() {
            return N === n ? P : Xe(ii());
          }
          function an() {
            var bt = ii(), Ln = Le(bt);
            if (g = arguments, x = this, D = bt, Ln) {
              if (N === n)
                return Me(D);
              if (Y)
                return bu(N), N = $c(Ve, i), ye(D);
            }
            return N === n && (N = $c(Ve, i)), P;
          }
          return an.cancel = on, an.flush = Bt, an;
        }
        var hv = $e(function(r, i) {
          return K0(r, 1, i);
        }), vv = $e(function(r, i, l) {
          return K0(r, xn(i) || 0, l);
        });
        function bv(r) {
          return er(r, J);
        }
        function ai(r, i) {
          if (typeof r != "function" || i != null && typeof i != "function")
            throw new mn(s);
          var l = function() {
            var g = arguments, x = i ? i.apply(this, g) : g[0], E = l.cache;
            if (E.has(x))
              return E.get(x);
            var P = r.apply(this, g);
            return l.cache = E.set(x, P) || E, P;
          };
          return l.cache = new (ai.Cache || qn)(), l;
        }
        ai.Cache = qn;
        function si(r) {
          if (typeof r != "function")
            throw new mn(s);
          return function() {
            var i = arguments;
            switch (i.length) {
              case 0:
                return !r.call(this);
              case 1:
                return !r.call(this, i[0]);
              case 2:
                return !r.call(this, i[0], i[1]);
              case 3:
                return !r.call(this, i[0], i[1], i[2]);
            }
            return !r.apply(this, i);
          };
        }
        function Cv(r) {
          return c3(2, r);
        }
        var xv = im(function(r, i) {
          i = i.length == 1 && ze(i[0]) ? lt(i[0], nn(Ee())) : lt(Mt(i, 1), nn(Ee()));
          var l = i.length;
          return $e(function(g) {
            for (var x = -1, E = Tt(g.length, l); ++x < E; )
              g[x] = i[x].call(this, g[x]);
            return tn(r, this, g);
          });
        }), Q2 = $e(function(r, i) {
          var l = Ar(i, O1(Q2));
          return er(r, M, n, i, l);
        }), l3 = $e(function(r, i) {
          var l = Ar(i, O1(l3));
          return er(r, $, n, i, l);
        }), yv = tr(function(r, i) {
          return er(r, G, n, n, n, i);
        });
        function Iv(r, i) {
          if (typeof r != "function")
            throw new mn(s);
          return i = i === n ? i : Oe(i), $e(r, i);
        }
        function wv(r, i) {
          if (typeof r != "function")
            throw new mn(s);
          return i = i == null ? 0 : wt(Oe(i), 0), $e(function(l) {
            var g = l[i], x = Lr(l, 0, i);
            return g && wr(x, g), tn(r, this, x);
          });
        }
        function Av(r, i, l) {
          var g = !0, x = !0;
          if (typeof r != "function")
            throw new mn(s);
          return dt(l) && (g = "leading" in l ? !!l.leading : g, x = "trailing" in l ? !!l.trailing : x), s3(r, i, {
            leading: g,
            maxWait: i,
            trailing: x
          });
        }
        function Sv(r) {
          return r3(r, 1);
        }
        function _v(r, i) {
          return Q2(D2(i), r);
        }
        function Ev() {
          if (!arguments.length)
            return [];
          var r = arguments[0];
          return ze(r) ? r : [r];
        }
        function Mv(r) {
          return vn(r, y);
        }
        function Lv(r, i) {
          return i = typeof i == "function" ? i : n, vn(r, y, i);
        }
        function Rv(r) {
          return vn(r, m | y);
        }
        function Pv(r, i) {
          return i = typeof i == "function" ? i : n, vn(r, m | y, i);
        }
        function Tv(r, i) {
          return i == null || J0(r, i, At(i));
        }
        function Mn(r, i) {
          return r === i || r !== r && i !== i;
        }
        var zv = ei(S2), Nv = ei(function(r, i) {
          return r >= i;
        }), r1 = nu(/* @__PURE__ */ function() {
          return arguments;
        }()) ? nu : function(r) {
          return mt(r) && rt.call(r, "callee") && !V0.call(r, "callee");
        }, ze = k.isArray, Ov = w0 ? nn(w0) : Wg;
        function Yt(r) {
          return r != null && li(r.length) && !rr(r);
        }
        function vt(r) {
          return mt(r) && Yt(r);
        }
        function Fv(r) {
          return r === !0 || r === !1 || mt(r) && Gt(r) == ne;
        }
        var Rr = Jp || us, Dv = A0 ? nn(A0) : Hg;
        function $v(r) {
          return mt(r) && r.nodeType === 1 && !Gc(r);
        }
        function Gv(r) {
          if (r == null)
            return !0;
          if (Yt(r) && (ze(r) || typeof r == "string" || typeof r.splice == "function" || Rr(r) || F1(r) || r1(r)))
            return !r.length;
          var i = zt(r);
          if (i == Fe || i == en)
            return !r.size;
          if (Dc(r))
            return !M2(r).length;
          for (var l in r)
            if (rt.call(r, l))
              return !1;
          return !0;
        }
        function kv(r, i) {
          return Nc(r, i);
        }
        function Bv(r, i, l) {
          l = typeof l == "function" ? l : n;
          var g = l ? l(r, i) : n;
          return g === n ? Nc(r, i, n, l) : !!g;
        }
        function es(r) {
          if (!mt(r))
            return !1;
          var i = Gt(r);
          return i == we || i == me || typeof r.message == "string" && typeof r.name == "string" && !Gc(r);
        }
        function Vv(r) {
          return typeof r == "number" && H0(r);
        }
        function rr(r) {
          if (!dt(r))
            return !1;
          var i = Gt(r);
          return i == j || i == Be || i == Z || i == Qt;
        }
        function u3(r) {
          return typeof r == "number" && r == Oe(r);
        }
        function li(r) {
          return typeof r == "number" && r > -1 && r % 1 == 0 && r <= ee;
        }
        function dt(r) {
          var i = typeof r;
          return r != null && (i == "object" || i == "function");
        }
        function mt(r) {
          return r != null && typeof r == "object";
        }
        var f3 = S0 ? nn(S0) : Xg;
        function Wv(r, i) {
          return r === i || E2(r, i, H2(i));
        }
        function Hv(r, i, l) {
          return l = typeof l == "function" ? l : n, E2(r, i, H2(i), l);
        }
        function jv(r) {
          return d3(r) && r != +r;
        }
        function Xv(r) {
          if (Lm(r))
            throw new Pe(a);
          return ru(r);
        }
        function Zv(r) {
          return r === null;
        }
        function Yv(r) {
          return r == null;
        }
        function d3(r) {
          return typeof r == "number" || mt(r) && Gt(r) == ut;
        }
        function Gc(r) {
          if (!mt(r) || Gt(r) != Ct)
            return !1;
          var i = Fo(r);
          if (i === null)
            return !0;
          var l = rt.call(i, "constructor") && i.constructor;
          return typeof l == "function" && l instanceof l && To.call(l) == Hp;
        }
        var ts = _0 ? nn(_0) : Zg;
        function Uv(r) {
          return u3(r) && r >= -9007199254740991 && r <= ee;
        }
        var p3 = E0 ? nn(E0) : Yg;
        function ui(r) {
          return typeof r == "string" || !ze(r) && mt(r) && Gt(r) == Un;
        }
        function cn(r) {
          return typeof r == "symbol" || mt(r) && Gt(r) == b1;
        }
        var F1 = M0 ? nn(M0) : Ug;
        function Jv(r) {
          return r === n;
        }
        function Kv(r) {
          return mt(r) && zt(r) == br;
        }
        function qv(r) {
          return mt(r) && Gt(r) == xo;
        }
        var Qv = ei(L2), eb = ei(function(r, i) {
          return r <= i;
        });
        function g3(r) {
          if (!r)
            return [];
          if (Yt(r))
            return ui(r) ? _n(r) : Zt(r);
          if (_c && r[_c])
            return Tp(r[_c]());
          var i = zt(r), l = i == Fe ? h2 : i == en ? Lo : D1;
          return l(r);
        }
        function cr(r) {
          if (!r)
            return r === 0 ? r : 0;
          if (r = xn(r), r === se || r === -1 / 0) {
            var i = r < 0 ? -1 : 1;
            return i * q;
          }
          return r === r ? r : 0;
        }
        function Oe(r) {
          var i = cr(r), l = i % 1;
          return i === i ? l ? i - l : i : 0;
        }
        function m3(r) {
          return r ? Qr(Oe(r), 0, X) : 0;
        }
        function xn(r) {
          if (typeof r == "number")
            return r;
          if (cn(r))
            return B;
          if (dt(r)) {
            var i = typeof r.valueOf == "function" ? r.valueOf() : r;
            r = dt(i) ? i + "" : i;
          }
          if (typeof r != "string")
            return r === 0 ? r : +r;
          r = N0(r);
          var l = Ge.test(r);
          return l || ft.test(r) ? mp(r.slice(2), l ? 2 : 8) : We.test(r) ? B : +r;
        }
        function h3(r) {
          return Nn(r, Ut(r));
        }
        function tb(r) {
          return r ? Qr(Oe(r), -9007199254740991, ee) : r === 0 ? r : 0;
        }
        function et(r) {
          return r == null ? "" : rn(r);
        }
        var nb = z1(function(r, i) {
          if (Dc(i) || Yt(i)) {
            Nn(i, At(i), r);
            return;
          }
          for (var l in i)
            rt.call(i, l) && Pc(r, l, i[l]);
        }), v3 = z1(function(r, i) {
          Nn(i, Ut(i), r);
        }), fi = z1(function(r, i, l, g) {
          Nn(i, Ut(i), r, g);
        }), rb = z1(function(r, i, l, g) {
          Nn(i, At(i), r, g);
        }), cb = tr(I2);
        function ob(r, i) {
          var l = T1(r);
          return i == null ? l : U0(l, i);
        }
        var ib = $e(function(r, i) {
          r = ot(r);
          var l = -1, g = i.length, x = g > 2 ? i[2] : n;
          for (x && kt(i[0], i[1], x) && (g = 1); ++l < g; )
            for (var E = i[l], P = Ut(E), N = -1, D = P.length; ++N < D; ) {
              var W = P[N], H = r[W];
              (H === n || Mn(H, L1[W]) && !rt.call(r, W)) && (r[W] = E[W]);
            }
          return r;
        }), ab = $e(function(r) {
          return r.push(n, Nu), tn(b3, n, r);
        });
        function sb(r, i) {
          return R0(r, Ee(i, 3), zn);
        }
        function lb(r, i) {
          return R0(r, Ee(i, 3), A2);
        }
        function ub(r, i) {
          return r == null ? r : w2(r, Ee(i, 3), Ut);
        }
        function fb(r, i) {
          return r == null ? r : eu(r, Ee(i, 3), Ut);
        }
        function db(r, i) {
          return r && zn(r, Ee(i, 3));
        }
        function pb(r, i) {
          return r && A2(r, Ee(i, 3));
        }
        function gb(r) {
          return r == null ? [] : Xo(r, At(r));
        }
        function mb(r) {
          return r == null ? [] : Xo(r, Ut(r));
        }
        function ns(r, i, l) {
          var g = r == null ? n : e1(r, i);
          return g === n ? l : g;
        }
        function hb(r, i) {
          return r != null && Du(r, i, Gg);
        }
        function rs(r, i) {
          return r != null && Du(r, i, kg);
        }
        var vb = Lu(function(r, i, l) {
          i != null && typeof i.toString != "function" && (i = zo.call(i)), r[i] = l;
        }, os(Jt)), bb = Lu(function(r, i, l) {
          i != null && typeof i.toString != "function" && (i = zo.call(i)), rt.call(r, i) ? r[i].push(l) : r[i] = [l];
        }, Ee), Cb = $e(zc);
        function At(r) {
          return Yt(r) ? Z0(r) : M2(r);
        }
        function Ut(r) {
          return Yt(r) ? Z0(r, !0) : Jg(r);
        }
        function xb(r, i) {
          var l = {};
          return i = Ee(i, 3), zn(r, function(g, x, E) {
            Qn(l, i(g, x, E), g);
          }), l;
        }
        function yb(r, i) {
          var l = {};
          return i = Ee(i, 3), zn(r, function(g, x, E) {
            Qn(l, x, i(g, x, E));
          }), l;
        }
        var Ib = z1(function(r, i, l) {
          Zo(r, i, l);
        }), b3 = z1(function(r, i, l, g) {
          Zo(r, i, l, g);
        }), wb = tr(function(r, i) {
          var l = {};
          if (r == null)
            return l;
          var g = !1;
          i = lt(i, function(E) {
            return E = Mr(E, r), g || (g = E.length > 1), E;
          }), Nn(r, V2(r), l), g && (l = vn(l, m | b | y, vm));
          for (var x = i.length; x--; )
            N2(l, i[x]);
          return l;
        });
        function Ab(r, i) {
          return C3(r, si(Ee(i)));
        }
        var Sb = tr(function(r, i) {
          return r == null ? {} : qg(r, i);
        });
        function C3(r, i) {
          if (r == null)
            return {};
          var l = lt(V2(r), function(g) {
            return [g];
          });
          return i = Ee(i), uu(r, l, function(g, x) {
            return i(g, x[0]);
          });
        }
        function _b(r, i, l) {
          i = Mr(i, r);
          var g = -1, x = i.length;
          for (x || (x = 1, r = n); ++g < x; ) {
            var E = r == null ? n : r[On(i[g])];
            E === n && (g = x, E = l), r = rr(E) ? E.call(r) : E;
          }
          return r;
        }
        function Eb(r, i, l) {
          return r == null ? r : Oc(r, i, l);
        }
        function Mb(r, i, l, g) {
          return g = typeof g == "function" ? g : n, r == null ? r : Oc(r, i, l, g);
        }
        var x3 = Tu(At), y3 = Tu(Ut);
        function Lb(r, i, l) {
          var g = ze(r), x = g || Rr(r) || F1(r);
          if (i = Ee(i, 4), l == null) {
            var E = r && r.constructor;
            x ? l = g ? new E() : [] : dt(r) ? l = rr(E) ? T1(Fo(r)) : {} : l = {};
          }
          return (x ? gn : zn)(r, function(P, N, D) {
            return i(l, P, N, D);
          }), l;
        }
        function Rb(r, i) {
          return r == null ? !0 : N2(r, i);
        }
        function Pb(r, i, l) {
          return r == null ? r : mu(r, i, D2(l));
        }
        function Tb(r, i, l, g) {
          return g = typeof g == "function" ? g : n, r == null ? r : mu(r, i, D2(l), g);
        }
        function D1(r) {
          return r == null ? [] : m2(r, At(r));
        }
        function zb(r) {
          return r == null ? [] : m2(r, Ut(r));
        }
        function Nb(r, i, l) {
          return l === n && (l = i, i = n), l !== n && (l = xn(l), l = l === l ? l : 0), i !== n && (i = xn(i), i = i === i ? i : 0), Qr(xn(r), i, l);
        }
        function Ob(r, i, l) {
          return i = cr(i), l === n ? (l = i, i = 0) : l = cr(l), r = xn(r), Bg(r, i, l);
        }
        function Fb(r, i, l) {
          if (l && typeof l != "boolean" && kt(r, i, l) && (i = l = n), l === n && (typeof i == "boolean" ? (l = i, i = n) : typeof r == "boolean" && (l = r, r = n)), r === n && i === n ? (r = 0, i = 1) : (r = cr(r), i === n ? (i = r, r = 0) : i = cr(i)), r > i) {
            var g = r;
            r = i, i = g;
          }
          if (l || r % 1 || i % 1) {
            var x = j0();
            return Tt(r + x * (i - r + gp("1e-" + ((x + "").length - 1))), i);
          }
          return P2(r, i);
        }
        var Db = N1(function(r, i, l) {
          return i = i.toLowerCase(), r + (l ? I3(i) : i);
        });
        function I3(r) {
          return cs(et(r).toLowerCase());
        }
        function w3(r) {
          return r = et(r), r && r.replace(Xt, Ep).replace(cp, "");
        }
        function $b(r, i, l) {
          r = et(r), i = rn(i);
          var g = r.length;
          l = l === n ? g : Qr(Oe(l), 0, g);
          var x = l;
          return l -= i.length, l >= 0 && r.slice(l, x) == i;
        }
        function Gb(r) {
          return r = et(r), r && Xa.test(r) ? r.replace(I1, Mp) : r;
        }
        function kb(r) {
          return r = et(r), r && So.test(r) ? r.replace(w1, "\\$&") : r;
        }
        var Bb = N1(function(r, i, l) {
          return r + (l ? "-" : "") + i.toLowerCase();
        }), Vb = N1(function(r, i, l) {
          return r + (l ? " " : "") + i.toLowerCase();
        }), Wb = _u("toLowerCase");
        function Hb(r, i, l) {
          r = et(r), i = Oe(i);
          var g = i ? E1(r) : 0;
          if (!i || g >= i)
            return r;
          var x = (i - g) / 2;
          return Qo(ko(x), l) + r + Qo(Go(x), l);
        }
        function jb(r, i, l) {
          r = et(r), i = Oe(i);
          var g = i ? E1(r) : 0;
          return i && g < i ? r + Qo(i - g, l) : r;
        }
        function Xb(r, i, l) {
          r = et(r), i = Oe(i);
          var g = i ? E1(r) : 0;
          return i && g < i ? Qo(i - g, l) + r : r;
        }
        function Zb(r, i, l) {
          return l || i == null ? i = 0 : i && (i = +i), eg(et(r).replace(wc, ""), i || 0);
        }
        function Yb(r, i, l) {
          return (l ? kt(r, i, l) : i === n) ? i = 1 : i = Oe(i), T2(et(r), i);
        }
        function Ub() {
          var r = arguments, i = et(r[0]);
          return r.length < 3 ? i : i.replace(r[1], r[2]);
        }
        var Jb = N1(function(r, i, l) {
          return r + (l ? "_" : "") + i.toLowerCase();
        });
        function Kb(r, i, l) {
          return l && typeof l != "number" && kt(r, i, l) && (i = l = n), l = l === n ? X : l >>> 0, l ? (r = et(r), r && (typeof i == "string" || i != null && !ts(i)) && (i = rn(i), !i && _1(r)) ? Lr(_n(r), 0, l) : r.split(i, l)) : [];
        }
        var qb = N1(function(r, i, l) {
          return r + (l ? " " : "") + cs(i);
        });
        function Qb(r, i, l) {
          return r = et(r), l = l == null ? 0 : Qr(Oe(l), 0, r.length), i = rn(i), r.slice(l, l + i.length) == i;
        }
        function eC(r, i, l) {
          var g = _.templateSettings;
          l && kt(r, i, l) && (i = n), r = et(r), i = fi({}, i, g, zu);
          var x = fi({}, i.imports, g.imports, zu), E = At(x), P = m2(x, E), N, D, W = 0, H = i.interpolate || Sn, Y = "__p += '", pe = v2(
            (i.escape || Sn).source + "|" + H.source + "|" + (H === Ic ? Ye : Sn).source + "|" + (i.evaluate || Sn).source + "|$",
            "g"
          ), ye = "//# sourceURL=" + (rt.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++lp + "]") + `
`;
          r.replace(pe, function(Le, Ve, Xe, on, Bt, an) {
            return Xe || (Xe = on), Y += r.slice(W, an).replace(Jn, Lp), Ve && (N = !0, Y += `' +
__e(` + Ve + `) +
'`), Bt && (D = !0, Y += `';
` + Bt + `;
__p += '`), Xe && (Y += `' +
((__t = (` + Xe + `)) == null ? '' : __t) +
'`), W = an + Le.length, Le;
          }), Y += `';
`;
          var Me = rt.call(i, "variable") && i.variable;
          if (!Me)
            Y = `with (obj) {
` + Y + `
}
`;
          else if (be.test(Me))
            throw new Pe(u);
          Y = (D ? Y.replace(yc, "") : Y).replace(yo, "$1").replace(yr, "$1;"), Y = "function(" + (Me || "obj") + `) {
` + (Me ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N ? ", __e = _.escape" : "") + (D ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Y + `return __p
}`;
          var De = S3(function() {
            return Ue(E, ye + "return " + Y).apply(n, P);
          });
          if (De.source = Y, es(De))
            throw De;
          return De;
        }
        function tC(r) {
          return et(r).toLowerCase();
        }
        function nC(r) {
          return et(r).toUpperCase();
        }
        function rC(r, i, l) {
          if (r = et(r), r && (l || i === n))
            return N0(r);
          if (!r || !(i = rn(i)))
            return r;
          var g = _n(r), x = _n(i), E = O0(g, x), P = F0(g, x) + 1;
          return Lr(g, E, P).join("");
        }
        function cC(r, i, l) {
          if (r = et(r), r && (l || i === n))
            return r.slice(0, $0(r) + 1);
          if (!r || !(i = rn(i)))
            return r;
          var g = _n(r), x = F0(g, _n(i)) + 1;
          return Lr(g, 0, x).join("");
        }
        function oC(r, i, l) {
          if (r = et(r), r && (l || i === n))
            return r.replace(wc, "");
          if (!r || !(i = rn(i)))
            return r;
          var g = _n(r), x = O0(g, _n(i));
          return Lr(g, x).join("");
        }
        function iC(r, i) {
          var l = ae, g = fe;
          if (dt(i)) {
            var x = "separator" in i ? i.separator : x;
            l = "length" in i ? Oe(i.length) : l, g = "omission" in i ? rn(i.omission) : g;
          }
          r = et(r);
          var E = r.length;
          if (_1(r)) {
            var P = _n(r);
            E = P.length;
          }
          if (l >= E)
            return r;
          var N = l - E1(g);
          if (N < 1)
            return g;
          var D = P ? Lr(P, 0, N).join("") : r.slice(0, N);
          if (x === n)
            return D + g;
          if (P && (N += D.length - N), ts(x)) {
            if (r.slice(N).search(x)) {
              var W, H = D;
              for (x.global || (x = v2(x.source, et(Qe.exec(x)) + "g")), x.lastIndex = 0; W = x.exec(H); )
                var Y = W.index;
              D = D.slice(0, Y === n ? N : Y);
            }
          } else if (r.indexOf(rn(x), N) != N) {
            var pe = D.lastIndexOf(x);
            pe > -1 && (D = D.slice(0, pe));
          }
          return D + g;
        }
        function aC(r) {
          return r = et(r), r && Io.test(r) ? r.replace(y1, Fp) : r;
        }
        var sC = N1(function(r, i, l) {
          return r + (l ? " " : "") + i.toUpperCase();
        }), cs = _u("toUpperCase");
        function A3(r, i, l) {
          return r = et(r), i = l ? n : i, i === n ? Pp(r) ? Gp(r) : Ip(r) : r.match(i) || [];
        }
        var S3 = $e(function(r, i) {
          try {
            return tn(r, n, i);
          } catch (l) {
            return es(l) ? l : new Pe(l);
          }
        }), lC = tr(function(r, i) {
          return gn(i, function(l) {
            l = On(l), Qn(r, l, q2(r[l], r));
          }), r;
        });
        function uC(r) {
          var i = r == null ? 0 : r.length, l = Ee();
          return r = i ? lt(r, function(g) {
            if (typeof g[1] != "function")
              throw new mn(s);
            return [l(g[0]), g[1]];
          }) : [], $e(function(g) {
            for (var x = -1; ++x < i; ) {
              var E = r[x];
              if (tn(E[0], this, g))
                return tn(E[1], this, g);
            }
          });
        }
        function fC(r) {
          return Fg(vn(r, m));
        }
        function os(r) {
          return function() {
            return r;
          };
        }
        function dC(r, i) {
          return r == null || r !== r ? i : r;
        }
        var pC = Mu(), gC = Mu(!0);
        function Jt(r) {
          return r;
        }
        function is(r) {
          return cu(typeof r == "function" ? r : vn(r, m));
        }
        function mC(r) {
          return iu(vn(r, m));
        }
        function hC(r, i) {
          return au(r, vn(i, m));
        }
        var vC = $e(function(r, i) {
          return function(l) {
            return zc(l, r, i);
          };
        }), bC = $e(function(r, i) {
          return function(l) {
            return zc(r, l, i);
          };
        });
        function as(r, i, l) {
          var g = At(i), x = Xo(i, g);
          l == null && !(dt(i) && (x.length || !g.length)) && (l = i, i = r, r = this, x = Xo(i, At(i)));
          var E = !(dt(l) && "chain" in l) || !!l.chain, P = rr(r);
          return gn(x, function(N) {
            var D = i[N];
            r[N] = D, P && (r.prototype[N] = function() {
              var W = this.__chain__;
              if (E || W) {
                var H = r(this.__wrapped__), Y = H.__actions__ = Zt(this.__actions__);
                return Y.push({ func: D, args: arguments, thisArg: r }), H.__chain__ = W, H;
              }
              return D.apply(r, wr([this.value()], arguments));
            });
          }), r;
        }
        function CC() {
          return Et._ === this && (Et._ = jp), this;
        }
        function ss() {
        }
        function xC(r) {
          return r = Oe(r), $e(function(i) {
            return su(i, r);
          });
        }
        var yC = G2(lt), IC = G2(L0), wC = G2(u2);
        function _3(r) {
          return X2(r) ? f2(On(r)) : Qg(r);
        }
        function AC(r) {
          return function(i) {
            return r == null ? n : e1(r, i);
          };
        }
        var SC = Ru(), _C = Ru(!0);
        function ls() {
          return [];
        }
        function us() {
          return !1;
        }
        function EC() {
          return {};
        }
        function MC() {
          return "";
        }
        function LC() {
          return !0;
        }
        function RC(r, i) {
          if (r = Oe(r), r < 1 || r > ee)
            return [];
          var l = X, g = Tt(r, X);
          i = Ee(i), r -= X;
          for (var x = g2(g, i); ++l < r; )
            i(l);
          return x;
        }
        function PC(r) {
          return ze(r) ? lt(r, On) : cn(r) ? [r] : Zt(Xu(et(r)));
        }
        function TC(r) {
          var i = ++Wp;
          return et(r) + i;
        }
        var zC = qo(function(r, i) {
          return r + i;
        }, 0), NC = k2("ceil"), OC = qo(function(r, i) {
          return r / i;
        }, 1), FC = k2("floor");
        function DC(r) {
          return r && r.length ? jo(r, Jt, S2) : n;
        }
        function $C(r, i) {
          return r && r.length ? jo(r, Ee(i, 2), S2) : n;
        }
        function GC(r) {
          return T0(r, Jt);
        }
        function kC(r, i) {
          return T0(r, Ee(i, 2));
        }
        function BC(r) {
          return r && r.length ? jo(r, Jt, L2) : n;
        }
        function VC(r, i) {
          return r && r.length ? jo(r, Ee(i, 2), L2) : n;
        }
        var WC = qo(function(r, i) {
          return r * i;
        }, 1), HC = k2("round"), jC = qo(function(r, i) {
          return r - i;
        }, 0);
        function XC(r) {
          return r && r.length ? p2(r, Jt) : 0;
        }
        function ZC(r, i) {
          return r && r.length ? p2(r, Ee(i, 2)) : 0;
        }
        return _.after = mv, _.ary = r3, _.assign = nb, _.assignIn = v3, _.assignInWith = fi, _.assignWith = rb, _.at = cb, _.before = c3, _.bind = q2, _.bindAll = lC, _.bindKey = o3, _.castArray = Ev, _.chain = e3, _.chunk = Fm, _.compact = Dm, _.concat = $m, _.cond = uC, _.conforms = fC, _.constant = os, _.countBy = Xh, _.create = ob, _.curry = i3, _.curryRight = a3, _.debounce = s3, _.defaults = ib, _.defaultsDeep = ab, _.defer = hv, _.delay = vv, _.difference = Gm, _.differenceBy = km, _.differenceWith = Bm, _.drop = Vm, _.dropRight = Wm, _.dropRightWhile = Hm, _.dropWhile = jm, _.fill = Xm, _.filter = Yh, _.flatMap = Kh, _.flatMapDeep = qh, _.flatMapDepth = Qh, _.flatten = Ju, _.flattenDeep = Zm, _.flattenDepth = Ym, _.flip = bv, _.flow = pC, _.flowRight = gC, _.fromPairs = Um, _.functions = gb, _.functionsIn = mb, _.groupBy = ev, _.initial = Km, _.intersection = qm, _.intersectionBy = Qm, _.intersectionWith = eh, _.invert = vb, _.invertBy = bb, _.invokeMap = nv, _.iteratee = is, _.keyBy = rv, _.keys = At, _.keysIn = Ut, _.map = oi, _.mapKeys = xb, _.mapValues = yb, _.matches = mC, _.matchesProperty = hC, _.memoize = ai, _.merge = Ib, _.mergeWith = b3, _.method = vC, _.methodOf = bC, _.mixin = as, _.negate = si, _.nthArg = xC, _.omit = wb, _.omitBy = Ab, _.once = Cv, _.orderBy = cv, _.over = yC, _.overArgs = xv, _.overEvery = IC, _.overSome = wC, _.partial = Q2, _.partialRight = l3, _.partition = ov, _.pick = Sb, _.pickBy = C3, _.property = _3, _.propertyOf = AC, _.pull = ch, _.pullAll = qu, _.pullAllBy = oh, _.pullAllWith = ih, _.pullAt = ah, _.range = SC, _.rangeRight = _C, _.rearg = yv, _.reject = sv, _.remove = sh, _.rest = Iv, _.reverse = J2, _.sampleSize = uv, _.set = Eb, _.setWith = Mb, _.shuffle = fv, _.slice = lh, _.sortBy = gv, _.sortedUniq = hh, _.sortedUniqBy = vh, _.split = Kb, _.spread = wv, _.tail = bh, _.take = Ch, _.takeRight = xh, _.takeRightWhile = yh, _.takeWhile = Ih, _.tap = Dh, _.throttle = Av, _.thru = ci, _.toArray = g3, _.toPairs = x3, _.toPairsIn = y3, _.toPath = PC, _.toPlainObject = h3, _.transform = Lb, _.unary = Sv, _.union = wh, _.unionBy = Ah, _.unionWith = Sh, _.uniq = _h, _.uniqBy = Eh, _.uniqWith = Mh, _.unset = Rb, _.unzip = K2, _.unzipWith = Qu, _.update = Pb, _.updateWith = Tb, _.values = D1, _.valuesIn = zb, _.without = Lh, _.words = A3, _.wrap = _v, _.xor = Rh, _.xorBy = Ph, _.xorWith = Th, _.zip = zh, _.zipObject = Nh, _.zipObjectDeep = Oh, _.zipWith = Fh, _.entries = x3, _.entriesIn = y3, _.extend = v3, _.extendWith = fi, as(_, _), _.add = zC, _.attempt = S3, _.camelCase = Db, _.capitalize = I3, _.ceil = NC, _.clamp = Nb, _.clone = Mv, _.cloneDeep = Rv, _.cloneDeepWith = Pv, _.cloneWith = Lv, _.conformsTo = Tv, _.deburr = w3, _.defaultTo = dC, _.divide = OC, _.endsWith = $b, _.eq = Mn, _.escape = Gb, _.escapeRegExp = kb, _.every = Zh, _.find = Uh, _.findIndex = Yu, _.findKey = sb, _.findLast = Jh, _.findLastIndex = Uu, _.findLastKey = lb, _.floor = FC, _.forEach = t3, _.forEachRight = n3, _.forIn = ub, _.forInRight = fb, _.forOwn = db, _.forOwnRight = pb, _.get = ns, _.gt = zv, _.gte = Nv, _.has = hb, _.hasIn = rs, _.head = Ku, _.identity = Jt, _.includes = tv, _.indexOf = Jm, _.inRange = Ob, _.invoke = Cb, _.isArguments = r1, _.isArray = ze, _.isArrayBuffer = Ov, _.isArrayLike = Yt, _.isArrayLikeObject = vt, _.isBoolean = Fv, _.isBuffer = Rr, _.isDate = Dv, _.isElement = $v, _.isEmpty = Gv, _.isEqual = kv, _.isEqualWith = Bv, _.isError = es, _.isFinite = Vv, _.isFunction = rr, _.isInteger = u3, _.isLength = li, _.isMap = f3, _.isMatch = Wv, _.isMatchWith = Hv, _.isNaN = jv, _.isNative = Xv, _.isNil = Yv, _.isNull = Zv, _.isNumber = d3, _.isObject = dt, _.isObjectLike = mt, _.isPlainObject = Gc, _.isRegExp = ts, _.isSafeInteger = Uv, _.isSet = p3, _.isString = ui, _.isSymbol = cn, _.isTypedArray = F1, _.isUndefined = Jv, _.isWeakMap = Kv, _.isWeakSet = qv, _.join = th, _.kebabCase = Bb, _.last = Cn, _.lastIndexOf = nh, _.lowerCase = Vb, _.lowerFirst = Wb, _.lt = Qv, _.lte = eb, _.max = DC, _.maxBy = $C, _.mean = GC, _.meanBy = kC, _.min = BC, _.minBy = VC, _.stubArray = ls, _.stubFalse = us, _.stubObject = EC, _.stubString = MC, _.stubTrue = LC, _.multiply = WC, _.nth = rh, _.noConflict = CC, _.noop = ss, _.now = ii, _.pad = Hb, _.padEnd = jb, _.padStart = Xb, _.parseInt = Zb, _.random = Fb, _.reduce = iv, _.reduceRight = av, _.repeat = Yb, _.replace = Ub, _.result = _b, _.round = HC, _.runInContext = F, _.sample = lv, _.size = dv, _.snakeCase = Jb, _.some = pv, _.sortedIndex = uh, _.sortedIndexBy = fh, _.sortedIndexOf = dh, _.sortedLastIndex = ph, _.sortedLastIndexBy = gh, _.sortedLastIndexOf = mh, _.startCase = qb, _.startsWith = Qb, _.subtract = jC, _.sum = XC, _.sumBy = ZC, _.template = eC, _.times = RC, _.toFinite = cr, _.toInteger = Oe, _.toLength = m3, _.toLower = tC, _.toNumber = xn, _.toSafeInteger = tb, _.toString = et, _.toUpper = nC, _.trim = rC, _.trimEnd = cC, _.trimStart = oC, _.truncate = iC, _.unescape = aC, _.uniqueId = TC, _.upperCase = sC, _.upperFirst = cs, _.each = t3, _.eachRight = n3, _.first = Ku, as(_, function() {
          var r = {};
          return zn(_, function(i, l) {
            rt.call(_.prototype, l) || (r[l] = i);
          }), r;
        }(), { chain: !1 }), _.VERSION = c, gn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(r) {
          _[r].placeholder = _;
        }), gn(["drop", "take"], function(r, i) {
          He.prototype[r] = function(l) {
            l = l === n ? 1 : wt(Oe(l), 0);
            var g = this.__filtered__ && !i ? new He(this) : this.clone();
            return g.__filtered__ ? g.__takeCount__ = Tt(l, g.__takeCount__) : g.__views__.push({
              size: Tt(l, X),
              type: r + (g.__dir__ < 0 ? "Right" : "")
            }), g;
          }, He.prototype[r + "Right"] = function(l) {
            return this.reverse()[r](l).reverse();
          };
        }), gn(["filter", "map", "takeWhile"], function(r, i) {
          var l = i + 1, g = l == oe || l == te;
          He.prototype[r] = function(x) {
            var E = this.clone();
            return E.__iteratees__.push({
              iteratee: Ee(x, 3),
              type: l
            }), E.__filtered__ = E.__filtered__ || g, E;
          };
        }), gn(["head", "last"], function(r, i) {
          var l = "take" + (i ? "Right" : "");
          He.prototype[r] = function() {
            return this[l](1).value()[0];
          };
        }), gn(["initial", "tail"], function(r, i) {
          var l = "drop" + (i ? "" : "Right");
          He.prototype[r] = function() {
            return this.__filtered__ ? new He(this) : this[l](1);
          };
        }), He.prototype.compact = function() {
          return this.filter(Jt);
        }, He.prototype.find = function(r) {
          return this.filter(r).head();
        }, He.prototype.findLast = function(r) {
          return this.reverse().find(r);
        }, He.prototype.invokeMap = $e(function(r, i) {
          return typeof r == "function" ? new He(this) : this.map(function(l) {
            return zc(l, r, i);
          });
        }), He.prototype.reject = function(r) {
          return this.filter(si(Ee(r)));
        }, He.prototype.slice = function(r, i) {
          r = Oe(r);
          var l = this;
          return l.__filtered__ && (r > 0 || i < 0) ? new He(l) : (r < 0 ? l = l.takeRight(-r) : r && (l = l.drop(r)), i !== n && (i = Oe(i), l = i < 0 ? l.dropRight(-i) : l.take(i - r)), l);
        }, He.prototype.takeRightWhile = function(r) {
          return this.reverse().takeWhile(r).reverse();
        }, He.prototype.toArray = function() {
          return this.take(X);
        }, zn(He.prototype, function(r, i) {
          var l = /^(?:filter|find|map|reject)|While$/.test(i), g = /^(?:head|last)$/.test(i), x = _[g ? "take" + (i == "last" ? "Right" : "") : i], E = g || /^find/.test(i);
          x && (_.prototype[i] = function() {
            var P = this.__wrapped__, N = g ? [1] : arguments, D = P instanceof He, W = N[0], H = D || ze(P), Y = function(Ve) {
              var Xe = x.apply(_, wr([Ve], N));
              return g && pe ? Xe[0] : Xe;
            };
            H && l && typeof W == "function" && W.length != 1 && (D = H = !1);
            var pe = this.__chain__, ye = !!this.__actions__.length, Me = E && !pe, De = D && !ye;
            if (!E && H) {
              P = De ? P : new He(this);
              var Le = r.apply(P, N);
              return Le.__actions__.push({ func: ci, args: [Y], thisArg: n }), new hn(Le, pe);
            }
            return Me && De ? r.apply(this, N) : (Le = this.thru(Y), Me ? g ? Le.value()[0] : Le.value() : Le);
          });
        }), gn(["pop", "push", "shift", "sort", "splice", "unshift"], function(r) {
          var i = Ro[r], l = /^(?:push|sort|unshift)$/.test(r) ? "tap" : "thru", g = /^(?:pop|shift)$/.test(r);
          _.prototype[r] = function() {
            var x = arguments;
            if (g && !this.__chain__) {
              var E = this.value();
              return i.apply(ze(E) ? E : [], x);
            }
            return this[l](function(P) {
              return i.apply(ze(P) ? P : [], x);
            });
          };
        }), zn(He.prototype, function(r, i) {
          var l = _[i];
          if (l) {
            var g = l.name + "";
            rt.call(P1, g) || (P1[g] = []), P1[g].push({ name: i, func: l });
          }
        }), P1[Ko(n, I).name] = [{
          name: "wrapper",
          func: n
        }], He.prototype.clone = ag, He.prototype.reverse = sg, He.prototype.value = lg, _.prototype.at = $h, _.prototype.chain = Gh, _.prototype.commit = kh, _.prototype.next = Bh, _.prototype.plant = Wh, _.prototype.reverse = Hh, _.prototype.toJSON = _.prototype.valueOf = _.prototype.value = jh, _.prototype.first = _.prototype.head, _c && (_.prototype[_c] = Vh), _;
      }, M1 = kp();
      Ur ? ((Ur.exports = M1)._ = M1, i2._ = M1) : Et._ = M1;
    }).call(ak);
  }(Yc, Yc.exports)), Yc.exports;
}
var lk = sk();
const uk = "_selectEnv_fixe8_405", fk = "_activeOption_fixe8_426", dk = "_option_fixe8_430", pk = "_focused_fixe8_441", gk = "_Checkbox_fixe8_445", mk = "_Label_fixe8_456", hk = "_FooterComponent_fixe8_464", vk = "_EmptyIconContainer_fixe8_469", bk = "_inputEnv_fixe8_487", Ck = "_InputSearch_fixe8_492", xk = "_Placeholder_fixe8_508", yk = "_IconClear_fixe8_519", Ik = "_IconGray_fixe8_523", wk = "_ActionBar_fixe8_527", Ak = "_ActionBarCounter_fixe8_536", Sk = "_ActionBtn_fixe8_547", _k = "_Secondary_fixe8_559", Ek = "_disabled_fixe8_562", Mk = "_clear_fixe8_570", Lk = "_fadeIn_fixe8_1", Rk = "_fadeOut_fixe8_1", Pk = "_slideUpAndFade_fixe8_1", Tk = "_slideRightAndFade_fixe8_1", zk = "_slideDownAndFade_fixe8_1", Nk = "_slideLeftAndFade_fixe8_1", Ok = "_slideDown_fixe8_1", Fk = "_slideUp_fixe8_1", Dk = "_rotateUp_fixe8_1", $k = "_rotateDown_fixe8_1", Rt = {
  selectEnv: uk,
  activeOption: fk,
  option: dk,
  focused: pk,
  Checkbox: gk,
  Label: mk,
  FooterComponent: hk,
  EmptyIconContainer: vk,
  inputEnv: bk,
  InputSearch: Ck,
  Placeholder: xk,
  IconClear: yk,
  IconGray: Ik,
  ActionBar: wk,
  ActionBarCounter: Ak,
  ActionBtn: Sk,
  Secondary: _k,
  disabled: Ek,
  clear: Mk,
  fadeIn: Lk,
  fadeOut: Rk,
  slideUpAndFade: Pk,
  slideRightAndFade: Tk,
  slideDownAndFade: zk,
  slideLeftAndFade: Nk,
  slideDown: Ok,
  slideUp: Fk,
  rotateUp: Dk,
  rotateDown: $k
};
function Gk(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, qi(e, t);
}
var Tf = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function kk(e, t) {
  return !!(e === t || Tf(e) && Tf(t));
}
function Bk(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!kk(e[n], t[n]))
      return !1;
  return !0;
}
function js(e, t) {
  t === void 0 && (t = Bk);
  var n, c = [], o, a = !1;
  function s() {
    for (var u = [], f = 0; f < arguments.length; f++)
      u[f] = arguments[f];
    return a && n === this && t(u, c) || (o = e.apply(this, u), a = !0, n = this, c = u), o;
  }
  return s;
}
var Vk = typeof performance == "object" && typeof performance.now == "function", zf = Vk ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function Nf(e) {
  cancelAnimationFrame(e.id);
}
function Wk(e, t) {
  var n = zf();
  function c() {
    zf() - n >= t ? e.call(null) : o.id = requestAnimationFrame(c);
  }
  var o = {
    id: requestAnimationFrame(c)
  };
  return o;
}
var Xs = -1;
function Of(e) {
  if (e === void 0 && (e = !1), Xs === -1 || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(t), Xs = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Xs;
}
var H1 = null;
function Ff(e) {
  if (e === void 0 && (e = !1), H1 === null || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var c = document.createElement("div"), o = c.style;
    return o.width = "100px", o.height = "100px", t.appendChild(c), document.body.appendChild(t), t.scrollLeft > 0 ? H1 = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? H1 = "negative" : H1 = "positive-ascending"), document.body.removeChild(t), H1;
  }
  return H1;
}
process.env.NODE_ENV;
var Hk = 150, jk = function(t, n) {
  return t;
}, Gi = null, ki = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (Gi = /* @__PURE__ */ new WeakSet(), ki = /* @__PURE__ */ new WeakSet());
function Xk(e) {
  var t, n = e.getItemOffset, c = e.getEstimatedTotalSize, o = e.getItemSize, a = e.getOffsetForIndexAndAlignment, s = e.getStartIndexForOffset, u = e.getStopIndexForStartIndex, f = e.initInstanceProps, d = e.shouldResetStyleCacheOnItemSizeChange, p = e.validateProps;
  return t = /* @__PURE__ */ function(m) {
    Gk(b, m);
    function b(C) {
      var h;
      return h = m.call(this, C) || this, h._instanceProps = f(h.props, Tl(h)), h._outerRef = void 0, h._resetIsScrollingTimeoutId = null, h.state = {
        instance: Tl(h),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof h.props.initialScrollOffset == "number" ? h.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, h._callOnItemsRendered = void 0, h._callOnItemsRendered = js(function(v, I, S, L) {
        return h.props.onItemsRendered({
          overscanStartIndex: v,
          overscanStopIndex: I,
          visibleStartIndex: S,
          visibleStopIndex: L
        });
      }), h._callOnScroll = void 0, h._callOnScroll = js(function(v, I, S) {
        return h.props.onScroll({
          scrollDirection: v,
          scrollOffset: I,
          scrollUpdateWasRequested: S
        });
      }), h._getItemStyle = void 0, h._getItemStyle = function(v) {
        var I = h.props, S = I.direction, L = I.itemSize, R = I.layout, M = h._getItemStyleCache(d && L, d && R, d && S), $;
        if (M.hasOwnProperty(v))
          $ = M[v];
        else {
          var O = n(h.props, v, h._instanceProps), G = o(h.props, v, h._instanceProps), J = S === "horizontal" || R === "horizontal", ae = S === "rtl", fe = J ? O : 0;
          M[v] = $ = {
            position: "absolute",
            left: ae ? void 0 : fe,
            right: ae ? fe : void 0,
            top: J ? 0 : O,
            height: J ? "100%" : G,
            width: J ? G : "100%"
          };
        }
        return $;
      }, h._getItemStyleCache = void 0, h._getItemStyleCache = js(function(v, I, S) {
        return {};
      }), h._onScrollHorizontal = function(v) {
        var I = v.currentTarget, S = I.clientWidth, L = I.scrollLeft, R = I.scrollWidth;
        h.setState(function(M) {
          if (M.scrollOffset === L)
            return null;
          var $ = h.props.direction, O = L;
          if ($ === "rtl")
            switch (Ff()) {
              case "negative":
                O = -L;
                break;
              case "positive-descending":
                O = R - S - L;
                break;
            }
          return O = Math.max(0, Math.min(O, R - S)), {
            isScrolling: !0,
            scrollDirection: M.scrollOffset < O ? "forward" : "backward",
            scrollOffset: O,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._onScrollVertical = function(v) {
        var I = v.currentTarget, S = I.clientHeight, L = I.scrollHeight, R = I.scrollTop;
        h.setState(function(M) {
          if (M.scrollOffset === R)
            return null;
          var $ = Math.max(0, Math.min(R, L - S));
          return {
            isScrolling: !0,
            scrollDirection: M.scrollOffset < $ ? "forward" : "backward",
            scrollOffset: $,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._outerRefSetter = function(v) {
        var I = h.props.outerRef;
        h._outerRef = v, typeof I == "function" ? I(v) : I != null && typeof I == "object" && I.hasOwnProperty("current") && (I.current = v);
      }, h._resetIsScrollingDebounced = function() {
        h._resetIsScrollingTimeoutId !== null && Nf(h._resetIsScrollingTimeoutId), h._resetIsScrollingTimeoutId = Wk(h._resetIsScrolling, Hk);
      }, h._resetIsScrolling = function() {
        h._resetIsScrollingTimeoutId = null, h.setState({
          isScrolling: !1
        }, function() {
          h._getItemStyleCache(-1, null);
        });
      }, h;
    }
    b.getDerivedStateFromProps = function(h, v) {
      return Zk(h, v), p(h), null;
    };
    var y = b.prototype;
    return y.scrollTo = function(h) {
      h = Math.max(0, h), this.setState(function(v) {
        return v.scrollOffset === h ? null : {
          scrollDirection: v.scrollOffset < h ? "forward" : "backward",
          scrollOffset: h,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, y.scrollToItem = function(h, v) {
      v === void 0 && (v = "auto");
      var I = this.props, S = I.itemCount, L = I.layout, R = this.state.scrollOffset;
      h = Math.max(0, Math.min(h, S - 1));
      var M = 0;
      if (this._outerRef) {
        var $ = this._outerRef;
        L === "vertical" ? M = $.scrollWidth > $.clientWidth ? Of() : 0 : M = $.scrollHeight > $.clientHeight ? Of() : 0;
      }
      this.scrollTo(a(this.props, h, v, R, this._instanceProps, M));
    }, y.componentDidMount = function() {
      var h = this.props, v = h.direction, I = h.initialScrollOffset, S = h.layout;
      if (typeof I == "number" && this._outerRef != null) {
        var L = this._outerRef;
        v === "horizontal" || S === "horizontal" ? L.scrollLeft = I : L.scrollTop = I;
      }
      this._callPropsCallbacks();
    }, y.componentDidUpdate = function() {
      var h = this.props, v = h.direction, I = h.layout, S = this.state, L = S.scrollOffset, R = S.scrollUpdateWasRequested;
      if (R && this._outerRef != null) {
        var M = this._outerRef;
        if (v === "horizontal" || I === "horizontal")
          if (v === "rtl")
            switch (Ff()) {
              case "negative":
                M.scrollLeft = -L;
                break;
              case "positive-ascending":
                M.scrollLeft = L;
                break;
              default:
                var $ = M.clientWidth, O = M.scrollWidth;
                M.scrollLeft = O - $ - L;
                break;
            }
          else
            M.scrollLeft = L;
        else
          M.scrollTop = L;
      }
      this._callPropsCallbacks();
    }, y.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && Nf(this._resetIsScrollingTimeoutId);
    }, y.render = function() {
      var h = this.props, v = h.children, I = h.className, S = h.direction, L = h.height, R = h.innerRef, M = h.innerElementType, $ = h.innerTagName, O = h.itemCount, G = h.itemData, J = h.itemKey, ae = J === void 0 ? jk : J, fe = h.layout, U = h.outerElementType, re = h.outerTagName, oe = h.style, ue = h.useIsScrolling, te = h.width, se = this.state.isScrolling, ee = S === "horizontal" || fe === "horizontal", q = ee ? this._onScrollHorizontal : this._onScrollVertical, B = this._getRangeToRender(), X = B[0], ie = B[1], he = [];
      if (O > 0)
        for (var le = X; le <= ie; le++)
          he.push(xe(v, {
            data: G,
            key: ae(le, G),
            index: le,
            isScrolling: ue ? se : void 0,
            style: this._getItemStyle(le)
          }));
      var ve = c(this.props, this._instanceProps);
      return xe(U || re || "div", {
        className: I,
        onScroll: q,
        ref: this._outerRefSetter,
        style: ce({
          position: "relative",
          height: L,
          width: te,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: S
        }, oe)
      }, xe(M || $ || "div", {
        children: he,
        ref: R,
        style: {
          height: ee ? "100%" : ve,
          pointerEvents: se ? "none" : void 0,
          width: ee ? ve : "100%"
        }
      }));
    }, y._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var h = this.props.itemCount;
        if (h > 0) {
          var v = this._getRangeToRender(), I = v[0], S = v[1], L = v[2], R = v[3];
          this._callOnItemsRendered(I, S, L, R);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var M = this.state, $ = M.scrollDirection, O = M.scrollOffset, G = M.scrollUpdateWasRequested;
        this._callOnScroll($, O, G);
      }
    }, y._getRangeToRender = function() {
      var h = this.props, v = h.itemCount, I = h.overscanCount, S = this.state, L = S.isScrolling, R = S.scrollDirection, M = S.scrollOffset;
      if (v === 0)
        return [0, 0, 0, 0];
      var $ = s(this.props, M, this._instanceProps), O = u(this.props, $, M, this._instanceProps), G = !L || R === "backward" ? Math.max(1, I) : 1, J = !L || R === "forward" ? Math.max(1, I) : 1;
      return [Math.max(0, $ - G), Math.max(0, Math.min(v - 1, O + J)), $, O];
    }, b;
  }(UC), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var Zk = function(t, n) {
  var c = t.children, o = t.direction, a = t.height, s = t.layout, u = t.innerTagName, f = t.outerTagName, d = t.width, p = n.instance;
  if (process.env.NODE_ENV !== "production") {
    (u != null || f != null) && ki && !ki.has(p) && (ki.add(p), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var m = o === "horizontal" || s === "horizontal";
    switch (o) {
      case "horizontal":
      case "vertical":
        Gi && !Gi.has(p) && (Gi.add(p), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + o + '" was specified.'));
    }
    switch (s) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + s + '" was specified.'));
    }
    if (c == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (c === null ? "null" : typeof c) + '" was specified.'));
    if (m && typeof d != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (d === null ? "null" : typeof d) + '" was specified.'));
    if (!m && typeof a != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (a === null ? "null" : typeof a) + '" was specified.'));
  }
}, Yk = /* @__PURE__ */ Xk({
  getItemOffset: function(t, n) {
    var c = t.itemSize;
    return n * c;
  },
  getItemSize: function(t, n) {
    var c = t.itemSize;
    return c;
  },
  getEstimatedTotalSize: function(t) {
    var n = t.itemCount, c = t.itemSize;
    return c * n;
  },
  getOffsetForIndexAndAlignment: function(t, n, c, o, a, s) {
    var u = t.direction, f = t.height, d = t.itemCount, p = t.itemSize, m = t.layout, b = t.width, y = u === "horizontal" || m === "horizontal", C = y ? b : f, h = Math.max(0, d * p - C), v = Math.min(h, n * p), I = Math.max(0, n * p - C + p + s);
    switch (c === "smart" && (o >= I - C && o <= v + C ? c = "auto" : c = "center"), c) {
      case "start":
        return v;
      case "end":
        return I;
      case "center": {
        var S = Math.round(I + (v - I) / 2);
        return S < Math.ceil(C / 2) ? 0 : S > h + Math.floor(C / 2) ? h : S;
      }
      case "auto":
      default:
        return o >= I && o <= v ? o : o < I ? I : v;
    }
  },
  getStartIndexForOffset: function(t, n) {
    var c = t.itemCount, o = t.itemSize;
    return Math.max(0, Math.min(c - 1, Math.floor(n / o)));
  },
  getStopIndexForStartIndex: function(t, n, c) {
    var o = t.direction, a = t.height, s = t.itemCount, u = t.itemSize, f = t.layout, d = t.width, p = o === "horizontal" || f === "horizontal", m = n * u, b = p ? d : a, y = Math.ceil((b + c - m) / u);
    return Math.max(0, Math.min(
      s - 1,
      n + y - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(t) {
    var n = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
});
function c1() {
  return /* @__PURE__ */ w.jsx("span", {});
}
function Uk() {
  return /* @__PURE__ */ w.jsxs("div", { className: Rt.EmptyIconContainer, children: [
    /* @__PURE__ */ w.jsx(v_, {}),
    /* @__PURE__ */ w.jsx("span", { children: "Nothing Found" })
  ] });
}
function Jk(e) {
  const { children: t, selectProps: n } = e, { components: c, menuHeight: o } = n, { MenuListFooter: a = null } = c, s = !Array.isArray(t), u = ({ index: f, style: d }) => /* @__PURE__ */ w.jsx("div", { style: d, children: t[f] });
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    s ? (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      /* @__PURE__ */ w.jsx(w.Fragment, { children: t })
    ) : /* @__PURE__ */ w.jsx(Yk, { style: { margin: "4px" }, height: o, itemSize: 37, itemCount: (t == null ? void 0 : t.length) || 0, children: u }),
    a
  ] });
}
function Wa(e = {}) {
  const { isSelected: t, label: n, isFocused: c } = e;
  return /* @__PURE__ */ w.jsx(ra.Option, { ...e, children: /* @__PURE__ */ w.jsxs("div", { className: `${Rt.option} ${c ? Rt.focused : null}`, children: [
    /* @__PURE__ */ w.jsx("input", { className: Rt.Checkbox, type: "checkbox", checked: t, onChange: () => null }),
    " ",
    /* @__PURE__ */ w.jsx("label", { className: `${Rt.Label} ${t ? Rt.activeOption : ""}`, children: n })
  ] }) });
}
Wa.propTypes = {
  label: z.string.isRequired,
  isSelected: z.bool.isRequired,
  isFocused: z.bool.isRequired
};
function I9({ selectedCount: e, showCounter: t, onClick: n, optionsCount: c, children: o }) {
  const a = e > 0 ? "Clear All" : "Select All";
  return /* @__PURE__ */ w.jsxs("div", { className: Rt.ActionBar, children: [
    t && e > 0 ? /* @__PURE__ */ w.jsxs("div", { className: Rt.ActionBarCounter, children: [
      "Selected:",
      " ",
      /* @__PURE__ */ w.jsxs("span", { children: [
        e,
        "/",
        c
      ] })
    ] }) : null,
    /* @__PURE__ */ w.jsx("div", { children: o }),
    /* @__PURE__ */ w.jsxs("div", { className: Rt.ActionBtn, onClick: n, children: [
      /* @__PURE__ */ w.jsx("span", { role: "presentation", className: Rt.clear, children: a }),
      /* @__PURE__ */ w.jsx("span", { children: `(${e > 0 ? e : c})` })
    ] })
  ] });
}
I9.propTypes = {
  selectedCount: z.number.isRequired,
  onClick: z.func.isRequired,
  optionsCount: z.number.isRequired,
  children: z.object.isRequired,
  showCounter: z.bool.isRequired
};
const Kk = (e, t, n) => ({
  option: (c) => ({
    ...c,
    width: "100%",
    height: "100%",
    borderRadius: 0,
    borderWidth: 0,
    margin: 0,
    padding: 0,
    display: "flex",
    backgroundColor: "unset",
    "&:active": {
      backgroundColor: "unset"
    },
    "&:hover": {
      backgroundColor: "unset"
    },
    "&:focus": {
      backgroundColor: "unset"
    }
  }),
  container: (c) => ({
    ...c,
    width: e,
    minWidth: n,
    margin: 0,
    position: "absolute",
    backgroundColor: "white",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    boxShadow: "rgba(0, 0, 36, 0.25) 0px 4px 12px -2px"
  }),
  control: (c) => ({
    ...c,
    border: 0,
    boxShadow: "none",
    padding: "0 15px",
    borderRadius: "unset",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottom: "1px solid #C9DBFF",
    backgroundColor: "rgba(38, 113, 255, 0.1)",
    "> div": {
      display: "flex",
      padding: "unset",
      borderTopLeftRadius: "6px",
      borderTopRightRadius: "6px"
    },
    "&:hover": {
      borderBottom: "1px solid #C9DBFF"
    }
  }),
  indicatorSeparator: () => ({}),
  menu: (c) => ({
    ...c,
    width: "100%",
    margin: 0,
    border: 0,
    borderRadius: 6,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: "0 4px 12px -2px rgba(0, 0, 36, 0.25)",
    zIndex: 2
  }),
  menuList: (c) => ({
    ...c,
    maxHeight: t,
    minHeight: t,
    overflowY: "hidden",
    position: "relative"
  }),
  input: () => ({
    width: "100%"
  })
});
function w9({
  isOpen: e,
  onMenuBlur: t = () => {
  },
  options: n = [],
  width: c = "100%",
  height: o = 240,
  selected: a = [],
  minWidth: s,
  hideFooter: u,
  children: f,
  onChange: d = () => {
  },
  showCounter: p,
  customOptionMultiComponent: m,
  ...b
}) {
  const y = je(null), [C, h] = Ne(""), [v, I] = Ne([]), [S, L] = Ne(n), R = () => setTimeout(() => {
    var U;
    (U = y.current) == null || U.focus();
  }, 1);
  ct(() => {
    e && R();
  }, [e]), ct(() => {
    if (e) {
      const U = [], re = (se) => se != null && se !== "";
      let oe = 0;
      for (oe; oe < n.length; oe++) {
        const { value: se, label: ee } = n[oe];
        !re(se) && !re(ee) || (re(se) ? re(ee) ? a.some((q) => q.value === se) || U.push(n[oe]) : a.some((q) => q.value === se) || U.push({ value: se, label: se }) : a.some((q) => q.value === ee) || U.push({ value: ee, label: ee }));
      }
      const te = [...[...a].sort((se, ee) => se.label.localeCompare(ee.label)), ...U];
      L(te), I(te);
    }
  }, [n, e]);
  const M = (U) => {
    t(U);
  };
  function $(U) {
    var re;
    return U.value === "" && R(), U.selectProps.menuIsOpen ? /* @__PURE__ */ w.jsxs("div", { className: Rt.InputSearch, children: [
      /* @__PURE__ */ w.jsx(Hn, { iconName: yn.magnifyingGlass.name, className: Rt.IconGray }),
      /* @__PURE__ */ w.jsx("span", { className: Rt.Placeholder, children: U.selectProps.inputValue ? null : "Search" }),
      /* @__PURE__ */ w.jsx("div", { className: Rt.inputEnv, children: /* @__PURE__ */ w.jsx(ra.Input, { ...U }) }),
      (re = U.selectProps) != null && re.inputValue ? /* @__PURE__ */ w.jsx(
        "div",
        {
          className: Rt.IconClear,
          onClick: (oe) => {
            oe.currentTarget.name = "clearBtn";
          },
          children: /* @__PURE__ */ w.jsx(Hn, { className: Rt.IconGray, iconName: yn.circleXmark.name })
        }
      ) : null
    ] }) : /* @__PURE__ */ w.jsx(ra.Input, { ...U });
  }
  const O = () => v.length ? v.filter((re) => a.find((oe) => oe.value === re.value)).length : a.length, G = () => {
    let U = [];
    const re = a.filter((ue) => v.find((te) => te.value === ue.value)), oe = a.filter((ue) => !v.find((te) => te.value === ue.value));
    re.length > 0 ? U = oe : U = [...oe, ...v.filter((ue) => !ue.isDisabled)], d(U), R();
  }, J = {
    DropdownIndicator: c1,
    MultiValue: c1,
    SingleValue: c1,
    MultiValueRemove: c1,
    Placeholder: c1,
    ClearIndicator: c1,
    Option: m || Wa,
    NoOptionsMessage: Uk,
    MenuList: Jk,
    Input: (U) => $(U),
    MenuListFooter: u ? c1 : /* @__PURE__ */ w.jsx(
      I9,
      {
        showCounter: p,
        selectedCount: O(),
        onClick: G,
        optionsCount: v.filter((U) => !U.isDisabled).length,
        children: f
      }
    )
  }, ae = (U) => {
    d(U);
  }, fe = (U, re) => {
    if (re.action === "set-value") {
      R();
      return;
    }
    h(U), R();
    const oe = () => {
      if (re.action === "menu-close" && re.prevInputValue !== "") {
        I(S), R();
        return;
      }
      if (re.action === "input-change") {
        const ue = n.filter(
          (te) => {
            var se, ee;
            return !U || ((se = te.label) == null ? void 0 : se.toLowerCase().indexOf(U.toLowerCase())) > -1 || ((ee = te.value) == null ? void 0 : ee.toLowerCase().indexOf(U.toLowerCase())) > -1;
          }
        );
        I(ue);
      } else
        I(S);
      R();
    };
    lk.debounce(oe, 200)();
  };
  return /* @__PURE__ */ w.jsx("div", { className: Rt.selectEnv, children: e && /* @__PURE__ */ w.jsx(
    ik,
    {
      ...b,
      menuIsOpen: e,
      ref: y,
      onChange: ae,
      onInputChange: fe,
      options: v,
      menuHeight: o,
      components: J,
      value: a,
      styles: Kk(c, o, s),
      isMulti: !0,
      autoFocus: !0,
      closeMenuOnSelect: !1,
      escapeClearsValue: !0,
      hideSelectedOptions: !1,
      onBlur: M,
      defaultMenuIsOpen: !0,
      inputValue: C
    }
  ) });
}
w9.propTypes = {
  isOpen: z.bool,
  showCounter: z.bool,
  hideFooter: z.bool,
  onMenuBlur: z.func,
  options: z.array,
  width: z.string,
  minWidth: z.string,
  height: z.number,
  selected: z.array,
  onChange: z.func,
  children: z.object,
  customOptionMultiComponent: z.object
};
Wa.defaultProps = {
  props: {}
};
Wa.propTypes = {
  props: z.any
};
function qk({
  handleSelectionChange: e,
  label: t = "",
  options: n = [],
  width: c = "100%",
  minWidth: o,
  height: a = 240,
  customStyles: s,
  showCounter: u,
  hideFooter: f,
  hideTooltip: d,
  selectButtonComponentGetter: p,
  selectMultiMenuComponentGetter: m,
  selected: b = [],
  onSelectMultiButtonClick: y,
  onSelectMultiMenuClose: C
}) {
  const [h, v] = Ne(!1), S = `multi_select_${JC()}`, L = () => {
    const fe = !h;
    v(fe), y && y(fe);
  }, R = (fe) => {
    e(fe);
  }, M = (fe) => {
    var U;
    ((U = fe.relatedTarget) == null ? void 0 : U.id) !== S && (v(!1), C && C());
  }, $ = {
    id: S,
    tabIndex: "0"
  }, O = p && p(L, b, h, $), G = m && m(R, b, h, M, $), J = O || // eslint-disable-next-line react/jsx-filename-extension
  /* @__PURE__ */ w.jsx(
    G7,
    {
      isSelectMenuOpen: h,
      label: t,
      hideTooltip: d,
      selectedOptions: b,
      onButtonClick: L,
      containerProps: $
    }
  ), ae = G || // eslint-disable-next-line react/jsx-filename-extension
  /* @__PURE__ */ w.jsx(
    w9,
    {
      isOpen: h,
      options: n,
      hideFooter: f,
      showCounter: u,
      onChange: R,
      selected: b,
      onMenuBlur: M,
      width: c,
      minWidth: o,
      height: a,
      containerProps: $
    }
  );
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    /* @__PURE__ */ w.jsxs("div", { style: s || { position: "relative" }, children: [
      J,
      ae
    ] })
  );
}
qk.propTypes = {
  label: z.string,
  hideFooter: z.bool,
  hideTooltip: z.bool,
  options: z.array,
  width: z.number,
  minWidth: z.number,
  height: z.number,
  customStyles: z.object,
  handleSelectionChange: z.func.isRequired,
  selectButtonComponentGetter: z.func,
  selectMultiMenuComponentGetter: z.func,
  selected: z.array,
  showCounter: z.bool,
  onSelectMultiButtonClick: z.func,
  onSelectMultiMenuClose: z.func
};
var Q4 = "Tabs", [Qk, EV] = Ht(Q4, [
  Xr
]), A9 = Xr(), [eB, e0] = Qk(Q4), S9 = A.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: c,
      onValueChange: o,
      defaultValue: a,
      orientation: s = "horizontal",
      dir: u,
      activationMode: f = "automatic",
      ...d
    } = e, p = ic(u), [m, b] = qt({
      prop: c,
      onChange: o,
      defaultProp: a
    });
    return /* @__PURE__ */ w.jsx(
      eB,
      {
        scope: n,
        baseId: jn(),
        value: m,
        onValueChange: b,
        orientation: s,
        dir: p,
        activationMode: f,
        children: /* @__PURE__ */ w.jsx(
          ke.div,
          {
            dir: p,
            "data-orientation": s,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
S9.displayName = Q4;
var _9 = "TabsList", E9 = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: c = !0, ...o } = e, a = e0(_9, n), s = A9(n);
    return /* @__PURE__ */ w.jsx(
      Aa,
      {
        asChild: !0,
        ...s,
        orientation: a.orientation,
        dir: a.dir,
        loop: c,
        children: /* @__PURE__ */ w.jsx(
          ke.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
E9.displayName = _9;
var M9 = "TabsTrigger", L9 = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: c, disabled: o = !1, ...a } = e, s = e0(M9, n), u = A9(n), f = T9(s.baseId, c), d = z9(s.baseId, c), p = c === s.value;
    return /* @__PURE__ */ w.jsx(
      Sa,
      {
        asChild: !0,
        ...u,
        focusable: !o,
        active: p,
        children: /* @__PURE__ */ w.jsx(
          ke.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": p,
            "aria-controls": d,
            "data-state": p ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: f,
            ...a,
            ref: t,
            onMouseDown: Ae(e.onMouseDown, (m) => {
              !o && m.button === 0 && m.ctrlKey === !1 ? s.onValueChange(c) : m.preventDefault();
            }),
            onKeyDown: Ae(e.onKeyDown, (m) => {
              [" ", "Enter"].includes(m.key) && s.onValueChange(c);
            }),
            onFocus: Ae(e.onFocus, () => {
              const m = s.activationMode !== "manual";
              !p && !o && m && s.onValueChange(c);
            })
          }
        )
      }
    );
  }
);
L9.displayName = M9;
var R9 = "TabsContent", P9 = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: c, forceMount: o, children: a, ...s } = e, u = e0(R9, n), f = T9(u.baseId, c), d = z9(u.baseId, c), p = c === u.value, m = A.useRef(p);
    return A.useEffect(() => {
      const b = requestAnimationFrame(() => m.current = !1);
      return () => cancelAnimationFrame(b);
    }, []), /* @__PURE__ */ w.jsx(Tn, { present: o || p, children: ({ present: b }) => /* @__PURE__ */ w.jsx(
      ke.div,
      {
        "data-state": p ? "active" : "inactive",
        "data-orientation": u.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !b,
        id: d,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: m.current ? "0s" : void 0
        },
        children: b && a
      }
    ) });
  }
);
P9.displayName = R9;
function T9(e, t) {
  return `${e}-trigger-${t}`;
}
function z9(e, t) {
  return `${e}-content-${t}`;
}
var tB = S9, nB = E9, rB = L9, cB = P9;
const oB = "_tabsRoot_1u7qj_2", iB = "_tabsList_1u7qj_6", aB = "_tabsTrigger_1u7qj_21", sB = "_tabsContent_1u7qj_61", Ha = {
  tabsRoot: oB,
  tabsList: iB,
  tabsTrigger: aB,
  tabsContent: sB
};
function lB({ className: e = "", onValueChange: t = () => {
}, id: n, ...c }) {
  const { click: o } = Zr.componentTypes, a = je(), s = (u) => {
    t({ value: u }), jr(a.current.id, u, o);
  };
  return /* @__PURE__ */ w.jsx("div", { ref: a, id: `${g1}_Tabs${n ? `_${n}` : ""}`, children: /* @__PURE__ */ w.jsx(tB, { onValueChange: s, ...c, className: `${e} ${Ha.tabsRoot}` }) });
}
function uB({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(rB, { ...t, className: `${e} ${Ha.tabsTrigger}` });
}
function fB({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(nB, { ...t, className: `${e} ${Ha.tabsList}` });
}
function dB({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(cB, { ...t, className: `${e} ${Ha.tabsContent}` });
}
lB.propTypes = {
  className: z.string,
  onValueChange: z.func,
  id: z.string
};
fB.propTypes = {
  className: z.string
};
dB.propTypes = {
  className: z.string
};
uB.propTypes = {
  className: z.string
};
var pB = "Toggle", N9 = A.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: c = !1, onPressedChange: o, ...a } = e, [s = !1, u] = qt({
    prop: n,
    onChange: o,
    defaultProp: c
  });
  return /* @__PURE__ */ w.jsx(
    ke.button,
    {
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: Ae(e.onClick, () => {
        e.disabled || u(!s);
      })
    }
  );
});
N9.displayName = pB;
var pc = "ToggleGroup", [O9, MV] = Ht(pc, [
  Xr
]), F9 = Xr(), t0 = Te.forwardRef((e, t) => {
  const { type: n, ...c } = e;
  if (n === "single") {
    const o = c;
    return /* @__PURE__ */ w.jsx(gB, { ...o, ref: t });
  }
  if (n === "multiple") {
    const o = c;
    return /* @__PURE__ */ w.jsx(mB, { ...o, ref: t });
  }
  throw new Error(`Missing prop \`type\` expected on \`${pc}\``);
});
t0.displayName = pc;
var [D9, $9] = O9(pc), gB = Te.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: c,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s, u] = qt({
    prop: n,
    defaultProp: c,
    onChange: o
  });
  return /* @__PURE__ */ w.jsx(
    D9,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: s ? [s] : [],
      onItemActivate: u,
      onItemDeactivate: Te.useCallback(() => u(""), [u]),
      children: /* @__PURE__ */ w.jsx(G9, { ...a, ref: t })
    }
  );
}), mB = Te.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: c,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s = [], u] = qt({
    prop: n,
    defaultProp: c,
    onChange: o
  }), f = Te.useCallback(
    (p) => u((m = []) => [...m, p]),
    [u]
  ), d = Te.useCallback(
    (p) => u((m = []) => m.filter((b) => b !== p)),
    [u]
  );
  return /* @__PURE__ */ w.jsx(
    D9,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: s,
      onItemActivate: f,
      onItemDeactivate: d,
      children: /* @__PURE__ */ w.jsx(G9, { ...a, ref: t })
    }
  );
});
t0.displayName = pc;
var [hB, vB] = O9(pc), G9 = Te.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: c = !1,
      rovingFocus: o = !0,
      orientation: a,
      dir: s,
      loop: u = !0,
      ...f
    } = e, d = F9(n), p = ic(s), m = { role: "group", dir: p, ...f };
    return /* @__PURE__ */ w.jsx(hB, { scope: n, rovingFocus: o, disabled: c, children: o ? /* @__PURE__ */ w.jsx(
      Aa,
      {
        asChild: !0,
        ...d,
        orientation: a,
        dir: p,
        loop: u,
        children: /* @__PURE__ */ w.jsx(ke.div, { ...m, ref: t })
      }
    ) : /* @__PURE__ */ w.jsx(ke.div, { ...m, ref: t }) });
  }
), oa = "ToggleGroupItem", k9 = Te.forwardRef(
  (e, t) => {
    const n = $9(oa, e.__scopeToggleGroup), c = vB(oa, e.__scopeToggleGroup), o = F9(e.__scopeToggleGroup), a = n.value.includes(e.value), s = c.disabled || e.disabled, u = { ...e, pressed: a, disabled: s }, f = Te.useRef(null);
    return c.rovingFocus ? /* @__PURE__ */ w.jsx(
      Sa,
      {
        asChild: !0,
        ...o,
        focusable: !s,
        active: a,
        ref: f,
        children: /* @__PURE__ */ w.jsx(Df, { ...u, ref: t })
      }
    ) : /* @__PURE__ */ w.jsx(Df, { ...u, ref: t });
  }
);
k9.displayName = oa;
var Df = Te.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: c, ...o } = e, a = $9(oa, n), s = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, u = a.type === "single" ? s : void 0;
    return /* @__PURE__ */ w.jsx(
      N9,
      {
        ...u,
        ...o,
        ref: t,
        onPressedChange: (f) => {
          f ? a.onItemActivate(c) : a.onItemDeactivate(c);
        }
      }
    );
  }
), bB = t0, CB = k9;
const xB = "_ToggleGroupItem_15j05_1", yB = {
  ToggleGroupItem: xB
};
function B9({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(bB, { ...t });
}
function V9({ className: e = "", ...t }) {
  return /* @__PURE__ */ w.jsx(CB, { ...t, className: `${yB.ToggleGroupItem} ${e}` });
}
B9.propTypes = {
  className: z.string
};
V9.propTypes = {
  className: z.string
};
const IB = "_navbar_12ope_2", wB = "_leftSide_12ope_17", AB = "_childrenWrapper_12ope_24", SB = "_mainLogo_12ope_33", _B = "_isOnClick_12ope_38", EB = "_title_12ope_42", o1 = {
  navbar: IB,
  leftSide: wB,
  childrenWrapper: AB,
  mainLogo: SB,
  isOnClick: _B,
  title: EB
};
function MB({ children: e, value: t, logo: n, menu: c, tooltip: o, onClick: a, id: s }) {
  const { click: u } = Zr.componentTypes, f = je(), d = (p) => {
    a({
      event: p,
      value: t
    }), jr(f.current.id, t, u);
  };
  return /* @__PURE__ */ w.jsxs("div", { ref: f, id: `${g1}_Navbar${s ? `_${s}` : ""}`, className: o1.navbar, children: [
    /* @__PURE__ */ w.jsxs("div", { className: o1.leftSide, children: [
      c || null,
      /* @__PURE__ */ w.jsx(v1, { content: o, children: /* @__PURE__ */ w.jsxs(
        "div",
        {
          onClick: d,
          className: a ? `${o1.mainLogo} ${o1.isOnClick}` : o1.mainLogo,
          id: "logoAndTitleWrapper",
          children: [
            n,
            /* @__PURE__ */ w.jsx("div", { className: o1.title, id: "currentTitle", children: t }, "currentTitle")
          ]
        }
      ) }, "ToolTipWrapper")
    ] }, "leftSide"),
    /* @__PURE__ */ w.jsx("div", { className: o1.childrenWrapper, children: e }, "childrenWrapper")
  ] });
}
MB.propTypes = {
  children: z.node.isRequired,
  value: z.string.isRequired,
  logo: z.element.isRequired,
  menu: z.element,
  tooltip: z.string,
  onClick: z.func,
  id: z.string
};
function n0() {
  const e = je(!0);
  return ia(() => {
    e.current = !1;
  }, []), e.current;
}
const LB = "_packageItem_1lytg_2", RB = "_wrapper_1lytg_14", PB = "_label_1lytg_22", TB = "_icon_1lytg_36", zB = "_name_1lytg_37", Hc = {
  packageItem: LB,
  wrapper: RB,
  label: PB,
  icon: TB,
  name: zB
};
function W9({ value: e, iconName: t = "", label: n, isDisabled: c }) {
  return /* @__PURE__ */ w.jsx(V9, { value: e, disabled: c, className: Hc.packageItem, id: `bizPackItem-${e}`, children: /* @__PURE__ */ w.jsxs("div", { className: Hc.wrapper, children: [
    n && /* @__PURE__ */ w.jsx("span", { className: Hc.label, children: n }),
    /* @__PURE__ */ w.jsx(Hn, { iconName: t, className: Hc.icon, size: pa.lg }),
    /* @__PURE__ */ w.jsx("span", { className: Hc.name, children: e })
  ] }) });
}
W9.propTypes = {
  value: z.string.isRequired,
  isDisabled: z.bool,
  iconName: z.string,
  label: z.string
};
const NB = "#3d4c59", OB = "#FF8F24", FB = "_bizContainer_1f46a_405", DB = "_fadeIn_1f46a_1", $B = "_fadeOut_1f46a_1", GB = "_slideUpAndFade_1f46a_1", kB = "_slideRightAndFade_1f46a_1", BB = "_slideDownAndFade_1f46a_1", VB = "_slideLeftAndFade_1f46a_1", WB = "_slideDown_1f46a_1", HB = "_slideUp_1f46a_1", jB = "_rotateUp_1f46a_1", XB = "_rotateDown_1f46a_1", ZB = {
  bizContainer: FB,
  fadeIn: DB,
  fadeOut: $B,
  slideUpAndFade: GB,
  slideRightAndFade: kB,
  slideDownAndFade: BB,
  slideLeftAndFade: VB,
  slideDown: WB,
  slideUp: HB,
  rotateUp: jB,
  rotateDown: XB
};
function YB({ id: e, defaultValue: t = "", onChange: n, options: c }) {
  const { optionSelected: o, click: a } = Zr.componentTypes, s = n0(), u = je(null), [f, d] = Ne(!1), p = Wt(() => Object.values(c).map((y) => y), [c]), m = () => {
    d(!f);
  }, b = (y) => {
    n({ value: y }), m(), jr(u.current.id, y, o);
  };
  return ct(() => {
    s || jr(u.current.id, f ? "open" : "close", a);
  }, [f]), /* @__PURE__ */ w.jsx("div", { ref: u, id: `${g1}_BizPack${e ? `_${e}` : ""}`, children: /* @__PURE__ */ w.jsxs(Ma, { open: f, onOpenChange: m, children: [
    /* @__PURE__ */ w.jsx(La, { children: /* @__PURE__ */ w.jsx(v1, { content: `App: ${t}`, children: /* @__PURE__ */ w.jsx(Hn, { iconName: yn.grid.name, size: pa.lg, color: NB }) }) }),
    /* @__PURE__ */ w.jsx(Ra, { align: "end", children: /* @__PURE__ */ w.jsx(
      B9,
      {
        type: "single",
        value: t,
        onValueChange: b,
        className: ZB.bizContainer,
        children: p.map((y) => /* @__PURE__ */ w.jsx(
          W9,
          {
            value: y.value,
            isDisabled: y.isDisabled,
            iconName: y.iconName,
            label: y.label
          },
          y.value
        ))
      }
    ) })
  ] }) });
}
YB.propTypes = {
  options: z.shape({
    value: z.string.isRequired,
    title: z.string.isRequired,
    iconName: z.string.isRequired,
    label: z.string,
    isDisabled: z.bool
  }).isRequired,
  onChange: z.func.isRequired,
  defaultValue: z.string,
  id: z.string
};
const UB = K1({
  toggleOpen: () => {
  }
}), JB = "_logo_1fhu8_2", KB = "_name_1fhu8_7", $f = {
  logo: JB,
  name: KB
};
function qB({ children: e, tooltip: t = "", value: n, id: c }) {
  const { click: o } = Zr.componentTypes, a = n0(), s = je(null), [u, f] = Ne(!1), d = () => {
    f(!u);
  }, p = Wt(() => ({ toggleOpen: d }), [d]);
  return ct(() => {
    a || jr(s.current.id, u ? "open" : "close", o);
  }, [u]), /* @__PURE__ */ w.jsx(UB.Provider, { value: p, children: /* @__PURE__ */ w.jsx("div", { ref: s, id: `${g1}_user_settings${c ? `_${c}` : ""}`, children: /* @__PURE__ */ w.jsxs(Ma, { open: u, onOpenChange: d, children: [
    /* @__PURE__ */ w.jsx(La, { id: "topbar_current_user", children: /* @__PURE__ */ w.jsxs(v1, { content: t, children: [
      /* @__PURE__ */ w.jsx(Hn, { iconName: yn.user.name, className: $f.logo, size: pa.lg }),
      !!n && /* @__PURE__ */ w.jsx("span", { className: $f.name, children: n })
    ] }) }),
    /* @__PURE__ */ w.jsx(Ra, { align: "end", id: "userSettingsContent", children: e })
  ] }) }) });
}
qB.propTypes = {
  children: z.element.isRequired,
  value: z.string,
  tooltip: z.string,
  id: z.string
};
function QB({ children: e, tooltip: t, isOn: n, onClick: c = () => {
}, id: o }) {
  const a = n0(), { click: s } = Zr.componentTypes, u = je(), [f, d] = Ne(!1), p = () => {
    d(!f), c({ id: u.current.id });
  };
  return ct(() => {
    if (!a) {
      const m = e ? e && f ? "open" : "close" : "click";
      jr(u.current.id, m, s);
    }
  }, [f]), /* @__PURE__ */ w.jsx("div", { ref: u, id: `${g1}_notification${o ? `_${o}` : ""}`, children: /* @__PURE__ */ w.jsxs(Ma, { open: e && f, onOpenChange: p, children: [
    /* @__PURE__ */ w.jsx(v1, { content: t, children: /* @__PURE__ */ w.jsx(La, { children: /* @__PURE__ */ w.jsx(Md, { currentColorDot: n ? OB : "" }) }) }),
    e && /* @__PURE__ */ w.jsx(Ra, { align: "end", children: e })
  ] }) });
}
QB.propTypes = {
  children: z.element,
  tooltip: z.string,
  isOn: z.bool,
  onClick: z.func,
  id: z.string
};
const Gf = "data:image/svg+xml,%3csvg%20width='31'%20height='16'%20viewBox='0%200%2031%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M29.4433%203.69336L29.3027%209.71094H28.0956L27.9491%203.69336H29.4433ZM27.9081%2011.5566C27.9081%2011.3418%2027.9784%2011.1621%2028.1191%2011.0176C28.2636%2010.8691%2028.4628%2010.7949%2028.7167%2010.7949C28.9667%2010.7949%2029.164%2010.8691%2029.3085%2011.0176C29.453%2011.1621%2029.5253%2011.3418%2029.5253%2011.5566C29.5253%2011.7637%2029.453%2011.9414%2029.3085%2012.0898C29.164%2012.2344%2028.9667%2012.3066%2028.7167%2012.3066C28.4628%2012.3066%2028.2636%2012.2344%2028.1191%2012.0898C27.9784%2011.9414%2027.9081%2011.7637%2027.9081%2011.5566Z'%20fill='%23B756DA'/%3e%3cpath%20d='M19.1634%2010.3086L20.8626%203.69336H21.7532L21.6536%205.39844L19.8372%2012.2246H18.9114L19.1634%2010.3086ZM17.8919%203.69336L19.2688%2010.2559L19.3919%2012.2246H18.4075L16.4329%203.69336H17.8919ZM23.6809%2010.2383L25.0403%203.69336H26.5052L24.5305%2012.2246H23.5462L23.6809%2010.2383ZM22.0989%203.69336L23.7805%2010.3262L24.0266%2012.2246H23.1009L21.3137%205.39844L21.22%203.69336H22.0989Z'%20fill='%23B756DA'/%3e%3cpath%20d='M15.4635%2011.0586V12.2246H10.9342V11.0586H15.4635ZM11.3502%203.69336V12.2246H9.87953V3.69336H11.3502ZM14.8717%207.25586V8.4043H10.9342V7.25586H14.8717ZM15.4342%203.69336V4.86523H10.9342V3.69336H15.4342Z'%20fill='%23B756DA'/%3e%3cpath%20d='M7.76758%203.69336V12.2246H6.29688L2.4707%206.11328V12.2246H1V3.69336H2.4707L6.30859%209.81641V3.69336H7.76758Z'%20fill='%23B756DA'/%3e%3c/svg%3e", kf = "data:image/svg+xml,%3csvg%20width='75'%20height='16'%20viewBox='0%200%2075%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.00189%207.9624V7.74365C1.1386%205.55615%202.97064%203.8335%205.15814%203.8335H11.0097L9.50579%202.32959C9.23235%202.0835%209.23235%201.67334%209.50579%201.3999C9.75189%201.15381%2010.162%201.15381%2010.4355%201.3999L13.0605%204.0249C13.3066%204.29834%2013.3066%204.7085%2013.0605%204.95459L10.4355%207.57959C10.162%207.85303%209.75189%207.85303%209.50579%207.57959C9.23235%207.3335%209.23235%206.92334%209.50579%206.6499L11.0097%205.146H5.15814C3.65423%205.146%202.39642%206.32178%202.31439%207.82568V8.04443C2.28704%208.3999%201.95892%208.67334%201.60345%208.646C1.24798%208.646%200.974542%208.31787%201.00189%207.9624ZM14.9745%208.04443H15.0019L14.9745%208.26318C14.8378%2010.4507%2013.0331%2012.146%2010.8183%2012.146H4.96673L6.47064%2013.6499C6.74407%2013.9233%206.74407%2014.3335%206.47064%2014.5796C6.22454%2014.853%205.81439%2014.853%205.56829%2014.5796L2.94329%2011.9546C2.66985%2011.7085%202.66985%2011.2983%202.94329%2011.0249L5.56829%208.42725C5.81439%208.15381%206.22454%208.15381%206.47064%208.42725C6.74407%208.67334%206.74407%209.0835%206.47064%209.32959L4.96673%2010.8335H10.8183C12.3222%2010.8335%2013.58%209.68506%2013.662%208.18115L13.6894%207.9624C13.6894%207.60693%2014.0175%207.3335%2014.373%207.3335C14.7284%207.36084%2015.0019%207.68896%2014.9745%208.04443Z'%20fill='%23B756DA'/%3e%3cpath%20d='M69.6913%2012.2656H67.8691L67.8808%2011.0996H69.6913C70.2187%2011.0996%2070.6601%2010.9844%2071.0156%2010.7539C71.3749%2010.5234%2071.6445%2010.1934%2071.8242%209.76367C72.0077%209.33398%2072.0995%208.82227%2072.0995%208.22852V7.76562C72.0995%207.30469%2072.0468%206.89648%2071.9413%206.54102C71.8398%206.18555%2071.6874%205.88672%2071.4843%205.64453C71.2851%205.40234%2071.039%205.21875%2070.746%205.09375C70.457%204.96875%2070.123%204.90625%2069.7441%204.90625H67.8339V3.73438H69.7441C70.3105%203.73438%2070.8281%203.83008%2071.2968%204.02148C71.7656%204.20898%2072.1699%204.48047%2072.5097%204.83594C72.8534%205.19141%2073.1171%205.61719%2073.3007%206.11328C73.4843%206.60938%2073.5761%207.16406%2073.5761%207.77734V8.22852C73.5761%208.8418%2073.4843%209.39648%2073.3007%209.89258C73.1171%2010.3887%2072.8534%2010.8145%2072.5097%2011.1699C72.1659%2011.5215%2071.7558%2011.793%2071.2792%2011.9844C70.8066%2012.1719%2070.2773%2012.2656%2069.6913%2012.2656ZM68.6835%203.73438V12.2656H67.2128V3.73438H68.6835Z'%20fill='%23B756DA'/%3e%3cpath%20d='M66.0117%2011.0996V12.2656H61.4824V11.0996H66.0117ZM61.8984%203.73438V12.2656H60.4277V3.73438H61.8984ZM65.4199%207.29688V8.44531H61.4824V7.29688H65.4199ZM65.9824%203.73438V4.90625H61.4824V3.73438H65.9824Z'%20fill='%23B756DA'/%3e%3cpath%20d='M50.5253%203.73438H51.8378L54.3046%2010.3145L56.7656%203.73438H58.0781L54.8202%2012.2656H53.7773L50.5253%203.73438ZM49.9277%203.73438H51.1757L51.3925%209.42969V12.2656H49.9277V3.73438ZM57.4277%203.73438H58.6816V12.2656H57.2109V9.42969L57.4277%203.73438Z'%20fill='%23B756DA'/%3e%3cpath%20d='M45.2929%204.87109L42.7441%2012.2656H41.2031L44.414%203.73438H45.3984L45.2929%204.87109ZM47.4257%2012.2656L44.871%204.87109L44.7597%203.73438H45.7499L48.9726%2012.2656H47.4257ZM47.3027%209.10156V10.2676H42.662V9.10156H47.3027Z'%20fill='%23B756DA'/%3e%3cpath%20d='M40.1132%203.73438V12.2656H38.6425L34.8163%206.1543V12.2656H33.3456V3.73438H34.8163L38.6542%209.85742V3.73438H40.1132Z'%20fill='%23B756DA'/%3e%3cpath%20d='M32.1445%2011.0996V12.2656H27.6152V11.0996H32.1445ZM28.0312%203.73438V12.2656H26.5605V3.73438H28.0312ZM31.5527%207.29688V8.44531H27.6152V7.29688H31.5527ZM32.1152%203.73438V4.90625H27.6152V3.73438H32.1152Z'%20fill='%23B756DA'/%3e%3cpath%20d='M19.0019%203.73438H22.0195C22.6679%203.73438%2023.2206%203.83203%2023.6777%204.02734C24.1347%204.22266%2024.4843%204.51172%2024.7265%204.89453C24.9726%205.27344%2025.0956%205.74219%2025.0956%206.30078C25.0956%206.72656%2025.0175%207.10156%2024.8613%207.42578C24.705%207.75%2024.4843%208.02344%2024.1992%208.24609C23.914%208.46484%2023.5742%208.63477%2023.1796%208.75586L22.7343%208.97266H20.0214L20.0097%207.80664H22.0429C22.3945%207.80664%2022.6874%207.74414%2022.9218%207.61914C23.1562%207.49414%2023.332%207.32422%2023.4492%207.10938C23.5702%206.89062%2023.6308%206.64453%2023.6308%206.37109C23.6308%206.07422%2023.5722%205.81641%2023.455%205.59766C23.3417%205.375%2023.1659%205.20508%2022.9277%205.08789C22.6894%204.9668%2022.3867%204.90625%2022.0195%204.90625H20.4726V12.2656H19.0019V3.73438ZM23.871%2012.2656L21.8671%208.43359L23.4081%208.42773L25.4413%2012.1895V12.2656H23.871Z'%20fill='%23B756DA'/%3e%3c/svg%3e", eV = "_SidebarRoot_1k5kj_2", tV = "_SidebarTrigger_1k5kj_15", nV = "_SidebarSubTrigger_1k5kj_20", rV = "_SidebarIcon_1k5kj_36", cV = "_active_1k5kj_44", oV = "_SidebarTitle_1k5kj_51", iV = "_SidebarSubTitle_1k5kj_56", aV = "_sidebarTitleWrapper_1k5kj_75", sV = "_SidebarChevron_1k5kj_92", lV = "_SidebarActiveIndicator_1k5kj_104", uV = "_SidebarContent_1k5kj_119", fV = "_Line_1k5kj_122", Vt = {
  SidebarRoot: eV,
  SidebarTrigger: tV,
  SidebarSubTrigger: nV,
  SidebarIcon: rV,
  active: cV,
  SidebarTitle: oV,
  SidebarSubTitle: iV,
  sidebarTitleWrapper: aV,
  SidebarChevron: sV,
  SidebarActiveIndicator: lV,
  SidebarContent: uV,
  Line: fV
};
function dV({ options: e, onValueChange: t, id: n }) {
  let c = !1;
  const { optionSelected: o } = Zr.componentTypes, a = je(null), [s, u] = Ne(null), f = (C) => {
    const h = C.indexOf("/");
    let v = C, I = null;
    return h > -1 ? (v = C.slice(0, h), I = C.slice(h + 1, C.length), [v, I]) : [v, null];
  }, d = (C, h) => {
    const [v, I] = f(C), S = Object.values(h).find((L) => L.value === v);
    return I ? S.children.find((L) => L.value === I) : S;
  }, p = (C) => {
    u(C);
    const h = d(C, e);
    h && (!h.children || !h.children.length) && (t(C, c), jr(a.current.id, C, o));
  };
  function m(C) {
    c = C.metaKey || C.ctrlKey;
  }
  const b = () => {
    u(null);
  }, y = (C) => C.isActive || C.children && C.children.length && C.children.some((h) => h.isActive);
  return /* @__PURE__ */ w.jsx(
    "div",
    {
      ref: a,
      id: `${g1}_Sidebar${n ? `_${n}` : ""}`,
      onMouseLeave: b,
      className: Vt.SidebarRoot,
      children: /* @__PURE__ */ w.jsx(Yd, { onValueChange: p, type: "single", collapsible: !0, value: s, children: e.map((C) => {
        if (!C.value) return null;
        const h = y(C);
        return /* @__PURE__ */ w.jsxs(gl, { value: C.value, children: [
          /* @__PURE__ */ w.jsx(ml, { children: /* @__PURE__ */ w.jsxs(hl, { className: Vt.SidebarTrigger, id: `sideBarItemButton-${C.value}`, children: [
            /* @__PURE__ */ w.jsx("div", { className: `${Vt.SidebarActiveIndicator} ${h ? Vt.active : ""}` }),
            /* @__PURE__ */ w.jsx(
              "span",
              {
                className: `${Vt.SidebarIcon} ${h ? Vt.active : ""}`,
                id: `sideBarItemIcon-${C.value}`,
                children: /* @__PURE__ */ w.jsx(Hn, { iconName: C.icon })
              }
            ),
            /* @__PURE__ */ w.jsxs("div", { className: `${Vt.sidebarTitleWrapper}`, children: [
              /* @__PURE__ */ w.jsx("span", { className: `${Vt.SidebarTitle}`, id: `sideBarItemTitle-${C.value}`, children: C.title }),
              C.isNew ? /* @__PURE__ */ w.jsx("img", { src: Gf, alt: "New option" }) : null,
              C.isRenamed ? /* @__PURE__ */ w.jsx("img", { src: kf, alt: "Renamed option" }) : null
            ] }),
            C.children && !!C.children.length && /* @__PURE__ */ w.jsx(
              Jd,
              {
                className: Vt.SidebarChevron,
                "aria-hidden": !0,
                id: `sideBarItemChevron-${C.value}`
              }
            )
          ] }) }),
          C.children && !!C.children.length && /* @__PURE__ */ w.jsxs(Ud, { className: Vt.SidebarContent, id: `innerSideBarContent-${C.value}`, children: [
            /* @__PURE__ */ w.jsx("div", { className: Vt.Line }),
            C.children.map((v) => /* @__PURE__ */ w.jsx(gl, { value: `${C.value}/${v.value}`, children: /* @__PURE__ */ w.jsx(ml, { children: /* @__PURE__ */ w.jsx(
              hl,
              {
                className: Vt.SidebarSubTrigger,
                id: `innerSideBarItemButton-${v.value}`,
                children: /* @__PURE__ */ w.jsx("div", { className: `${Vt.sidebarTitleWrapper}`, children: /* @__PURE__ */ w.jsxs(v1, { content: v.tooltip, children: [
                  /* @__PURE__ */ w.jsx(
                    "span",
                    {
                      className: `${Vt.SidebarSubTitle} ${v.isActive ? Vt.active : ""}`,
                      id: `innerSideBarItemTitle-${v.value}`,
                      onClick: m,
                      "aria-hidden": "true",
                      children: v.title
                    }
                  ),
                  v.isNew ? /* @__PURE__ */ w.jsx("img", { src: Gf, alt: "New option" }) : null,
                  v.isRenamed ? /* @__PURE__ */ w.jsx("img", { src: kf, alt: "Renamed option" }) : null
                ] }) })
              }
            ) }) }, v.value))
          ] })
        ] }, C.value);
      }) })
    }
  );
}
dV.propTypes = {
  id: z.string,
  onValueChange: z.func.isRequired,
  options: z.arrayOf(
    z.shape({
      value: z.string.isRequired,
      title: z.string.isRequired,
      icon: z.string.isRequired,
      isActive: z.bool,
      isDisabled: z.bool,
      isNew: z.bool,
      isRenamed: z.bool,
      children: z.arrayOf(
        z.shape({
          value: z.string.isRequired,
          title: z.string.isRequired,
          isActive: z.bool,
          isDisabled: z.any,
          isNew: z.bool,
          isRenamed: z.bool,
          tooltip: z.string
        })
      )
    })
  ).isRequired
};
const LV = {
  businessMonitoring: {
    value: "Revenue Intelligence",
    url: "https://app.anodot.com",
    iconName: yn.monitor.name
  },
  cloudCost: {
    value: "Cost Intelligence",
    url: "https://mypileus.io",
    iconName: yn.cloud.name
  },
  paymentIntelligence: {
    value: "Payments Monitoring",
    url: "https://www.anodot.com/payment-transaction-monitoring/?utm_source=smartburger&utm_medium=clarity",
    iconName: yn.fileInvoiceDollar.name
  },
  funnelObserver: {
    value: "Funnel Observer",
    url: "https://www.anodot.com/ad-campaigns/?utm_source=smartburger&utm_medium=clarity",
    iconName: yn.binoculars.name
  }
};
export {
  Jd as AccordionChevron,
  Ud as AccordionContent,
  ml as AccordionHeader,
  gl as AccordionItem,
  Yd as AccordionRoot,
  hl as AccordionTrigger,
  LV as BIZ_PACK_OPTIONS,
  YB as BizPack,
  OE as CheckboxItem,
  h_ as ClarityLogo,
  FP as DropdownMenuContent,
  $P as DropdownMenuItem,
  DP as DropdownMenuLabel,
  TP as DropdownMenuRoot,
  kP as DropdownMenuSeparator,
  NP as DropdownMenuSub,
  OP as DropdownMenuSubContent,
  GP as DropdownMenuTitle,
  zP as DropdownMenuTrigger,
  c1 as EmptyComponent,
  v_ as EmptyDdIcon,
  I9 as FooterComponent,
  Hn as GenerateIcon,
  Ld as GenerateIconValidation,
  yn as ICONS,
  lT as ListContent,
  uT as ListItem,
  aT as ListLabel,
  sT as ListSeparator,
  iT as ListTitle,
  Jk as MenuList,
  MB as Navbar,
  Uk as NothingToShow,
  QB as Notification,
  Md as NotificationIcon,
  Wa as OptionMulti,
  Ma as Popover,
  FT as PopoverAnchor,
  $T as PopoverArrow,
  Ra as PopoverContent,
  DT as PopoverPortal,
  La as PopoverTrigger,
  oz as Progress,
  xV as RadioGroup,
  PP as RadioGroupIndicator,
  H8 as RadioGroupItem,
  pa as SIZES,
  MO as SelectContent,
  PO as SelectGroup,
  TO as SelectIcon,
  NO as SelectItem,
  FO as SelectItemIndicator,
  OO as SelectItemText,
  zO as SelectLabel,
  qk as SelectMulti,
  w9 as SelectMultiItem,
  LO as SelectPortal,
  SO as SelectRoot,
  GO as SelectScrollDownButton,
  $O as SelectScrollUpButton,
  DO as SelectSeparator,
  _O as SelectTrigger,
  EO as SelectValue,
  RO as SelectViewport,
  dV as Sidebar,
  lB as Tabs,
  dB as TabsContent,
  fB as TabsList,
  uB as TabsTrigger,
  B9 as ToggleGroup,
  V9 as ToggleGroupItem,
  v1 as ToolTipWrapper,
  IF as TooltipArrow,
  yF as TooltipContent,
  $7 as TooltipProvider,
  CF as TooltipRoot,
  xF as TooltipTrigger,
  qB as UserSettings,
  UB as UserSettingsContext,
  Kk as customStyles
};
